var pd = Object.defineProperty;
var md = (e, t, n) => t in e ? pd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var oe = (e, t, n) => md(e, typeof t != "symbol" ? t + "" : t, n);
import { inject as Lt, reactive as Kt, defineComponent as Y, computed as F, resolveComponent as ne, createElementBlock as M, openBlock as y, normalizeClass as J, createElementVNode as b, createVNode as w, ref as L, onMounted as Ne, toDisplayString as R, unref as k, Fragment as fe, renderList as He, normalizeStyle as Se, renderSlot as q, mergeModels as pt, useModel as ye, createBlock as G, withCtx as T, watch as Ae, createCommentVNode as W, h as Ts, resolveDirective as Sa, withDirectives as Qt, createTextVNode as ke, toRefs as at, onBeforeMount as Ls, onUnmounted as wn, withKeys as Ta, withModifiers as xt, vModelDynamic as Ad, shallowRef as Yl, getCurrentInstance as ta, Text as gd, vShow as vo, Teleport as hd, nextTick as kn, watchEffect as bn, mergeProps as ni, toHandlers as Gl, useCssVars as ai, createStaticVNode as vd, render as Le, readonly as bd, onBeforeUpdate as xd, onBeforeUnmount as yd } from "vue";
import { defineStore as _n, storeToRefs as Ed, setActivePinia as Cd } from "pinia";
import Bd from "primevue/toggleswitch";
import { v5 as Id } from "uuid";
import { STLLibrary as rs, WebCADModule as wd, AuthAPI as kd } from "@xlabmedical/medic-api";
import _d from "primevue/config";
import Sd from "primevue/autocomplete";
import Td from "primevue/accordion";
import Ld from "primevue/accordiontab";
import Dd from "primevue/avatar";
import Md from "primevue/avatargroup";
import Od from "primevue/badge";
import Nd from "primevue/badgedirective";
import gn from "primevue/button";
import Rd from "primevue/breadcrumb";
import Pd from "primevue/calendar";
import Fd from "primevue/card";
import Qd from "primevue/cascadeselect";
import Ud from "primevue/carousel";
import Yd from "primevue/checkbox";
import jl from "primevue/chip";
import Gd from "primevue/chips";
import si from "primevue/colorpicker";
import jd from "primevue/column";
import Hd from "primevue/confirmdialog";
import Vd from "primevue/confirmpopup";
import Hl from "primevue/contextmenu";
import Kd from "primevue/confirmationservice";
import Wd from "primevue/datatable";
import Vl from "primevue/dialog";
import Kl from "primevue/divider";
import zd from "primevue/dropdown";
import $d from "primevue/fieldset";
import Jd from "primevue/fileupload";
import qd from "primevue/galleria";
import Wl from "primevue/image";
import Xd from "primevue/inlinemessage";
import Zd from "primevue/inplace";
import zl from "primevue/inputswitch";
import oi from "primevue/inputtext";
import ef from "primevue/inputmask";
import Ds from "primevue/inputnumber";
import tf from "primevue/knob";
import $l from "primevue/listbox";
import nf from "primevue/megamenu";
import af from "primevue/menu";
import sf from "primevue/menubar";
import of from "primevue/message";
import rf from "primevue/multiselect";
import lf from "primevue/orderlist";
import cf from "primevue/organizationchart";
import La from "primevue/popover";
import uf from "primevue/paginator";
import df from "primevue/panel";
import ff from "primevue/panelmenu";
import pf from "primevue/password";
import mf from "primevue/picklist";
import Af from "primevue/progressbar";
import gf from "primevue/rating";
import hf from "primevue/radiobutton";
import vf from "primevue/selectbutton";
import bf from "primevue/scrollpanel";
import xf from "primevue/scrolltop";
import yf from "primevue/skeleton";
import ii from "primevue/slider";
import Ef from "primevue/sidebar";
import Cf from "primevue/splitbutton";
import Bf from "primevue/splitter";
import If from "primevue/splitterpanel";
import wf from "primevue/steps";
import kf from "primevue/tabmenu";
import _f from "primevue/tieredmenu";
import Sf from "primevue/textarea";
import Tf from "primevue/toast";
import Lf from "primevue/toolbar";
import Df from "primevue/tabview";
import Mf from "primevue/tabpanel";
import Of from "primevue/tag";
import Nf from "primevue/timeline";
import Rf from "primevue/toastservice";
import Pf from "primevue/togglebutton";
import Ff from "primevue/tooltip";
import Qf from "primevue/tree";
import Uf from "primevue/treeselect";
import Yf from "primevue/treetable";
import { useToast as Gf } from "primevue/usetoast";
import { useLocalStorage as jf } from "@vueuse/core";
import Xi from "primevue/dialogservice";
import { definePreset as ri, updatePreset as Hf } from "@primevue/themes";
import Vf from "@primevue/themes/aura";
import { useDialog as Jl } from "primevue/usedialog";
import Ms from "primevue/select";
import Kf from "primevue/progressspinner";
import Wf from "primevue/steplist";
import zf from "primevue/step";
import $f from "primevue/stepper";
import { useRoute as Jf } from "vue-router";
function ql(e, t) {
  for (var n = 0; n < t.length; n++) {
    const a = t[n];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const s in a)
        if (s !== "default" && !(s in e)) {
          const o = Object.getOwnPropertyDescriptor(a, s);
          o && Object.defineProperty(e, s, o.get ? o : {
            enumerable: !0,
            get: () => a[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function Os() {
  const e = /* @__PURE__ */ new Map();
  return {
    on(t, n) {
      let a = e.get(t);
      return a ? a.push(n) : a = [n], e.set(t, a), this;
    },
    off(t, n) {
      let a = e.get(t);
      return a && a.splice(a.indexOf(n) >>> 0, 1), this;
    },
    emit(t, n) {
      let a = e.get(t);
      a && a.slice().map((s) => {
        s(n);
      });
    },
    clear() {
      e.clear();
    }
  };
}
const qf = Os();
var j = /* @__PURE__ */ ((e) => (e.EN = "en", e.IT = "it", e.BG = "bg", e.ZH_HANS = "zh_hans", e.HR = "hr", e.CS = "cs", e.DA = "da", e.NL = "nl", e.FR = "fr", e.DE = "de", e.HU = "hu", e.JA = "ja", e.KO = "ko", e.LT = "lt", e.PL = "pl", e.PT = "pt", e.RO = "ro", e.SK = "sk", e.SL = "sl", e.ES = "es", e.SV = "sv", e.TR = "tr", e))(j || {}), Ut = /* @__PURE__ */ ((e) => (e.SIDEBAR = "sidebar", e.STATIC = "static", e.OVERLAY = "overlay", e.HORIZONTAL = "horizontal", e.SLIM = "slim", e))(Ut || {}), na = /* @__PURE__ */ ((e) => (e.DARK = "dark", e.LIGHT = "light", e))(na || {}), wt = /* @__PURE__ */ ((e) => (e.BLUE = "blue", e.GREEN = "green", e.MAGENTA = "magenta", e.ORANGE = "orange", e.PURPLE = "purple", e.RED = "red", e.TEAL = "teal", e.YELLOW = "yellow", e))(wt || {});
function Xf() {
  const e = localStorage.getItem("navBarPos");
  return e ? JSON.parse(e) : "sidebar";
}
function Zf() {
  const e = localStorage.getItem("colorTheme");
  return e ? JSON.parse(e) : "sidebar";
}
function ep() {
  const e = localStorage.getItem("colorScheme");
  return e ? JSON.parse(e) : "dark";
}
class Xl {
  constructor() {
    oe(this, "activeInlineProfile", !1);
    oe(this, "configActive", !1);
    oe(this, "configClick", !1);
    oe(this, "inlineMenuClick", !1);
    oe(this, "menu", []);
    oe(this, "menuActive", !1);
    oe(this, "menuClick", !1);
    oe(this, "menuMode", Xf());
    oe(this, "overlayMenuActive", !1);
    oe(this, "pinActive", !1);
    oe(this, "rightMenuActive", !1);
    oe(this, "rightMenuClick", !1);
    oe(this, "search", !1);
    oe(this, "searchActive", !1);
    oe(this, "searchClick", !1);
    oe(this, "sidebarActive", !1);
    oe(this, "sidebarStatic", !1);
    oe(this, "staticMenuDesktopInactive", !1);
    oe(this, "staticMenuMobileActive", !1);
    oe(this, "topbarItemClick", !1);
    oe(this, "topbarMenuActive", !1);
    oe(this, "colorScheme", ep());
    oe(this, "componentTheme", "");
    oe(this, "theme", Zf());
    oe(this, "topbarTheme", "");
  }
  isHorizontal() {
    return this.menuMode === "horizontal";
  }
  isSlim() {
    return this.menuMode === "slim";
  }
  isOverlay() {
    return this.menuMode === "overlay";
  }
  isStatic() {
    return this.menuMode === "static";
  }
  isSidebar() {
    return this.menuMode === "sidebar";
  }
  isDesktop() {
    return window.innerWidth > 991;
  }
  isMobile() {
    return window.innerWidth <= 991;
  }
  onChangeColorScheme(t) {
    this.changeStyleSheetUrl("layout-css", "layout-" + t + ".css", 1), this.changeStyleSheetUrl("theme-css", "theme-" + t + ".css", 1), this.colorScheme = t;
  }
  onChangeMenuTheme(t) {
    const n = document.getElementById("layout-css"), a = "layout/css/" + t + "/layout-" + this.colorScheme + ".css";
    n && this.replaceLink(n, a), this.theme = t;
  }
  onChangeComponentTheme(t) {
    const n = document.getElementById("theme-css"), a = "theme/" + t + "/theme-" + this.colorScheme + ".css";
    n && this.replaceLink(n, a), this.componentTheme = t;
  }
  changeStyleSheetUrl(t, n, a) {
    const s = document.getElementById(t);
    if (s) {
      const o = s.getAttribute("href");
      if (o) {
        const i = o.split("/");
        a === 1 ? i[i.length - 1] = n : a === 2 && (i[i.length - 2] = n);
        const r = i.join("/");
        this.replaceLink(s, r);
      }
    }
  }
  replaceLink(t, n, a) {
    const s = t.getAttribute("id"), o = t.cloneNode(!0);
    o.setAttribute("href", n), o.setAttribute("id", s + "-clone");
    const i = t.parentNode;
    i && i.insertBefore(o, t.nextSibling), o.addEventListener("load", () => {
      t.remove(), s && (o.setAttribute("id", s), a && a());
    });
  }
}
const tp = {
  symbol: Symbol(),
  install(e) {
    const t = Kt(new Xl()), n = Kt({ theme: "Aura", darkTheme: !0 });
    t.menu = [], e.config.globalProperties.$guiConfig = t, e.config.globalProperties.$appState = n, e.provide(this.symbol, t);
  }
};
function Zl() {
  const e = Lt(tp.symbol);
  return e === void 0 ? new Xl() : e;
}
const Jn = _n("userSettingsStore", {
  state: () => ({
    loading: !1,
    menuMode: {},
    colorScheme: {},
    colorTheme: {},
    wizardLayouts: {},
    selectedWizardIndex: {},
    lastSelectedImplantId: void 0,
    lastSelectedAbutmentId: void 0,
    lastSelectedSleeveId: void 0,
    lastAppliedImplant: {},
    showDoctorsOnPatientList: !1,
    patientListFilter: {},
    timezone: ""
  }),
  actions: {
    prepareDefaults(e) {
      const t = localStorage.getItem("navBarPos");
      if (this.menuMode = t ? JSON.parse(t) : Ut.SIDEBAR, e) {
        const r = localStorage.getItem("wizardLayouts");
        this.wizardLayouts = r ? JSON.parse(r) : e;
      }
      const n = localStorage.getItem("selectedWizardIndex");
      this.selectedWizardIndex = n ? JSON.parse(n) : 0;
      const a = localStorage.getItem("colorScheme");
      this.colorScheme = a ? JSON.parse(a) : na.DARK;
      const s = localStorage.getItem("colorTheme");
      this.colorTheme = s ? JSON.parse(s) : wt.BLUE, this.lastSelectedImplantId = localStorage.getItem("lastSelectedImplantId") ?? "", this.lastSelectedAbutmentId = localStorage.getItem("lastSelectedAbutmentId") ?? "", this.lastSelectedSleeveId = localStorage.getItem("lastSelectedSleeveId") ?? "", localStorage.getItem("lastAppliedImplant") && (this.lastAppliedImplant = JSON.parse(localStorage.getItem("lastAppliedImplant") ?? ""));
      const i = localStorage.getItem("showDoctorsOnPatientList") ?? !1;
      this.showDoctorsOnPatientList = i ? JSON.parse(i) : !1;
    },
    prepareWeblinkDefaults() {
      this.timezone = "";
    },
    setNavbarPosition(e) {
      localStorage.setItem("navBarPos", JSON.stringify(e)), this.menuMode = e;
    },
    getNavbarPosition() {
      const e = localStorage.getItem("navBarPos");
      return e ? this.menuMode = JSON.parse(e) : this.menuMode = Ut.SIDEBAR;
    },
    getColorScheme() {
      const e = localStorage.getItem("colorScheme");
      return e ? this.colorScheme = JSON.parse(e) : this.colorScheme = na.DARK;
    },
    updateColorScheme(e) {
      this.colorScheme = e, this.colorScheme && localStorage.setItem("colorScheme", JSON.stringify(this.colorScheme));
    },
    getColorTheme() {
      const e = localStorage.getItem("colorTheme");
      return e ? this.colorTheme = JSON.parse(e) : this.colorTheme = wt.BLUE;
    },
    updateColorTheme(e) {
      this.colorTheme = e, localStorage.setItem("colorTheme", JSON.stringify(this.colorTheme) ?? "");
    },
    setWizardLayout(e, t) {
      this.wizardLayouts[e] = t, localStorage.setItem("wizardLayouts", JSON.stringify(this.wizardLayouts));
    },
    updateSelectedWizardIndex(e) {
      this.selectedWizardIndex = e, localStorage.setItem("selectedWizardIndex", JSON.stringify(this.selectedWizardIndex));
    },
    updateLastSelection(e) {
      this.updateLastSelectedImplantId(e.implantId), this.updateLastSelectedAbutmentId(e.abutmentId), this.updateLastSelectedSleeveId(e.sleeveId);
    },
    updateLastSelectedImplantId(e) {
      this.lastSelectedImplantId = e, e ? localStorage.setItem("lastSelectedImplantId", e) : localStorage.removeItem("lastSelectedImplantId");
    },
    updateLastSelectedAbutmentId(e) {
      this.lastSelectedAbutmentId = e, e ? localStorage.setItem("lastSelectedAbutmentId", e) : localStorage.removeItem("lastSelectedAbutmentId");
    },
    updateLastSelectedSleeveId(e) {
      this.lastSelectedSleeveId = e, e ? localStorage.setItem("lastSelectedSleeveId", e) : localStorage.removeItem("lastSelectedSleeveId");
    },
    getLastAppliedImplant() {
      return this.lastAppliedImplant;
    },
    updateLastAppliedImplant(e) {
      this.lastAppliedImplant = e, localStorage.setItem("lastAppliedImplant", JSON.stringify(e));
    },
    getShowDoctorsOnPatientList() {
      return this.showDoctorsOnPatientList;
    },
    updateShowDoctorsOnPatientList() {
      this.showDoctorsOnPatientList = !this.showDoctorsOnPatientList, localStorage.setItem("showDoctorsOnPatientList", JSON.stringify(this.showDoctorsOnPatientList));
    },
    getUserTimezone() {
      return this.timezone ?? "";
    },
    updateUserTimezone(e) {
      this.timezone = e;
    }
  }
}), np = {
  class: "layout-main bg-body",
  id: "div-body"
}, ap = {
  class: "layout-main-content",
  style: { padding: "0" }
}, Uk = /* @__PURE__ */ Y({
  __name: "App",
  emits: [
    "layout-mode-change",
    "menu-theme",
    "layoutModeChange",
    "sidebar-mouse-over",
    "sidebar-mouse-leave",
    "change-color-scheme",
    "change-component-theme",
    "change-menu-theme",
    "change-inlinemenu"
  ],
  setup(e, { emit: t }) {
    const n = Zl(), a = Jn(), { menuMode: s } = Ed(a);
    function o() {
      n.menuClick || ((n.isHorizontal() || n.isSlim()) && (n.menuActive = !1, qf.emit("reset-active-index")), (n.overlayMenuActive || n.staticMenuMobileActive) && (n.overlayMenuActive = !1, n.staticMenuMobileActive = !1), i(), r()), n.configActive && !n.configClick && (n.configActive = !1), n.menuClick = !1, n.configClick = !1;
    }
    function i() {
      n.overlayMenuActive = !1, n.staticMenuMobileActive = !1;
    }
    function r() {
      document.body.classList ? document.body.classList.remove("blocked-scroll") : document.body.className = document.body.className.replace(new RegExp("(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function l() {
      n.menuMode = s.value;
    }
    const c = F(() => (l(), [
      "layout-wrapper",
      {
        "layout-static": n.menuMode === "static",
        "layout-overlay": n.menuMode === "overlay",
        "layout-overlay-active": n.overlayMenuActive,
        "layout-slim": n.menuMode === "slim",
        "layout-horizontal": n.menuMode === "horizontal",
        "layout-active": n.menuActive,
        "layout-mobile-active": n.staticMenuMobileActive,
        "layout-sidebar": n.menuMode === "sidebar",
        "layout-sidebar-static": n.menuMode === "sidebar" && n.sidebarStatic,
        "layout-static-inactive": n.staticMenuDesktopInactive && n.menuMode === "static"
        // "p-ripple-disabled": app.$primevue.config.ripple === false
      }
    ]));
    return (u, p) => {
      const m = ne("router-view");
      return y(), M("div", {
        class: J(c.value),
        onClick: o,
        id: "layout-container-div"
      }, [
        b("div", np, [
          b("div", ap, [
            w(m)
          ])
        ])
      ], 2);
    };
  }
}), sp = { id: "menu-type-combo" }, op = { class: "p-field-radiobutton" }, ip = { for: "mode3" }, rp = { class: "p-field-radiobutton" }, lp = { for: "mode4" }, cp = { class: "p-field-radiobutton" }, up = { for: "mode5" }, dp = { class: "p-field-radiobutton" }, fp = { for: "theme1" }, pp = { class: "p-field-radiobutton" }, mp = { for: "theme2" }, Ap = { class: "layout-themes" }, gp = ["title", "onClick"], Yk = /* @__PURE__ */ Y({
  __name: "AppConfig",
  props: {
    configActive: { type: Boolean },
    configClick: { type: Boolean },
    colorScheme: {},
    theme: {},
    componentTheme: {},
    menuMode: {}
  },
  emits: ["config-button-click", "config-click", "hange-color-scheme", "change-menu-theme", "change-component-theme", "change-menu-mode", "close-menu-config"],
  setup(e, { emit: t }) {
    const n = e, a = L(n.menuMode), s = L(n.colorScheme), o = F(() => n.configActive), i = t, r = L([
      {
        name: "blue",
        color: "#0F8BFD",
        hover: "#0E81E6",
        lighten: "#55a8ff",
        scaleLightness60: "#94cfff",
        scaleLightnessMinus60: "#004cae",
        scaleLightnessMinus20: "#0c5fb9",
        darken: "#075b99",
        scaleAlpha24: "#0f8bfd3d"
      },
      {
        name: "green",
        color: "#0BD18A",
        hover: "#0A9B79",
        lighten: "#49e1a9",
        scaleLightness60: "#8af7cf",
        scaleLightnessMinus60: "#004a34",
        scaleLightnessMinus20: "#0a7c5d",
        darken: "#068059",
        scaleAlpha24: "#0bd18a3d"
      },
      {
        name: "magenta",
        color: "#EC4DBC",
        hover: "#D142A7",
        lighten: "#f07ed3",
        scaleLightness60: "#ffa3eb",
        scaleLightnessMinus60: "#7a116e",
        scaleLightnessMinus20: "#ac4586",
        darken: "#b72e9f",
        scaleAlpha24: "#ec4dbc3d"
      },
      {
        name: "orange",
        color: "#FD9214",
        hover: "#E28212",
        lighten: "#ffb343",
        scaleLightness60: "#ffd39c",
        scaleLightnessMinus60: "#7f5701",
        scaleLightnessMinus20: "#b57f03",
        darken: "#a76d0f",
        scaleAlpha24: "#fd92143d"
      },
      {
        name: "purple",
        color: "#873EFE",
        hover: "#7735E5",
        lighten: "#a268fe",
        scaleLightness60: "#d4a3ff",
        scaleLightnessMinus60: "#3503ba",
        scaleLightnessMinus20: "#4f26d1",
        darken: "#6d38e7",
        scaleAlpha24: "#873efe3d"
      },
      {
        name: "red",
        color: "#FC6161",
        hover: "#E25555",
        lighten: "#fd8c8c",
        scaleLightness60: "#ffb3b3",
        scaleLightnessMinus60: "#7f0707",
        scaleLightnessMinus20: "#b51d1d",
        darken: "#a31717",
        scaleAlpha24: "#fc61613d"
      },
      {
        name: "teal",
        color: "#00D0DE",
        hover: "#00B9C1",
        lighten: "#4fe7ee",
        scaleLightness60: "#8fffff",
        scaleLightnessMinus60: "#005d66",
        scaleLightnessMinus20: "#00899b",
        darken: "#0096a5",
        scaleAlpha24: "#00d0de3d"
      },
      {
        name: "yellow",
        color: "#EEE500",
        hover: "#D4CC00",
        lighten: "#fff34c",
        scaleLightness60: "#fffb9c",
        scaleLightnessMinus60: "#7f7a00",
        scaleLightnessMinus20: "#b5ad00",
        darken: "#ad9c00",
        scaleAlpha24: "#eee5003d"
      }
    ]), l = Jn(), c = () => {
      i("close-menu-config");
    }, u = (h) => {
      i("change-component-theme", h);
    }, p = (h) => {
      var _, O;
      const d = document.documentElement;
      d.style.setProperty("--webcad-primary-color", h);
      const f = r.value.find((S) => S.color === h);
      f && (d.style.setProperty("--webcad-primary-color-hover", f.hover), d.style.setProperty("--webcad-primary-color-lighten", f.lighten), d.style.setProperty("--webcad-primary-color-light", f.scaleLightness60), d.style.setProperty("--webcad-primary-color-dark", f.scaleLightnessMinus60), d.style.setProperty("--webcad-primary-color-darker", f.scaleLightnessMinus20), d.style.setProperty("--webcad-primary-color-darken", f.darken), d.style.setProperty("--webcad-primary-color-scale-alpha", f.scaleAlpha24));
      const g = Jn();
      g.updateColorTheme((_ = r.value.find((S) => S.color.toString() === h.toString())) == null ? void 0 : _.name), u(((O = r.value.find((S) => S.color === h)) == null ? void 0 : O.name) ?? "blue");
      let B = g.colorScheme === "dark" ? "invert(100%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(107%) contrast(101%)" : "invert(0%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(100%) contrast(101%)", E = g.colorScheme === "dark" ? "#FFFFFF" : "#000000";
      d.style.removeProperty("--webcad-top-navbar-icon-color"), d.style.setProperty("--webcad-top-navbar-icon-color", B), A(), d.style.removeProperty("--top-navbar-text-color"), d.style.setProperty("--top-navbar-text-color", E);
    }, m = (h) => {
      const d = document.documentElement, f = h === "dark";
      Jn().updateColorScheme(h), d.style.setProperty("--webcad-primary-text-color", f ? "#FFFFFF" : "#000000"), d.style.setProperty("--webcad-primary-text-color-inverse", f ? "#000000" : "#FFFFFF"), d.style.setProperty("--webcad-text-color", f ? "#FFFFFF" : "#343434"), d.style.setProperty("--webcad-body-bg", f ? "#28292C" : "#EEEEEE"), d.style.setProperty("--webcad-main-bg", f ? "#28292C" : "#FFFFFF"), d.style.setProperty("--webcad-patient-list-bg", "#FFFFFF"), d.style.setProperty("--webcad-card-wizard-bg", f ? "#333437" : "#EEEEEE"), d.style.setProperty("--webcad-bg-not-selected", "#707070"), d.style.setProperty("--webcad-main-card-color", f ? "#32343A" : "#E2E2E2"), d.style.setProperty("--webcad-bg-input-text", "#FFFFFF"), d.style.setProperty("--webcad-bg-patient-item", f ? "#3C3E46" : "#EEEEEE"), d.style.setProperty("--webcad-bg-patient-item-image-card", "#1B1C1E"), d.style.setProperty("--webcad-bg-main-menu-btn", "#EEEEEE"), d.style.setProperty("--webcad-bg-main-menu-item", f ? "#3C3E46" : "#E2E2E2"), d.style.setProperty("--webcad-tab-menu-color", "#868C9B"), d.style.setProperty("--webcad-btn-selected-item-main-tab", "#EEEEEE"), d.style.setProperty("--webcad-top-navbar-bg", f ? "#28292C" : "#E2E2E2"), d.style.setProperty("--webcad-sidebar-wiz-bg", f ? "#28292C" : "#E2E2E2"), d.style.setProperty("--webcad-sidebar-wiz-item-bg", f ? "#32343A" : "#EEEEEE"), d.style.setProperty("--webcad-footer-text-color", "#808080"), d.style.setProperty("--webcad-card-menu-item-bg", f ? "#32343A" : "#EEEEEE"), d.style.setProperty("--webcad-wiz-bg", "#3D3D3D"), d.style.setProperty("--webcad-object-list-bg", f ? "#707070" : "#FFFFFF"), d.style.setProperty("--webcad-object-list-text-color", f ? "#B7B7B7" : "#000000"), d.style.setProperty("--footer-text-color", "#808080"), d.style.setProperty(
        "--webcad-primary-icon-color",
        f ? "invert(0%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)" : "invert(100%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)"
      ), d.style.setProperty(
        "--webcad-primary-icon-color-inverse",
        f ? "invert(100%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)" : "invert(0%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)"
      ), d.style.setProperty("--webcad-paginator-color", f ? "#FFFFFF" : "#3C3E46"), d.style.setProperty("--webcad-input-placeholder-color", f ? "#868C9B" : "#8A8EA6"), d.style.setProperty("--webcad-tab-border-color", f ? "#808080" : "#FFFFFF"), d.style.setProperty("--webcad-input-background", f ? "#3C3E46" : "#EEEEEE"), d.style.setProperty("--webcad-progress-bar-background", f ? "#32343A" : "#D6D7DB"), d.style.setProperty("--webcad-modal-background", f ? "#3E3E3E" : "#E2E2E2"), d.style.setProperty("--webcad-modal-text-color", f ? "#FFFFFF" : "#000000"), d.style.setProperty("--webcad-dropdown-bg-color", f ? "#535763 " : "#C6C6C6"), d.style.setProperty("--webcad-dropdown-hover-bg-color", f ? "rgba(255, 255, 255, 0.05)" : "rgba(68, 72, 109, 0.07)"), d.style.setProperty("--webcad-switch-bg-color", f ? "gba(255, 255, 255, 0.05)" : "rgba(68, 72, 109, 0.07)"), d.style.setProperty("--webcad-switch-before-bg-color", f ? "#C8CCD8" : "#676B89"), d.style.setProperty("--webcad-accorion-header-bg", f ? "rgba(255, 255, 255, 0.15)" : "rgba(68, 72, 109, 0.12)"), d.style.setProperty("--webcad-accorion-header-border-color", f ? "rgba(255, 255, 255, 0.05)" : "rgba(68, 72, 109, 0.17)"), d.style.setProperty("--webcad-accorion-header-color", f ? "#FFFFFF" : "#44486D"), d.style.setProperty("--webcad-accorion-header-color-hover", f ? "#b9b8b8" : "#92939d"), d.style.setProperty("--webcad-overlay-bg-color", f ? "#535763" : "#ECECF9"), d.style.setProperty("--webcad-input-card-background", f ? "#464646" : "#C6C6C6"), d.style.setProperty("--webcad-toast-bg", f ? "#0A061A" : "#F8FCFC"), d.style.setProperty("--webcad-progress-next-step", f ? "#505259" : "#FDFDFF"), d.style.setProperty("--webcad-dropdown-text-color", f ? "#FFFFFF" : "#000000");
      let B = f ? "invert(100%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(107%) contrast(101%)" : "invert(0%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(100%) contrast(101%)", E = f ? "#FFFFFF" : "#000000";
      d.style.removeProperty("--webcad-top-navbar-icon-color"), d.style.setProperty("--webcad-top-navbar-icon-color", B), d.style.removeProperty("--top-navbar-text-color"), d.style.setProperty("--top-navbar-text-color", E);
    }, v = (h) => {
      Jn().setNavbarPosition(h), i("change-menu-mode", h);
    };
    function A() {
      const h = document.documentElement;
      let d = "";
      switch (l.getColorTheme()) {
        case wt.BLUE:
          d = "invert(41%) sepia(100%) saturate(432%) hue-rotate(166deg) brightness(95%) contrast(91%)";
          break;
        case wt.GREEN:
          d = "invert(60%) sepia(27%) saturate(3523%) hue-rotate(115deg) brightness(101%) contrast(91%)";
          break;
        case wt.MAGENTA:
          d = "invert(46%) sepia(47%) saturate(3111%) hue-rotate(291deg) brightness(96%) contrast(91%)";
          break;
        case wt.ORANGE:
          d = "invert(64%) sepia(98%) saturate(2224%) hue-rotate(350deg) brightness(101%) contrast(98%)";
          break;
        case wt.PURPLE:
          d = "invert(35%) sepia(64%) saturate(6258%) hue-rotate(252deg) brightness(99%) contrast(102%)";
          break;
        case wt.RED:
          d = "invert(47%) sepia(63%) saturate(804%) hue-rotate(316deg) brightness(106%) contrast(101%)";
          break;
        case wt.TEAL:
          d = "invert(59%) sepia(23%) saturate(1740%) hue-rotate(136deg) brightness(101%) contrast(105%)";
          break;
        case wt.YELLOW:
          d = "invert(82%) sepia(43%) saturate(3357%) hue-rotate(12deg) brightness(104%) contrast(119%)";
          break;
      }
      h.style.setProperty("--webcad-horizontal-icon-color", d, "important");
    }
    return Ne(() => {
      var h;
      p(((h = r.value.find((d) => d.name === l.getColorTheme())) == null ? void 0 : h.color) ?? "blue"), m(l.getColorScheme());
    }), (h, d) => {
      const f = ne("RadioButton");
      return y(), M("div", {
        id: "layout-config",
        onmouseleave: c
      }, [
        b("div", {
          class: J([{ "layout-config-active": o.value }, "layout-config"])
        }, [
          b("span", sp, [
            b("h5", null, R(h.$t("medic-web-framework.menuType")), 1),
            b("div", op, [
              w(f, {
                id: "mode3",
                modelValue: a.value,
                "onUpdate:modelValue": d[0] || (d[0] = (g) => a.value = g),
                name: "menuMode",
                value: "slim",
                onChange: d[1] || (d[1] = (g) => v(k(Ut).SLIM))
              }, null, 8, ["modelValue"]),
              b("label", ip, R(h.$t("medic-web-framework.slim")), 1)
            ]),
            b("div", rp, [
              w(f, {
                id: "mode4",
                modelValue: a.value,
                "onUpdate:modelValue": d[2] || (d[2] = (g) => a.value = g),
                name: "menuMode",
                value: "horizontal",
                onChange: d[3] || (d[3] = (g) => v(k(Ut).HORIZONTAL))
              }, null, 8, ["modelValue"]),
              b("label", lp, R(h.$t("shared.horizontal")), 1)
            ]),
            b("div", cp, [
              w(f, {
                id: "mode5",
                modelValue: a.value,
                "onUpdate:modelValue": d[4] || (d[4] = (g) => a.value = g),
                name: "menuMode",
                value: "sidebar",
                onChange: d[5] || (d[5] = (g) => v(k(Ut).SIDEBAR))
              }, null, 8, ["modelValue"]),
              b("label", up, R(h.$t("medic-web-framework.sidebar")), 1)
            ]),
            d[10] || (d[10] = b("hr", null, null, -1))
          ]),
          b("h5", null, R(h.$t("medic-web-framework.colorScheme")), 1),
          b("div", dp, [
            w(f, {
              id: "theme1",
              modelValue: s.value,
              "onUpdate:modelValue": d[6] || (d[6] = (g) => s.value = g),
              name: "colorScheme",
              value: "light",
              onChange: d[7] || (d[7] = (g) => m("light"))
            }, null, 8, ["modelValue"]),
            b("label", fp, R(h.$t("medic-web-framework.light")), 1)
          ]),
          b("div", pp, [
            w(f, {
              id: "theme2",
              modelValue: s.value,
              "onUpdate:modelValue": d[8] || (d[8] = (g) => s.value = g),
              name: "colorScheme",
              value: "dark",
              onChange: d[9] || (d[9] = (g) => m("dark"))
            }, null, 8, ["modelValue"]),
            b("label", mp, R(h.$t("medic-web-framework.dark")), 1)
          ]),
          d[11] || (d[11] = b("hr", null, null, -1)),
          b("h5", null, R(h.$t("medic-web-framework.layouts")), 1),
          b("div", Ap, [
            (y(!0), M(fe, null, He(r.value, (g) => (y(), M("div", {
              key: g.name
            }, [
              b("a", {
                style: Se([{ "background-color": g.color }, { cursor: "pointer" }]),
                title: g.name,
                onClick: (B) => p(g.color)
              }, null, 12, gp)
            ]))), 128))
          ])
        ], 2)
      ]);
    };
  }
}), le = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, s] of t)
    n[a] = s;
  return n;
}, hp = {}, vp = { class: "flex" };
function bp(e, t) {
  return y(), M("div", vp, [
    q(e.$slots, "default")
  ]);
}
const te = /* @__PURE__ */ le(hp, [["render", bp]]);
function xp() {
  return {
    root: {
      background: "transparent",
      checkedBackground: "var(--p-primary-color)",
      checkedHoverBackground: "var(--p-primary-hover-color)",
      width: "28px",
      height: "15px",
      border: {
        width: "2px !important",
        color: "var(--p-text-color) !important"
      }
    },
    handle: {
      size: "0.6rem",
      background: "var(--p-text-color) !important",
      checkedHoverBackground: "var(--p-form-field-hover-border-color)"
    }
  };
}
const ls = /* @__PURE__ */ Y({
  __name: "MFSwitch",
  props: {
    state: { type: Boolean, required: !0 },
    stateModifiers: {},
    disabled: { type: Boolean },
    disabledModifiers: {}
  },
  emits: /* @__PURE__ */ pt(["change"], ["update:state", "update:disabled"]),
  setup(e, { emit: t }) {
    const n = ye(e, "state"), a = ye(e, "disabled"), s = t, o = L(xp());
    return (i, r) => (y(), G(te, {
      class: "flex-row",
      style: { "align-items": "center" }
    }, {
      default: T(() => [
        q(i.$slots, "falseLabel"),
        w(k(Bd), {
          modelValue: n.value,
          "onUpdate:modelValue": r[0] || (r[0] = (l) => n.value = l),
          dt: o.value,
          onChange: r[1] || (r[1] = (l) => s("change", n.value)),
          disabled: a.value
        }, null, 8, ["modelValue", "dt", "disabled"]),
        q(i.$slots, "trueLabel")
      ]),
      _: 3
    }));
  }
}), yp = ["src"], Ep = /* @__PURE__ */ Y({
  __name: "MButton",
  props: {
    class: {},
    icon: {},
    label: {},
    modelValue: {}
  },
  setup(e) {
    const t = e, n = F(() => !t.modelValue || !t.modelValue.pressable ? !1 : a.value), a = L();
    t.modelValue && Ae(t.modelValue, () => {
      a.value = t.modelValue ? t.modelValue.pressed : !1;
    });
    const s = () => {
      var r;
      t.modelValue && (r = t.modelValue) != null && r.pressable && (a.value = !a.value);
    }, o = F(() => {
      var l;
      let r = t.class ? `${t.class} flex items-center justify-center` : "flex items-center justify-center";
      return n.value && (r += (l = t.modelValue) != null && l.toggleable ? " btn-pressed-toggle" : " btn-pressed"), r;
    }), i = F(() => t.modelValue ? t.modelValue.disabled : !1);
    return (r, l) => {
      const c = ne("Button");
      return y(), G(c, {
        class: J([o.value, i.value ? "p-disabled" : ""]),
        disabled: i.value,
        type: "button",
        onClick: s
      }, {
        default: T(() => [
          t.icon ? (y(), M("img", {
            key: 0,
            src: t.icon,
            alt: "logo",
            class: "ml-1",
            style: { width: "1.5rem" },
            draggable: "false"
          }, null, 8, yp)) : W("", !0),
          b("span", {
            class: J([t.icon ? "ml-1" : ""])
          }, R(t.label), 3)
        ]),
        _: 1
      }, 8, ["class", "disabled"]);
    };
  }
}), Cp = "85cc4579-fe41-48be-abaf-fdec1d587ec8";
async function Gk(e) {
  const t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t);
  return Array.from(new Uint8Array(n)).map((o) => o.toString(16).padStart(2, "0")).join("");
}
async function jk(e) {
  const t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-1", t);
  return Array.from(new Uint8Array(n)).map((o) => o.toString(16).padStart(2, "0")).join("");
}
function Hk(e) {
  return Id(e, Cp);
}
const Vk = (e) => /Chrome|Chromium/.test(e) && !/Edg|OPR|Opera|Brave|SamsungBrowser/.test(e), Kk = () => {
  var r;
  if (typeof navigator > "u")
    return !1;
  const e = navigator.userAgent || "", t = navigator.platform || "", n = navigator.maxTouchPoints || 0, a = (((r = navigator.userAgentData) == null ? void 0 : r.platform) ?? "").toLowerCase(), s = /iPad|iPhone|iPod/.test(e), o = t === "MacIntel" && n > 1, i = a.includes("ios") || a.includes("ipados");
  return s || o || i;
}, Wk = (e) => Array.isArray(e) ? e.some((t) => t === "1" || t === "true") : e === "1" || e === "true";
class zk extends Map {
  constructor(n) {
    super();
    oe(this, "constructFunc");
    this.constructFunc = n;
  }
  get(n) {
    super.has(n) || super.set(n, this.constructFunc());
    const a = super.get(n);
    if (a === void 0)
      throw new Error(`Key "${n}" not found`);
    return a;
  }
  merge(n, a) {
    this.set(n, {
      ...this.get(n),
      ...a
    });
  }
}
function $k(e, t) {
  const n = document.createElement("a");
  n.href = window.URL.createObjectURL(new Blob([e], { type: "application/zip" })), n.download = t, n.click();
}
const Bp = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function Ip(e) {
  const t = Bp;
  console.log("metaEnv:", t);
  const a = (t == null ? void 0 : t.MODE) === "development", s = !0, o = a;
  console.log("Is development mode:", a, "debugEnabled:", o);
  const i = typeof console < "u", r = e.trim() ? `[${e}]` : "", l = (c, u) => (...p) => {
    if (!(!u || !i)) {
      if (r) {
        console[c](r, ...p);
        return;
      }
      console[c](...p);
    }
  };
  return {
    debug: l("debug", o),
    log: l("log", s),
    info: l("info", s),
    warn: l("warn", s),
    error: l("error", s)
  };
}
const Jk = Ip("WebCAD-JS");
function qk(e, t, n) {
  const a = Mh(e.name);
  return {
    model: "RealGUIDE",
    version: "RealGUIDE WEB",
    license: e.name,
    softwareVersion: "6.0.0",
    udi: t ? `(01)08050038833196(8012)600(21)${t}(250)${a}` : `(01)08050038833196(8012)600(21)00001(250)${a}`,
    build: n || "20241017",
    computerId: "003134619",
    certificateNumber: "003/MDR",
    _510kNumber: "K173041",
    ownerNumber: "10059505",
    company: {
      name: "3DIEMME Srl",
      address: "Via Risorgimento 9 - 22063 Cantù (CO) - ITALY",
      website: "www.3diemme.it",
      email: "support@3diemme.it",
      telephone: "+39 0317073353"
    },
    headquarter: {
      name: "ZimVie Switzerland GmbH",
      address: "Grüzefeldstrasse 41",
      city: "8404 WinterHur",
      country: "Switzerland"
    }
  };
}
var de = /* @__PURE__ */ ((e) => (e.TOP_NAVBAR_ICON = "svg-icon", e.TOP_NAVBAR_MOBILE_ICON = "svg-icon-mobile", e.BUTTON_ICON = "", e.OBJECT_LIST_ICON = "svg-icon-grey-light", e.BUTTON_ICON_NO_LABEL = "no-label", e.TOP_NAVBAR_ICON_LABEL = "topnavbariconlabelclass", e))(de || {}), hn = /* @__PURE__ */ ((e) => (e.TOP = "flex-col-reverse", e.BOTTOM = "flex-col", e.RIGHT = "flex-row", e.LEFT = "flex-row-reverse", e))(hn || {});
function Xk() {
  return {
    clicked: !1,
    disabled: !1,
    checkable: !1,
    checked: !1,
    pressable: !1,
    pressed: !1,
    toggleable: !1,
    icon: "",
    iconPos: "flex-row-reverse"
    /* LEFT */
  };
}
const Zk = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  IN: "in",
  LESS_THAN: "lessThan",
  LESS_THAN_OR_EQUAL_TO: "lessThanOrEqualTo",
  GREATER_THAN: "greaterThan",
  GREATER_THAN_OR_EQUAL_TO: "greaterThanOrEqualTo",
  BETWEEN: "between",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
};
var wp = /* @__PURE__ */ ((e) => (e[e.MESSAGE = 0] = "MESSAGE", e[e.NOTIFICATION = 1] = "NOTIFICATION", e[e.MEDIA_MESSAGE = 2] = "MEDIA_MESSAGE", e[e.SHIPPING_DATE_CHANGE = 3] = "SHIPPING_DATE_CHANGE", e))(wp || {}), ja = /* @__PURE__ */ ((e) => (e.ADMIN = "ADMIN", e.OPERATOR = "OPERATOR", e.READONLY_OPERATOR = "READONLY_OPERATOR", e.USER = "USER", e))(ja || {}), Ha = /* @__PURE__ */ ((e) => (e.EDIT_WORKFLOWS = "EDIT_WORKFLOWS", e.EDIT_MATERIAL_LIB = "EDIT_MATERIAL_LIB", e.EDIT_USERS = "EDIT_USERS", e))(Ha || {});
function e_() {
  return {
    role: "USER",
    workflowPermissions: Object.keys(Ha),
    isReadOnly: !1
  };
}
var kp = /* @__PURE__ */ ((e) => (e.STATUS_CHANGE = "STATUS_CHANGE", e))(kp || {});
function _p() {
  return {
    value: 0,
    minValue: 0,
    maxValue: 10,
    step: 0.1,
    hideValueInput: !1
  };
}
function t_() {
  return {
    rangeValue: [0, 1],
    minValue: 0,
    maxValue: 10,
    step: 0.1,
    hideValueInput: !1
  };
}
function n_() {
  return {
    clicked: !1,
    state: !1,
    disabled: !1
  };
}
function a_() {
  return {
    id: 0,
    name: "test 1",
    materialType: "Titanium (Ti)",
    gap: {
      cementAreaOffsetRange: [0, 0.1],
      cementAreaOffsetMinMax: [0, 0.1],
      cementAreaOffsetStep: 5e-3,
      cementAreaOffsetDefault: 0.03,
      sealingAreaOffsetRange: [0, 0.1],
      sealingAreaOffsetMinMax: [0, 0.1],
      sealingAreaOffsetStep: 5e-3,
      sealingAreaOffsetDefault: 0
    },
    border: {
      horizontalRange: [0.01, 0.5],
      horizontalMinMax: [0.01, 0.5],
      horizontalRangeStep: 0.01,
      angleRange: [0, 90],
      angleMinMax: [0, 90],
      angleRangeStep: 1,
      angledRange: [0.01, 2],
      angledMinMax: [0.01, 2],
      angledRangeStep: 0.01,
      verticalRange: [0, 2],
      verticalMinMax: [0, 2],
      verticalRangeStep: 0.01,
      angleDefault: 0,
      angledDefault: 0,
      horizontalDefault: 0,
      verticalDefault: 0
    },
    minimalThickness: {
      minimalThicknessRange: [0.01, 1.5],
      minimalThicknessMinMax: [0.01, 1.5],
      minimalThicknessStep: 0.05
    },
    reconstructionDesigns: []
  };
}
function s_(e) {
  return {
    name: e,
    gap: {
      cementAreaOffsetRange: [0, 0.1],
      cementAreaOffsetMinMax: [0, 0.1],
      cementAreaOffsetStep: 5e-3,
      cementAreaOffsetDefault: 0.03,
      sealingAreaOffsetRange: [0, 0.1],
      sealingAreaOffsetMinMax: [0, 0.1],
      sealingAreaOffsetStep: 5e-3,
      sealingAreaOffsetDefault: 0
    },
    border: {
      horizontalRange: [0.01, 0.5],
      horizontalMinMax: [0.01, 0.5],
      horizontalRangeStep: 0.01,
      angleRange: [0, 90],
      angleMinMax: [0, 90],
      angleRangeStep: 1,
      angledRange: [0.01, 2],
      angledMinMax: [0.01, 2],
      angledRangeStep: 0.01,
      verticalRange: [0, 2],
      verticalMinMax: [0, 2],
      verticalRangeStep: 0.01,
      angleDefault: 0,
      angledDefault: 0,
      horizontalDefault: 0,
      verticalDefault: 0
    },
    minimalThickness: {
      minimalThicknessRange: [0.01, 1.5],
      minimalThicknessMinMax: [0.01, 1.5],
      minimalThicknessStep: 0.05
    },
    reconstructionDesigns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  };
}
function o_(e, t) {
  return {
    name: t,
    gap: {
      cementAreaOffsetRange: e.gap.cementAreaOffsetRange,
      cementAreaOffsetMinMax: e.gap.cementAreaOffsetMinMax,
      cementAreaOffsetStep: e.gap.cementAreaOffsetStep,
      cementAreaOffsetDefault: e.gap.cementAreaOffsetDefault,
      sealingAreaOffsetRange: e.gap.sealingAreaOffsetRange,
      sealingAreaOffsetMinMax: e.gap.sealingAreaOffsetMinMax,
      sealingAreaOffsetStep: e.gap.sealingAreaOffsetStep,
      sealingAreaOffsetDefault: e.gap.sealingAreaOffsetDefault
    },
    border: {
      horizontalRange: e.border.horizontalRange,
      horizontalMinMax: e.border.horizontalMinMax,
      horizontalRangeStep: e.border.horizontalRangeStep,
      angleRange: e.border.angleRange,
      angleMinMax: e.border.angleMinMax,
      angleRangeStep: e.border.angleRangeStep,
      angledRange: e.border.angledRange,
      angledMinMax: e.border.angledMinMax,
      angledRangeStep: e.border.angledRangeStep,
      verticalRange: e.border.verticalRange,
      verticalMinMax: e.border.verticalMinMax,
      verticalRangeStep: e.border.verticalRangeStep,
      angleDefault: e.border.angleDefault,
      angledDefault: e.border.angledDefault,
      horizontalDefault: e.border.horizontalDefault,
      verticalDefault: e.border.verticalDefault
    },
    minimalThickness: {
      minimalThicknessRange: e.minimalThickness.minimalThicknessRange,
      minimalThicknessMinMax: e.minimalThickness.minimalThicknessMinMax,
      minimalThicknessStep: e.minimalThickness.minimalThicknessStep,
      minimalThicknessDefault: e.minimalThickness.minimalThicknessDefault
    },
    reconstructionDesigns: e.reconstructionDesigns
  };
}
function i_() {
  return {
    name: "",
    username: "",
    id: 0
  };
}
const ec = [".zip", ".stl", ".pdf", ".docx", ".xlsx", ".png", ".jpg", ".txt", ".pts", ".xml", ".constructioninfo"];
function r_(e, t, n) {
  return e.id ? {
    id: e.id,
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: e.sortOrder,
    visibleToUser: e.visibleToUser,
    sku: e.sku,
    defaultOperatorId: e.defaultOperatorId,
    defaultStatusId: e.defaultStatusId,
    workflowId: t,
    jsonData: ""
  } : {
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: n + 1,
    visibleToUser: e.visibleToUser,
    sku: e.sku,
    defaultOperatorId: e.defaultOperatorId,
    defaultStatusId: e.defaultStatusId,
    workflowId: t,
    jsonData: ""
  };
}
function l_() {
  return {};
}
function c_(e) {
  return {
    id: 0,
    name: "",
    description: "",
    activated: !0,
    oneOperator: !1,
    prodCenterId: e,
    supportedTypes: [],
    machine: "",
    sortOrder: 0,
    steps: [],
    statusIds: [],
    minProcessingDays: 0,
    multiMachine: !1
  };
}
function u_(e, t) {
  return {
    //id: id ? id : 1,
    name: "",
    displayString: "",
    enabled: !0,
    sortOrder: e || 0,
    visibleToUser: !0,
    sku: "",
    defaultOperatorId: void 0,
    defaultStatusId: void 0,
    //workflowId: 0,
    jsonData: ""
  };
}
function d_() {
  return {
    id: 0,
    sortOrder: 0,
    name: "",
    description: "",
    dataType: [],
    activated: !1,
    oneOperator: !1,
    machine: "",
    steps: [],
    statuses: [],
    types: [],
    minProcessingDays: 0,
    multiMachine: !1
  };
}
function f_(e, t) {
  return {
    //id: id ? id : 1,
    name: "",
    displayString: "",
    enabled: !0,
    sortOrder: e || 0,
    jsonData: "",
    allowUserEdit: !1,
    awaitUserConfirmation: !1,
    moveToNext: !1,
    incoming: !1,
    statusClass: ""
    //workflowId: 0
  };
}
function p_(e, t, n) {
  return e.id ? {
    id: e.id,
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: e.sortOrder,
    allowUserEdit: e.allowUserEdit,
    moveToNext: e.moveToNext,
    incoming: e.incoming,
    workflowId: t,
    jsonData: ""
  } : {
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: n + 1,
    allowUserEdit: e.allowUserEdit,
    moveToNext: e.moveToNext,
    incoming: e.incoming,
    workflowId: t
  };
}
function li(e) {
  const t = Lt(e);
  if (!t) throw new Error("Module is null!");
  return t;
}
class Sp {
  constructor(t) {
    this.assetPath = t, console.log("AssetPlugin", t);
  }
  getAssetUrl(t) {
    return this.assetPath === "" || this.assetPath === "/" ? t : (this.assetPath + t).replaceAll("//", "/");
  }
}
const tc = {
  symbol: Symbol(),
  plugin: null,
  install(e, t) {
    this.plugin = new Sp(t.assetPath), e.config.globalProperties.$asset = this.plugin, e.provide(this.symbol, this.plugin);
  }
};
function Sn() {
  return li(tc.symbol);
}
const Tp = { layout: "dark", palette: { 0: "#ffffff", 50: "#f4f4f4", 100: "#e8e9e9", 200: "#d2d2d4", 300: "#bbbcbe", 400: "#a5a5a9", 500: "#8e8f93", 600: "#77787d", 700: "#616268", 800: "#4a4b52", 900: "#34343d", 950: "#1d1e27" }, color: { name: "blue", palette: { 50: "#eff6ff", 100: "#dbeafe", 200: "#bfdbfe", 300: "#93c5fd", 400: "#4B7AE7", 500: "#3b82f6", 600: "#2563eb", 700: "#1d4ed8", 800: "#1e40af", 900: "#1e3a8a", 950: "#172554" } } }, hs = {
  theme: Tp
}, to = {
  "application/andrew-inset": { source: "iana", extensions: ["ez"] },
  "application/appinstaller": { compressible: !1, extensions: ["appinstaller"] },
  "application/applixware": { source: "apache", extensions: ["aw"] },
  "application/appx": { compressible: !1, extensions: ["appx"] },
  "application/appxbundle": { compressible: !1, extensions: ["appxbundle"] },
  "application/atom+xml": { source: "iana", compressible: !0, extensions: ["atom"] },
  "application/atomcat+xml": { source: "iana", compressible: !0, extensions: ["atomcat"] },
  "application/atomdeleted+xml": { source: "iana", compressible: !0, extensions: ["atomdeleted"] },
  "application/atomsvc+xml": { source: "iana", compressible: !0, extensions: ["atomsvc"] },
  "application/atsc-dwd+xml": { source: "iana", compressible: !0, extensions: ["dwd"] },
  "application/atsc-held+xml": { source: "iana", compressible: !0, extensions: ["held"] },
  "application/atsc-rsat+xml": { source: "iana", compressible: !0, extensions: ["rsat"] },
  "application/automationml-aml+xml": { source: "iana", compressible: !0, extensions: ["aml"] },
  "application/automationml-amlx+zip": { source: "iana", compressible: !1, extensions: ["amlx"] },
  "application/bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/calendar+xml": { source: "iana", compressible: !0, extensions: ["xcs"] },
  "application/ccxml+xml": { source: "iana", compressible: !0, extensions: ["ccxml"] },
  "application/cdfx+xml": { source: "iana", compressible: !0, extensions: ["cdfx"] },
  "application/cdmi-capability": { source: "iana", extensions: ["cdmia"] },
  "application/cdmi-container": { source: "iana", extensions: ["cdmic"] },
  "application/cdmi-domain": { source: "iana", extensions: ["cdmid"] },
  "application/cdmi-object": { source: "iana", extensions: ["cdmio"] },
  "application/cdmi-queue": { source: "iana", extensions: ["cdmiq"] },
  "application/cpl+xml": { source: "iana", compressible: !0, extensions: ["cpl"] },
  "application/cu-seeme": { source: "apache", extensions: ["cu"] },
  "application/cwl": { source: "iana", extensions: ["cwl"] },
  "application/dash+xml": { source: "iana", compressible: !0, extensions: ["mpd"] },
  "application/dash-patch+xml": { source: "iana", compressible: !0, extensions: ["mpp"] },
  "application/davmount+xml": { source: "iana", compressible: !0, extensions: ["davmount"] },
  "application/dicom": { source: "iana", extensions: ["dcm"] },
  "application/docbook+xml": { source: "apache", compressible: !0, extensions: ["dbk"] },
  "application/dssc+der": { source: "iana", extensions: ["dssc"] },
  "application/dssc+xml": { source: "iana", compressible: !0, extensions: ["xdssc"] },
  "application/ecmascript": { source: "apache", compressible: !0, extensions: ["ecma"] },
  "application/emma+xml": { source: "iana", compressible: !0, extensions: ["emma"] },
  "application/emotionml+xml": { source: "iana", compressible: !0, extensions: ["emotionml"] },
  "application/epub+zip": { source: "iana", compressible: !1, extensions: ["epub"] },
  "application/exi": { source: "iana", extensions: ["exi"] },
  "application/express": { source: "iana", extensions: ["exp"] },
  "application/fdf": { source: "iana", extensions: ["fdf"] },
  "application/fdt+xml": { source: "iana", compressible: !0, extensions: ["fdt"] },
  "application/font-tdpfr": { source: "iana", extensions: ["pfr"] },
  "application/geo+json": { source: "iana", compressible: !0, extensions: ["geojson"] },
  "application/gml+xml": { source: "iana", compressible: !0, extensions: ["gml"] },
  "application/gpx+xml": { source: "apache", compressible: !0, extensions: ["gpx"] },
  "application/gxf": { source: "apache", extensions: ["gxf"] },
  "application/gzip": { source: "iana", compressible: !1, extensions: ["gz"] },
  "application/hjson": { extensions: ["hjson"] },
  "application/hyperstudio": { source: "iana", extensions: ["stk"] },
  "application/inkml+xml": { source: "iana", compressible: !0, extensions: ["ink", "inkml"] },
  "application/ipfix": { source: "iana", extensions: ["ipfix"] },
  "application/its+xml": { source: "iana", compressible: !0, extensions: ["its"] },
  "application/java-archive": { source: "iana", compressible: !1, extensions: ["jar", "war", "ear"] },
  "application/java-serialized-object": { source: "apache", compressible: !1, extensions: ["ser"] },
  "application/java-vm": { source: "apache", compressible: !1, extensions: ["class"] },
  "application/javascript": { source: "apache", charset: "UTF-8", compressible: !0, extensions: ["js"] },
  "application/json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["json", "map"] },
  "application/json5": { extensions: ["json5"] },
  "application/jsonml+json": { source: "apache", compressible: !0, extensions: ["jsonml"] },
  "application/ld+json": { source: "iana", compressible: !0, extensions: ["jsonld"] },
  "application/lgr+xml": { source: "iana", compressible: !0, extensions: ["lgr"] },
  "application/lost+xml": { source: "iana", compressible: !0, extensions: ["lostxml"] },
  "application/mac-binhex40": { source: "iana", extensions: ["hqx"] },
  "application/mac-compactpro": { source: "apache", extensions: ["cpt"] },
  "application/mads+xml": { source: "iana", compressible: !0, extensions: ["mads"] },
  "application/manifest+json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["webmanifest"] },
  "application/marc": { source: "iana", extensions: ["mrc"] },
  "application/marcxml+xml": { source: "iana", compressible: !0, extensions: ["mrcx"] },
  "application/mathematica": { source: "iana", extensions: ["ma", "nb", "mb"] },
  "application/mathml+xml": { source: "iana", compressible: !0, extensions: ["mathml"] },
  "application/mbox": { source: "iana", extensions: ["mbox"] },
  "application/media-policy-dataset+xml": { source: "iana", compressible: !0, extensions: ["mpf"] },
  "application/mediaservercontrol+xml": { source: "iana", compressible: !0, extensions: ["mscml"] },
  "application/metalink+xml": { source: "apache", compressible: !0, extensions: ["metalink"] },
  "application/metalink4+xml": { source: "iana", compressible: !0, extensions: ["meta4"] },
  "application/mets+xml": { source: "iana", compressible: !0, extensions: ["mets"] },
  "application/mmt-aei+xml": { source: "iana", compressible: !0, extensions: ["maei"] },
  "application/mmt-usd+xml": { source: "iana", compressible: !0, extensions: ["musd"] },
  "application/mods+xml": { source: "iana", compressible: !0, extensions: ["mods"] },
  "application/mp21": { source: "iana", extensions: ["m21", "mp21"] },
  "application/mp4": { source: "iana", extensions: ["mp4", "mpg4", "mp4s", "m4p"] },
  "application/msix": { compressible: !1, extensions: ["msix"] },
  "application/msixbundle": { compressible: !1, extensions: ["msixbundle"] },
  "application/msword": { source: "iana", compressible: !1, extensions: ["doc", "dot"] },
  "application/mxf": { source: "iana", extensions: ["mxf"] },
  "application/n-quads": { source: "iana", extensions: ["nq"] },
  "application/n-triples": { source: "iana", extensions: ["nt"] },
  "application/node": { source: "iana", extensions: ["cjs"] },
  "application/octet-stream": { source: "iana", compressible: !0, extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] },
  "application/oda": { source: "iana", extensions: ["oda"] },
  "application/oebps-package+xml": { source: "iana", compressible: !0, extensions: ["opf"] },
  "application/ogg": { source: "iana", compressible: !1, extensions: ["ogx"] },
  "application/omdoc+xml": { source: "apache", compressible: !0, extensions: ["omdoc"] },
  "application/onenote": { source: "apache", extensions: ["onetoc", "onetoc2", "onetmp", "onepkg", "one", "onea"] },
  "application/oxps": { source: "iana", extensions: ["oxps"] },
  "application/p2p-overlay+xml": { source: "iana", compressible: !0, extensions: ["relo"] },
  "application/patch-ops-error+xml": { source: "iana", compressible: !0, extensions: ["xer"] },
  "application/pdf": { source: "iana", compressible: !1, extensions: ["pdf"] },
  "application/pgp-encrypted": { source: "iana", compressible: !1, extensions: ["pgp"] },
  "application/pgp-keys": { source: "iana", extensions: ["asc"] },
  "application/pgp-signature": { source: "iana", extensions: ["sig", "asc"] },
  "application/pics-rules": { source: "apache", extensions: ["prf"] },
  "application/pkcs10": { source: "iana", extensions: ["p10"] },
  "application/pkcs7-mime": { source: "iana", extensions: ["p7m", "p7c"] },
  "application/pkcs7-signature": { source: "iana", extensions: ["p7s"] },
  "application/pkcs8": { source: "iana", extensions: ["p8"] },
  "application/pkix-attr-cert": { source: "iana", extensions: ["ac"] },
  "application/pkix-cert": { source: "iana", extensions: ["cer"] },
  "application/pkix-crl": { source: "iana", extensions: ["crl"] },
  "application/pkix-pkipath": { source: "iana", extensions: ["pkipath"] },
  "application/pkixcmp": { source: "iana", extensions: ["pki"] },
  "application/pls+xml": { source: "iana", compressible: !0, extensions: ["pls"] },
  "application/postscript": { source: "iana", compressible: !0, extensions: ["ai", "eps", "ps"] },
  "application/provenance+xml": { source: "iana", compressible: !0, extensions: ["provx"] },
  "application/prs.cww": { source: "iana", extensions: ["cww"] },
  "application/prs.xsf+xml": { source: "iana", compressible: !0, extensions: ["xsf"] },
  "application/pskc+xml": { source: "iana", compressible: !0, extensions: ["pskcxml"] },
  "application/raml+yaml": { compressible: !0, extensions: ["raml"] },
  "application/rdf+xml": { source: "iana", compressible: !0, extensions: ["rdf", "owl"] },
  "application/reginfo+xml": { source: "iana", compressible: !0, extensions: ["rif"] },
  "application/relax-ng-compact-syntax": { source: "iana", extensions: ["rnc"] },
  "application/resource-lists+xml": { source: "iana", compressible: !0, extensions: ["rl"] },
  "application/resource-lists-diff+xml": { source: "iana", compressible: !0, extensions: ["rld"] },
  "application/rls-services+xml": { source: "iana", compressible: !0, extensions: ["rs"] },
  "application/route-apd+xml": { source: "iana", compressible: !0, extensions: ["rapd"] },
  "application/route-s-tsid+xml": { source: "iana", compressible: !0, extensions: ["sls"] },
  "application/route-usd+xml": { source: "iana", compressible: !0, extensions: ["rusd"] },
  "application/rpki-ghostbusters": { source: "iana", extensions: ["gbr"] },
  "application/rpki-manifest": { source: "iana", extensions: ["mft"] },
  "application/rpki-roa": { source: "iana", extensions: ["roa"] },
  "application/rsd+xml": { source: "apache", compressible: !0, extensions: ["rsd"] },
  "application/rss+xml": { source: "apache", compressible: !0, extensions: ["rss"] },
  "application/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "application/sbml+xml": { source: "iana", compressible: !0, extensions: ["sbml"] },
  "application/scvp-cv-request": { source: "iana", extensions: ["scq"] },
  "application/scvp-cv-response": { source: "iana", extensions: ["scs"] },
  "application/scvp-vp-request": { source: "iana", extensions: ["spq"] },
  "application/scvp-vp-response": { source: "iana", extensions: ["spp"] },
  "application/sdp": { source: "iana", extensions: ["sdp"] },
  "application/senml+xml": { source: "iana", compressible: !0, extensions: ["senmlx"] },
  "application/sensml+xml": { source: "iana", compressible: !0, extensions: ["sensmlx"] },
  "application/set-payment-initiation": { source: "iana", extensions: ["setpay"] },
  "application/set-registration-initiation": { source: "iana", extensions: ["setreg"] },
  "application/shf+xml": { source: "iana", compressible: !0, extensions: ["shf"] },
  "application/sieve": { source: "iana", extensions: ["siv", "sieve"] },
  "application/smil+xml": { source: "iana", compressible: !0, extensions: ["smi", "smil"] },
  "application/sparql-query": { source: "iana", extensions: ["rq"] },
  "application/sparql-results+xml": { source: "iana", compressible: !0, extensions: ["srx"] },
  "application/sql": { source: "iana", extensions: ["sql"] },
  "application/srgs": { source: "iana", extensions: ["gram"] },
  "application/srgs+xml": { source: "iana", compressible: !0, extensions: ["grxml"] },
  "application/sru+xml": { source: "iana", compressible: !0, extensions: ["sru"] },
  "application/ssdl+xml": { source: "apache", compressible: !0, extensions: ["ssdl"] },
  "application/ssml+xml": { source: "iana", compressible: !0, extensions: ["ssml"] },
  "application/swid+xml": { source: "iana", compressible: !0, extensions: ["swidtag"] },
  "application/tei+xml": { source: "iana", compressible: !0, extensions: ["tei", "teicorpus"] },
  "application/thraud+xml": { source: "iana", compressible: !0, extensions: ["tfi"] },
  "application/timestamped-data": { source: "iana", extensions: ["tsd"] },
  "application/toml": { source: "iana", compressible: !0, extensions: ["toml"] },
  "application/trig": { source: "iana", extensions: ["trig"] },
  "application/ttml+xml": { source: "iana", compressible: !0, extensions: ["ttml"] },
  "application/ubjson": { compressible: !1, extensions: ["ubj"] },
  "application/urc-ressheet+xml": { source: "iana", compressible: !0, extensions: ["rsheet"] },
  "application/urc-targetdesc+xml": { source: "iana", compressible: !0, extensions: ["td"] },
  "application/vnd.1000minds.decision-model+xml": { source: "iana", compressible: !0, extensions: ["1km"] },
  "application/vnd.3gpp.pic-bw-large": { source: "iana", extensions: ["plb"] },
  "application/vnd.3gpp.pic-bw-small": { source: "iana", extensions: ["psb"] },
  "application/vnd.3gpp.pic-bw-var": { source: "iana", extensions: ["pvb"] },
  "application/vnd.3gpp2.tcap": { source: "iana", extensions: ["tcap"] },
  "application/vnd.3m.post-it-notes": { source: "iana", extensions: ["pwn"] },
  "application/vnd.accpac.simply.aso": { source: "iana", extensions: ["aso"] },
  "application/vnd.accpac.simply.imp": { source: "iana", extensions: ["imp"] },
  "application/vnd.acucobol": { source: "iana", extensions: ["acu"] },
  "application/vnd.acucorp": { source: "iana", extensions: ["atc", "acutc"] },
  "application/vnd.adobe.air-application-installer-package+zip": { source: "apache", compressible: !1, extensions: ["air"] },
  "application/vnd.adobe.formscentral.fcdt": { source: "iana", extensions: ["fcdt"] },
  "application/vnd.adobe.fxp": { source: "iana", extensions: ["fxp", "fxpl"] },
  "application/vnd.adobe.xdp+xml": { source: "iana", compressible: !0, extensions: ["xdp"] },
  "application/vnd.adobe.xfdf": { source: "apache", extensions: ["xfdf"] },
  "application/vnd.age": { source: "iana", extensions: ["age"] },
  "application/vnd.ahead.space": { source: "iana", extensions: ["ahead"] },
  "application/vnd.airzip.filesecure.azf": { source: "iana", extensions: ["azf"] },
  "application/vnd.airzip.filesecure.azs": { source: "iana", extensions: ["azs"] },
  "application/vnd.amazon.ebook": { source: "apache", extensions: ["azw"] },
  "application/vnd.americandynamics.acc": { source: "iana", extensions: ["acc"] },
  "application/vnd.amiga.ami": { source: "iana", extensions: ["ami"] },
  "application/vnd.android.package-archive": { source: "apache", compressible: !1, extensions: ["apk"] },
  "application/vnd.anser-web-certificate-issue-initiation": { source: "iana", extensions: ["cii"] },
  "application/vnd.anser-web-funds-transfer-initiation": { source: "apache", extensions: ["fti"] },
  "application/vnd.antix.game-component": { source: "iana", extensions: ["atx"] },
  "application/vnd.apple.installer+xml": { source: "iana", compressible: !0, extensions: ["mpkg"] },
  "application/vnd.apple.keynote": { source: "iana", extensions: ["key"] },
  "application/vnd.apple.mpegurl": { source: "iana", extensions: ["m3u8"] },
  "application/vnd.apple.numbers": { source: "iana", extensions: ["numbers"] },
  "application/vnd.apple.pages": { source: "iana", extensions: ["pages"] },
  "application/vnd.apple.pkpass": { compressible: !1, extensions: ["pkpass"] },
  "application/vnd.aristanetworks.swi": { source: "iana", extensions: ["swi"] },
  "application/vnd.astraea-software.iota": { source: "iana", extensions: ["iota"] },
  "application/vnd.audiograph": { source: "iana", extensions: ["aep"] },
  "application/vnd.autodesk.fbx": { extensions: ["fbx"] },
  "application/vnd.balsamiq.bmml+xml": { source: "iana", compressible: !0, extensions: ["bmml"] },
  "application/vnd.blueice.multipass": { source: "iana", extensions: ["mpm"] },
  "application/vnd.bmi": { source: "iana", extensions: ["bmi"] },
  "application/vnd.businessobjects": { source: "iana", extensions: ["rep"] },
  "application/vnd.chemdraw+xml": { source: "iana", compressible: !0, extensions: ["cdxml"] },
  "application/vnd.chipnuts.karaoke-mmd": { source: "iana", extensions: ["mmd"] },
  "application/vnd.cinderella": { source: "iana", extensions: ["cdy"] },
  "application/vnd.citationstyles.style+xml": { source: "iana", compressible: !0, extensions: ["csl"] },
  "application/vnd.claymore": { source: "iana", extensions: ["cla"] },
  "application/vnd.cloanto.rp9": { source: "iana", extensions: ["rp9"] },
  "application/vnd.clonk.c4group": { source: "iana", extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"] },
  "application/vnd.cluetrust.cartomobile-config": { source: "iana", extensions: ["c11amc"] },
  "application/vnd.cluetrust.cartomobile-config-pkg": { source: "iana", extensions: ["c11amz"] },
  "application/vnd.commonspace": { source: "iana", extensions: ["csp"] },
  "application/vnd.contact.cmsg": { source: "iana", extensions: ["cdbcmsg"] },
  "application/vnd.cosmocaller": { source: "iana", extensions: ["cmc"] },
  "application/vnd.crick.clicker": { source: "iana", extensions: ["clkx"] },
  "application/vnd.crick.clicker.keyboard": { source: "iana", extensions: ["clkk"] },
  "application/vnd.crick.clicker.palette": { source: "iana", extensions: ["clkp"] },
  "application/vnd.crick.clicker.template": { source: "iana", extensions: ["clkt"] },
  "application/vnd.crick.clicker.wordbank": { source: "iana", extensions: ["clkw"] },
  "application/vnd.criticaltools.wbs+xml": { source: "iana", compressible: !0, extensions: ["wbs"] },
  "application/vnd.ctc-posml": { source: "iana", extensions: ["pml"] },
  "application/vnd.cups-ppd": { source: "iana", extensions: ["ppd"] },
  "application/vnd.curl.car": { source: "apache", extensions: ["car"] },
  "application/vnd.curl.pcurl": { source: "apache", extensions: ["pcurl"] },
  "application/vnd.dart": { source: "iana", compressible: !0, extensions: ["dart"] },
  "application/vnd.data-vision.rdz": { source: "iana", extensions: ["rdz"] },
  "application/vnd.dbf": { source: "iana", extensions: ["dbf"] },
  "application/vnd.dcmp+xml": { source: "iana", compressible: !0, extensions: ["dcmp"] },
  "application/vnd.dece.data": { source: "iana", extensions: ["uvf", "uvvf", "uvd", "uvvd"] },
  "application/vnd.dece.ttml+xml": { source: "iana", compressible: !0, extensions: ["uvt", "uvvt"] },
  "application/vnd.dece.unspecified": { source: "iana", extensions: ["uvx", "uvvx"] },
  "application/vnd.dece.zip": { source: "iana", extensions: ["uvz", "uvvz"] },
  "application/vnd.denovo.fcselayout-link": { source: "iana", extensions: ["fe_launch"] },
  "application/vnd.dna": { source: "iana", extensions: ["dna"] },
  "application/vnd.dolby.mlp": { source: "apache", extensions: ["mlp"] },
  "application/vnd.dpgraph": { source: "iana", extensions: ["dpg"] },
  "application/vnd.dreamfactory": { source: "iana", extensions: ["dfac"] },
  "application/vnd.ds-keypoint": { source: "apache", extensions: ["kpxx"] },
  "application/vnd.dvb.ait": { source: "iana", extensions: ["ait"] },
  "application/vnd.dvb.service": { source: "iana", extensions: ["svc"] },
  "application/vnd.dynageo": { source: "iana", extensions: ["geo"] },
  "application/vnd.ecowin.chart": { source: "iana", extensions: ["mag"] },
  "application/vnd.enliven": { source: "iana", extensions: ["nml"] },
  "application/vnd.epson.esf": { source: "iana", extensions: ["esf"] },
  "application/vnd.epson.msf": { source: "iana", extensions: ["msf"] },
  "application/vnd.epson.quickanime": { source: "iana", extensions: ["qam"] },
  "application/vnd.epson.salt": { source: "iana", extensions: ["slt"] },
  "application/vnd.epson.ssf": { source: "iana", extensions: ["ssf"] },
  "application/vnd.eszigno3+xml": { source: "iana", compressible: !0, extensions: ["es3", "et3"] },
  "application/vnd.ezpix-album": { source: "iana", extensions: ["ez2"] },
  "application/vnd.ezpix-package": { source: "iana", extensions: ["ez3"] },
  "application/vnd.fdf": { source: "apache", extensions: ["fdf"] },
  "application/vnd.fdsn.mseed": { source: "iana", extensions: ["mseed"] },
  "application/vnd.fdsn.seed": { source: "iana", extensions: ["seed", "dataless"] },
  "application/vnd.flographit": { source: "iana", extensions: ["gph"] },
  "application/vnd.fluxtime.clip": { source: "iana", extensions: ["ftc"] },
  "application/vnd.framemaker": { source: "iana", extensions: ["fm", "frame", "maker", "book"] },
  "application/vnd.frogans.fnc": { source: "apache", extensions: ["fnc"] },
  "application/vnd.frogans.ltf": { source: "apache", extensions: ["ltf"] },
  "application/vnd.fsc.weblaunch": { source: "iana", extensions: ["fsc"] },
  "application/vnd.fujitsu.oasys": { source: "iana", extensions: ["oas"] },
  "application/vnd.fujitsu.oasys2": { source: "iana", extensions: ["oa2"] },
  "application/vnd.fujitsu.oasys3": { source: "iana", extensions: ["oa3"] },
  "application/vnd.fujitsu.oasysgp": { source: "iana", extensions: ["fg5"] },
  "application/vnd.fujitsu.oasysprs": { source: "iana", extensions: ["bh2"] },
  "application/vnd.fujixerox.ddd": { source: "iana", extensions: ["ddd"] },
  "application/vnd.fujixerox.docuworks": { source: "iana", extensions: ["xdw"] },
  "application/vnd.fujixerox.docuworks.binder": { source: "iana", extensions: ["xbd"] },
  "application/vnd.fuzzysheet": { source: "iana", extensions: ["fzs"] },
  "application/vnd.genomatix.tuxedo": { source: "iana", extensions: ["txd"] },
  "application/vnd.geogebra.file": { source: "iana", extensions: ["ggb"] },
  "application/vnd.geogebra.slides": { source: "iana", extensions: ["ggs"] },
  "application/vnd.geogebra.tool": { source: "iana", extensions: ["ggt"] },
  "application/vnd.geometry-explorer": { source: "iana", extensions: ["gex", "gre"] },
  "application/vnd.geonext": { source: "iana", extensions: ["gxt"] },
  "application/vnd.geoplan": { source: "iana", extensions: ["g2w"] },
  "application/vnd.geospace": { source: "iana", extensions: ["g3w"] },
  "application/vnd.gmx": { source: "iana", extensions: ["gmx"] },
  "application/vnd.google-apps.document": { compressible: !1, extensions: ["gdoc"] },
  "application/vnd.google-apps.drawing": { compressible: !1, extensions: ["gdraw"] },
  "application/vnd.google-apps.form": { compressible: !1, extensions: ["gform"] },
  "application/vnd.google-apps.jam": { compressible: !1, extensions: ["gjam"] },
  "application/vnd.google-apps.map": { compressible: !1, extensions: ["gmap"] },
  "application/vnd.google-apps.presentation": { compressible: !1, extensions: ["gslides"] },
  "application/vnd.google-apps.script": { compressible: !1, extensions: ["gscript"] },
  "application/vnd.google-apps.site": { compressible: !1, extensions: ["gsite"] },
  "application/vnd.google-apps.spreadsheet": { compressible: !1, extensions: ["gsheet"] },
  "application/vnd.google-earth.kml+xml": { source: "iana", compressible: !0, extensions: ["kml"] },
  "application/vnd.google-earth.kmz": { source: "iana", compressible: !1, extensions: ["kmz"] },
  "application/vnd.gov.sk.xmldatacontainer+xml": { source: "iana", compressible: !0, extensions: ["xdcf"] },
  "application/vnd.grafeq": { source: "iana", extensions: ["gqf", "gqs"] },
  "application/vnd.groove-account": { source: "iana", extensions: ["gac"] },
  "application/vnd.groove-help": { source: "iana", extensions: ["ghf"] },
  "application/vnd.groove-identity-message": { source: "iana", extensions: ["gim"] },
  "application/vnd.groove-injector": { source: "iana", extensions: ["grv"] },
  "application/vnd.groove-tool-message": { source: "iana", extensions: ["gtm"] },
  "application/vnd.groove-tool-template": { source: "iana", extensions: ["tpl"] },
  "application/vnd.groove-vcard": { source: "iana", extensions: ["vcg"] },
  "application/vnd.hal+xml": { source: "iana", compressible: !0, extensions: ["hal"] },
  "application/vnd.handheld-entertainment+xml": { source: "iana", compressible: !0, extensions: ["zmm"] },
  "application/vnd.hbci": { source: "iana", extensions: ["hbci"] },
  "application/vnd.hhe.lesson-player": { source: "iana", extensions: ["les"] },
  "application/vnd.hp-hpgl": { source: "iana", extensions: ["hpgl"] },
  "application/vnd.hp-hpid": { source: "iana", extensions: ["hpid"] },
  "application/vnd.hp-hps": { source: "iana", extensions: ["hps"] },
  "application/vnd.hp-jlyt": { source: "iana", extensions: ["jlt"] },
  "application/vnd.hp-pcl": { source: "iana", extensions: ["pcl"] },
  "application/vnd.hp-pclxl": { source: "iana", extensions: ["pclxl"] },
  "application/vnd.hydrostatix.sof-data": { source: "iana", extensions: ["sfd-hdstx"] },
  "application/vnd.ibm.minipay": { source: "iana", extensions: ["mpy"] },
  "application/vnd.ibm.modcap": { source: "apache", extensions: ["afp", "listafp", "list3820"] },
  "application/vnd.ibm.rights-management": { source: "iana", extensions: ["irm"] },
  "application/vnd.ibm.secure-container": { source: "iana", extensions: ["sc"] },
  "application/vnd.iccprofile": { source: "iana", extensions: ["icc", "icm"] },
  "application/vnd.igloader": { source: "iana", extensions: ["igl"] },
  "application/vnd.immervision-ivp": { source: "iana", extensions: ["ivp"] },
  "application/vnd.immervision-ivu": { source: "iana", extensions: ["ivu"] },
  "application/vnd.insors.igm": { source: "iana", extensions: ["igm"] },
  "application/vnd.intercon.formnet": { source: "iana", extensions: ["xpw", "xpx"] },
  "application/vnd.intergeo": { source: "iana", extensions: ["i2g"] },
  "application/vnd.intu.qbo": { source: "iana", extensions: ["qbo"] },
  "application/vnd.intu.qfx": { source: "iana", extensions: ["qfx"] },
  "application/vnd.ipunplugged.rcprofile": { source: "iana", extensions: ["rcprofile"] },
  "application/vnd.irepository.package+xml": { source: "iana", compressible: !0, extensions: ["irp"] },
  "application/vnd.is-xpr": { source: "iana", extensions: ["xpr"] },
  "application/vnd.isac.fcs": { source: "iana", extensions: ["fcs"] },
  "application/vnd.jam": { source: "iana", extensions: ["jam"] },
  "application/vnd.jcp.javame.midlet-rms": { source: "iana", extensions: ["rms"] },
  "application/vnd.jisp": { source: "iana", extensions: ["jisp"] },
  "application/vnd.joost.joda-archive": { source: "iana", extensions: ["joda"] },
  "application/vnd.kahootz": { source: "iana", extensions: ["ktz", "ktr"] },
  "application/vnd.kde.karbon": { source: "iana", extensions: ["karbon"] },
  "application/vnd.kde.kchart": { source: "iana", extensions: ["chrt"] },
  "application/vnd.kde.kformula": { source: "iana", extensions: ["kfo"] },
  "application/vnd.kde.kivio": { source: "iana", extensions: ["flw"] },
  "application/vnd.kde.kontour": { source: "iana", extensions: ["kon"] },
  "application/vnd.kde.kpresenter": { source: "iana", extensions: ["kpr", "kpt"] },
  "application/vnd.kde.kspread": { source: "iana", extensions: ["ksp"] },
  "application/vnd.kde.kword": { source: "iana", extensions: ["kwd", "kwt"] },
  "application/vnd.kenameaapp": { source: "iana", extensions: ["htke"] },
  "application/vnd.kidspiration": { source: "iana", extensions: ["kia"] },
  "application/vnd.kinar": { source: "iana", extensions: ["kne", "knp"] },
  "application/vnd.koan": { source: "iana", extensions: ["skp", "skd", "skt", "skm"] },
  "application/vnd.kodak-descriptor": { source: "iana", extensions: ["sse"] },
  "application/vnd.las.las+xml": { source: "iana", compressible: !0, extensions: ["lasxml"] },
  "application/vnd.llamagraphics.life-balance.desktop": { source: "iana", extensions: ["lbd"] },
  "application/vnd.llamagraphics.life-balance.exchange+xml": { source: "iana", compressible: !0, extensions: ["lbe"] },
  "application/vnd.lotus-1-2-3": { source: "iana", extensions: ["123"] },
  "application/vnd.lotus-approach": { source: "iana", extensions: ["apr"] },
  "application/vnd.lotus-freelance": { source: "iana", extensions: ["pre"] },
  "application/vnd.lotus-notes": { source: "iana", extensions: ["nsf"] },
  "application/vnd.lotus-organizer": { source: "iana", extensions: ["org"] },
  "application/vnd.lotus-screencam": { source: "iana", extensions: ["scm"] },
  "application/vnd.lotus-wordpro": { source: "iana", extensions: ["lwp"] },
  "application/vnd.macports.portpkg": { source: "iana", extensions: ["portpkg"] },
  "application/vnd.mapbox-vector-tile": { source: "iana", extensions: ["mvt"] },
  "application/vnd.mcd": { source: "iana", extensions: ["mcd"] },
  "application/vnd.medcalcdata": { source: "iana", extensions: ["mc1"] },
  "application/vnd.mediastation.cdkey": { source: "iana", extensions: ["cdkey"] },
  "application/vnd.mfer": { source: "iana", extensions: ["mwf"] },
  "application/vnd.mfmp": { source: "iana", extensions: ["mfm"] },
  "application/vnd.micrografx.flo": { source: "iana", extensions: ["flo"] },
  "application/vnd.micrografx.igx": { source: "iana", extensions: ["igx"] },
  "application/vnd.mif": { source: "iana", extensions: ["mif"] },
  "application/vnd.mobius.daf": { source: "iana", extensions: ["daf"] },
  "application/vnd.mobius.dis": { source: "iana", extensions: ["dis"] },
  "application/vnd.mobius.mbk": { source: "iana", extensions: ["mbk"] },
  "application/vnd.mobius.mqy": { source: "iana", extensions: ["mqy"] },
  "application/vnd.mobius.msl": { source: "iana", extensions: ["msl"] },
  "application/vnd.mobius.plc": { source: "iana", extensions: ["plc"] },
  "application/vnd.mobius.txf": { source: "iana", extensions: ["txf"] },
  "application/vnd.mophun.application": { source: "iana", extensions: ["mpn"] },
  "application/vnd.mophun.certificate": { source: "iana", extensions: ["mpc"] },
  "application/vnd.mozilla.xul+xml": { source: "iana", compressible: !0, extensions: ["xul"] },
  "application/vnd.ms-artgalry": { source: "iana", extensions: ["cil"] },
  "application/vnd.ms-cab-compressed": { source: "iana", extensions: ["cab"] },
  "application/vnd.ms-excel": { source: "iana", compressible: !1, extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] },
  "application/vnd.ms-excel.addin.macroenabled.12": { source: "iana", extensions: ["xlam"] },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": { source: "iana", extensions: ["xlsb"] },
  "application/vnd.ms-excel.sheet.macroenabled.12": { source: "iana", extensions: ["xlsm"] },
  "application/vnd.ms-excel.template.macroenabled.12": { source: "iana", extensions: ["xltm"] },
  "application/vnd.ms-fontobject": { source: "iana", compressible: !0, extensions: ["eot"] },
  "application/vnd.ms-htmlhelp": { source: "iana", extensions: ["chm"] },
  "application/vnd.ms-ims": { source: "iana", extensions: ["ims"] },
  "application/vnd.ms-lrm": { source: "iana", extensions: ["lrm"] },
  "application/vnd.ms-officetheme": { source: "iana", extensions: ["thmx"] },
  "application/vnd.ms-outlook": { compressible: !1, extensions: ["msg"] },
  "application/vnd.ms-pki.seccat": { source: "apache", extensions: ["cat"] },
  "application/vnd.ms-pki.stl": { source: "apache", extensions: ["stl"] },
  "application/vnd.ms-powerpoint": { source: "iana", compressible: !1, extensions: ["ppt", "pps", "pot"] },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": { source: "iana", extensions: ["ppam"] },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": { source: "iana", extensions: ["pptm"] },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": { source: "iana", extensions: ["sldm"] },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": { source: "iana", extensions: ["ppsm"] },
  "application/vnd.ms-powerpoint.template.macroenabled.12": { source: "iana", extensions: ["potm"] },
  "application/vnd.ms-project": { source: "iana", extensions: ["mpp", "mpt"] },
  "application/vnd.ms-visio.viewer": { extensions: ["vdx"] },
  "application/vnd.ms-word.document.macroenabled.12": { source: "iana", extensions: ["docm"] },
  "application/vnd.ms-word.template.macroenabled.12": { source: "iana", extensions: ["dotm"] },
  "application/vnd.ms-works": { source: "iana", extensions: ["wps", "wks", "wcm", "wdb"] },
  "application/vnd.ms-wpl": { source: "iana", extensions: ["wpl"] },
  "application/vnd.ms-xpsdocument": { source: "iana", compressible: !1, extensions: ["xps"] },
  "application/vnd.mseq": { source: "iana", extensions: ["mseq"] },
  "application/vnd.musician": { source: "iana", extensions: ["mus"] },
  "application/vnd.muvee.style": { source: "iana", extensions: ["msty"] },
  "application/vnd.mynfc": { source: "iana", extensions: ["taglet"] },
  "application/vnd.nato.bindingdataobject+xml": { source: "iana", compressible: !0, extensions: ["bdo"] },
  "application/vnd.neurolanguage.nlu": { source: "iana", extensions: ["nlu"] },
  "application/vnd.nitf": { source: "iana", extensions: ["ntf", "nitf"] },
  "application/vnd.noblenet-directory": { source: "iana", extensions: ["nnd"] },
  "application/vnd.noblenet-sealer": { source: "iana", extensions: ["nns"] },
  "application/vnd.noblenet-web": { source: "iana", extensions: ["nnw"] },
  "application/vnd.nokia.n-gage.ac+xml": { source: "iana", compressible: !0, extensions: ["ac"] },
  "application/vnd.nokia.n-gage.data": { source: "iana", extensions: ["ngdat"] },
  "application/vnd.nokia.n-gage.symbian.install": { source: "apache", extensions: ["n-gage"] },
  "application/vnd.nokia.radio-preset": { source: "iana", extensions: ["rpst"] },
  "application/vnd.nokia.radio-presets": { source: "iana", extensions: ["rpss"] },
  "application/vnd.novadigm.edm": { source: "iana", extensions: ["edm"] },
  "application/vnd.novadigm.edx": { source: "iana", extensions: ["edx"] },
  "application/vnd.novadigm.ext": { source: "iana", extensions: ["ext"] },
  "application/vnd.oasis.opendocument.chart": { source: "iana", extensions: ["odc"] },
  "application/vnd.oasis.opendocument.chart-template": { source: "iana", extensions: ["otc"] },
  "application/vnd.oasis.opendocument.database": { source: "apache", extensions: ["odb"] },
  "application/vnd.oasis.opendocument.formula": { source: "iana", extensions: ["odf"] },
  "application/vnd.oasis.opendocument.formula-template": { source: "iana", extensions: ["odft"] },
  "application/vnd.oasis.opendocument.graphics": { source: "iana", compressible: !1, extensions: ["odg"] },
  "application/vnd.oasis.opendocument.graphics-template": { source: "iana", extensions: ["otg"] },
  "application/vnd.oasis.opendocument.image": { source: "iana", extensions: ["odi"] },
  "application/vnd.oasis.opendocument.image-template": { source: "iana", extensions: ["oti"] },
  "application/vnd.oasis.opendocument.presentation": { source: "iana", compressible: !1, extensions: ["odp"] },
  "application/vnd.oasis.opendocument.presentation-template": { source: "iana", extensions: ["otp"] },
  "application/vnd.oasis.opendocument.spreadsheet": { source: "iana", compressible: !1, extensions: ["ods"] },
  "application/vnd.oasis.opendocument.spreadsheet-template": { source: "iana", extensions: ["ots"] },
  "application/vnd.oasis.opendocument.text": { source: "iana", compressible: !1, extensions: ["odt"] },
  "application/vnd.oasis.opendocument.text-master": { source: "iana", extensions: ["odm"] },
  "application/vnd.oasis.opendocument.text-template": { source: "iana", extensions: ["ott"] },
  "application/vnd.oasis.opendocument.text-web": { source: "iana", extensions: ["oth"] },
  "application/vnd.olpc-sugar": { source: "iana", extensions: ["xo"] },
  "application/vnd.oma.dd2+xml": { source: "iana", compressible: !0, extensions: ["dd2"] },
  "application/vnd.openblox.game+xml": { source: "iana", compressible: !0, extensions: ["obgx"] },
  "application/vnd.openofficeorg.extension": { source: "apache", extensions: ["oxt"] },
  "application/vnd.openstreetmap.data+xml": { source: "iana", compressible: !0, extensions: ["osm"] },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { source: "iana", compressible: !1, extensions: ["pptx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": { source: "iana", extensions: ["sldx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { source: "iana", extensions: ["ppsx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { source: "iana", extensions: ["potx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { source: "iana", compressible: !1, extensions: ["xlsx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": { source: "iana", extensions: ["xltx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { source: "iana", compressible: !1, extensions: ["docx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { source: "iana", extensions: ["dotx"] },
  "application/vnd.osgeo.mapguide.package": { source: "iana", extensions: ["mgp"] },
  "application/vnd.osgi.dp": { source: "iana", extensions: ["dp"] },
  "application/vnd.osgi.subsystem": { source: "iana", extensions: ["esa"] },
  "application/vnd.palm": { source: "iana", extensions: ["pdb", "pqa", "oprc"] },
  "application/vnd.pawaafile": { source: "iana", extensions: ["paw"] },
  "application/vnd.pg.format": { source: "iana", extensions: ["str"] },
  "application/vnd.pg.osasli": { source: "iana", extensions: ["ei6"] },
  "application/vnd.picsel": { source: "iana", extensions: ["efif"] },
  "application/vnd.pmi.widget": { source: "iana", extensions: ["wg"] },
  "application/vnd.pocketlearn": { source: "iana", extensions: ["plf"] },
  "application/vnd.powerbuilder6": { source: "iana", extensions: ["pbd"] },
  "application/vnd.previewsystems.box": { source: "iana", extensions: ["box"] },
  "application/vnd.procrate.brushset": { extensions: ["brushset"] },
  "application/vnd.procreate.brush": { extensions: ["brush"] },
  "application/vnd.procreate.dream": { extensions: ["drm"] },
  "application/vnd.proteus.magazine": { source: "iana", extensions: ["mgz"] },
  "application/vnd.publishare-delta-tree": { source: "iana", extensions: ["qps"] },
  "application/vnd.pvi.ptid1": { source: "iana", extensions: ["ptid"] },
  "application/vnd.pwg-xhtml-print+xml": { source: "iana", compressible: !0, extensions: ["xhtm"] },
  "application/vnd.quark.quarkxpress": { source: "iana", extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"] },
  "application/vnd.rar": { source: "iana", extensions: ["rar"] },
  "application/vnd.realvnc.bed": { source: "iana", extensions: ["bed"] },
  "application/vnd.recordare.musicxml": { source: "iana", extensions: ["mxl"] },
  "application/vnd.recordare.musicxml+xml": { source: "iana", compressible: !0, extensions: ["musicxml"] },
  "application/vnd.rig.cryptonote": { source: "iana", extensions: ["cryptonote"] },
  "application/vnd.rim.cod": { source: "apache", extensions: ["cod"] },
  "application/vnd.rn-realmedia": { source: "apache", extensions: ["rm"] },
  "application/vnd.rn-realmedia-vbr": { source: "apache", extensions: ["rmvb"] },
  "application/vnd.route66.link66+xml": { source: "iana", compressible: !0, extensions: ["link66"] },
  "application/vnd.sailingtracker.track": { source: "iana", extensions: ["st"] },
  "application/vnd.seemail": { source: "iana", extensions: ["see"] },
  "application/vnd.sema": { source: "iana", extensions: ["sema"] },
  "application/vnd.semd": { source: "iana", extensions: ["semd"] },
  "application/vnd.semf": { source: "iana", extensions: ["semf"] },
  "application/vnd.shana.informed.formdata": { source: "iana", extensions: ["ifm"] },
  "application/vnd.shana.informed.formtemplate": { source: "iana", extensions: ["itp"] },
  "application/vnd.shana.informed.interchange": { source: "iana", extensions: ["iif"] },
  "application/vnd.shana.informed.package": { source: "iana", extensions: ["ipk"] },
  "application/vnd.simtech-mindmapper": { source: "iana", extensions: ["twd", "twds"] },
  "application/vnd.smaf": { source: "iana", extensions: ["mmf"] },
  "application/vnd.smart.teacher": { source: "iana", extensions: ["teacher"] },
  "application/vnd.software602.filler.form+xml": { source: "iana", compressible: !0, extensions: ["fo"] },
  "application/vnd.solent.sdkm+xml": { source: "iana", compressible: !0, extensions: ["sdkm", "sdkd"] },
  "application/vnd.spotfire.dxp": { source: "iana", extensions: ["dxp"] },
  "application/vnd.spotfire.sfs": { source: "iana", extensions: ["sfs"] },
  "application/vnd.stardivision.calc": { source: "apache", extensions: ["sdc"] },
  "application/vnd.stardivision.draw": { source: "apache", extensions: ["sda"] },
  "application/vnd.stardivision.impress": { source: "apache", extensions: ["sdd"] },
  "application/vnd.stardivision.math": { source: "apache", extensions: ["smf"] },
  "application/vnd.stardivision.writer": { source: "apache", extensions: ["sdw", "vor"] },
  "application/vnd.stardivision.writer-global": { source: "apache", extensions: ["sgl"] },
  "application/vnd.stepmania.package": { source: "iana", extensions: ["smzip"] },
  "application/vnd.stepmania.stepchart": { source: "iana", extensions: ["sm"] },
  "application/vnd.sun.wadl+xml": { source: "iana", compressible: !0, extensions: ["wadl"] },
  "application/vnd.sun.xml.calc": { source: "apache", extensions: ["sxc"] },
  "application/vnd.sun.xml.calc.template": { source: "apache", extensions: ["stc"] },
  "application/vnd.sun.xml.draw": { source: "apache", extensions: ["sxd"] },
  "application/vnd.sun.xml.draw.template": { source: "apache", extensions: ["std"] },
  "application/vnd.sun.xml.impress": { source: "apache", extensions: ["sxi"] },
  "application/vnd.sun.xml.impress.template": { source: "apache", extensions: ["sti"] },
  "application/vnd.sun.xml.math": { source: "apache", extensions: ["sxm"] },
  "application/vnd.sun.xml.writer": { source: "apache", extensions: ["sxw"] },
  "application/vnd.sun.xml.writer.global": { source: "apache", extensions: ["sxg"] },
  "application/vnd.sun.xml.writer.template": { source: "apache", extensions: ["stw"] },
  "application/vnd.sus-calendar": { source: "iana", extensions: ["sus", "susp"] },
  "application/vnd.svd": { source: "iana", extensions: ["svd"] },
  "application/vnd.symbian.install": { source: "apache", extensions: ["sis", "sisx"] },
  "application/vnd.syncml+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xsm"] },
  "application/vnd.syncml.dm+wbxml": { source: "iana", charset: "UTF-8", extensions: ["bdm"] },
  "application/vnd.syncml.dm+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xdm"] },
  "application/vnd.syncml.dmddf+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["ddf"] },
  "application/vnd.tao.intent-module-archive": { source: "iana", extensions: ["tao"] },
  "application/vnd.tcpdump.pcap": { source: "iana", extensions: ["pcap", "cap", "dmp"] },
  "application/vnd.tmobile-livetv": { source: "iana", extensions: ["tmo"] },
  "application/vnd.trid.tpt": { source: "iana", extensions: ["tpt"] },
  "application/vnd.triscape.mxs": { source: "iana", extensions: ["mxs"] },
  "application/vnd.trueapp": { source: "iana", extensions: ["tra"] },
  "application/vnd.ufdl": { source: "iana", extensions: ["ufd", "ufdl"] },
  "application/vnd.uiq.theme": { source: "iana", extensions: ["utz"] },
  "application/vnd.umajin": { source: "iana", extensions: ["umj"] },
  "application/vnd.unity": { source: "iana", extensions: ["unityweb"] },
  "application/vnd.uoml+xml": { source: "iana", compressible: !0, extensions: ["uoml", "uo"] },
  "application/vnd.vcx": { source: "iana", extensions: ["vcx"] },
  "application/vnd.visio": { source: "iana", extensions: ["vsd", "vst", "vss", "vsw", "vsdx", "vtx"] },
  "application/vnd.visionary": { source: "iana", extensions: ["vis"] },
  "application/vnd.vsf": { source: "iana", extensions: ["vsf"] },
  "application/vnd.wap.wbxml": { source: "iana", charset: "UTF-8", extensions: ["wbxml"] },
  "application/vnd.wap.wmlc": { source: "iana", extensions: ["wmlc"] },
  "application/vnd.wap.wmlscriptc": { source: "iana", extensions: ["wmlsc"] },
  "application/vnd.webturbo": { source: "iana", extensions: ["wtb"] },
  "application/vnd.wolfram.player": { source: "iana", extensions: ["nbp"] },
  "application/vnd.wordperfect": { source: "iana", extensions: ["wpd"] },
  "application/vnd.wqd": { source: "iana", extensions: ["wqd"] },
  "application/vnd.wt.stf": { source: "iana", extensions: ["stf"] },
  "application/vnd.xara": { source: "iana", extensions: ["xar"] },
  "application/vnd.xfdl": { source: "iana", extensions: ["xfdl"] },
  "application/vnd.yamaha.hv-dic": { source: "iana", extensions: ["hvd"] },
  "application/vnd.yamaha.hv-script": { source: "iana", extensions: ["hvs"] },
  "application/vnd.yamaha.hv-voice": { source: "iana", extensions: ["hvp"] },
  "application/vnd.yamaha.openscoreformat": { source: "iana", extensions: ["osf"] },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": { source: "iana", compressible: !0, extensions: ["osfpvg"] },
  "application/vnd.yamaha.smaf-audio": { source: "iana", extensions: ["saf"] },
  "application/vnd.yamaha.smaf-phrase": { source: "iana", extensions: ["spf"] },
  "application/vnd.yellowriver-custom-menu": { source: "iana", extensions: ["cmp"] },
  "application/vnd.zul": { source: "iana", extensions: ["zir", "zirz"] },
  "application/vnd.zzazz.deck+xml": { source: "iana", compressible: !0, extensions: ["zaz"] },
  "application/voicexml+xml": { source: "iana", compressible: !0, extensions: ["vxml"] },
  "application/wasm": { source: "iana", compressible: !0, extensions: ["wasm"] },
  "application/watcherinfo+xml": { source: "iana", compressible: !0, extensions: ["wif"] },
  "application/widget": { source: "iana", extensions: ["wgt"] },
  "application/winhlp": { source: "apache", extensions: ["hlp"] },
  "application/wsdl+xml": { source: "iana", compressible: !0, extensions: ["wsdl"] },
  "application/wspolicy+xml": { source: "iana", compressible: !0, extensions: ["wspolicy"] },
  "application/x-7z-compressed": { source: "apache", compressible: !1, extensions: ["7z"] },
  "application/x-abiword": { source: "apache", extensions: ["abw"] },
  "application/x-ace-compressed": { source: "apache", extensions: ["ace"] },
  "application/x-apple-diskimage": { source: "apache", extensions: ["dmg"] },
  "application/x-arj": { compressible: !1, extensions: ["arj"] },
  "application/x-authorware-bin": { source: "apache", extensions: ["aab", "x32", "u32", "vox"] },
  "application/x-authorware-map": { source: "apache", extensions: ["aam"] },
  "application/x-authorware-seg": { source: "apache", extensions: ["aas"] },
  "application/x-bcpio": { source: "apache", extensions: ["bcpio"] },
  "application/x-bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/x-bittorrent": { source: "apache", extensions: ["torrent"] },
  "application/x-blender": { extensions: ["blend"] },
  "application/x-blorb": { source: "apache", extensions: ["blb", "blorb"] },
  "application/x-bzip": { source: "apache", compressible: !1, extensions: ["bz"] },
  "application/x-bzip2": { source: "apache", compressible: !1, extensions: ["bz2", "boz"] },
  "application/x-cbr": { source: "apache", extensions: ["cbr", "cba", "cbt", "cbz", "cb7"] },
  "application/x-cdlink": { source: "apache", extensions: ["vcd"] },
  "application/x-cfs-compressed": { source: "apache", extensions: ["cfs"] },
  "application/x-chat": { source: "apache", extensions: ["chat"] },
  "application/x-chess-pgn": { source: "apache", extensions: ["pgn"] },
  "application/x-chrome-extension": { extensions: ["crx"] },
  "application/x-cocoa": { source: "nginx", extensions: ["cco"] },
  "application/x-compressed": { extensions: ["rar"] },
  "application/x-conference": { source: "apache", extensions: ["nsc"] },
  "application/x-cpio": { source: "apache", extensions: ["cpio"] },
  "application/x-csh": { source: "apache", extensions: ["csh"] },
  "application/x-debian-package": { source: "apache", extensions: ["deb", "udeb"] },
  "application/x-dgc-compressed": { source: "apache", extensions: ["dgc"] },
  "application/x-director": { source: "apache", extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"] },
  "application/x-doom": { source: "apache", extensions: ["wad"] },
  "application/x-dtbncx+xml": { source: "apache", compressible: !0, extensions: ["ncx"] },
  "application/x-dtbook+xml": { source: "apache", compressible: !0, extensions: ["dtb"] },
  "application/x-dtbresource+xml": { source: "apache", compressible: !0, extensions: ["res"] },
  "application/x-dvi": { source: "apache", compressible: !1, extensions: ["dvi"] },
  "application/x-envoy": { source: "apache", extensions: ["evy"] },
  "application/x-eva": { source: "apache", extensions: ["eva"] },
  "application/x-font-bdf": { source: "apache", extensions: ["bdf"] },
  "application/x-font-ghostscript": { source: "apache", extensions: ["gsf"] },
  "application/x-font-linux-psf": { source: "apache", extensions: ["psf"] },
  "application/x-font-pcf": { source: "apache", extensions: ["pcf"] },
  "application/x-font-snf": { source: "apache", extensions: ["snf"] },
  "application/x-font-type1": { source: "apache", extensions: ["pfa", "pfb", "pfm", "afm"] },
  "application/x-freearc": { source: "apache", extensions: ["arc"] },
  "application/x-futuresplash": { source: "apache", extensions: ["spl"] },
  "application/x-gca-compressed": { source: "apache", extensions: ["gca"] },
  "application/x-glulx": { source: "apache", extensions: ["ulx"] },
  "application/x-gnumeric": { source: "apache", extensions: ["gnumeric"] },
  "application/x-gramps-xml": { source: "apache", extensions: ["gramps"] },
  "application/x-gtar": { source: "apache", extensions: ["gtar"] },
  "application/x-hdf": { source: "apache", extensions: ["hdf"] },
  "application/x-httpd-php": { compressible: !0, extensions: ["php"] },
  "application/x-install-instructions": { source: "apache", extensions: ["install"] },
  "application/x-ipynb+json": { compressible: !0, extensions: ["ipynb"] },
  "application/x-iso9660-image": { source: "apache", extensions: ["iso"] },
  "application/x-iwork-keynote-sffkey": { extensions: ["key"] },
  "application/x-iwork-numbers-sffnumbers": { extensions: ["numbers"] },
  "application/x-iwork-pages-sffpages": { extensions: ["pages"] },
  "application/x-java-archive-diff": { source: "nginx", extensions: ["jardiff"] },
  "application/x-java-jnlp-file": { source: "apache", compressible: !1, extensions: ["jnlp"] },
  "application/x-keepass2": { extensions: ["kdbx"] },
  "application/x-latex": { source: "apache", compressible: !1, extensions: ["latex"] },
  "application/x-lua-bytecode": { extensions: ["luac"] },
  "application/x-lzh-compressed": { source: "apache", extensions: ["lzh", "lha"] },
  "application/x-makeself": { source: "nginx", extensions: ["run"] },
  "application/x-mie": { source: "apache", extensions: ["mie"] },
  "application/x-mobipocket-ebook": { source: "apache", extensions: ["prc", "mobi"] },
  "application/x-ms-application": { source: "apache", extensions: ["application"] },
  "application/x-ms-shortcut": { source: "apache", extensions: ["lnk"] },
  "application/x-ms-wmd": { source: "apache", extensions: ["wmd"] },
  "application/x-ms-wmz": { source: "apache", extensions: ["wmz"] },
  "application/x-ms-xbap": { source: "apache", extensions: ["xbap"] },
  "application/x-msaccess": { source: "apache", extensions: ["mdb"] },
  "application/x-msbinder": { source: "apache", extensions: ["obd"] },
  "application/x-mscardfile": { source: "apache", extensions: ["crd"] },
  "application/x-msclip": { source: "apache", extensions: ["clp"] },
  "application/x-msdos-program": { extensions: ["exe"] },
  "application/x-msdownload": { source: "apache", extensions: ["exe", "dll", "com", "bat", "msi"] },
  "application/x-msmediaview": { source: "apache", extensions: ["mvb", "m13", "m14"] },
  "application/x-msmetafile": { source: "apache", extensions: ["wmf", "wmz", "emf", "emz"] },
  "application/x-msmoney": { source: "apache", extensions: ["mny"] },
  "application/x-mspublisher": { source: "apache", extensions: ["pub"] },
  "application/x-msschedule": { source: "apache", extensions: ["scd"] },
  "application/x-msterminal": { source: "apache", extensions: ["trm"] },
  "application/x-mswrite": { source: "apache", extensions: ["wri"] },
  "application/x-netcdf": { source: "apache", extensions: ["nc", "cdf"] },
  "application/x-ns-proxy-autoconfig": { compressible: !0, extensions: ["pac"] },
  "application/x-nzb": { source: "apache", extensions: ["nzb"] },
  "application/x-perl": { source: "nginx", extensions: ["pl", "pm"] },
  "application/x-pilot": { source: "nginx", extensions: ["prc", "pdb"] },
  "application/x-pkcs12": { source: "apache", compressible: !1, extensions: ["p12", "pfx"] },
  "application/x-pkcs7-certificates": { source: "apache", extensions: ["p7b", "spc"] },
  "application/x-pkcs7-certreqresp": { source: "apache", extensions: ["p7r"] },
  "application/x-rar-compressed": { source: "apache", compressible: !1, extensions: ["rar"] },
  "application/x-redhat-package-manager": { source: "nginx", extensions: ["rpm"] },
  "application/x-research-info-systems": { source: "apache", extensions: ["ris"] },
  "application/x-sea": { source: "nginx", extensions: ["sea"] },
  "application/x-sh": { source: "apache", compressible: !0, extensions: ["sh"] },
  "application/x-shar": { source: "apache", extensions: ["shar"] },
  "application/x-shockwave-flash": { source: "apache", compressible: !1, extensions: ["swf"] },
  "application/x-silverlight-app": { source: "apache", extensions: ["xap"] },
  "application/x-sql": { source: "apache", extensions: ["sql"] },
  "application/x-stuffit": { source: "apache", compressible: !1, extensions: ["sit"] },
  "application/x-stuffitx": { source: "apache", extensions: ["sitx"] },
  "application/x-subrip": { source: "apache", extensions: ["srt"] },
  "application/x-sv4cpio": { source: "apache", extensions: ["sv4cpio"] },
  "application/x-sv4crc": { source: "apache", extensions: ["sv4crc"] },
  "application/x-t3vm-image": { source: "apache", extensions: ["t3"] },
  "application/x-tads": { source: "apache", extensions: ["gam"] },
  "application/x-tar": { source: "apache", compressible: !0, extensions: ["tar"] },
  "application/x-tcl": { source: "apache", extensions: ["tcl", "tk"] },
  "application/x-tex": { source: "apache", extensions: ["tex"] },
  "application/x-tex-tfm": { source: "apache", extensions: ["tfm"] },
  "application/x-texinfo": { source: "apache", extensions: ["texinfo", "texi"] },
  "application/x-tgif": { source: "apache", extensions: ["obj"] },
  "application/x-ustar": { source: "apache", extensions: ["ustar"] },
  "application/x-virtualbox-hdd": { compressible: !0, extensions: ["hdd"] },
  "application/x-virtualbox-ova": { compressible: !0, extensions: ["ova"] },
  "application/x-virtualbox-ovf": { compressible: !0, extensions: ["ovf"] },
  "application/x-virtualbox-vbox": { compressible: !0, extensions: ["vbox"] },
  "application/x-virtualbox-vbox-extpack": { compressible: !1, extensions: ["vbox-extpack"] },
  "application/x-virtualbox-vdi": { compressible: !0, extensions: ["vdi"] },
  "application/x-virtualbox-vhd": { compressible: !0, extensions: ["vhd"] },
  "application/x-virtualbox-vmdk": { compressible: !0, extensions: ["vmdk"] },
  "application/x-wais-source": { source: "apache", extensions: ["src"] },
  "application/x-web-app-manifest+json": { compressible: !0, extensions: ["webapp"] },
  "application/x-x509-ca-cert": { source: "iana", extensions: ["der", "crt", "pem"] },
  "application/x-xfig": { source: "apache", extensions: ["fig"] },
  "application/x-xliff+xml": { source: "apache", compressible: !0, extensions: ["xlf"] },
  "application/x-xpinstall": { source: "apache", compressible: !1, extensions: ["xpi"] },
  "application/x-xz": { source: "apache", extensions: ["xz"] },
  "application/x-zip-compressed": { extensions: ["zip"] },
  "application/x-zmachine": { source: "apache", extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"] },
  "application/xaml+xml": { source: "apache", compressible: !0, extensions: ["xaml"] },
  "application/xcap-att+xml": { source: "iana", compressible: !0, extensions: ["xav"] },
  "application/xcap-caps+xml": { source: "iana", compressible: !0, extensions: ["xca"] },
  "application/xcap-diff+xml": { source: "iana", compressible: !0, extensions: ["xdf"] },
  "application/xcap-el+xml": { source: "iana", compressible: !0, extensions: ["xel"] },
  "application/xcap-ns+xml": { source: "iana", compressible: !0, extensions: ["xns"] },
  "application/xenc+xml": { source: "iana", compressible: !0, extensions: ["xenc"] },
  "application/xfdf": { source: "iana", extensions: ["xfdf"] },
  "application/xhtml+xml": { source: "iana", compressible: !0, extensions: ["xhtml", "xht"] },
  "application/xliff+xml": { source: "iana", compressible: !0, extensions: ["xlf"] },
  "application/xml": { source: "iana", compressible: !0, extensions: ["xml", "xsl", "xsd", "rng"] },
  "application/xml-dtd": { source: "iana", compressible: !0, extensions: ["dtd"] },
  "application/xop+xml": { source: "iana", compressible: !0, extensions: ["xop"] },
  "application/xproc+xml": { source: "apache", compressible: !0, extensions: ["xpl"] },
  "application/xslt+xml": { source: "iana", compressible: !0, extensions: ["xsl", "xslt"] },
  "application/xspf+xml": { source: "apache", compressible: !0, extensions: ["xspf"] },
  "application/xv+xml": { source: "iana", compressible: !0, extensions: ["mxml", "xhvml", "xvml", "xvm"] },
  "application/yang": { source: "iana", extensions: ["yang"] },
  "application/yin+xml": { source: "iana", compressible: !0, extensions: ["yin"] },
  "application/zip": { source: "iana", compressible: !1, extensions: ["zip"] },
  "application/zip+dotlottie": { extensions: ["lottie"] },
  "audio/3gpp": { source: "iana", compressible: !1, extensions: ["3gpp"] },
  "audio/aac": { source: "iana", extensions: ["adts", "aac"] },
  "audio/adpcm": { source: "apache", extensions: ["adp"] },
  "audio/amr": { source: "iana", extensions: ["amr"] },
  "audio/basic": { source: "iana", compressible: !1, extensions: ["au", "snd"] },
  "audio/midi": { source: "apache", extensions: ["mid", "midi", "kar", "rmi"] },
  "audio/mobile-xmf": { source: "iana", extensions: ["mxmf"] },
  "audio/mp3": { compressible: !1, extensions: ["mp3"] },
  "audio/mp4": { source: "iana", compressible: !1, extensions: ["m4a", "mp4a", "m4b"] },
  "audio/mpeg": { source: "iana", compressible: !1, extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] },
  "audio/ogg": { source: "iana", compressible: !1, extensions: ["oga", "ogg", "spx", "opus"] },
  "audio/s3m": { source: "apache", extensions: ["s3m"] },
  "audio/silk": { source: "apache", extensions: ["sil"] },
  "audio/vnd.dece.audio": { source: "iana", extensions: ["uva", "uvva"] },
  "audio/vnd.digital-winds": { source: "iana", extensions: ["eol"] },
  "audio/vnd.dra": { source: "iana", extensions: ["dra"] },
  "audio/vnd.dts": { source: "iana", extensions: ["dts"] },
  "audio/vnd.dts.hd": { source: "iana", extensions: ["dtshd"] },
  "audio/vnd.lucent.voice": { source: "iana", extensions: ["lvp"] },
  "audio/vnd.ms-playready.media.pya": { source: "iana", extensions: ["pya"] },
  "audio/vnd.nuera.ecelp4800": { source: "iana", extensions: ["ecelp4800"] },
  "audio/vnd.nuera.ecelp7470": { source: "iana", extensions: ["ecelp7470"] },
  "audio/vnd.nuera.ecelp9600": { source: "iana", extensions: ["ecelp9600"] },
  "audio/vnd.rip": { source: "iana", extensions: ["rip"] },
  "audio/wav": { compressible: !1, extensions: ["wav"] },
  "audio/wave": { compressible: !1, extensions: ["wav"] },
  "audio/webm": { source: "apache", compressible: !1, extensions: ["weba"] },
  "audio/x-aac": { source: "apache", compressible: !1, extensions: ["aac"] },
  "audio/x-aiff": { source: "apache", extensions: ["aif", "aiff", "aifc"] },
  "audio/x-caf": { source: "apache", compressible: !1, extensions: ["caf"] },
  "audio/x-flac": { source: "apache", extensions: ["flac"] },
  "audio/x-m4a": { source: "nginx", extensions: ["m4a"] },
  "audio/x-matroska": { source: "apache", extensions: ["mka"] },
  "audio/x-mpegurl": { source: "apache", extensions: ["m3u"] },
  "audio/x-ms-wax": { source: "apache", extensions: ["wax"] },
  "audio/x-ms-wma": { source: "apache", extensions: ["wma"] },
  "audio/x-pn-realaudio": { source: "apache", extensions: ["ram", "ra"] },
  "audio/x-pn-realaudio-plugin": { source: "apache", extensions: ["rmp"] },
  "audio/x-realaudio": { source: "nginx", extensions: ["ra"] },
  "audio/x-wav": { source: "apache", extensions: ["wav"] },
  "audio/xm": { source: "apache", extensions: ["xm"] },
  "chemical/x-cdx": { source: "apache", extensions: ["cdx"] },
  "chemical/x-cif": { source: "apache", extensions: ["cif"] },
  "chemical/x-cmdf": { source: "apache", extensions: ["cmdf"] },
  "chemical/x-cml": { source: "apache", extensions: ["cml"] },
  "chemical/x-csml": { source: "apache", extensions: ["csml"] },
  "chemical/x-xyz": { source: "apache", extensions: ["xyz"] },
  "font/collection": { source: "iana", extensions: ["ttc"] },
  "font/otf": { source: "iana", compressible: !0, extensions: ["otf"] },
  "font/ttf": { source: "iana", compressible: !0, extensions: ["ttf"] },
  "font/woff": { source: "iana", extensions: ["woff"] },
  "font/woff2": { source: "iana", extensions: ["woff2"] },
  "image/aces": { source: "iana", extensions: ["exr"] },
  "image/apng": { source: "iana", compressible: !1, extensions: ["apng"] },
  "image/avci": { source: "iana", extensions: ["avci"] },
  "image/avcs": { source: "iana", extensions: ["avcs"] },
  "image/avif": { source: "iana", compressible: !1, extensions: ["avif"] },
  "image/bmp": { source: "iana", compressible: !0, extensions: ["bmp", "dib"] },
  "image/cgm": { source: "iana", extensions: ["cgm"] },
  "image/dicom-rle": { source: "iana", extensions: ["drle"] },
  "image/dpx": { source: "iana", extensions: ["dpx"] },
  "image/emf": { source: "iana", extensions: ["emf"] },
  "image/fits": { source: "iana", extensions: ["fits"] },
  "image/g3fax": { source: "iana", extensions: ["g3"] },
  "image/gif": { source: "iana", compressible: !1, extensions: ["gif"] },
  "image/heic": { source: "iana", extensions: ["heic"] },
  "image/heic-sequence": { source: "iana", extensions: ["heics"] },
  "image/heif": { source: "iana", extensions: ["heif"] },
  "image/heif-sequence": { source: "iana", extensions: ["heifs"] },
  "image/hej2k": { source: "iana", extensions: ["hej2"] },
  "image/ief": { source: "iana", extensions: ["ief"] },
  "image/jaii": { source: "iana", extensions: ["jaii"] },
  "image/jais": { source: "iana", extensions: ["jais"] },
  "image/jls": { source: "iana", extensions: ["jls"] },
  "image/jp2": { source: "iana", compressible: !1, extensions: ["jp2", "jpg2"] },
  "image/jpeg": { source: "iana", compressible: !1, extensions: ["jpg", "jpeg", "jpe"] },
  "image/jph": { source: "iana", extensions: ["jph"] },
  "image/jphc": { source: "iana", extensions: ["jhc"] },
  "image/jpm": { source: "iana", compressible: !1, extensions: ["jpm", "jpgm"] },
  "image/jpx": { source: "iana", compressible: !1, extensions: ["jpx", "jpf"] },
  "image/jxl": { source: "iana", extensions: ["jxl"] },
  "image/jxr": { source: "iana", extensions: ["jxr"] },
  "image/jxra": { source: "iana", extensions: ["jxra"] },
  "image/jxrs": { source: "iana", extensions: ["jxrs"] },
  "image/jxs": { source: "iana", extensions: ["jxs"] },
  "image/jxsc": { source: "iana", extensions: ["jxsc"] },
  "image/jxsi": { source: "iana", extensions: ["jxsi"] },
  "image/jxss": { source: "iana", extensions: ["jxss"] },
  "image/ktx": { source: "iana", extensions: ["ktx"] },
  "image/ktx2": { source: "iana", extensions: ["ktx2"] },
  "image/pjpeg": { compressible: !1, extensions: ["jfif"] },
  "image/png": { source: "iana", compressible: !1, extensions: ["png"] },
  "image/prs.btif": { source: "iana", extensions: ["btif", "btf"] },
  "image/prs.pti": { source: "iana", extensions: ["pti"] },
  "image/sgi": { source: "apache", extensions: ["sgi"] },
  "image/svg+xml": { source: "iana", compressible: !0, extensions: ["svg", "svgz"] },
  "image/t38": { source: "iana", extensions: ["t38"] },
  "image/tiff": { source: "iana", compressible: !1, extensions: ["tif", "tiff"] },
  "image/tiff-fx": { source: "iana", extensions: ["tfx"] },
  "image/vnd.adobe.photoshop": { source: "iana", compressible: !0, extensions: ["psd"] },
  "image/vnd.airzip.accelerator.azv": { source: "iana", extensions: ["azv"] },
  "image/vnd.blockfact.facti": { source: "iana", extensions: ["facti"] },
  "image/vnd.dece.graphic": { source: "iana", extensions: ["uvi", "uvvi", "uvg", "uvvg"] },
  "image/vnd.djvu": { source: "iana", extensions: ["djvu", "djv"] },
  "image/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "image/vnd.dwg": { source: "iana", extensions: ["dwg"] },
  "image/vnd.dxf": { source: "iana", extensions: ["dxf"] },
  "image/vnd.fastbidsheet": { source: "iana", extensions: ["fbs"] },
  "image/vnd.fpx": { source: "iana", extensions: ["fpx"] },
  "image/vnd.fst": { source: "iana", extensions: ["fst"] },
  "image/vnd.fujixerox.edmics-mmr": { source: "iana", extensions: ["mmr"] },
  "image/vnd.fujixerox.edmics-rlc": { source: "iana", extensions: ["rlc"] },
  "image/vnd.microsoft.icon": { source: "iana", compressible: !0, extensions: ["ico"] },
  "image/vnd.ms-dds": { compressible: !0, extensions: ["dds"] },
  "image/vnd.ms-modi": { source: "iana", extensions: ["mdi"] },
  "image/vnd.ms-photo": { source: "apache", extensions: ["wdp"] },
  "image/vnd.net-fpx": { source: "iana", extensions: ["npx"] },
  "image/vnd.pco.b16": { source: "iana", extensions: ["b16"] },
  "image/vnd.tencent.tap": { source: "iana", extensions: ["tap"] },
  "image/vnd.valve.source.texture": { source: "iana", extensions: ["vtf"] },
  "image/vnd.wap.wbmp": { source: "iana", extensions: ["wbmp"] },
  "image/vnd.xiff": { source: "iana", extensions: ["xif"] },
  "image/vnd.zbrush.pcx": { source: "iana", extensions: ["pcx"] },
  "image/webp": { source: "iana", extensions: ["webp"] },
  "image/wmf": { source: "iana", extensions: ["wmf"] },
  "image/x-3ds": { source: "apache", extensions: ["3ds"] },
  "image/x-adobe-dng": { extensions: ["dng"] },
  "image/x-cmu-raster": { source: "apache", extensions: ["ras"] },
  "image/x-cmx": { source: "apache", extensions: ["cmx"] },
  "image/x-freehand": { source: "apache", extensions: ["fh", "fhc", "fh4", "fh5", "fh7"] },
  "image/x-icon": { source: "apache", compressible: !0, extensions: ["ico"] },
  "image/x-jng": { source: "nginx", extensions: ["jng"] },
  "image/x-mrsid-image": { source: "apache", extensions: ["sid"] },
  "image/x-ms-bmp": { source: "nginx", compressible: !0, extensions: ["bmp"] },
  "image/x-pcx": { source: "apache", extensions: ["pcx"] },
  "image/x-pict": { source: "apache", extensions: ["pic", "pct"] },
  "image/x-portable-anymap": { source: "apache", extensions: ["pnm"] },
  "image/x-portable-bitmap": { source: "apache", extensions: ["pbm"] },
  "image/x-portable-graymap": { source: "apache", extensions: ["pgm"] },
  "image/x-portable-pixmap": { source: "apache", extensions: ["ppm"] },
  "image/x-rgb": { source: "apache", extensions: ["rgb"] },
  "image/x-tga": { source: "apache", extensions: ["tga"] },
  "image/x-xbitmap": { source: "apache", extensions: ["xbm"] },
  "image/x-xpixmap": { source: "apache", extensions: ["xpm"] },
  "image/x-xwindowdump": { source: "apache", extensions: ["xwd"] },
  "message/disposition-notification": { source: "iana", extensions: ["disposition-notification"] },
  "message/global": { source: "iana", extensions: ["u8msg"] },
  "message/global-delivery-status": { source: "iana", extensions: ["u8dsn"] },
  "message/global-disposition-notification": { source: "iana", extensions: ["u8mdn"] },
  "message/global-headers": { source: "iana", extensions: ["u8hdr"] },
  "message/rfc822": { source: "iana", compressible: !0, extensions: ["eml", "mime", "mht", "mhtml"] },
  "message/vnd.wfa.wsc": { source: "iana", extensions: ["wsc"] },
  "model/3mf": { source: "iana", extensions: ["3mf"] },
  "model/gltf+json": { source: "iana", compressible: !0, extensions: ["gltf"] },
  "model/gltf-binary": { source: "iana", compressible: !0, extensions: ["glb"] },
  "model/iges": { source: "iana", compressible: !1, extensions: ["igs", "iges"] },
  "model/jt": { source: "iana", extensions: ["jt"] },
  "model/mesh": { source: "iana", compressible: !1, extensions: ["msh", "mesh", "silo"] },
  "model/mtl": { source: "iana", extensions: ["mtl"] },
  "model/obj": { source: "iana", extensions: ["obj"] },
  "model/prc": { source: "iana", extensions: ["prc"] },
  "model/step": { source: "iana", extensions: ["step", "stp", "stpnc", "p21", "210"] },
  "model/step+xml": { source: "iana", compressible: !0, extensions: ["stpx"] },
  "model/step+zip": { source: "iana", compressible: !1, extensions: ["stpz"] },
  "model/step-xml+zip": { source: "iana", compressible: !1, extensions: ["stpxz"] },
  "model/stl": { source: "iana", extensions: ["stl"] },
  "model/u3d": { source: "iana", extensions: ["u3d"] },
  "model/vnd.bary": { source: "iana", extensions: ["bary"] },
  "model/vnd.cld": { source: "iana", extensions: ["cld"] },
  "model/vnd.collada+xml": { source: "iana", compressible: !0, extensions: ["dae"] },
  "model/vnd.dwf": { source: "iana", extensions: ["dwf"] },
  "model/vnd.gdl": { source: "iana", extensions: ["gdl"] },
  "model/vnd.gtw": { source: "iana", extensions: ["gtw"] },
  "model/vnd.mts": { source: "iana", extensions: ["mts"] },
  "model/vnd.opengex": { source: "iana", extensions: ["ogex"] },
  "model/vnd.parasolid.transmit.binary": { source: "iana", extensions: ["x_b"] },
  "model/vnd.parasolid.transmit.text": { source: "iana", extensions: ["x_t"] },
  "model/vnd.pytha.pyox": { source: "iana", extensions: ["pyo", "pyox"] },
  "model/vnd.sap.vds": { source: "iana", extensions: ["vds"] },
  "model/vnd.usda": { source: "iana", extensions: ["usda"] },
  "model/vnd.usdz+zip": { source: "iana", compressible: !1, extensions: ["usdz"] },
  "model/vnd.valve.source.compiled-map": { source: "iana", extensions: ["bsp"] },
  "model/vnd.vtu": { source: "iana", extensions: ["vtu"] },
  "model/vrml": { source: "iana", compressible: !1, extensions: ["wrl", "vrml"] },
  "model/x3d+binary": { source: "apache", compressible: !1, extensions: ["x3db", "x3dbz"] },
  "model/x3d+fastinfoset": { source: "iana", extensions: ["x3db"] },
  "model/x3d+vrml": { source: "apache", compressible: !1, extensions: ["x3dv", "x3dvz"] },
  "model/x3d+xml": { source: "iana", compressible: !0, extensions: ["x3d", "x3dz"] },
  "model/x3d-vrml": { source: "iana", extensions: ["x3dv"] },
  "text/cache-manifest": { source: "iana", compressible: !0, extensions: ["appcache", "manifest"] },
  "text/calendar": { source: "iana", extensions: ["ics", "ifb"] },
  "text/coffeescript": { extensions: ["coffee", "litcoffee"] },
  "text/css": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["css"] },
  "text/csv": { source: "iana", compressible: !0, extensions: ["csv"] },
  "text/html": { source: "iana", compressible: !0, extensions: ["html", "htm", "shtml"] },
  "text/jade": { extensions: ["jade"] },
  "text/javascript": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["js", "mjs"] },
  "text/jsx": { compressible: !0, extensions: ["jsx"] },
  "text/less": { compressible: !0, extensions: ["less"] },
  "text/markdown": { source: "iana", compressible: !0, extensions: ["md", "markdown"] },
  "text/mathml": { source: "nginx", extensions: ["mml"] },
  "text/mdx": { compressible: !0, extensions: ["mdx"] },
  "text/n3": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["n3"] },
  "text/plain": { source: "iana", compressible: !0, extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"] },
  "text/prs.lines.tag": { source: "iana", extensions: ["dsc"] },
  "text/richtext": { source: "iana", compressible: !0, extensions: ["rtx"] },
  "text/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "text/sgml": { source: "iana", extensions: ["sgml", "sgm"] },
  "text/shex": { source: "iana", extensions: ["shex"] },
  "text/slim": { extensions: ["slim", "slm"] },
  "text/spdx": { source: "iana", extensions: ["spdx"] },
  "text/stylus": { extensions: ["stylus", "styl"] },
  "text/tab-separated-values": { source: "iana", compressible: !0, extensions: ["tsv"] },
  "text/troff": { source: "iana", extensions: ["t", "tr", "roff", "man", "me", "ms"] },
  "text/turtle": { source: "iana", charset: "UTF-8", extensions: ["ttl"] },
  "text/uri-list": { source: "iana", compressible: !0, extensions: ["uri", "uris", "urls"] },
  "text/vcard": { source: "iana", compressible: !0, extensions: ["vcard"] },
  "text/vnd.curl": { source: "iana", extensions: ["curl"] },
  "text/vnd.curl.dcurl": { source: "apache", extensions: ["dcurl"] },
  "text/vnd.curl.mcurl": { source: "apache", extensions: ["mcurl"] },
  "text/vnd.curl.scurl": { source: "apache", extensions: ["scurl"] },
  "text/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "text/vnd.familysearch.gedcom": { source: "iana", extensions: ["ged"] },
  "text/vnd.fly": { source: "iana", extensions: ["fly"] },
  "text/vnd.fmi.flexstor": { source: "iana", extensions: ["flx"] },
  "text/vnd.graphviz": { source: "iana", extensions: ["gv"] },
  "text/vnd.in3d.3dml": { source: "iana", extensions: ["3dml"] },
  "text/vnd.in3d.spot": { source: "iana", extensions: ["spot"] },
  "text/vnd.sun.j2me.app-descriptor": { source: "iana", charset: "UTF-8", extensions: ["jad"] },
  "text/vnd.wap.wml": { source: "iana", extensions: ["wml"] },
  "text/vnd.wap.wmlscript": { source: "iana", extensions: ["wmls"] },
  "text/vtt": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["vtt"] },
  "text/wgsl": { source: "iana", extensions: ["wgsl"] },
  "text/x-asm": { source: "apache", extensions: ["s", "asm"] },
  "text/x-c": { source: "apache", extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"] },
  "text/x-component": { source: "nginx", extensions: ["htc"] },
  "text/x-fortran": { source: "apache", extensions: ["f", "for", "f77", "f90"] },
  "text/x-handlebars-template": { extensions: ["hbs"] },
  "text/x-java-source": { source: "apache", extensions: ["java"] },
  "text/x-lua": { extensions: ["lua"] },
  "text/x-markdown": { compressible: !0, extensions: ["mkd"] },
  "text/x-nfo": { source: "apache", extensions: ["nfo"] },
  "text/x-opml": { source: "apache", extensions: ["opml"] },
  "text/x-org": { compressible: !0, extensions: ["org"] },
  "text/x-pascal": { source: "apache", extensions: ["p", "pas"] },
  "text/x-processing": { compressible: !0, extensions: ["pde"] },
  "text/x-sass": { extensions: ["sass"] },
  "text/x-scss": { extensions: ["scss"] },
  "text/x-setext": { source: "apache", extensions: ["etx"] },
  "text/x-sfv": { source: "apache", extensions: ["sfv"] },
  "text/x-suse-ymp": { compressible: !0, extensions: ["ymp"] },
  "text/x-uuencode": { source: "apache", extensions: ["uu"] },
  "text/x-vcalendar": { source: "apache", extensions: ["vcs"] },
  "text/x-vcard": { source: "apache", extensions: ["vcf"] },
  "text/xml": { source: "iana", compressible: !0, extensions: ["xml"] },
  "text/yaml": { compressible: !0, extensions: ["yaml", "yml"] },
  "video/3gpp": { source: "iana", extensions: ["3gp", "3gpp"] },
  "video/3gpp2": { source: "iana", extensions: ["3g2"] },
  "video/h261": { source: "iana", extensions: ["h261"] },
  "video/h263": { source: "iana", extensions: ["h263"] },
  "video/h264": { source: "iana", extensions: ["h264"] },
  "video/iso.segment": { source: "iana", extensions: ["m4s"] },
  "video/jpeg": { source: "iana", extensions: ["jpgv"] },
  "video/jpm": { source: "apache", extensions: ["jpm", "jpgm"] },
  "video/mj2": { source: "iana", extensions: ["mj2", "mjp2"] },
  "video/mp2t": { source: "iana", extensions: ["ts", "m2t", "m2ts", "mts"] },
  "video/mp4": { source: "iana", compressible: !1, extensions: ["mp4", "mp4v", "mpg4"] },
  "video/mpeg": { source: "iana", compressible: !1, extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"] },
  "video/ogg": { source: "iana", compressible: !1, extensions: ["ogv"] },
  "video/quicktime": { source: "iana", compressible: !1, extensions: ["qt", "mov"] },
  "video/vnd.dece.hd": { source: "iana", extensions: ["uvh", "uvvh"] },
  "video/vnd.dece.mobile": { source: "iana", extensions: ["uvm", "uvvm"] },
  "video/vnd.dece.pd": { source: "iana", extensions: ["uvp", "uvvp"] },
  "video/vnd.dece.sd": { source: "iana", extensions: ["uvs", "uvvs"] },
  "video/vnd.dece.video": { source: "iana", extensions: ["uvv", "uvvv"] },
  "video/vnd.dvb.file": { source: "iana", extensions: ["dvb"] },
  "video/vnd.fvt": { source: "iana", extensions: ["fvt"] },
  "video/vnd.mpegurl": { source: "iana", extensions: ["mxu", "m4u"] },
  "video/vnd.ms-playready.media.pyv": { source: "iana", extensions: ["pyv"] },
  "video/vnd.uvvu.mp4": { source: "iana", extensions: ["uvu", "uvvu"] },
  "video/vnd.vivo": { source: "iana", extensions: ["viv"] },
  "video/webm": { source: "apache", compressible: !1, extensions: ["webm"] },
  "video/x-f4v": { source: "apache", extensions: ["f4v"] },
  "video/x-fli": { source: "apache", extensions: ["fli"] },
  "video/x-flv": { source: "apache", compressible: !1, extensions: ["flv"] },
  "video/x-m4v": { source: "apache", extensions: ["m4v"] },
  "video/x-matroska": { source: "apache", compressible: !1, extensions: ["mkv", "mk3d", "mks"] },
  "video/x-mng": { source: "apache", extensions: ["mng"] },
  "video/x-ms-asf": { source: "apache", extensions: ["asf", "asx"] },
  "video/x-ms-vob": { source: "apache", extensions: ["vob"] },
  "video/x-ms-wm": { source: "apache", extensions: ["wm"] },
  "video/x-ms-wmv": { source: "apache", compressible: !1, extensions: ["wmv"] },
  "video/x-ms-wmx": { source: "apache", extensions: ["wmx"] },
  "video/x-ms-wvx": { source: "apache", extensions: ["wvx"] },
  "video/x-msvideo": { source: "apache", extensions: ["avi"] },
  "video/x-sgi-movie": { source: "apache", extensions: ["movie"] },
  "video/x-smv": { source: "apache", extensions: ["smv"] },
  "x-conference/x-cooltalk": { source: "apache", extensions: ["ice"] }
};
function m_(e) {
  const t = /\*\.(\w+)/g, n = [];
  let a;
  for (; (a = t.exec(e)) !== null; )
    n.push("." + a[1]);
  return n;
}
function Lp(e) {
  switch (e) {
    case j.EN:
      return "English";
    case j.IT:
      return "Italiano";
    case j.BG:
      return "Български";
    case j.ZH_HANS:
      return "汉语";
    case j.HR:
      return "Hrvatski";
    case j.CS:
      return "Čeština";
    case j.DA:
      return "Dansk";
    case j.NL:
      return "Nederlands";
    case j.FR:
      return "Français";
    case j.DE:
      return "Deutsch";
    case j.HU:
      return "Magyar";
    case j.JA:
      return "日本語";
    case j.KO:
      return "한국어";
    case j.LT:
      return "Lietuvių";
    case j.PL:
      return "Polski";
    case j.PT:
      return "Português";
    case j.RO:
      return "Română";
    case j.SK:
      return "Slovenčina";
    case j.SL:
      return "Slovenščina";
    case j.ES:
      return "Español";
    case j.SV:
      return "Svenska";
    case j.TR:
      return "Türkçe";
    default:
      return e;
  }
}
function A_(e) {
  if (e.toLowerCase().endsWith(".mobile.json"))
    return e.slice(0, -12);
  const t = e.lastIndexOf(".");
  return t === -1 ? e : e.substring(0, t);
}
function nc(e) {
  if (!e || Math.floor(e) === e) return 0;
  const t = e.toString();
  return t.indexOf(".") !== -1 && t.indexOf("-") !== -1 ? t.split("-")[1] || 0 : t.indexOf(".") !== -1 ? t.split(".")[1].length || 0 : t.split("-")[1] || 0;
}
function Zi(e, t = 2) {
  if (!+e) return "0 Bytes";
  const n = 1024, a = t < 0 ? 0 : t, s = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], o = Math.floor(Math.log(e) / Math.log(n));
  return `${parseFloat((e / Math.pow(n, o)).toFixed(a))} ${s[o]}`;
}
function g_() {
  return window.screen.width < 520;
}
function h_() {
  const e = window.screen.width;
  return 520 < e && e < 1e3;
}
function v_(e, t) {
  var n;
  (n = document.getElementById(t)) == null || n.classList.add(e);
}
function b_(e, t) {
  var n;
  (n = document.getElementById(t)) == null || n.classList.remove(e);
}
function x_(e, t) {
  const n = document.getElementsByClassName(t);
  n && n[0].classList.add(e);
}
function y_(e, t) {
  const n = document.getElementsByClassName(t);
  n && n[0].classList.remove(e);
}
function E_(e) {
  const t = document.getElementsByClassName(e);
  t.length > 0 && (t[0].style.height = "100vh");
}
function C_(e) {
  const t = document.getElementsByClassName(e);
  if (t.length > 0) {
    const n = t[0];
    n.style.height = "";
  }
}
function Dp() {
  const e = document.getElementById("btn_profile");
  e && (e.style.marginTop = "0.28rem");
}
function B_(e) {
  return e && e.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(t, n) {
    return +t == 0 ? "" : n === 0 ? t.toLowerCase() : t.toUpperCase();
  });
}
function I_(e, t) {
  const n = t.messages.value;
  for (const a in n)
    for (const s in n[a]) {
      const o = n[a][s];
      if (o[e] !== void 0)
        return o[e];
    }
  return e;
}
function w_(e) {
  let t = "";
  const n = new Uint8Array(e), a = n.byteLength;
  for (let s = 0; s < a; s++)
    t += String.fromCharCode(n[s]);
  return window.btoa(t);
}
function k_(e) {
  return e instanceof Date && !isNaN(Number(e));
}
function Mp(e) {
  const t = /* @__PURE__ */ new Set();
  return e.split(",").map((n) => n.trim()).forEach((n) => {
    if (n.startsWith("."))
      t.add(n);
    else if (n in to)
      to[n].extensions.forEach((a) => t.add(`.${a}`));
    else if (n.endsWith("/*")) {
      const a = n.slice(0, -2);
      Object.entries(to).forEach(([s, o]) => {
        s.startsWith(a) && o.extensions.forEach((i) => t.add(`.${i}`));
      });
    }
  }), Array.from(t);
}
function ac(e, t) {
  if (t) {
    const n = Mp(t);
    return e.some((a) => {
      const s = a.split(".").pop() || "";
      return !n.includes(`.${s.toLowerCase()}`);
    });
  } else
    return e.some((n) => {
      const a = n.split(".").pop() || "";
      return !ec.includes(`.${a.toLowerCase()}`);
    });
}
function vs(e) {
  return Sn().getAssetUrl(`/icons/${e}.svg`);
}
function __(e) {
  switch ((e ?? "").toLowerCase().replace(/^\./, "")) {
    case "pdf":
      return new URL("/img/pdf_file_icon.png", import.meta.url).href;
    case "zip":
      return new URL("/img/zip_file_icon.png", import.meta.url).href;
    case "docx":
      return new URL("/img/docx_file_icon.png", import.meta.url).href;
    case "xlsx":
      return new URL("/img/xlsx_file_icon.png", import.meta.url).href;
    case "txt":
      return new URL("/img/txt_file_icon.png", import.meta.url).href;
    case "pts":
      return new URL("/img/txt_file_icon.png", import.meta.url).href;
    case "xml":
      return new URL("/img/xml_file_icon.png", import.meta.url).href;
    case "constructioninfo":
      return new URL("/img/xml_file_icon.png", import.meta.url).href;
    default:
      return new URL("/img/pdf-icon.png", import.meta.url).href;
  }
}
function S_() {
  return hs.theme.palette;
}
function T_() {
  return {
    name: hs.theme.color.name,
    palette: hs.theme.color.palette
  };
}
function Op(e) {
  document.documentElement.classList.toggle("p-dark", e === "dark"), document.documentElement.classList.toggle("app-dark", e === "dark"), localStorage.setItem("colorScheme", JSON.stringify(e));
}
function L_() {
  const { layout: e } = hs.theme;
  Op(e);
}
function D_() {
  const e = document.getElementById("app");
  e && (e.style.background = "radial-gradient(41.26% 792.78% at 49.97% 506.11%, rgba(20, 48, 94, 0.80) 5.22%, rgba(11, 14, 26, 0.80) 100%)", e.style.height = "100%", e.style.overflowY = "hidden");
}
function M_() {
  const e = document.getElementById("app");
  e && (e.style.background = "linear-gradient(to top, #286AAD 1%, #0b0e1a 105%)");
}
function bo(e) {
  return Sn().getAssetUrl(`/img/${e}.png`);
}
function Ja(e) {
  return Sn().getAssetUrl(`/icons/${e}.svg`);
}
function O_(e, t) {
  var n;
  return (n = Object.entries(e).find(([, a]) => a === t)) == null ? void 0 : n[0];
}
function N_(e) {
  const t = JSON.stringify(e), a = new TextEncoder().encode(t);
  let s = "";
  return a.forEach((o) => s += String.fromCharCode(o)), btoa(s);
}
function R_(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let o = 0; o < t.length; o++)
    n[o] = t.charCodeAt(o);
  const s = new TextDecoder().decode(n);
  return JSON.parse(s);
}
let xo = null;
function P_(e) {
  xo = e.global;
}
function Np() {
  return xo || (console.warn("[lib] i18n not initialized. Returning fallback composer."), {
    t: (e) => e
    // just echoes the key back
    // you can add other methods as needed (d, n, locale, etc.)
  });
}
function Ce(e, t) {
  const n = Np();
  return t === void 0 ? n.t(e) : n.t(e, t);
}
function Rp(e, t) {
  const n = t.startsWith(".") ? t : `.${t}`;
  return e.replace(/\.[^/.]+$/, "") + n;
}
function F_(e, t) {
  const n = new URL(e), a = n.searchParams.get("file_name");
  if (a) {
    const s = Rp(a, t);
    n.searchParams.set("file_name", s);
  }
  return n.toString();
}
function Q_(e) {
  const n = new URL(e).searchParams.get("file_name");
  if (!n) return null;
  const a = n.match(/\.[^/.]+$/);
  return a ? a[0] : null;
}
const Pp = ".pdf,.zip,.doc,.docx,.doc,.txt", Fp = ".png,.jpg,.jpeg,.bmp", U_ = ".png,.jpg,.jpeg,.bmp,.svg,.heic,.heif", Qp = ".mhd,.nii,.nii.gz,.nrrd", sc = ".stl,.ply,.obj", Y_ = ".mtl,.png,.jpg,.jpeg", G_ = ".zip,.nii.gz,.nii,.dcm", Up = sc.split(","), j_ = ".off,.x3d,.cam5zip";
function H_(e) {
  var n;
  if (!e)
    return !1;
  const t = (n = e.split(".").pop()) == null ? void 0 : n.toLowerCase();
  return Up.includes(`.${t}`);
}
function V_(e) {
  const t = e.indexOf("/");
  return t !== -1 ? e.substring(0, t) : e;
}
function K_(e, t) {
  let n = 0;
  for (const a of e)
    (a.label === t || a.parent === t) && n++;
  return n;
}
function W_(e, t) {
  for (const n of e)
    if (n.label === t)
      return !0;
  return !1;
}
function z_(e, t) {
  let n = "";
  for (const a of e)
    if (a.label === t)
      return a.key;
  return n;
}
function $_(e) {
  const t = {}, n = [];
  return e.forEach((a) => {
    if (t[a.key] = {
      // Store nodes by key
      key: a.key,
      label: a.label,
      icon: a.icon,
      data: {}
    }, a.parent !== "root") {
      const s = t[a.parentKey];
      s && (s.children || (s.children = []), s.children.push(t[a.key]));
    } else
      n.push(t[a.key]);
  }), n;
}
function J_(e) {
  const n = e / 1048576;
  return n < 1 ? (n * 1024).toFixed(2) + " KB" : n >= 1024 ? (n / 1024).toFixed(2) + " GB" : n.toFixed(2) + " MB";
}
const Yp = [...Pp.split(","), ...Fp.split(","), ...Qp.split(","), ...sc.split(",")].map((e) => e.trim().replace(".", "\\.")).sort((e, t) => t.length - e.length), Gp = new RegExp(
  `(${Yp.join("|")})\\b`,
  // match extension followed by word boundary
  "gi"
);
function q_(e) {
  return e.replace(Gp, "").replace(/\s+$/, "");
}
function X_(e, t) {
  if (t > e)
    return "step-done";
  if (t === e)
    return "current-step";
  if (t < e)
    return "next-step";
}
function Z_(e, t) {
  return t === e ? "text-selected-step" : "text-default-step";
}
function e1(e) {
  try {
    if (!e || typeof e != "string")
      throw new Error("Invalid JSON input");
    const t = JSON.parse(e), n = t == null ? void 0 : t.color;
    return {
      "red-status": n === "red",
      "orange-status": n === "orange",
      "green-status": n === "green"
    };
  } catch {
    return {
      "red-status": !1,
      "orange-status": !1,
      "green-status": !1
    };
  }
}
function t1(e) {
  try {
    const t = JSON.parse(e).color;
    switch (t) {
      case "red":
        return "#FF0000";
      case "green":
        return "#43C261";
      case "orange":
        return "#FFA500";
      case "white":
        return "#FFFFFF";
      default:
        return `${t}`;
    }
  } catch {
    return "#FFFFFF";
  }
}
function n1(e) {
  try {
    return JSON.parse(e).append_message;
  } catch {
    return "";
  }
}
function a1(e) {
  return e.startsWith("base64, ") ? atob(e.slice(8)) : e.slice(8);
}
function s1(e) {
  return e.startsWith("base64, ") ? e.slice(8) : btoa(e.slice(8));
}
const oc = "https://www.3diemme.it/en/tutorial-videos/", jp = "https://realguide.com/en/video/", ic = "https://get.teamviewer.com/jrunq9w";
function o1() {
  window.location.host.startsWith("localhost:5") ? window.open("http://localhost:8080/admin", "_blank") : window.open("/admin", "_blank");
}
function i1() {
  window.location.host.startsWith("localhost:5") ? window.open("http://localhost:8080/auth/forgot-password", "_blank") : window.open("/auth/forgot-password", "_blank");
}
function Hp(e) {
  return (e == null ? void 0 : e.trim().toLowerCase()) === "zimvie";
}
function Vp(e) {
  return Hp(e) ? jp : oc;
}
function r1(e, t) {
  const n = t ?? Vp(e);
  window.open(n, "_blank");
}
function l1(e = ic) {
  window.open(e, "_blank");
}
function c1() {
  window.open("/planner/patients", "_blank");
}
function u1(e) {
  window.location.host.startsWith("localhost") ? window.open(`https://gama-cloud.medicteam.io/weblink/prod-center-selection?loginToken=${e}`, "_blank") : window.open(`/weblink/prod-center-selection?loginToken=${e}`, "_blank");
}
function d1(e, t, n) {
  window.open(`https://helpdesk.3diemme.it/Tickets/New?cf10=${e}&cf9=${t}&cf11=${n}`, "_blank");
}
function f1() {
  return !1;
}
function p1() {
  return !0;
}
const Kp = "sessionId";
function m1(e) {
  if (typeof document > "u")
    return;
  const n = typeof window < "u" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${Kp}=${encodeURIComponent(e)}; Path=/; SameSite=Lax${n}`;
}
var Wp = /* @__PURE__ */ ((e) => (e[e.DEFAULT_APP = 0] = "DEFAULT_APP", e[e.BELLATEK = 1] = "BELLATEK", e))(Wp || {}), ci = /* @__PURE__ */ ((e) => (e.IMPLANT_PLANNER = "ImplantPlannerApp", e.WEBLINK = "WeblinkViewerApp", e))(ci || {});
function zp(e) {
  e.config.globalProperties.$appState = Kt({ colorScheme: "dark" });
  const t = localStorage.getItem("colorScheme");
  t && JSON.parse(t) === na.DARK && document.documentElement.classList.toggle("p-dark"), e._component.__name !== ci.IMPLANT_PLANNER && (e.use(Kd), e.use(Rf)), e.directive("tooltip", Ff), e.directive("badge", Nd), e.component("Accordion", Td), e.component("AccordionTab", Ld), e.component("AutoComplete", Sd), e.component("Avatar", Dd), e.component("AvatarGroup", Md), e.component("Badge", Od), e.component("Breadcrumb", Rd), e.component("Button", gn), e.component("Calendar", Pd), e.component("Card", Fd), e.component("Carousel", Ud), e.component("CascadeSelect", Qd), e.component("Checkbox", Yd), e.component("Chip", jl), e.component("Chips", Gd), e.component("ColorPicker", si), e.component("Column", jd), e.component("ConfirmDialog", Hd), e.component("ConfirmPopup", Vd), e.component("ContextMenu", Hl), e.component("DataTable", Wd), e.component("Dialog", Vl), e.component("Divider", Kl), e.component("Dropdown", zd), e.component("Fieldset", $d), e.component("FileUpload", Jd), e.component("Galleria", qd), e.component("Image", Wl), e.component("InlineMessage", Xd), e.component("Inplace", Zd), e.component("InputMask", ef), e.component("InputNumber", Ds), e.component("InputSwitch", zl), e.component("InputText", oi), e.component("Knob", tf), e.component("Listbox", $l), e.component("MegaMenu", nf), e.component("Menu", af), e.component("Menubar", sf), e.component("Message", of), e.component("MultiSelect", rf), e.component("OrderList", lf), e.component("OrganizationChart", cf), e.component("Popover", La), e.component("Paginator", uf), e.component("Panel", df), e.component("PanelMenu", ff), e.component("Password", pf), e.component("PickList", mf), e.component("ProgressBar", Af), e.component("RadioButton", hf), e.component("Rating", gf), e.component("SelectButton", vf), e.component("ScrollPanel", bf), e.component("ScrollTop", xf), e.component("Slider", ii), e.component("Sidebar", Ef), e.component("Skeleton", yf), e.component("SplitButton", Cf), e.component("Splitter", Bf), e.component("SplitterPanel", If), e.component("Steps", wf), e.component("TabMenu", kf), e.component("TabView", Df), e.component("TabPanel", Mf), e.component("Tag", Of), e.component("Textarea", Sf), e.component("TieredMenu", _f), e.component("Timeline", Nf), e.component("Toast", Tf), e.component("Toolbar", Lf), e.component("ToggleButton", Pf), e.component("Tree", Qf), e.component("TreeSelect", Uf), e.component("TreeTable", Yf);
}
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function $p(e, t, n) {
  return (t = qp(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function er(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function P(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? er(Object(n), !0).forEach(function(a) {
      $p(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : er(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function Jp(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qp(e) {
  var t = Jp(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const tr = () => {
};
let ui = {}, rc = {}, lc = null, cc = {
  mark: tr,
  measure: tr
};
try {
  typeof window < "u" && (ui = window), typeof document < "u" && (rc = document), typeof MutationObserver < "u" && (lc = MutationObserver), typeof performance < "u" && (cc = performance);
} catch {
}
const {
  userAgent: nr = ""
} = ui.navigator || {}, xn = ui, _e = rc, ar = lc, qa = cc;
xn.document;
const dn = !!_e.documentElement && !!_e.head && typeof _e.addEventListener == "function" && typeof _e.createElement == "function", uc = ~nr.indexOf("MSIE") || ~nr.indexOf("Trident/");
var Xp = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, Zp = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, dc = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, em = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, fc = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], et = "classic", Ns = "duotone", tm = "sharp", nm = "sharp-duotone", pc = [et, Ns, tm, nm], am = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, sm = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, om = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), im = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, rm = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], sr = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, lm = ["kit"], cm = {
  kit: {
    "fa-kit": "fak"
  }
}, um = ["fak", "fakd"], dm = {
  kit: {
    fak: "fa-kit"
  }
}, or = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Xa = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, fm = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], pm = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], mm = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Am = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, gm = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, yo = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, hm = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Eo = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...fm, ...hm], vm = ["solid", "regular", "light", "thin", "duotone", "brands"], mc = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], bm = mc.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), xm = [...Object.keys(gm), ...vm, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Xa.GROUP, Xa.SWAP_OPACITY, Xa.PRIMARY, Xa.SECONDARY].concat(mc.map((e) => "".concat(e, "x"))).concat(bm.map((e) => "w-".concat(e))), ym = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const on = "___FONT_AWESOME___", Co = 16, Ac = "fa", gc = "svg-inline--fa", Fn = "data-fa-i2svg", Bo = "data-fa-pseudo-element", Em = "data-fa-pseudo-element-pending", di = "data-prefix", fi = "data-icon", ir = "fontawesome-i2svg", Cm = "async", Bm = ["HTML", "HEAD", "STYLE", "SCRIPT"], hc = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Va(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[et];
    }
  });
}
const vc = P({}, dc);
vc[et] = P(P(P(P({}, {
  "fa-duotone": "duotone"
}), dc[et]), sr.kit), sr["kit-duotone"]);
const Im = Va(vc), Io = P({}, im);
Io[et] = P(P(P(P({}, {
  duotone: "fad"
}), Io[et]), or.kit), or["kit-duotone"]);
const rr = Va(Io), wo = P({}, yo);
wo[et] = P(P({}, wo[et]), dm.kit);
const pi = Va(wo), ko = P({}, Am);
ko[et] = P(P({}, ko[et]), cm.kit);
Va(ko);
const wm = Xp, bc = "fa-layers-text", km = Zp, _m = P({}, am);
Va(_m);
const Sm = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], no = em, Tm = [...lm, ...xm], Ea = xn.FontAwesomeConfig || {};
function Lm(e) {
  var t = _e.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Dm(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
_e && typeof _e.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, a] = t;
  const s = Dm(Lm(n));
  s != null && (Ea[a] = s);
});
const xc = {
  styleDefault: "solid",
  familyDefault: et,
  cssPrefix: Ac,
  replacementClass: gc,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Ea.familyPrefix && (Ea.cssPrefix = Ea.familyPrefix);
const aa = P(P({}, xc), Ea);
aa.autoReplaceSvg || (aa.observeMutations = !1);
const $ = {};
Object.keys(xc).forEach((e) => {
  Object.defineProperty($, e, {
    enumerable: !0,
    set: function(t) {
      aa[e] = t, Ca.forEach((n) => n($));
    },
    get: function() {
      return aa[e];
    }
  });
});
Object.defineProperty($, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    aa.cssPrefix = e, Ca.forEach((t) => t($));
  },
  get: function() {
    return aa.cssPrefix;
  }
});
xn.FontAwesomeConfig = $;
const Ca = [];
function Mm(e) {
  return Ca.push(e), () => {
    Ca.splice(Ca.indexOf(e), 1);
  };
}
const mn = Co, Yt = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Om(e) {
  if (!e || !dn)
    return;
  const t = _e.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = _e.head.childNodes;
  let a = null;
  for (let s = n.length - 1; s > -1; s--) {
    const o = n[s], i = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(i) > -1 && (a = o);
  }
  return _e.head.insertBefore(t, a), e;
}
const Nm = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Da() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += Nm[Math.random() * 62 | 0];
  return t;
}
function ua(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function mi(e) {
  return e.classList ? ua(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function yc(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Rm(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(yc(e[n]), '" '), "").trim();
}
function Rs(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Ai(e) {
  return e.size !== Yt.size || e.x !== Yt.x || e.y !== Yt.y || e.rotate !== Yt.rotate || e.flipX || e.flipY;
}
function Pm(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: a
  } = e;
  const s = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), i = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), r = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(i, " ").concat(r)
  }, c = {
    transform: "translate(".concat(a / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: l,
    path: c
  };
}
function Fm(e) {
  let {
    transform: t,
    width: n = Co,
    height: a = Co,
    startCentered: s = !1
  } = e, o = "";
  return s && uc ? o += "translate(".concat(t.x / mn - n / 2, "em, ").concat(t.y / mn - a / 2, "em) ") : s ? o += "translate(calc(-50% + ".concat(t.x / mn, "em), calc(-50% + ").concat(t.y / mn, "em)) ") : o += "translate(".concat(t.x / mn, "em, ").concat(t.y / mn, "em) "), o += "scale(".concat(t.size / mn * (t.flipX ? -1 : 1), ", ").concat(t.size / mn * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var Qm = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function Ec() {
  const e = Ac, t = gc, n = $.cssPrefix, a = $.replacementClass;
  let s = Qm;
  if (n !== e || a !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), i = new RegExp("\\--".concat(e, "\\-"), "g"), r = new RegExp("\\.".concat(t), "g");
    s = s.replace(o, ".".concat(n, "-")).replace(i, "--".concat(n, "-")).replace(r, ".".concat(a));
  }
  return s;
}
let lr = !1;
function ao() {
  $.autoAddCss && !lr && (Om(Ec()), lr = !0);
}
var Um = {
  mixout() {
    return {
      dom: {
        css: Ec,
        insertCss: ao
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ao();
      },
      beforeI2svg() {
        ao();
      }
    };
  }
};
const rn = xn || {};
rn[on] || (rn[on] = {});
rn[on].styles || (rn[on].styles = {});
rn[on].hooks || (rn[on].hooks = {});
rn[on].shims || (rn[on].shims = []);
var Gt = rn[on];
const Cc = [], Bc = function() {
  _e.removeEventListener("DOMContentLoaded", Bc), bs = 1, Cc.map((e) => e());
};
let bs = !1;
dn && (bs = (_e.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(_e.readyState), bs || _e.addEventListener("DOMContentLoaded", Bc));
function Ym(e) {
  dn && (bs ? setTimeout(e, 0) : Cc.push(e));
}
function Ka(e) {
  const {
    tag: t,
    attributes: n = {},
    children: a = []
  } = e;
  return typeof e == "string" ? yc(e) : "<".concat(t, " ").concat(Rm(n), ">").concat(a.map(Ka).join(""), "</").concat(t, ">");
}
function cr(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var so = function(t, n, a, s) {
  var o = Object.keys(t), i = o.length, r = n, l, c, u;
  for (a === void 0 ? (l = 1, u = t[o[0]]) : (l = 0, u = a); l < i; l++)
    c = o[l], u = r(u, t[c], c, t);
  return u;
};
function Gm(e) {
  const t = [];
  let n = 0;
  const a = e.length;
  for (; n < a; ) {
    const s = e.charCodeAt(n++);
    if (s >= 55296 && s <= 56319 && n < a) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((s & 1023) << 10) + (o & 1023) + 65536) : (t.push(s), n--);
    } else
      t.push(s);
  }
  return t;
}
function _o(e) {
  const t = Gm(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function jm(e, t) {
  const n = e.length;
  let a = e.charCodeAt(t), s;
  return a >= 55296 && a <= 56319 && n > t + 1 && (s = e.charCodeAt(t + 1), s >= 56320 && s <= 57343) ? (a - 55296) * 1024 + s - 56320 + 65536 : a;
}
function ur(e) {
  return Object.keys(e).reduce((t, n) => {
    const a = e[n];
    return !!a.icon ? t[a.iconName] = a.icon : t[n] = a, t;
  }, {});
}
function So(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: a = !1
  } = n, s = ur(t);
  typeof Gt.hooks.addPack == "function" && !a ? Gt.hooks.addPack(e, ur(t)) : Gt.styles[e] = P(P({}, Gt.styles[e] || {}), s), e === "fas" && So("fa", t);
}
const {
  styles: Ma,
  shims: Hm
} = Gt, Ic = Object.keys(pi), Vm = Ic.reduce((e, t) => (e[t] = Object.keys(pi[t]), e), {});
let gi = null, wc = {}, kc = {}, _c = {}, Sc = {}, Tc = {};
function Km(e) {
  return ~Tm.indexOf(e);
}
function Wm(e, t) {
  const n = t.split("-"), a = n[0], s = n.slice(1).join("-");
  return a === e && s !== "" && !Km(s) ? s : null;
}
const Lc = () => {
  const e = (a) => so(Ma, (s, o, i) => (s[i] = so(o, a, {}), s), {});
  wc = e((a, s, o) => (s[3] && (a[s[3]] = o), s[2] && s[2].filter((r) => typeof r == "number").forEach((r) => {
    a[r.toString(16)] = o;
  }), a)), kc = e((a, s, o) => (a[o] = o, s[2] && s[2].filter((r) => typeof r == "string").forEach((r) => {
    a[r] = o;
  }), a)), Tc = e((a, s, o) => {
    const i = s[2];
    return a[o] = o, i.forEach((r) => {
      a[r] = o;
    }), a;
  });
  const t = "far" in Ma || $.autoFetchSvg, n = so(Hm, (a, s) => {
    const o = s[0];
    let i = s[1];
    const r = s[2];
    return i === "far" && !t && (i = "fas"), typeof o == "string" && (a.names[o] = {
      prefix: i,
      iconName: r
    }), typeof o == "number" && (a.unicodes[o.toString(16)] = {
      prefix: i,
      iconName: r
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  _c = n.names, Sc = n.unicodes, gi = Ps($.styleDefault, {
    family: $.familyDefault
  });
};
Mm((e) => {
  gi = Ps(e.styleDefault, {
    family: $.familyDefault
  });
});
Lc();
function hi(e, t) {
  return (wc[e] || {})[t];
}
function zm(e, t) {
  return (kc[e] || {})[t];
}
function Nn(e, t) {
  return (Tc[e] || {})[t];
}
function Dc(e) {
  return _c[e] || {
    prefix: null,
    iconName: null
  };
}
function $m(e) {
  const t = Sc[e], n = hi("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function yn() {
  return gi;
}
const Mc = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function Jm(e) {
  let t = et;
  const n = Ic.reduce((a, s) => (a[s] = "".concat($.cssPrefix, "-").concat(s), a), {});
  return pc.forEach((a) => {
    (e.includes(n[a]) || e.some((s) => Vm[a].includes(s))) && (t = a);
  }), t;
}
function Ps(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = et
  } = t, a = Im[n][e];
  if (n === Ns && !e)
    return "fad";
  const s = rr[n][e] || rr[n][a], o = e in Gt.styles ? e : null;
  return s || o || null;
}
function qm(e) {
  let t = [], n = null;
  return e.forEach((a) => {
    const s = Wm($.cssPrefix, a);
    s ? n = s : a && t.push(a);
  }), {
    iconName: n,
    rest: t
  };
}
function dr(e) {
  return e.sort().filter((t, n, a) => a.indexOf(t) === n);
}
function Fs(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let a = null;
  const s = Eo.concat(pm), o = dr(e.filter((p) => s.includes(p))), i = dr(e.filter((p) => !Eo.includes(p))), r = o.filter((p) => (a = p, !fc.includes(p))), [l = null] = r, c = Jm(o), u = P(P({}, qm(i)), {}, {
    prefix: Ps(l, {
      family: c
    })
  });
  return P(P(P({}, u), tA({
    values: e,
    family: c,
    styles: Ma,
    config: $,
    canonical: u,
    givenPrefix: a
  })), Xm(n, a, u));
}
function Xm(e, t, n) {
  let {
    prefix: a,
    iconName: s
  } = n;
  if (e || !a || !s)
    return {
      prefix: a,
      iconName: s
    };
  const o = t === "fa" ? Dc(s) : {}, i = Nn(a, s);
  return s = o.iconName || i || s, a = o.prefix || a, a === "far" && !Ma.far && Ma.fas && !$.autoFetchSvg && (a = "fas"), {
    prefix: a,
    iconName: s
  };
}
const Zm = pc.filter((e) => e !== et || e !== Ns), eA = Object.keys(yo).filter((e) => e !== et).map((e) => Object.keys(yo[e])).flat();
function tA(e) {
  const {
    values: t,
    family: n,
    canonical: a,
    givenPrefix: s = "",
    styles: o = {},
    config: i = {}
  } = e, r = n === Ns, l = t.includes("fa-duotone") || t.includes("fad"), c = i.familyDefault === "duotone", u = a.prefix === "fad" || a.prefix === "fa-duotone";
  if (!r && (l || c || u) && (a.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (a.prefix = "fab"), !a.prefix && Zm.includes(n) && (Object.keys(o).find((m) => eA.includes(m)) || i.autoFetchSvg)) {
    const m = om.get(n).defaultShortPrefixId;
    a.prefix = m, a.iconName = Nn(a.prefix, a.iconName) || a.iconName;
  }
  return (a.prefix === "fa" || s === "fa") && (a.prefix = yn() || "fas"), a;
}
class nA {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    const s = n.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((o) => {
      this.definitions[o] = P(P({}, this.definitions[o] || {}), s[o]), So(o, s[o]);
      const i = pi[et][o];
      i && So(i, s[o]), Lc();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const a = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(a).map((s) => {
      const {
        prefix: o,
        iconName: i,
        icon: r
      } = a[s], l = r[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((c) => {
        typeof c == "string" && (t[o][c] = r);
      }), t[o][i] = r;
    }), t;
  }
}
let fr = [], qn = {};
const Zn = {}, aA = Object.keys(Zn);
function sA(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return fr = e, qn = {}, Object.keys(Zn).forEach((a) => {
    aA.indexOf(a) === -1 && delete Zn[a];
  }), fr.forEach((a) => {
    const s = a.mixout ? a.mixout() : {};
    if (Object.keys(s).forEach((o) => {
      typeof s[o] == "function" && (n[o] = s[o]), typeof s[o] == "object" && Object.keys(s[o]).forEach((i) => {
        n[o] || (n[o] = {}), n[o][i] = s[o][i];
      });
    }), a.hooks) {
      const o = a.hooks();
      Object.keys(o).forEach((i) => {
        qn[i] || (qn[i] = []), qn[i].push(o[i]);
      });
    }
    a.provides && a.provides(Zn);
  }), n;
}
function To(e, t) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    a[s - 2] = arguments[s];
  return (qn[e] || []).forEach((i) => {
    t = i.apply(null, [t, ...a]);
  }), t;
}
function Qn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  (qn[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function En() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Zn[e] ? Zn[e].apply(null, t) : void 0;
}
function Lo(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || yn();
  if (t)
    return t = Nn(n, t) || t, cr(Oc.definitions, n, t) || cr(Gt.styles, n, t);
}
const Oc = new nA(), oA = () => {
  $.autoReplaceSvg = !1, $.observeMutations = !1, Qn("noAuto");
}, iA = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return dn ? (Qn("beforeI2svg", e), En("pseudoElements2svg", e), En("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    $.autoReplaceSvg === !1 && ($.autoReplaceSvg = !0), $.observeMutations = !0, Ym(() => {
      lA({
        autoReplaceSvgRoot: t
      }), Qn("watch", e);
    });
  }
}, rA = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: Nn(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Ps(e[0]);
      return {
        prefix: n,
        iconName: Nn(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat($.cssPrefix, "-")) > -1 || e.match(wm))) {
      const t = Fs(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || yn(),
        iconName: Nn(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = yn();
      return {
        prefix: t,
        iconName: Nn(t, e) || e
      };
    }
  }
}, At = {
  noAuto: oA,
  config: $,
  dom: iA,
  parse: rA,
  library: Oc,
  findIconDefinition: Lo,
  toHtml: Ka
}, lA = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = _e
  } = e;
  (Object.keys(Gt.styles).length > 0 || $.autoFetchSvg) && dn && $.autoReplaceSvg && At.dom.i2svg({
    node: t
  });
};
function Qs(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Ka(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!dn) return;
      const n = _e.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function cA(e) {
  let {
    children: t,
    main: n,
    mask: a,
    attributes: s,
    styles: o,
    transform: i
  } = e;
  if (Ai(i) && n.found && !a.found) {
    const {
      width: r,
      height: l
    } = n, c = {
      x: r / l / 2,
      y: 0.5
    };
    s.style = Rs(P(P({}, o), {}, {
      "transform-origin": "".concat(c.x + i.x / 16, "em ").concat(c.y + i.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: t
  }];
}
function uA(e) {
  let {
    prefix: t,
    iconName: n,
    children: a,
    attributes: s,
    symbol: o
  } = e;
  const i = o === !0 ? "".concat(t, "-").concat($.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: P(P({}, s), {}, {
        id: i
      }),
      children: a
    }]
  }];
}
function vi(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: a,
    iconName: s,
    transform: o,
    symbol: i,
    title: r,
    maskId: l,
    titleId: c,
    extra: u,
    watchable: p = !1
  } = e, {
    width: m,
    height: v
  } = n.found ? n : t, A = um.includes(a), h = [$.replacementClass, s ? "".concat($.cssPrefix, "-").concat(s) : ""].filter((_) => u.classes.indexOf(_) === -1).filter((_) => _ !== "" || !!_).concat(u.classes).join(" ");
  let d = {
    children: [],
    attributes: P(P({}, u.attributes), {}, {
      "data-prefix": a,
      "data-icon": s,
      class: h,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(m, " ").concat(v)
    })
  };
  const f = A && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(m / v * 16 * 0.0625, "em")
  } : {};
  p && (d.attributes[Fn] = ""), r && (d.children.push({
    tag: "title",
    attributes: {
      id: d.attributes["aria-labelledby"] || "title-".concat(c || Da())
    },
    children: [r]
  }), delete d.attributes.title);
  const g = P(P({}, d), {}, {
    prefix: a,
    iconName: s,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: i,
    styles: P(P({}, f), u.styles)
  }), {
    children: B,
    attributes: E
  } = n.found && t.found ? En("generateAbstractMask", g) || {
    children: [],
    attributes: {}
  } : En("generateAbstractIcon", g) || {
    children: [],
    attributes: {}
  };
  return g.children = B, g.attributes = E, i ? uA(g) : cA(g);
}
function pr(e) {
  const {
    content: t,
    width: n,
    height: a,
    transform: s,
    title: o,
    extra: i,
    watchable: r = !1
  } = e, l = P(P(P({}, i.attributes), o ? {
    title: o
  } : {}), {}, {
    class: i.classes.join(" ")
  });
  r && (l[Fn] = "");
  const c = P({}, i.styles);
  Ai(s) && (c.transform = Fm({
    transform: s,
    startCentered: !0,
    width: n,
    height: a
  }), c["-webkit-transform"] = c.transform);
  const u = Rs(c);
  u.length > 0 && (l.style = u);
  const p = [];
  return p.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && p.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), p;
}
function dA(e) {
  const {
    content: t,
    title: n,
    extra: a
  } = e, s = P(P(P({}, a.attributes), n ? {
    title: n
  } : {}), {}, {
    class: a.classes.join(" ")
  }), o = Rs(a.styles);
  o.length > 0 && (s.style = o);
  const i = [];
  return i.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), n && i.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), i;
}
const {
  styles: oo
} = Gt;
function Do(e) {
  const t = e[0], n = e[1], [a] = e.slice(4);
  let s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat($.cssPrefix, "-").concat(no.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat($.cssPrefix, "-").concat(no.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat($.cssPrefix, "-").concat(no.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: s
  };
}
const fA = {
  found: !1,
  width: 512,
  height: 512
};
function pA(e, t) {
  !hc && !$.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Mo(e, t) {
  let n = t;
  return t === "fa" && $.styleDefault !== null && (t = yn()), new Promise((a, s) => {
    if (n === "fa") {
      const o = Dc(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && oo[t] && oo[t][e]) {
      const o = oo[t][e];
      return a(Do(o));
    }
    pA(e, t), a(P(P({}, fA), {}, {
      icon: $.showMissingIcons && e ? En("missingIconAbstract") || {} : {}
    }));
  });
}
const mr = () => {
}, Oo = $.measurePerformance && qa && qa.mark && qa.measure ? qa : {
  mark: mr,
  measure: mr
}, xa = 'FA "6.7.2"', mA = (e) => (Oo.mark("".concat(xa, " ").concat(e, " begins")), () => Nc(e)), Nc = (e) => {
  Oo.mark("".concat(xa, " ").concat(e, " ends")), Oo.measure("".concat(xa, " ").concat(e), "".concat(xa, " ").concat(e, " begins"), "".concat(xa, " ").concat(e, " ends"));
};
var bi = {
  begin: mA,
  end: Nc
};
const cs = () => {
};
function Ar(e) {
  return typeof (e.getAttribute ? e.getAttribute(Fn) : null) == "string";
}
function AA(e) {
  const t = e.getAttribute ? e.getAttribute(di) : null, n = e.getAttribute ? e.getAttribute(fi) : null;
  return t && n;
}
function gA(e) {
  return e && e.classList && e.classList.contains && e.classList.contains($.replacementClass);
}
function hA() {
  return $.autoReplaceSvg === !0 ? us.replace : us[$.autoReplaceSvg] || us.replace;
}
function vA(e) {
  return _e.createElementNS("http://www.w3.org/2000/svg", e);
}
function bA(e) {
  return _e.createElement(e);
}
function Rc(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? vA : bA
  } = t;
  if (typeof e == "string")
    return _e.createTextNode(e);
  const a = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    a.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    a.appendChild(Rc(o, {
      ceFn: n
    }));
  }), a;
}
function xA(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const us = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(Rc(n), t);
      }), t.getAttribute(Fn) === null && $.keepOriginalSource) {
        let n = _e.createComment(xA(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~mi(t).indexOf($.replacementClass))
      return us.replace(e);
    const a = new RegExp("".concat($.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((i, r) => (r === $.replacementClass || r.match(a) ? i.toSvg.push(r) : i.toNode.push(r), i), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const s = n.map((o) => Ka(o)).join(`
`);
    t.setAttribute(Fn, ""), t.innerHTML = s;
  }
};
function gr(e) {
  e();
}
function Pc(e, t) {
  const n = typeof t == "function" ? t : cs;
  if (e.length === 0)
    n();
  else {
    let a = gr;
    $.mutateApproach === Cm && (a = xn.requestAnimationFrame || gr), a(() => {
      const s = hA(), o = bi.begin("mutate");
      e.map(s), o(), n();
    });
  }
}
let xi = !1;
function Fc() {
  xi = !0;
}
function No() {
  xi = !1;
}
let xs = null;
function hr(e) {
  if (!ar || !$.observeMutations)
    return;
  const {
    treeCallback: t = cs,
    nodeCallback: n = cs,
    pseudoElementsCallback: a = cs,
    observeMutationsRoot: s = _e
  } = e;
  xs = new ar((o) => {
    if (xi) return;
    const i = yn();
    ua(o).forEach((r) => {
      if (r.type === "childList" && r.addedNodes.length > 0 && !Ar(r.addedNodes[0]) && ($.searchPseudoElements && a(r.target), t(r.target)), r.type === "attributes" && r.target.parentNode && $.searchPseudoElements && a(r.target.parentNode), r.type === "attributes" && Ar(r.target) && ~Sm.indexOf(r.attributeName))
        if (r.attributeName === "class" && AA(r.target)) {
          const {
            prefix: l,
            iconName: c
          } = Fs(mi(r.target));
          r.target.setAttribute(di, l || i), c && r.target.setAttribute(fi, c);
        } else gA(r.target) && n(r.target);
    });
  }), dn && xs.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function yA() {
  xs && xs.disconnect();
}
function EA(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((a, s) => {
    const o = s.split(":"), i = o[0], r = o.slice(1);
    return i && r.length > 0 && (a[i] = r.join(":").trim()), a;
  }, {})), n;
}
function CA(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), a = e.innerText !== void 0 ? e.innerText.trim() : "";
  let s = Fs(mi(e));
  return s.prefix || (s.prefix = yn()), t && n && (s.prefix = t, s.iconName = n), s.iconName && s.prefix || (s.prefix && a.length > 0 && (s.iconName = zm(s.prefix, e.innerText) || hi(s.prefix, _o(e.innerText))), !s.iconName && $.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function BA(e) {
  const t = ua(e.attributes).reduce((s, o) => (s.name !== "class" && s.name !== "style" && (s[o.name] = o.value), s), {}), n = e.getAttribute("title"), a = e.getAttribute("data-fa-title-id");
  return $.autoA11y && (n ? t["aria-labelledby"] = "".concat($.replacementClass, "-title-").concat(a || Da()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function IA() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Yt,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function vr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: a,
    rest: s
  } = CA(e), o = BA(e), i = To("parseNodeAttributes", {}, e);
  let r = t.styleParser ? EA(e) : [];
  return P({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: Yt,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: r,
      attributes: o
    }
  }, i);
}
const {
  styles: wA
} = Gt;
function Qc(e) {
  const t = $.autoReplaceSvg === "nest" ? vr(e, {
    styleParser: !1
  }) : vr(e);
  return ~t.extra.classes.indexOf(bc) ? En("generateLayersText", e, t) : En("generateSvgReplacementMutation", e, t);
}
function kA() {
  return [...rm, ...Eo];
}
function br(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!dn) return Promise.resolve();
  const n = _e.documentElement.classList, a = (u) => n.add("".concat(ir, "-").concat(u)), s = (u) => n.remove("".concat(ir, "-").concat(u)), o = $.autoFetchSvg ? kA() : fc.concat(Object.keys(wA));
  o.includes("fa") || o.push("fa");
  const i = [".".concat(bc, ":not([").concat(Fn, "])")].concat(o.map((u) => ".".concat(u, ":not([").concat(Fn, "])"))).join(", ");
  if (i.length === 0)
    return Promise.resolve();
  let r = [];
  try {
    r = ua(e.querySelectorAll(i));
  } catch {
  }
  if (r.length > 0)
    a("pending"), s("complete");
  else
    return Promise.resolve();
  const l = bi.begin("onTree"), c = r.reduce((u, p) => {
    try {
      const m = Qc(p);
      m && u.push(m);
    } catch (m) {
      hc || m.name === "MissingIcon" && console.error(m);
    }
    return u;
  }, []);
  return new Promise((u, p) => {
    Promise.all(c).then((m) => {
      Pc(m, () => {
        a("active"), a("complete"), s("pending"), typeof t == "function" && t(), l(), u();
      });
    }).catch((m) => {
      l(), p(m);
    });
  });
}
function _A(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Qc(e).then((n) => {
    n && Pc([n], t);
  });
}
function SA(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = (t || {}).icon ? t : Lo(t || {});
    let {
      mask: s
    } = n;
    return s && (s = (s || {}).icon ? s : Lo(s || {})), e(a, P(P({}, n), {}, {
      mask: s
    }));
  };
}
const TA = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Yt,
    symbol: a = !1,
    mask: s = null,
    maskId: o = null,
    title: i = null,
    titleId: r = null,
    classes: l = [],
    attributes: c = {},
    styles: u = {}
  } = t;
  if (!e) return;
  const {
    prefix: p,
    iconName: m,
    icon: v
  } = e;
  return Qs(P({
    type: "icon"
  }, e), () => (Qn("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), $.autoA11y && (i ? c["aria-labelledby"] = "".concat($.replacementClass, "-title-").concat(r || Da()) : (c["aria-hidden"] = "true", c.focusable = "false")), vi({
    icons: {
      main: Do(v),
      mask: s ? Do(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: p,
    iconName: m,
    transform: P(P({}, Yt), n),
    symbol: a,
    title: i,
    maskId: o,
    titleId: r,
    extra: {
      attributes: c,
      styles: u,
      classes: l
    }
  })));
};
var LA = {
  mixout() {
    return {
      icon: SA(TA)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = br, e.nodeCallback = _A, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = _e,
        callback: a = () => {
        }
      } = t;
      return br(n, a);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: a,
        title: s,
        titleId: o,
        prefix: i,
        transform: r,
        symbol: l,
        mask: c,
        maskId: u,
        extra: p
      } = n;
      return new Promise((m, v) => {
        Promise.all([Mo(a, i), c.iconName ? Mo(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((A) => {
          let [h, d] = A;
          m([t, vi({
            icons: {
              main: h,
              mask: d
            },
            prefix: i,
            iconName: a,
            transform: r,
            symbol: l,
            maskId: u,
            title: s,
            titleId: o,
            extra: p,
            watchable: !0
          })]);
        }).catch(v);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: a,
        main: s,
        transform: o,
        styles: i
      } = t;
      const r = Rs(i);
      r.length > 0 && (a.style = r);
      let l;
      return Ai(o) && (l = En("generateAbstractTransformGrouping", {
        main: s,
        transform: o,
        containerWidth: s.width,
        iconWidth: s.width
      })), n.push(l || s.icon), {
        children: n,
        attributes: a
      };
    };
  }
}, DA = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return Qs({
          type: "layer"
        }, () => {
          Qn("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let a = [];
          return e((s) => {
            Array.isArray(s) ? s.map((o) => {
              a = a.concat(o.abstract);
            }) : a = a.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat($.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: a
          }];
        });
      }
    };
  }
}, MA = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: a = [],
          attributes: s = {},
          styles: o = {}
        } = t;
        return Qs({
          type: "counter",
          content: e
        }, () => (Qn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), dA({
          content: e.toString(),
          title: n,
          extra: {
            attributes: s,
            styles: o,
            classes: ["".concat($.cssPrefix, "-layers-counter"), ...a]
          }
        })));
      }
    };
  }
}, OA = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Yt,
          title: a = null,
          classes: s = [],
          attributes: o = {},
          styles: i = {}
        } = t;
        return Qs({
          type: "text",
          content: e
        }, () => (Qn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), pr({
          content: e,
          transform: P(P({}, Yt), n),
          title: a,
          extra: {
            attributes: o,
            styles: i,
            classes: ["".concat($.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: a,
        transform: s,
        extra: o
      } = n;
      let i = null, r = null;
      if (uc) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        i = c.width / l, r = c.height / l;
      }
      return $.autoA11y && !a && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, pr({
        content: t.innerHTML,
        width: i,
        height: r,
        transform: s,
        title: a,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const NA = new RegExp('"', "ug"), xr = [1105920, 1112319], yr = P(P(P(P({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), sm), ym), mm), Ro = Object.keys(yr).reduce((e, t) => (e[t.toLowerCase()] = yr[t], e), {}), RA = Object.keys(Ro).reduce((e, t) => {
  const n = Ro[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function PA(e) {
  const t = e.replace(NA, ""), n = jm(t, 0), a = n >= xr[0] && n <= xr[1], s = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: _o(s ? t[0] : t),
    isSecondary: a || s
  };
}
function FA(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), a = parseInt(t), s = isNaN(a) ? "normal" : a;
  return (Ro[n] || {})[s] || RA[n];
}
function Er(e, t) {
  const n = "".concat(Em).concat(t.replace(":", "-"));
  return new Promise((a, s) => {
    if (e.getAttribute(n) !== null)
      return a();
    const i = ua(e.children).filter((m) => m.getAttribute(Bo) === t)[0], r = xn.getComputedStyle(e, t), l = r.getPropertyValue("font-family"), c = l.match(km), u = r.getPropertyValue("font-weight"), p = r.getPropertyValue("content");
    if (i && !c)
      return e.removeChild(i), a();
    if (c && p !== "none" && p !== "") {
      const m = r.getPropertyValue("content");
      let v = FA(l, u);
      const {
        value: A,
        isSecondary: h
      } = PA(m), d = c[0].startsWith("FontAwesome");
      let f = hi(v, A), g = f;
      if (d) {
        const B = $m(A);
        B.iconName && B.prefix && (f = B.iconName, v = B.prefix);
      }
      if (f && !h && (!i || i.getAttribute(di) !== v || i.getAttribute(fi) !== g)) {
        e.setAttribute(n, g), i && e.removeChild(i);
        const B = IA(), {
          extra: E
        } = B;
        E.attributes[Bo] = t, Mo(f, v).then((_) => {
          const O = vi(P(P({}, B), {}, {
            icons: {
              main: _,
              mask: Mc()
            },
            prefix: v,
            iconName: g,
            extra: E,
            watchable: !0
          })), S = _e.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(S, e.firstChild) : e.appendChild(S), S.outerHTML = O.map((H) => Ka(H)).join(`
`), e.removeAttribute(n), a();
        }).catch(s);
      } else
        a();
    } else
      a();
  });
}
function QA(e) {
  return Promise.all([Er(e, "::before"), Er(e, "::after")]);
}
function UA(e) {
  return e.parentNode !== document.head && !~Bm.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Bo) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function Cr(e) {
  if (dn)
    return new Promise((t, n) => {
      const a = ua(e.querySelectorAll("*")).filter(UA).map(QA), s = bi.begin("searchPseudoElements");
      Fc(), Promise.all(a).then(() => {
        s(), No(), t();
      }).catch(() => {
        s(), No(), n();
      });
    });
}
var YA = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = Cr, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = _e
      } = t;
      $.searchPseudoElements && Cr(n);
    };
  }
};
let Br = !1;
var GA = {
  mixout() {
    return {
      dom: {
        unwatch() {
          Fc(), Br = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        hr(To("mutationObserverCallbacks", {}));
      },
      noAuto() {
        yA();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        Br ? No() : hr(To("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const Ir = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, a) => {
    const s = a.toLowerCase().split("-"), o = s[0];
    let i = s.slice(1).join("-");
    if (o && i === "h")
      return n.flipX = !0, n;
    if (o && i === "v")
      return n.flipY = !0, n;
    if (i = parseFloat(i), isNaN(i))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + i;
        break;
      case "shrink":
        n.size = n.size - i;
        break;
      case "left":
        n.x = n.x - i;
        break;
      case "right":
        n.x = n.x + i;
        break;
      case "up":
        n.y = n.y - i;
        break;
      case "down":
        n.y = n.y + i;
        break;
      case "rotate":
        n.rotate = n.rotate + i;
        break;
    }
    return n;
  }, t);
};
var jA = {
  mixout() {
    return {
      parse: {
        transform: (e) => Ir(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = Ir(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: a,
        containerWidth: s,
        iconWidth: o
      } = t;
      const i = {
        transform: "translate(".concat(s / 2, " 256)")
      }, r = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), l = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), c = "rotate(".concat(a.rotate, " 0 0)"), u = {
        transform: "".concat(r, " ").concat(l, " ").concat(c)
      }, p = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, m = {
        outer: i,
        inner: u,
        path: p
      };
      return {
        tag: "g",
        attributes: P({}, m.outer),
        children: [{
          tag: "g",
          attributes: P({}, m.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: P(P({}, n.icon.attributes), m.path)
          }]
        }]
      };
    };
  }
};
const io = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function wr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function HA(e) {
  return e.tag === "g" ? e.children : [e];
}
var VA = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), a = n ? Fs(n.split(" ").map((s) => s.trim())) : Mc();
        return a.prefix || (a.prefix = yn()), e.mask = a, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: a,
        main: s,
        mask: o,
        maskId: i,
        transform: r
      } = t;
      const {
        width: l,
        icon: c
      } = s, {
        width: u,
        icon: p
      } = o, m = Pm({
        transform: r,
        containerWidth: u,
        iconWidth: l
      }), v = {
        tag: "rect",
        attributes: P(P({}, io), {}, {
          fill: "white"
        })
      }, A = c.children ? {
        children: c.children.map(wr)
      } : {}, h = {
        tag: "g",
        attributes: P({}, m.inner),
        children: [wr(P({
          tag: c.tag,
          attributes: P(P({}, c.attributes), m.path)
        }, A))]
      }, d = {
        tag: "g",
        attributes: P({}, m.outer),
        children: [h]
      }, f = "mask-".concat(i || Da()), g = "clip-".concat(i || Da()), B = {
        tag: "mask",
        attributes: P(P({}, io), {}, {
          id: f,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [v, d]
      }, E = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: g
          },
          children: HA(p)
        }, B]
      };
      return n.push(E, {
        tag: "rect",
        attributes: P({
          fill: "currentColor",
          "clip-path": "url(#".concat(g, ")"),
          mask: "url(#".concat(f, ")")
        }, io)
      }), {
        children: n,
        attributes: a
      };
    };
  }
}, KA = {
  provides(e) {
    let t = !1;
    xn.matchMedia && (t = xn.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], a = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: P(P({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const o = P(P({}, s), {}, {
        attributeName: "opacity"
      }), i = {
        tag: "circle",
        attributes: P(P({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || i.children.push({
        tag: "animate",
        attributes: P(P({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: P(P({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(i), n.push({
        tag: "path",
        attributes: P(P({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: P(P({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: P(P({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: P(P({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, WA = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), a = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = a, e;
      }
    };
  }
}, zA = [Um, LA, DA, MA, OA, YA, GA, jA, VA, KA, WA];
sA(zA, {
  mixoutsTo: At
});
At.noAuto;
const Uc = At.config, $A = At.library;
At.dom;
const ys = At.parse;
At.findIconDefinition;
At.toHtml;
const JA = At.icon;
At.layer;
const qA = At.text;
At.counter;
function Po(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function XA(e) {
  if (Array.isArray(e)) return Po(e);
}
function qe(e, t, n) {
  return (t = sg(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ZA(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function eg() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kr(Object(n), !0).forEach(function(a) {
      qe(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kr(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function tg(e, t) {
  if (e == null) return {};
  var n, a, s = ng(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++) n = o[a], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (s[n] = e[n]);
  }
  return s;
}
function ng(e, t) {
  if (e == null) return {};
  var n = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (t.indexOf(a) !== -1) continue;
    n[a] = e[a];
  }
  return n;
}
function Fo(e) {
  return XA(e) || ZA(e) || og(e) || eg();
}
function ag(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function sg(e) {
  var t = ag(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Es(e) {
  "@babel/helpers - typeof";
  return Es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Es(e);
}
function og(e, t) {
  if (e) {
    if (typeof e == "string") return Po(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Po(e, t) : void 0;
  }
}
function Ba(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? qe({}, e, t) : {};
}
function ig(e) {
  var t, n = (t = {
    "fa-spin": e.spin,
    "fa-pulse": e.pulse,
    // the fixedWidth property has been deprecated as of version 7.0.0
    "fa-fw": e.fixedWidth,
    "fa-border": e.border,
    "fa-li": e.listItem,
    "fa-inverse": e.inverse,
    "fa-flip": e.flip === !0,
    "fa-flip-horizontal": e.flip === "horizontal" || e.flip === "both",
    "fa-flip-vertical": e.flip === "vertical" || e.flip === "both"
  }, qe(qe(qe(qe(qe(qe(qe(qe(qe(qe(t, "fa-".concat(e.size), e.size !== null), "fa-rotate-".concat(e.rotation), e.rotation !== null), "fa-rotate-by", e.rotateBy), "fa-pull-".concat(e.pull), e.pull !== null), "fa-swap-opacity", e.swapOpacity), "fa-bounce", e.bounce), "fa-shake", e.shake), "fa-beat", e.beat), "fa-fade", e.fade), "fa-beat-fade", e.beatFade), qe(qe(qe(qe(t, "fa-flash", e.flash), "fa-spin-pulse", e.spinPulse), "fa-spin-reverse", e.spinReverse), "fa-width-auto", e.widthAuto));
  return Object.keys(n).map(function(a) {
    return n[a] ? a : null;
  }).filter(function(a) {
    return a;
  });
}
var rg = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Yc = { exports: {} };
(function(e) {
  (function(t) {
    var n = function(f, g, B) {
      if (!c(g) || p(g) || m(g) || v(g) || l(g))
        return g;
      var E, _ = 0, O = 0;
      if (u(g))
        for (E = [], O = g.length; _ < O; _++)
          E.push(n(f, g[_], B));
      else {
        E = {};
        for (var S in g)
          Object.prototype.hasOwnProperty.call(g, S) && (E[f(S, B)] = n(f, g[S], B));
      }
      return E;
    }, a = function(f, g) {
      g = g || {};
      var B = g.separator || "_", E = g.split || /(?=[A-Z])/;
      return f.split(E).join(B);
    }, s = function(f) {
      return A(f) ? f : (f = f.replace(/[\-_\s]+(.)?/g, function(g, B) {
        return B ? B.toUpperCase() : "";
      }), f.substr(0, 1).toLowerCase() + f.substr(1));
    }, o = function(f) {
      var g = s(f);
      return g.substr(0, 1).toUpperCase() + g.substr(1);
    }, i = function(f, g) {
      return a(f, g).toLowerCase();
    }, r = Object.prototype.toString, l = function(f) {
      return typeof f == "function";
    }, c = function(f) {
      return f === Object(f);
    }, u = function(f) {
      return r.call(f) == "[object Array]";
    }, p = function(f) {
      return r.call(f) == "[object Date]";
    }, m = function(f) {
      return r.call(f) == "[object RegExp]";
    }, v = function(f) {
      return r.call(f) == "[object Boolean]";
    }, A = function(f) {
      return f = f - 0, f === f;
    }, h = function(f, g) {
      var B = g && "process" in g ? g.process : g;
      return typeof B != "function" ? f : function(E, _) {
        return B(E, f, _);
      };
    }, d = {
      camelize: s,
      decamelize: i,
      pascalize: o,
      depascalize: i,
      camelizeKeys: function(f, g) {
        return n(h(s, g), f);
      },
      decamelizeKeys: function(f, g) {
        return n(h(i, g), f, g);
      },
      pascalizeKeys: function(f, g) {
        return n(h(o, g), f);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = d : t.humps = d;
  })(rg);
})(Yc);
var lg = Yc.exports, cg = ["class", "style"];
function ug(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var a = n.indexOf(":"), s = lg.camelize(n.slice(0, a)), o = n.slice(a + 1).trim();
    return t[s] = o, t;
  }, {});
}
function dg(e) {
  return e.split(/\s+/).reduce(function(t, n) {
    return t[n] = !0, t;
  }, {});
}
function yi(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var a = (e.children || []).map(function(l) {
    return yi(l);
  }), s = Object.keys(e.attributes || {}).reduce(function(l, c) {
    var u = e.attributes[c];
    switch (c) {
      case "class":
        l.class = dg(u);
        break;
      case "style":
        l.style = ug(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  n.class;
  var o = n.style, i = o === void 0 ? {} : o, r = tg(n, cg);
  return Ts(e.tag, kt(kt(kt({}, t), {}, {
    class: s.class,
    style: kt(kt({}, s.style), i)
  }, s.attrs), r), a);
}
var Gc = !1;
try {
  Gc = process.env.NODE_ENV === "production";
} catch {
}
function fg() {
  if (!Gc && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function _r(e) {
  if (e && Es(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (ys.icon)
    return ys.icon(e);
  if (e === null)
    return null;
  if (Es(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
var pg = Y({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    // the fixedWidth property has been deprecated as of version 7
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(t) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(t) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(t) {
        return ["right", "left"].indexOf(t) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(t) {
        return [90, 180, 270].indexOf(Number.parseInt(t, 10)) > -1;
      }
    },
    // the rotateBy property is only supported in version 7.0.0 and later
    rotateBy: {
      type: Boolean,
      default: !1
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(t) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(t) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    },
    // the widthAuto property is only supported in version 7.0.0 and later
    widthAuto: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var a = n.attrs, s = F(function() {
      return _r(t.icon);
    }), o = F(function() {
      return Ba("classes", ig(t));
    }), i = F(function() {
      return Ba("transform", typeof t.transform == "string" ? ys.transform(t.transform) : t.transform);
    }), r = F(function() {
      return Ba("mask", _r(t.mask));
    }), l = F(function() {
      var u = kt(kt(kt(kt({}, o.value), i.value), r.value), {}, {
        symbol: t.symbol,
        maskId: t.maskId
      });
      return u.title = t.title, u.titleId = t.titleId, JA(s.value, u);
    });
    Ae(l, function(u) {
      if (!u)
        return fg("Could not find one or more icon(s)", s.value, r.value);
    }, {
      immediate: !0
    });
    var c = F(function() {
      return l.value ? yi(l.value.abstract[0], {}, a) : null;
    });
    return function() {
      return c.value;
    };
  }
});
Y({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var a = n.slots, s = Uc.familyPrefix, o = F(function() {
      return ["".concat(s, "-layers")].concat(Fo(t.fixedWidth ? ["".concat(s, "-fw")] : []));
    });
    return function() {
      return Ts("div", {
        class: o.value
      }, a.default ? a.default() : []);
    };
  }
});
Y({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(t) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(t) > -1;
      }
    }
  },
  setup: function(t, n) {
    var a = n.attrs, s = Uc.familyPrefix, o = F(function() {
      return Ba("classes", [].concat(Fo(t.counter ? ["".concat(s, "-layers-counter")] : []), Fo(t.position ? ["".concat(s, "-layers-").concat(t.position)] : [])));
    }), i = F(function() {
      return Ba("transform", typeof t.transform == "string" ? ys.transform(t.transform) : t.transform);
    }), r = F(function() {
      var c = qA(t.value.toString(), kt(kt({}, i.value), o.value)), u = c.abstract;
      return t.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = F(function() {
      return yi(r.value, {}, a);
    });
    return function() {
      return l.value;
    };
  }
});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const mg = {
  prefix: "fas",
  iconName: "circle-notch",
  icon: [512, 512, [], "f1ce", "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"]
}, Ag = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, gg = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, hg = gg, vg = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
function bg() {
  return {
    colorScheme: {
      light: {
        header: {
          active: {
            background: "rgba(68, 72, 109, 0.12)"
          }
        },
        panel: {
          border: {
            width: "1px"
          }
        },
        content: {
          border: {
            width: "1px"
          }
        }
      },
      dark: {
        header: {
          active: {
            background: "rgba(255, 255, 255, 0.15)"
          }
        },
        panel: {
          border: {
            width: "1px"
          }
        },
        content: {
          border: {
            width: "1px"
          }
        }
      }
    }
  };
}
function xg() {
  return {
    colorScheme: {
      light: {
        background: "transparent",
        checked: {
          background: "var(--p-primary-color)"
        },
        icon: {
          checked: {
            color: "#34343d"
          }
        }
      },
      dark: {
        background: "transparent",
        checked: {
          background: "var(--p-primary-color)"
        },
        icon: {
          checked: {
            color: "#FFFFFF"
          }
        }
      }
    }
  };
}
function yg() {
  return {
    colorScheme: {
      light: {
        background: "#ECECF9"
      },
      dark: {
        background: "#535763"
      }
    }
  };
}
function Eg() {
  return {
    header: {
      background: "transparent !important",
      cell: {
        border: {
          color: "#bfbfbf !important"
        }
      }
    },
    body: {
      cell: {
        background: "transparent !important",
        border: {
          color: "#bfbfbf !important"
        }
      }
    },
    footer: {
      cell: {
        background: "transparent !important"
      }
    },
    dialog: {
      title: {
        font: {
          size: "2.143rem !important"
        }
      }
    },
    row: {
      background: "transparent !important"
    },
    sort: {
      icon: {
        color: "var(--p-primary-color)"
      }
    },
    colorScheme: {
      light: {
        header: {
          background: "#E2E2E2 !important"
        },
        footer: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        header: {
          background: "#32343A!important"
        },
        footer: {
          background: "#32343A!important"
        }
      }
    }
  };
}
function Cg() {
  return {
    colorScheme: {
      light: {
        background: "#FFFFFF !important"
      },
      dark: {
        background: "#3C3E46 !important"
      }
    }
  };
}
function Bg() {
  return {
    option: {
      selected: {
        background: "var(--p-primary-color)"
      }
    },
    colorScheme: {
      light: {
        background: "transparent",
        border: {
          color: "var(--p-primary-color)"
        }
      },
      dark: {
        background: "#3C3E44"
      }
    }
  };
}
function Ig() {
  return {
    colorScheme: {
      light: {
        modal: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        modal: {
          background: "#3E3E3E !important"
        }
      }
    }
  };
}
function wg() {
  return {
    background: "transparent !important",
    border: {
      color: "var(--p-text-color) !important"
    }
  };
}
function kg() {
  return {
    track: {
      size: "6px"
    },
    border: {
      radius: "8px"
    }
  };
}
function _g() {
  return {
    tab: {
      padding: "0.5rem 1.55rem 0.4rem 0",
      margin: "0px 0px -2px 0px",
      border: {
        width: "0px 0px 2px 0px"
      }
    },
    tablist: {
      border: {
        width: 0
      }
    },
    tabpanel: {
      padding: 0
    },
    colorScheme: {
      light: {
        tablist: {
          background: "#E2E2E2 !important"
        },
        tabpanel: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        tablist: {
          background: "#32343A!important"
        },
        tabpanel: {
          background: "#32343A!important"
        }
      }
    }
  };
}
function Sg() {
  return {
    colorScheme: {
      light: {
        background: "#FFFFFF"
      },
      dark: {
        background: "#3C3E46"
      }
    }
  };
}
function Tg() {
  return {
    padding: "0",
    node: {
      padding: "0"
    },
    colorScheme: {
      light: {
        background: "#FFFFFF"
      },
      dark: {
        background: "#707070"
      }
    }
  };
}
function Lg() {
  return {
    primary: {
      color: "#FFFFFF !important"
    },
    success: {
      color: "#FFFFFF !important"
    },
    danger: {
      color: "#FFFFFF !important"
    },
    warning: {
      color: "#FFFFFF !important"
    }
  };
}
function Dg() {
  return {
    title: {
      font: {
        size: "2.1rem !important",
        weight: "500 !important"
      }
    },
    colorScheme: {
      light: {
        background: "#E2E2E2 !important"
      },
      dark: {
        background: "#3E3E3E !important"
      }
    }
  };
}
function Mg() {
  return {
    colorScheme: {
      light: {
        content: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        content: {
          background: "#32343A!important"
        }
      }
    }
  };
}
function Og() {
  return {
    content: {
      background: "transparent"
    }
  };
}
function Ng() {
  return {
    border: {
      color: "rgba(255, 255, 255, 0.05)"
    },
    background: "transparent"
  };
}
function Rg() {
  return {
    border: {
      color: "transparent !important"
    }
  };
}
function jc() {
  return ri(Vf, {
    semantic: {
      primary: {
        gray: "#54515f",
        blue: "#1c80cf",
        bluegray: "#526a76",
        username: {
          color: "#808080"
        },
        datatable: {
          line: {
            color: "#bfbfbf"
          }
        },
        progress: {
          bar: {
            next: {
              step: "#505259"
            }
          }
        }
      },
      colorScheme: {
        light: {
          body: {
            background: "#ffffff"
          },
          text: {
            color: "#000000"
          },
          textInverse: {
            color: "#FFFFFF"
          },
          navbarIcon: {
            filter: "invert(0%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(100%) contrast(101%)"
          },
          navbarText: {
            color: "#000000"
          },
          patientItem: {
            color: "#EEEEEE"
          },
          cardHome: {
            background: "#E2E2E2 !important"
          },
          image: {
            container: {
              background: "#C6C6C6"
            }
          },
          objectList: {
            background: "#FFFFFF !important"
          },
          inputTextCard: {
            background: "#C6C6C6"
          },
          inputTextSmall: {
            background: "#808080 !important"
          },
          wizObjectListText: {
            color: "#000000"
          },
          clippingPlanesBtn: {
            background: "#F0F0F0"
          },
          sidebar: {
            wiz: {
              background: "#E2E2E2"
            },
            wizItem: {
              background: "#EEEEEE"
            }
          },
          test2BorderColor: "rgba(255, 255, 255, 0.10)"
        },
        dark: {
          body: {
            background: "#28292C"
          },
          text: {
            color: "#FFFFFF"
          },
          textInverse: {
            color: "#000000"
          },
          navbarIcon: {
            filter: "invert(100%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(107%) contrast(101%)"
          },
          navbarText: {
            color: "#FFFFFF"
          },
          patientItem: {
            color: "#3c3e46"
          },
          cardHome: {
            background: "linear-gradient(180deg, #182B4B 0%, #161924 100%) !important"
          },
          image: {
            container: {
              background: "#535763"
            }
          },
          objectList: {
            background: "#707070 !important"
          },
          inputTextCard: {
            background: "#464646"
          },
          inputTextSmall: {
            background: "#808080 !important"
          },
          wizObjectListText: {
            color: "#B7B7B7"
          },
          clippingPlanesBtn: {
            background: "#FFFFFF"
          },
          sidebar: {
            wiz: {
              background: "#28292C"
            },
            wizItem: {
              background: "#32343A"
            }
          },
          test2BorderColor: "rgba(255, 255, 255, 0.10)"
        }
      }
    },
    components: {
      accordion: bg(),
      button: Lg(),
      checkbox: xg(),
      contextmenu: yg(),
      dialog: Dg(),
      datatable: Eg(),
      dataview: Mg(),
      divider: Og(),
      fileupload: Ng(),
      inputtext: Cg(),
      listbox: Bg(),
      overlay: Ig(),
      select: wg(),
      slider: kg(),
      tabs: _g(),
      textarea: Sg(),
      toolbar: Rg(),
      tree: Tg()
    }
  });
}
function Pg() {
  return ri(jc(), {
    semantic: {
      primary: {},
      colorScheme: {
        light: {
          body: {
            background: "#ffffff"
          },
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgTableHeaderBackgroundColor: "#1a3053"
        },
        dark: {
          body: {
            background: "#14305E"
          },
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgTableHeaderBackgroundColor: "#1a3053"
        }
      }
    },
    components: {
      progressbar: {
        colorScheme: {
          light: {
            background: "rgba(255, 255, 255, 0.06)"
          },
          dark: {
            background: "rgba(255, 255, 255, 0.06)"
          }
        }
      }
    }
  });
}
function Fg() {
  return ri(jc(), {
    semantic: {
      primary: {},
      colorScheme: {
        light: {
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgTableHeaderBackgroundColor: "#1a3053"
        },
        dark: {
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgTableHeaderBackgroundColor: "#1a3053"
        }
      }
    },
    components: {}
  });
}
function A1(e, t, n) {
  $A.add(mg, vg, hg, Ag), e.component("font-awesome-icon", pg), e.use(_d, {
    theme: {
      preset: e._component.__name === "RgApp" ? Pg() : Fg(),
      options: {
        darkModeSelector: ".p-dark"
      }
    }
  }), e.use(Xi), e._component.__name !== ci.IMPLANT_PLANNER && e.use(Xi), e.use(tc, { assetPath: (n == null ? void 0 : n.assetPath) ?? "" }), zp(e), t && Cd(t);
}
function Qg(e) {
  return (t) => t.id === e;
}
const Za = new Intl.Collator(void 0, { sensitivity: "base" });
function Sr(e) {
  const t = [];
  if (!e)
    return t;
  const n = /(\d+(?:\.\d+)?)/g;
  let a = 0, s = null;
  for (; (s = n.exec(e)) !== null; ) {
    s.index > a && t.push({ type: "text", value: e.slice(a, s.index) });
    const o = s[1];
    t.push({ type: "number", value: Number(o), raw: o }), a = s.index + o.length;
  }
  return a < e.length && t.push({ type: "text", value: e.slice(a) }), t;
}
function Qo(e, t) {
  if (e === t)
    return 0;
  const n = Sr(e), a = Sr(t), s = Math.max(n.length, a.length);
  for (let o = 0; o < s; o += 1) {
    const i = n[o], r = a[o];
    if (!i)
      return -1;
    if (!r)
      return 1;
    if (i.type === "number" && r.type === "number") {
      if (i.value !== r.value)
        return i.value - r.value;
      const p = Za.compare(i.raw, r.raw);
      if (p !== 0)
        return p;
      continue;
    }
    if (i.type === "text" && r.type === "text") {
      const p = Za.compare(i.value, r.value);
      if (p !== 0)
        return p;
      continue;
    }
    const l = i.type === "number" ? i.raw : i.value, c = r.type === "number" ? r.raw : r.value, u = Za.compare(l, c);
    if (u !== 0)
      return u;
  }
  return Za.compare(e, t);
}
function Nt(e) {
  return [...e].sort((t, n) => Qo(t.name ?? "", n.name ?? ""));
}
function ro(e) {
  return [...e].sort((t, n) => {
    const a = Qo(t.manufacturer ?? "", n.manufacturer ?? "");
    return a !== 0 ? a : Qo(t.name ?? "", n.name ?? "");
  });
}
async function Ug(e, t, n) {
  if (!t.has(e)) {
    const s = await n();
    t.set(e, s.data);
  }
  const a = t.get(e);
  if (a === void 0)
    throw new Error(`Value for key "${e}" not found in cache.`);
  return a;
}
function Yg(e, t, n) {
  if (!t.has(e)) {
    const s = n();
    t.set(e, s);
  }
  const a = t.get(e);
  if (a === void 0)
    throw new Error(`Value for key "${e}" not found in cache.`);
  return a;
}
function Tr(e, t) {
  return `${e}__${t}`;
}
class g1 {
  constructor(t, n) {
    oe(this, "api");
    oe(this, "cachedResponse");
    oe(this, "objectCache", /* @__PURE__ */ new Map());
    oe(this, "objectDepsCache", /* @__PURE__ */ new Map());
    oe(this, "manufacturerNameCache");
    this.api = n, this.cachedResponse = t;
  }
  getManufacturerName(t) {
    return t ? (this.manufacturerNameCache || (this.manufacturerNameCache = new Map(this.cachedResponse.manufacturers.map((n) => [n.id, n.name]))), this.manufacturerNameCache.get(t) ?? "") : "";
  }
  filterByIds(t, n, a) {
    return a ? t : !n || n.length === 0 ? [] : t.filter((s) => n.includes(s.id));
  }
  withManufacturerName(t) {
    return {
      ...t,
      manufacturerName: this.getManufacturerName(t.pId)
    };
  }
  formatNameWithSellingCode(t) {
    const n = t.name ?? "", a = typeof t.sellingCode == "string" ? t.sellingCode.trim() : "";
    return a.length > 0 ? `${n} / ${a}` : n;
  }
  buildListModelByManufacturer(t, n = !0, a = !1) {
    const s = t.map((i) => {
      const r = this.getManufacturerName(i.pId), l = a ? this.formatNameWithSellingCode(i) : i.name ?? "";
      return {
        manufacturer: r,
        name: l,
        item: {
          ...i,
          manufacturerName: r
        }
      };
    });
    return ro(s).map((i) => ({
      name: n && i.manufacturer ? `${i.manufacturer} / ${i.name}` : i.name,
      value: i.item
    }));
  }
  manufacturers() {
    const { manufacturers: t } = this.cachedResponse;
    return Nt(t);
  }
  implantManufacturers() {
    const { manufacturers: t, implantModels: n } = this.cachedResponse;
    return Nt(t.filter((a) => n.some((s) => s.pId === a.id)));
  }
  abutmentManufacturers() {
    const { manufacturers: t, abutmentModels: n } = this.cachedResponse;
    return Nt(t.filter((a) => n.some((s) => s.pId === a.id)));
  }
  implantModels() {
    const { implantModels: t } = this.cachedResponse;
    return Nt(t);
  }
  sleeves() {
    const { sleeves: t } = this.cachedResponse;
    return Nt(t);
  }
  extrusions() {
    const { extrusions: t } = this.cachedResponse;
    return t;
  }
  getExtrusionElements() {
    const { extrusions: t } = this.cachedResponse;
    return t.map((n) => {
      const a = n.jsonData ? JSON.parse(n.jsonData) : {}, s = ["d1model", "d2model", "l1model", "l2model", "cutsizemodel", "supportrmodel", "rotation_cutmodel", "bottomextrusionrmodel"];
      for (const o of s)
        o in a && typeof a[o] == "string" && (a[o] = Number(a[o]));
      return a.doublecutmodel = a.doublecutmodel === "true", {
        ...n,
        ...a
      };
    });
  }
  implants() {
    const { implants: t } = this.cachedResponse;
    return t.map((n) => ({ ...n, ...JSON.parse(n.jsonData ?? "") }));
  }
  pins() {
    const { pins: t, manufacturers: n } = this.cachedResponse;
    return ro(
      t.map((a) => {
        var o;
        return { manufacturer: ((o = n == null ? void 0 : n.find((i) => i.id === a.pId)) == null ? void 0 : o.name) || "", ...a, ...JSON.parse(a.jsonData ?? "") };
      })
    );
  }
  abutments() {
    const { abutments: t } = this.cachedResponse;
    return Nt(
      t.map((n) => {
        const a = n.jsonData ? JSON.parse(n.jsonData) : {}, s = ["angle", "color", "diameter", "rotation_z", "collar_height", "connector_height"];
        for (const o of s)
          o in a && typeof a[o] == "string" && (a[o] = Number(a[o]));
        return {
          ...n,
          ...a
        };
      })
    );
  }
  getScanAbutmentListModels(t, n) {
    const a = this.filterByIds(this.cachedResponse.scanAbuts ?? [], n, t);
    return this.buildListModelByManufacturer(a, t, !0);
  }
  getSecondaryAbutmentListModels(t) {
    const n = this.filterByIds(this.cachedResponse.secAbuts ?? [], t, !1);
    return this.buildListModelByManufacturer(n, !1, !0);
  }
  getSecondaryScanAbutmentListModels(t) {
    const n = this.filterByIds(this.cachedResponse.secScanAbuts ?? [], t, !1);
    return this.buildListModelByManufacturer(n, !1, !0);
  }
  getAnalogExtrusionListModels(t, n) {
    const a = this.filterByIds(this.getExtrusionElements(), n, t);
    return this.buildListModelByManufacturer(a, !1);
  }
  getScanAbutmentByGuid(t) {
    var a;
    const n = (a = this.cachedResponse.scanAbuts) == null ? void 0 : a.find((s) => s.uuid === t);
    if (n)
      return this.withManufacturerName(n);
  }
  getSecondaryAbutmentByGuid(t) {
    var a;
    const n = (a = this.cachedResponse.secAbuts) == null ? void 0 : a.find((s) => s.uuid === t);
    if (n)
      return this.withManufacturerName(n);
  }
  getSecondaryScanAbutmentByGuid(t) {
    var a;
    const n = (a = this.cachedResponse.secScanAbuts) == null ? void 0 : a.find((s) => s.uuid === t);
    if (n)
      return this.withManufacturerName(n);
  }
  getExtrusionByStlGuid(t) {
    const n = this.getExtrusionElements(), a = n.find((s) => s.stl_file_guid === t) ?? n.find((s) => s.uuid === t);
    if (a)
      return this.withManufacturerName(a);
  }
  abutmentModels() {
    const { abutmentModels: t } = this.cachedResponse;
    return Nt(t);
  }
  implantSleeveManufacturers() {
    const { sleeves: t, manufacturers: n } = this.cachedResponse;
    return Nt(n.filter((a) => t.filter((s) => s.type == rs.SleeveType.IMPLANT && s.pId == a.id).length > 0));
  }
  getImplantSleeves() {
    let t = [];
    const { sleeves: n, manufacturers: a } = this.cachedResponse;
    for (const s of a) {
      const o = n.filter((i) => i.type == rs.SleeveType.IMPLANT && i.pId == s.id).map((i) => ({
        ...i,
        ...JSON.parse(i.jsonData ?? ""),
        original_name: Tr(s.name, i.name)
      }));
      t = t.concat(o);
    }
    return Nt(t);
  }
  getImplantSleeveListModels(t, n) {
    const a = this.filterByIds(this.getImplantSleeves(), n, t);
    return this.buildListModelByManufacturer(a, t, !0);
  }
  getPinSleevesById(t) {
    return this.getPinSleeves().find((a) => a.id === t);
  }
  getPinSleevesFiltered(t, n) {
    const a = this.filterByIds(this.getPinSleeves(), n, t);
    return this.buildListModelByManufacturer(a, t, !0);
  }
  getPinSleeves() {
    let t = [];
    const { sleeves: n, manufacturers: a } = this.cachedResponse;
    for (const s of a) {
      const o = n.filter((i) => i.type == rs.SleeveType.PIN && i.pId == s.id).map((i) => ({
        ...i,
        ...JSON.parse(i.jsonData ?? ""),
        manufacturer: s.name,
        original_name: Tr(s.name, i.name)
      }));
      t = t.concat(o);
    }
    return ro(t);
  }
  getImplantModelsForManufacturer(t) {
    return this.implantModels().filter((n) => n.pId === t);
  }
  getImplantsForModel(t) {
    const n = this.implants();
    return Nt(n.filter((a) => a.pId === t));
  }
  async getFile(t) {
    return Ug(t, this.objectCache, () => this.api.getSTLFile(t));
  }
  getImplantTreeById(t) {
    return this.getObjectTreeById(t, {
      l3: this.implants(),
      l2: this.implantModels(),
      l1: this.implantManufacturers()
    });
  }
  getAbutmentTreeById(t) {
    return this.getObjectTreeById(t, {
      l3: this.abutments(),
      l2: this.abutmentModels(),
      l1: this.abutmentManufacturers()
    });
  }
  getSleeveTreeByName(t) {
    let n = this.getImplantSleeves().find((a) => a.original_name === t);
    if (n || (n = this.getImplantSleeves().find((a) => a.original_name.toLowerCase() === t.toLowerCase())), n) {
      const a = this.manufacturers().find((s) => s.id === n.pId);
      if (a)
        return {
          manufacturer: a,
          object: n
        };
    }
  }
  getSleeveTreeById(t) {
    let n = this.getImplantSleeves().find((a) => a.id === t);
    if (n) {
      const a = this.manufacturers().find((s) => s.id === n.pId);
      if (a)
        return {
          manufacturer: a,
          object: n
        };
    }
  }
  getObjectTreeById(t, n) {
    const a = n.l3.find((s) => s.uuid === t);
    if (a) {
      const s = n.l2.find((o) => o.id === a.pId);
      if (s) {
        const o = n.l1.find((i) => i.id === s.pId);
        if (o)
          return {
            manufacturer: o,
            model: s,
            object: a
          };
      }
    }
  }
  getDependantObjectsForImplant(t) {
    return Yg(t, this.objectDepsCache, () => this.buildDependantForImplant(t));
  }
  buildDependantForImplant(t) {
    const n = this.implants().find(Qg(t));
    let a = [], s = [], o = [], i = [];
    if (n && n.abutmentIds && n.abutmentIds.length > 0) {
      const r = this.abutmentManufacturers();
      o = this.abutments().filter((l) => {
        var c;
        return (c = n.abutmentIds) == null ? void 0 : c.some((u) => u === l.id);
      }), s = this.abutmentModels().filter((l) => o.some((c) => c.pId === l.id)), a = r.filter((l) => s.some((c) => c.pId === l.id));
    }
    return n && n.extrusionIds && n.extrusionIds.length > 0 && (i = this.getExtrusionElements().filter((r) => {
      var l;
      return (l = n.extrusionIds) == null ? void 0 : l.some((c) => c === r.id);
    })), {
      abManufacturers: a,
      abAbutments: o,
      abModels: s,
      extrusions: i
    };
  }
}
const da = _n("notificationStore", {
  state: () => ({
    message: {}
  }),
  actions: {
    add(e) {
      this.message = e;
    }
  }
});
function h1() {
  const e = da();
  Ne(() => {
    const t = Gf();
    e.$subscribe((n, a) => {
      const { severity: s, summary: o, detail: i, life: r, closable: l } = a.message;
      t.add({ severity: s, summary: o, detail: i, life: r, closable: l });
    });
  });
}
function Ge(e, t = Ce("shared.success")) {
  da().add({
    closable: !0,
    severity: "success",
    life: 3e3,
    summary: t,
    detail: e
  });
}
function v1(e, t, n = Ce("shared.error")) {
  var r;
  const a = (r = t == null ? void 0 : t.response) == null ? void 0 : r.data, o = (typeof a == "string" ? a : a == null ? void 0 : a.message) || (t == null ? void 0 : t.message);
  da().add({
    closable: !0,
    severity: "error",
    life: 3e3,
    summary: n,
    detail: o ? `${e}: ${o}` : e
  });
}
function Te(e, t = Ce("shared.error")) {
  da().add({
    closable: !0,
    severity: "error",
    life: 3e3,
    summary: t,
    detail: e
  });
}
function b1(e, t = Ce("shared.info")) {
  da().add({
    closable: !0,
    severity: "info",
    life: 3e3,
    summary: t,
    detail: `${e}`
  });
}
function x1(e, t = Ce("implant-planner.warning")) {
  da().add({
    closable: !0,
    severity: "warn",
    life: 3e3,
    summary: t,
    detail: `${e}`
  });
}
function Wa(e) {
  return e.weblinkRole === ja.ADMIN;
}
function Us(e) {
  return Wa(e) || e.weblinkRole === ja.OPERATOR;
}
function Ys(e) {
  return e.weblinkRole === ja.READONLY_OPERATOR;
}
function y1(e) {
  return e.weblinkRole === ja.USER;
}
function Gg(e) {
  if (Wa(e))
    return !0;
  const t = Us(e) || Ys(e), n = e.weblinkPermissions ? e.weblinkPermissions.includes(Ha.EDIT_WORKFLOWS) : !1;
  return t && n;
}
function jg(e) {
  if (Wa(e))
    return !0;
  const t = Us(e) || Ys(e), n = e.weblinkPermissions ? e.weblinkPermissions.includes(Ha.EDIT_USERS) : !1;
  return t && n;
}
function Lr(e) {
  if (Wa(e))
    return !0;
  const t = Us(e) || Ys(e), n = e.weblinkPermissions ? e.weblinkPermissions.includes(Ha.EDIT_MATERIAL_LIB) : !1;
  return t && n;
}
function Hg(e) {
  let t = "empty name";
  if (e.data) {
    const { firstName: n, lastName: a } = e.data;
    (n || a) && (t = `${n || ""} ${a || ""}`.trim());
  }
  return t;
}
function E1(e) {
  return Wa(e) || Us(e) || Ys(e) || Lr(e) ? Gg(e) || jg(e) || Lr(e) : !1;
}
function C1(e) {
  return e.username == "test_admin_1";
}
function es(e) {
  return e.data.organization ? e.data.organization : Hg(e);
}
const Ei = void 0, Un = "undefined", Ci = "function";
let Hc = 2;
try {
  typeof navigator != Un && navigator.hardwareConcurrency && (Hc = navigator.hardwareConcurrency);
} catch {
}
const Vg = {
  workerURI: "./core/web-worker-wasm.js",
  wasmURI: "./core/streams/zlib-wasm/zlib-streams.wasm",
  chunkSize: 64 * 1024,
  maxWorkers: Hc,
  terminateWorkerTimeout: 5e3,
  useWebWorkers: !0,
  useCompressionStream: !0,
  CompressionStream: typeof CompressionStream != Un && CompressionStream,
  DecompressionStream: typeof DecompressionStream != Un && DecompressionStream
}, Kg = Object.assign({}, Vg);
function Gs(e) {
  const {
    baseURI: t,
    chunkSize: n,
    maxWorkers: a,
    terminateWorkerTimeout: s,
    useCompressionStream: o,
    useWebWorkers: i,
    CompressionStream: r,
    DecompressionStream: l,
    CompressionStreamZlib: c,
    DecompressionStreamZlib: u,
    workerURI: p,
    wasmURI: m
  } = e;
  ht("baseURI", t), ht("wasmURI", m), ht("workerURI", p), ht("chunkSize", n), ht("maxWorkers", a), ht("terminateWorkerTimeout", s), ht("useCompressionStream", o), ht("useWebWorkers", i), ht("CompressionStream", r), ht("DecompressionStream", l), ht("CompressionStreamZlib", c), ht("DecompressionStreamZlib", u);
}
function ht(e, t) {
  t !== Ei && (Kg[e] = t);
}
function Wg(e) {
  let t;
  e({ workerURI: () => (t || (t = "data:text/javascript," + encodeURIComponent(`(t=>{"function"==typeof define&&define.amd?define(t):t()})(function(){"use strict";const{Array:t,Object:e,Number:n,Math:s,Error:r,Uint8Array:o,Uint16Array:i,Uint32Array:c,Int32Array:a,Map:h,DataView:f,Promise:l,TextEncoder:u,crypto:w,postMessage:p,TransformStream:d,ReadableStream:y,WritableStream:m,CompressionStream:g,DecompressionStream:S}=self,b=void 0,v="undefined",k="function",z=[];for(let t=0;256>t;t++){let e=t;for(let t=0;8>t;t++)1&e?e=e>>>1^3988292384:e>>>=1;z[t]=e}class C{constructor(t){this.t=t||-1}append(t){let e=0|this.t;for(let n=0,s=0|t.length;s>n;n++)e=e>>>8^z[255&(e^t[n])];this.t=e}get(){return~this.t}}class A extends d{constructor(){let t;const e=new C;super({transform(t,n){e.append(t),n.enqueue(t)},flush(){const n=new o(4);new f(n.buffer).setUint32(0,e.get()),t.value=n}}),t=this}}const x={concat(t,e){if(0===t.length||0===e.length)return t.concat(e);const n=t[t.length-1],s=x.o(n);return 32===s?t.concat(e):x.i(e,s,0|n,t.slice(0,t.length-1))},h(t){const e=t.length;if(0===e)return 0;const n=t[e-1];return 32*(e-1)+x.o(n)},l(t,e){if(32*t.length<e)return t;const n=(t=t.slice(0,s.ceil(e/32))).length;return e&=31,n>0&&e&&(t[n-1]=x.u(e,t[n-1]&2147483648>>e-1,1)),t},u:(t,e,n)=>32===t?e:(n?0|e:e<<32-t)+1099511627776*t,o:t=>s.round(t/1099511627776)||32,i(t,e,n,s){for(void 0===s&&(s=[]);e>=32;e-=32)s.push(n),n=0;if(0===e)return s.concat(t);for(let r=0;r<t.length;r++)s.push(n|t[r]>>>e),n=t[r]<<32-e;const r=t.length?t[t.length-1]:0,o=x.o(r);return s.push(x.u(e+o&31,e+o>32?n:s.pop(),1)),s}},I={bytes:{p(t){const e=x.h(t)/8,n=new o(e);let s;for(let r=0;e>r;r++)3&r||(s=t[r/4]),n[r]=s>>>24,s<<=8;return n},m(t){const e=[];let n,s=0;for(n=0;n<t.length;n++)s=s<<8|t[n],3&~n||(e.push(s),s=0);return 3&n&&e.push(x.u(8*(3&n),s)),e}}},R=class{constructor(t){const e=this;e.blockSize=512,e.S=[1732584193,4023233417,2562383102,271733878,3285377520],e.v=[1518500249,1859775393,2400959708,3395469782],t?(e.k=t.k.slice(0),e.C=t.C.slice(0),e.A=t.A):e.reset()}reset(){const t=this;return t.k=t.S.slice(0),t.C=[],t.A=0,t}update(t){const e=this;"string"==typeof t&&(t=I.I.m(t));const n=e.C=x.concat(e.C,t),s=e.A,o=e.A=s+x.h(t);if(o>9007199254740991)throw new r("Cannot hash more than 2^53 - 1 bits");const i=new c(n);let a=0;for(let t=e.blockSize+s-(e.blockSize+s&e.blockSize-1);o>=t;t+=e.blockSize)e.R(i.subarray(16*a,16*(a+1))),a+=1;return n.splice(0,16*a),e}P(){const t=this;let e=t.C;const n=t.k;e=x.concat(e,[x.u(1,1)]);for(let t=e.length+2;15&t;t++)e.push(0);for(e.push(s.floor(t.A/4294967296)),e.push(0|t.A);e.length;)t.R(e.splice(0,16));return t.reset(),n}U(t,e,n,s){return t>19?t>39?t>59?t>79?void 0:e^n^s:e&n|e&s|n&s:e^n^s:e&n|~e&s}V(t,e){return e<<t|e>>>32-t}R(e){const n=this,r=n.k,o=t(80);for(let t=0;16>t;t++)o[t]=e[t];let i=r[0],c=r[1],a=r[2],h=r[3],f=r[4];for(let t=0;79>=t;t++){16>t||(o[t]=n.V(1,o[t-3]^o[t-8]^o[t-14]^o[t-16]));const e=n.V(5,i)+n.U(t,c,a,h)+f+o[t]+n.v[s.floor(t/20)]|0;f=h,h=a,a=n.V(30,c),c=i,i=e}r[0]=r[0]+i|0,r[1]=r[1]+c|0,r[2]=r[2]+a|0,r[3]=r[3]+h|0,r[4]=r[4]+f|0}},P={getRandomValues(t){const e=new c(t.buffer),n=t=>{let e=987654321;const n=4294967295;return()=>(e=36969*(65535&e)+(e>>16)&n,(((e<<16)+(t=18e3*(65535&t)+(t>>16)&n)&n)/4294967296+.5)*(s.random()>.5?1:-1))};for(let r,o=0;o<t.length;o+=4){const t=n(4294967296*(r||s.random()));r=987654071*t(),e[o/4]=4294967296*t()|0}return t}},U={importKey:t=>new U.M(I.bytes.m(t)),_(t,e,n,s){if(n=n||1e4,0>s||0>n)throw new r("invalid params to pbkdf2");const o=1+(s>>5)<<2;let i,c,a,h,l;const u=new ArrayBuffer(o),w=new f(u);let p=0;const d=x;for(e=I.bytes.m(e),l=1;(o||1)>p;l++){for(i=c=t.encrypt(d.concat(e,[l])),a=1;n>a;a++)for(c=t.encrypt(c),h=0;h<c.length;h++)i[h]^=c[h];for(a=0;(o||1)>p&&a<i.length;a++)w.setInt32(p,i[a]),p+=4}return u.slice(0,s/8)},M:class{constructor(t){const e=this,n=e.B=R,s=[[],[]];e.D=[new n,new n];const r=e.D[0].blockSize/32;t.length>r&&(t=(new n).update(t).P());for(let e=0;r>e;e++)s[0][e]=909522486^t[e],s[1][e]=1549556828^t[e];e.D[0].update(s[0]),e.D[1].update(s[1]),e.W=new n(e.D[0])}reset(){const t=this;t.W=new t.B(t.D[0]),t.K=!1}update(t){this.K=!0,this.W.update(t)}digest(){const t=this,e=t.W.P(),n=new t.B(t.D[1]).update(e).P();return t.reset(),n}encrypt(t){if(this.K)throw new r("encrypt on already updated hmac called!");return this.update(t),this.digest(t)}}},V=typeof w!=v&&typeof w.getRandomValues==k,M="Invalid password",_="Invalid signature",B="zipjs-abort-check-password";function D(t){return V?w.getRandomValues(t):P.getRandomValues(t)}const W=16,K={name:"PBKDF2"},E=e.assign({hash:{name:"HMAC"}},K),L=e.assign({iterations:1e3,hash:{name:"SHA-1"}},K),O=["deriveBits"],T=[8,12,16],j=[16,24,32],H=10,Z=[0,0,0,0],F=typeof w!=v,N=F&&w.subtle,q=F&&typeof N!=v,G=I.bytes,J=class{constructor(t){const e=this;e.L=[[[],[],[],[],[]],[[],[],[],[],[]]],e.L[0][0][0]||e.O();const n=e.L[0][4],s=e.L[1],o=t.length;let i,c,a,h=1;if(4!==o&&6!==o&&8!==o)throw new r("invalid aes key size");for(e.v=[c=t.slice(0),a=[]],i=o;4*o+28>i;i++){let t=c[i-1];(i%o===0||8===o&&i%o===4)&&(t=n[t>>>24]<<24^n[t>>16&255]<<16^n[t>>8&255]<<8^n[255&t],i%o===0&&(t=t<<8^t>>>24^h<<24,h=h<<1^283*(h>>7))),c[i]=c[i-o]^t}for(let t=0;i;t++,i--){const e=c[3&t?i:i-4];a[t]=4>=i||4>t?e:s[0][n[e>>>24]]^s[1][n[e>>16&255]]^s[2][n[e>>8&255]]^s[3][n[255&e]]}}encrypt(t){return this.T(t,0)}decrypt(t){return this.T(t,1)}O(){const t=this.L[0],e=this.L[1],n=t[4],s=e[4],r=[],o=[];let i,c,a,h;for(let t=0;256>t;t++)o[(r[t]=t<<1^283*(t>>7))^t]=t;for(let f=i=0;!n[f];f^=c||1,i=o[i]||1){let o=i^i<<1^i<<2^i<<3^i<<4;o=o>>8^255&o^99,n[f]=o,s[o]=f,h=r[a=r[c=r[f]]];let l=16843009*h^65537*a^257*c^16843008*f,u=257*r[o]^16843008*o;for(let n=0;4>n;n++)t[n][f]=u=u<<24^u>>>8,e[n][o]=l=l<<24^l>>>8}for(let n=0;5>n;n++)t[n]=t[n].slice(0),e[n]=e[n].slice(0)}T(t,e){if(4!==t.length)throw new r("invalid aes block size");const n=this.v[e],s=n.length/4-2,o=[0,0,0,0],i=this.L[e],c=i[0],a=i[1],h=i[2],f=i[3],l=i[4];let u,w,p,d=t[0]^n[0],y=t[e?3:1]^n[1],m=t[2]^n[2],g=t[e?1:3]^n[3],S=4;for(let t=0;s>t;t++)u=c[d>>>24]^a[y>>16&255]^h[m>>8&255]^f[255&g]^n[S],w=c[y>>>24]^a[m>>16&255]^h[g>>8&255]^f[255&d]^n[S+1],p=c[m>>>24]^a[g>>16&255]^h[d>>8&255]^f[255&y]^n[S+2],g=c[g>>>24]^a[d>>16&255]^h[y>>8&255]^f[255&m]^n[S+3],S+=4,d=u,y=w,m=p;for(let t=0;4>t;t++)o[e?3&-t:t]=l[d>>>24]<<24^l[y>>16&255]<<16^l[m>>8&255]<<8^l[255&g]^n[S++],u=d,d=y,y=m,m=g,g=u;return o}},Q=class{constructor(t,e){this.j=t,this.H=e,this.Z=e}reset(){this.Z=this.H}update(t){return this.F(this.j,t,this.Z)}N(t){if(255&~(t>>24))t+=1<<24;else{let e=t>>16&255,n=t>>8&255,s=255&t;255===e?(e=0,255===n?(n=0,255===s?s=0:++s):++n):++e,t=0,t+=e<<16,t+=n<<8,t+=s}return t}q(t){0===(t[0]=this.N(t[0]))&&(t[1]=this.N(t[1]))}F(t,e,n){let s;if(!(s=e.length))return[];const r=x.h(e);for(let r=0;s>r;r+=4){this.q(n);const s=t.encrypt(n);e[r]^=s[0],e[r+1]^=s[1],e[r+2]^=s[2],e[r+3]^=s[3]}return x.l(e,r)}},X=U.M;let Y=F&&q&&typeof N.importKey==k,$=F&&q&&typeof N.deriveBits==k;class tt extends d{constructor({password:t,rawPassword:n,signed:s,encryptionStrength:i,checkPasswordOnly:c}){super({start(){e.assign(this,{ready:new l(t=>this.G=t),password:rt(t,n),signed:s,J:i-1,pending:new o})},async transform(t,e){const n=this,{password:s,J:i,G:a,ready:h}=n;s?(await(async(t,e,n,s)=>{const o=await st(t,e,n,it(s,0,T[e])),i=it(s,T[e]);if(o[0]!=i[0]||o[1]!=i[1])throw new r(M)})(n,i,s,it(t,0,T[i]+2)),t=it(t,T[i]+2),c?e.error(new r(B)):a()):await h;const f=new o(t.length-H-(t.length-H)%W);e.enqueue(nt(n,t,f,0,H,!0))},async flush(t){const{signed:e,X:n,Y:s,pending:i,ready:c}=this;if(s&&n){await c;const a=it(i,0,i.length-H),h=it(i,i.length-H);let f=new o;if(a.length){const t=at(G,a);s.update(t);const e=n.update(t);f=ct(G,e)}if(e){const t=it(ct(G,s.digest()),0,H);for(let e=0;H>e;e++)if(t[e]!=h[e])throw new r(_)}t.enqueue(f)}}})}}class et extends d{constructor({password:t,rawPassword:n,encryptionStrength:s}){let r;super({start(){e.assign(this,{ready:new l(t=>this.G=t),password:rt(t,n),J:s-1,pending:new o})},async transform(t,e){const n=this,{password:s,J:r,G:i,ready:c}=n;let a=new o;s?(a=await(async(t,e,n)=>{const s=D(new o(T[e]));return ot(s,await st(t,e,n,s))})(n,r,s),i()):await c;const h=new o(a.length+t.length-t.length%W);h.set(a,0),e.enqueue(nt(n,t,h,a.length,0))},async flush(t){const{X:e,Y:n,pending:s,ready:i}=this;if(n&&e){await i;let c=new o;if(s.length){const t=e.update(at(G,s));n.update(t),c=ct(G,t)}r.signature=ct(G,n.digest()).slice(0,H),t.enqueue(ot(c,r.signature))}}}),r=this}}function nt(t,e,n,s,r,i){const{X:c,Y:a,pending:h}=t,f=e.length-r;let l;for(h.length&&(e=ot(h,e),n=((t,e)=>{if(e&&e>t.length){const n=t;(t=new o(e)).set(n,0)}return t})(n,f-f%W)),l=0;f-W>=l;l+=W){const t=at(G,it(e,l,l+W));i&&a.update(t);const r=c.update(t);i||a.update(r),n.set(ct(G,r),l+s)}return t.pending=it(e,l),n}async function st(n,s,r,i){n.password=null;const c=await(async(t,e,n,s,r)=>{if(!Y)return U.importKey(e);try{return await N.importKey("raw",e,n,!1,r)}catch{return Y=!1,U.importKey(e)}})(0,r,E,0,O),a=await(async(t,e,n)=>{if(!$)return U._(e,t.salt,L.iterations,n);try{return await N.deriveBits(t,e,n)}catch{return $=!1,U._(e,t.salt,L.iterations,n)}})(e.assign({salt:i},L),c,8*(2*j[s]+2)),h=new o(a),f=at(G,it(h,0,j[s])),l=at(G,it(h,j[s],2*j[s])),u=it(h,2*j[s]);return e.assign(n,{keys:{key:f,$:l,passwordVerification:u},X:new Q(new J(f),t.from(Z)),Y:new X(l)}),u}function rt(t,e){return e===b?(t=>{if(typeof u==v){const e=new o((t=unescape(encodeURIComponent(t))).length);for(let n=0;n<e.length;n++)e[n]=t.charCodeAt(n);return e}return(new u).encode(t)})(t):e}function ot(t,e){let n=t;return t.length+e.length&&(n=new o(t.length+e.length),n.set(t,0),n.set(e,t.length)),n}function it(t,e,n){return t.subarray(e,n)}function ct(t,e){return t.p(e)}function at(t,e){return t.m(e)}class ht extends d{constructor({password:t,passwordVerification:n,checkPasswordOnly:s}){super({start(){e.assign(this,{password:t,passwordVerification:n}),wt(this,t)},transform(t,e){const n=this;if(n.password){const e=lt(n,t.subarray(0,12));if(n.password=null,e.at(-1)!=n.passwordVerification)throw new r(M);t=t.subarray(12)}s?e.error(new r(B)):e.enqueue(lt(n,t))}})}}class ft extends d{constructor({password:t,passwordVerification:n}){super({start(){e.assign(this,{password:t,passwordVerification:n}),wt(this,t)},transform(t,e){const n=this;let s,r;if(n.password){n.password=null;const e=D(new o(12));e[11]=n.passwordVerification,s=new o(t.length+e.length),s.set(ut(n,e),0),r=12}else s=new o(t.length),r=0;s.set(ut(n,t),r),e.enqueue(s)}})}}function lt(t,e){const n=new o(e.length);for(let s=0;s<e.length;s++)n[s]=dt(t)^e[s],pt(t,n[s]);return n}function ut(t,e){const n=new o(e.length);for(let s=0;s<e.length;s++)n[s]=dt(t)^e[s],pt(t,e[s]);return n}function wt(t,n){const s=[305419896,591751049,878082192];e.assign(t,{keys:s,tt:new C(s[0]),et:new C(s[2])});for(let e=0;e<n.length;e++)pt(t,n.charCodeAt(e))}function pt(t,e){let[n,r,o]=t.keys;t.tt.append([e]),n=~t.tt.get(),r=mt(s.imul(mt(r+yt(n)),134775813)+1),t.et.append([r>>>24]),o=~t.et.get(),t.keys=[n,r,o]}function dt(t){const e=2|t.keys[2];return yt(s.imul(e,1^e)>>>8)}function yt(t){return 255&t}function mt(t){return 4294967295&t}class gt extends d{constructor(t,{chunkSize:e,nt:n,CompressionStream:s}){super({});const{compressed:r,encrypted:o,useCompressionStream:i,zipCrypto:c,signed:a,level:h}=t,l=this;let u,w,p=super.readable;o&&!c||!a||(u=new A,p=kt(p,u)),r&&(p=vt(p,i,{level:h,chunkSize:e},s,n,s)),o&&(c?p=kt(p,new ft(t)):(w=new et(t),p=kt(p,w))),bt(l,p,()=>{let t;o&&!c&&(t=w.signature),o&&!c||!a||(t=new f(u.value.buffer).getUint32(0)),l.signature=t})}}class St extends d{constructor(t,{chunkSize:e,st:n,DecompressionStream:s}){super({});const{zipCrypto:o,encrypted:i,signed:c,signature:a,compressed:h,useCompressionStream:l,rt:u}=t;let w,p,d=super.readable;i&&(o?d=kt(d,new ht(t)):(p=new tt(t),d=kt(d,p))),h&&(d=vt(d,l,{chunkSize:e,rt:u},s,n,s)),i&&!o||!c||(w=new A,d=kt(d,w)),bt(this,d,()=>{if((!i||o)&&c){const t=new f(w.value.buffer);if(a!=t.getUint32(0,!1))throw new r(_)}})}}function bt(t,n,s){n=kt(n,new d({flush:s})),e.defineProperty(t,"readable",{get:()=>n})}function vt(t,e,n,s,r,o){const i=e&&s?s:r||o,c=n.rt?"deflate64-raw":"deflate-raw";try{t=kt(t,new i(c,n))}catch(s){if(!e)throw s;if(r)t=kt(t,new r(c,n));else{if(!o)throw s;t=kt(t,new o(c,n))}}return t}function kt(t,e){return t.pipeThrough(e)}const zt="data",Ct="close";class At extends d{constructor(t,n){super({});const s=this,{codecType:o}=t;let i;o.startsWith("deflate")?i=gt:o.startsWith("inflate")&&(i=St),s.outputSize=0;let c=0;const a=new i(t,n),h=super.readable,f=new d({transform(t,e){t&&t.length&&(c+=t.length,e.enqueue(t))},flush(){e.assign(s,{inputSize:c})}}),l=new d({transform(e,n){if(e&&e.length&&(n.enqueue(e),s.outputSize+=e.length,t.outputSize!==b&&s.outputSize>t.outputSize))throw new r("Invalid uncompressed size")},flush(){const{signature:t}=a;e.assign(s,{signature:t,inputSize:c})}});e.defineProperty(s,"readable",{get:()=>h.pipeThrough(f).pipeThrough(a).pipeThrough(l)})}}class xt extends d{constructor(t){let e;super({transform:function n(s,r){if(e){const t=new o(e.length+s.length);t.set(e),t.set(s,e.length),s=t,e=null}s.length>t?(r.enqueue(s.slice(0,t)),n(s.slice(t),r)):e=s},flush(t){e&&e.length&&t.enqueue(e)}})}}const It=new h,Rt=new h;let Pt,Ut,Vt,Mt,_t,Bt=0;async function Dt(t){try{const{options:e,config:s}=t;if(!e.useCompressionStream)try{await self.initModule(t.config)}catch{e.useCompressionStream=!0}s.CompressionStream=self.CompressionStream,s.DecompressionStream=self.DecompressionStream;const r={highWaterMark:1},o=t.readable||new y({async pull(t){const e=new l(t=>It.set(Bt,t));Wt({type:"pull",messageId:Bt}),Bt=(Bt+1)%n.MAX_SAFE_INTEGER;const{value:s,done:r}=await e;t.enqueue(s),r&&t.close()}},r),i=t.writable||new m({async write(t){let e;const s=new l(t=>e=t);Rt.set(Bt,e),Wt({type:zt,value:t,messageId:Bt}),Bt=(Bt+1)%n.MAX_SAFE_INTEGER,await s}},r),c=new At(e,s);Pt=new AbortController;const{signal:a}=Pt;await o.pipeThrough(c).pipeThrough(new xt(s.chunkSize)).pipeTo(i,{signal:a,preventClose:!0,preventAbort:!0}),await i.getWriter().close();const{signature:h,inputSize:f,outputSize:u}=c;Wt({type:Ct,result:{signature:h,inputSize:f,outputSize:u}})}catch(t){t.outputSize=0,Kt(t)}}function Wt(t){let{value:e}=t;if(e)if(e.length)try{e=new o(e),t.value=e.buffer,p(t,[t.value])}catch{p(t)}else p(t);else p(t)}function Kt(t=new r("Unknown error")){const{message:e,stack:n,code:s,name:o,outputSize:i}=t;p({error:{message:e,stack:n,code:s,name:o,outputSize:i}})}function Et(t,e,n={}){const i="number"==typeof n.level?n.level:-1,c="number"==typeof n.ot?n.ot:65536,a="number"==typeof n.it?n.it:65536;return new d({start(){let n;if(this.ct=Vt(c),this.in=Vt(a),this.it=a,this.ht=new o(c),t?(this.ft=Ut.deflate_process,this.lt=Ut.deflate_last_consumed,this.ut=Ut.deflate_end,this.wt=Ut.deflate_new(),n="gzip"===e?Ut.deflate_init_gzip(this.wt,i):"deflate-raw"===e?Ut.deflate_init_raw(this.wt,i):Ut.deflate_init(this.wt,i)):"deflate64-raw"===e?(this.ft=Ut.inflate9_process,this.lt=Ut.inflate9_last_consumed,this.ut=Ut.inflate9_end,this.wt=Ut.inflate9_new(),n=Ut.inflate9_init_raw(this.wt)):(this.ft=Ut.inflate_process,this.lt=Ut.inflate_last_consumed,this.ut=Ut.inflate_end,this.wt=Ut.inflate_new(),n="deflate-raw"===e?Ut.inflate_init_raw(this.wt):"gzip"===e?Ut.inflate_init_gzip(this.wt):Ut.inflate_init(this.wt)),0!==n)throw new r("init failed:"+n)},transform(e,n){try{const i=e,a=new o(_t.buffer),h=this.ft,f=this.lt,l=this.ct,u=this.ht;let w=0;for(;w<i.length;){const e=s.min(i.length-w,32768);this.in&&this.it>=e||(this.in&&Mt&&Mt(this.in),this.in=Vt(e),this.it=e),a.set(i.subarray(w,w+e),this.in);const o=h(this.wt,this.in,e,l,c,0);if(!t&&0>o)throw new r("process error:"+o);const p=16777215&o;p&&(u.set(a.subarray(l,l+p),0),n.enqueue(u.slice(0,p)));const d=f(this.wt);if(0===d)break;w+=d}}catch(t){this.ut&&this.wt&&this.ut(this.wt),this.in&&Mt&&Mt(this.in),this.ct&&Mt&&Mt(this.ct),n.error(t)}},flush(e){try{const n=new o(_t.buffer),s=this.ft,i=this.ct,a=this.ht;for(;;){const o=s(this.wt,0,0,i,c,4);if(!t&&0>o)throw new r("process error:"+o);const h=16777215&o,f=o>>24&255;if(h&&(a.set(n.subarray(i,i+h),0),e.enqueue(a.slice(0,h))),1===f||0===h)break}}catch(t){e.error(t)}finally{if(this.ut&&this.wt){const t=this.ut(this.wt);0!==t&&e.error(new r("end error:"+t))}this.in&&Mt&&Mt(this.in),this.ct&&Mt&&Mt(this.ct)}}})}addEventListener("message",({data:t})=>{const{type:e,messageId:n,value:s,done:r}=t;try{if("start"==e&&Dt(t),e==zt){const t=It.get(n);It.delete(n),t({value:new o(s),done:r})}if("ack"==e){const t=Rt.get(n);Rt.delete(n),t()}e==Ct&&Pt.abort()}catch(t){Kt(t)}});class Lt{constructor(t="deflate",e){return Et(!0,t,e)}}class Ot{constructor(t="deflate",e){return Et(!1,t,e)}}let Tt=!1;self.initModule=async t=>{try{const e=await(async(t,{baseURI:e})=>{if(!Tt){let n,s;try{try{s=new URL(t,e)}catch{}const r=await fetch(s);n=await r.arrayBuffer()}catch(e){if(!t.startsWith("data:application/wasm;base64,"))throw e;n=(t=>{const e=t.split(",")[1],n=atob(e),s=n.length,r=new o(s);for(let t=0;s>t;++t)r[t]=n.charCodeAt(t);return r.buffer})(t)}(t=>{if(Ut=t,({malloc:Vt,free:Mt,memory:_t}=Ut),"function"!=typeof Vt||"function"!=typeof Mt||!_t)throw Ut=Vt=Mt=_t=null,new r("Invalid WASM module")})((await WebAssembly.instantiate(n)).instance.exports),Tt=!0}})(t.wasmURI,t);return t.nt=Lt,t.st=Ot,e}catch{}}});
`)), t) });
}
const Vc = [];
for (let e = 0; e < 256; e++) {
  let t = e;
  for (let n = 0; n < 8; n++)
    t & 1 ? t = t >>> 1 ^ 3988292384 : t = t >>> 1;
  Vc[e] = t;
}
class Uo {
  constructor(t) {
    this.crc = t || -1;
  }
  append(t) {
    let n = this.crc | 0;
    for (let a = 0, s = t.length | 0; a < s; a++)
      n = n >>> 8 ^ Vc[(n ^ t[a]) & 255];
    this.crc = n;
  }
  get() {
    return ~this.crc;
  }
}
class Kc extends TransformStream {
  constructor() {
    let t;
    const n = new Uo();
    super({
      transform(a, s) {
        n.append(a), s.enqueue(a);
      },
      flush() {
        const a = new Uint8Array(4);
        new DataView(a.buffer).setUint32(0, n.get()), t.value = a;
      }
    }), t = this;
  }
}
function zg(e) {
  if (typeof TextEncoder == Un) {
    e = unescape(encodeURIComponent(e));
    const t = new Uint8Array(e.length);
    for (let n = 0; n < t.length; n++)
      t[n] = e.charCodeAt(n);
    return t;
  } else
    return new TextEncoder().encode(e);
}
const nt = {
  /**
   * Concatenate two bit arrays.
   * @param {bitArray} a1 The first array.
   * @param {bitArray} a2 The second array.
   * @return {bitArray} The concatenation of a1 and a2.
   */
  concat(e, t) {
    if (e.length === 0 || t.length === 0)
      return e.concat(t);
    const n = e[e.length - 1], a = nt.getPartial(n);
    return a === 32 ? e.concat(t) : nt._shiftRight(t, a, n | 0, e.slice(0, e.length - 1));
  },
  /**
   * Find the length of an array of bits.
   * @param {bitArray} a The array.
   * @return {Number} The length of a, in bits.
   */
  bitLength(e) {
    const t = e.length;
    if (t === 0)
      return 0;
    const n = e[t - 1];
    return (t - 1) * 32 + nt.getPartial(n);
  },
  /**
   * Truncate an array.
   * @param {bitArray} a The array.
   * @param {Number} len The length to truncate to, in bits.
   * @return {bitArray} A new array, truncated to len bits.
   */
  clamp(e, t) {
    if (e.length * 32 < t)
      return e;
    e = e.slice(0, Math.ceil(t / 32));
    const n = e.length;
    return t = t & 31, n > 0 && t && (e[n - 1] = nt.partial(t, e[n - 1] & 2147483648 >> t - 1, 1)), e;
  },
  /**
   * Make a partial word for a bit array.
   * @param {Number} len The number of bits in the word.
   * @param {Number} x The bits.
   * @param {Number} [_end=0] Pass 1 if x has already been shifted to the high side.
   * @return {Number} The partial word.
   */
  partial(e, t, n) {
    return e === 32 ? t : (n ? t | 0 : t << 32 - e) + e * 1099511627776;
  },
  /**
   * Get the number of bits used by a partial word.
   * @param {Number} x The partial word.
   * @return {Number} The number of bits used by the partial word.
   */
  getPartial(e) {
    return Math.round(e / 1099511627776) || 32;
  },
  /** Shift an array right.
   * @param {bitArray} a The array to shift.
   * @param {Number} shift The number of bits to shift.
   * @param {Number} [carry=0] A byte to carry in
   * @param {bitArray} [out=[]] An array to prepend to the output.
   * @private
   */
  _shiftRight(e, t, n, a) {
    for (a === void 0 && (a = []); t >= 32; t -= 32)
      a.push(n), n = 0;
    if (t === 0)
      return a.concat(e);
    for (let i = 0; i < e.length; i++)
      a.push(n | e[i] >>> t), n = e[i] << 32 - t;
    const s = e.length ? e[e.length - 1] : 0, o = nt.getPartial(s);
    return a.push(nt.partial(t + o & 31, t + o > 32 ? n : a.pop(), 1)), a;
  }
}, Cs = {
  bytes: {
    /** Convert from a bitArray to an array of bytes. */
    fromBits(e) {
      const n = nt.bitLength(e) / 8, a = new Uint8Array(n);
      let s;
      for (let o = 0; o < n; o++)
        (o & 3) === 0 && (s = e[o / 4]), a[o] = s >>> 24, s <<= 8;
      return a;
    },
    /** Convert from an array of bytes to a bitArray. */
    toBits(e) {
      const t = [];
      let n, a = 0;
      for (n = 0; n < e.length; n++)
        a = a << 8 | e[n], (n & 3) === 3 && (t.push(a), a = 0);
      return n & 3 && t.push(nt.partial(8 * (n & 3), a)), t;
    }
  }
}, Wc = {};
Wc.sha1 = class {
  constructor(e) {
    const t = this;
    t.blockSize = 512, t._init = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], t._key = [1518500249, 1859775393, 2400959708, 3395469782], e ? (t._h = e._h.slice(0), t._buffer = e._buffer.slice(0), t._length = e._length) : t.reset();
  }
  /**
   * Reset the hash state.
   * @return this
   */
  reset() {
    const e = this;
    return e._h = e._init.slice(0), e._buffer = [], e._length = 0, e;
  }
  /**
   * Input several words to the hash.
   * @param {bitArray|String} data the data to hash.
   * @return this
   */
  update(e) {
    const t = this;
    typeof e == "string" && (e = Cs.utf8String.toBits(e));
    const n = t._buffer = nt.concat(t._buffer, e), a = t._length, s = t._length = a + nt.bitLength(e);
    if (s > 9007199254740991)
      throw new Error("Cannot hash more than 2^53 - 1 bits");
    const o = new Uint32Array(n);
    let i = 0;
    for (let r = t.blockSize + a - (t.blockSize + a & t.blockSize - 1); r <= s; r += t.blockSize)
      t._block(o.subarray(16 * i, 16 * (i + 1))), i += 1;
    return n.splice(0, 16 * i), t;
  }
  /**
   * Complete hashing and output the hash value.
   * @return {bitArray} The hash value, an array of 5 big-endian words. TODO
   */
  finalize() {
    const e = this;
    let t = e._buffer;
    const n = e._h;
    t = nt.concat(t, [nt.partial(1, 1)]);
    for (let a = t.length + 2; a & 15; a++)
      t.push(0);
    for (t.push(Math.floor(e._length / 4294967296)), t.push(e._length | 0); t.length; )
      e._block(t.splice(0, 16));
    return e.reset(), n;
  }
  /**
   * The SHA-1 logical functions f(0), f(1), ..., f(79).
   * @private
   */
  _f(e, t, n, a) {
    if (e <= 19)
      return t & n | ~t & a;
    if (e <= 39)
      return t ^ n ^ a;
    if (e <= 59)
      return t & n | t & a | n & a;
    if (e <= 79)
      return t ^ n ^ a;
  }
  /**
   * Circular left-shift operator.
   * @private
   */
  _S(e, t) {
    return t << e | t >>> 32 - e;
  }
  /**
   * Perform one cycle of SHA-1.
   * @param {Uint32Array|bitArray} words one block of words.
   * @private
   */
  _block(e) {
    const t = this, n = t._h, a = Array(80);
    for (let c = 0; c < 16; c++)
      a[c] = e[c];
    let s = n[0], o = n[1], i = n[2], r = n[3], l = n[4];
    for (let c = 0; c <= 79; c++) {
      c >= 16 && (a[c] = t._S(1, a[c - 3] ^ a[c - 8] ^ a[c - 14] ^ a[c - 16]));
      const u = t._S(5, s) + t._f(c, o, i, r) + l + a[c] + t._key[Math.floor(c / 20)] | 0;
      l = r, r = i, i = t._S(30, o), o = s, s = u;
    }
    n[0] = n[0] + s | 0, n[1] = n[1] + o | 0, n[2] = n[2] + i | 0, n[3] = n[3] + r | 0, n[4] = n[4] + l | 0;
  }
};
const zc = {};
zc.aes = class {
  constructor(e) {
    const t = this;
    t._tables = [[[], [], [], [], []], [[], [], [], [], []]], t._tables[0][0][0] || t._precompute();
    const n = t._tables[0][4], a = t._tables[1], s = e.length;
    let o, i, r, l = 1;
    if (s !== 4 && s !== 6 && s !== 8)
      throw new Error("invalid aes key size");
    for (t._key = [i = e.slice(0), r = []], o = s; o < 4 * s + 28; o++) {
      let c = i[o - 1];
      (o % s === 0 || s === 8 && o % s === 4) && (c = n[c >>> 24] << 24 ^ n[c >> 16 & 255] << 16 ^ n[c >> 8 & 255] << 8 ^ n[c & 255], o % s === 0 && (c = c << 8 ^ c >>> 24 ^ l << 24, l = l << 1 ^ (l >> 7) * 283)), i[o] = i[o - s] ^ c;
    }
    for (let c = 0; o; c++, o--) {
      const u = i[c & 3 ? o : o - 4];
      o <= 4 || c < 4 ? r[c] = u : r[c] = a[0][n[u >>> 24]] ^ a[1][n[u >> 16 & 255]] ^ a[2][n[u >> 8 & 255]] ^ a[3][n[u & 255]];
    }
  }
  // public
  /* Something like this might appear here eventually
  name: "AES",
  blockSize: 4,
  keySizes: [4,6,8],
  */
  /**
   * Encrypt an array of 4 big-endian words.
   * @param {Array} data The plaintext.
   * @return {Array} The ciphertext.
   */
  encrypt(e) {
    return this._crypt(e, 0);
  }
  /**
   * Decrypt an array of 4 big-endian words.
   * @param {Array} data The ciphertext.
   * @return {Array} The plaintext.
   */
  decrypt(e) {
    return this._crypt(e, 1);
  }
  /**
   * Expand the S-box tables.
   *
   * @private
   */
  _precompute() {
    const e = this._tables[0], t = this._tables[1], n = e[4], a = t[4], s = [], o = [];
    let i, r, l, c;
    for (let u = 0; u < 256; u++)
      o[(s[u] = u << 1 ^ (u >> 7) * 283) ^ u] = u;
    for (let u = i = 0; !n[u]; u ^= r || 1, i = o[i] || 1) {
      let p = i ^ i << 1 ^ i << 2 ^ i << 3 ^ i << 4;
      p = p >> 8 ^ p & 255 ^ 99, n[u] = p, a[p] = u, c = s[l = s[r = s[u]]];
      let m = c * 16843009 ^ l * 65537 ^ r * 257 ^ u * 16843008, v = s[p] * 257 ^ p * 16843008;
      for (let A = 0; A < 4; A++)
        e[A][u] = v = v << 24 ^ v >>> 8, t[A][p] = m = m << 24 ^ m >>> 8;
    }
    for (let u = 0; u < 5; u++)
      e[u] = e[u].slice(0), t[u] = t[u].slice(0);
  }
  /**
   * Encryption and decryption core.
   * @param {Array} input Four words to be encrypted or decrypted.
   * @param dir The direction, 0 for encrypt and 1 for decrypt.
   * @return {Array} The four encrypted or decrypted words.
   * @private
   */
  _crypt(e, t) {
    if (e.length !== 4)
      throw new Error("invalid aes block size");
    const n = this._key[t], a = n.length / 4 - 2, s = [0, 0, 0, 0], o = this._tables[t], i = o[0], r = o[1], l = o[2], c = o[3], u = o[4];
    let p = e[0] ^ n[0], m = e[t ? 3 : 1] ^ n[1], v = e[2] ^ n[2], A = e[t ? 1 : 3] ^ n[3], h = 4, d, f, g;
    for (let B = 0; B < a; B++)
      d = i[p >>> 24] ^ r[m >> 16 & 255] ^ l[v >> 8 & 255] ^ c[A & 255] ^ n[h], f = i[m >>> 24] ^ r[v >> 16 & 255] ^ l[A >> 8 & 255] ^ c[p & 255] ^ n[h + 1], g = i[v >>> 24] ^ r[A >> 16 & 255] ^ l[p >> 8 & 255] ^ c[m & 255] ^ n[h + 2], A = i[A >>> 24] ^ r[p >> 16 & 255] ^ l[m >> 8 & 255] ^ c[v & 255] ^ n[h + 3], h += 4, p = d, m = f, v = g;
    for (let B = 0; B < 4; B++)
      s[t ? 3 & -B : B] = u[p >>> 24] << 24 ^ u[m >> 16 & 255] << 16 ^ u[v >> 8 & 255] << 8 ^ u[A & 255] ^ n[h++], d = p, p = m, m = v, v = A, A = d;
    return s;
  }
};
const $g = {
  /** 
   * Generate random words with pure js, cryptographically not as strong & safe as native implementation.
   * @param {TypedArray} typedArray The array to fill.
   * @return {TypedArray} The random values.
   */
  getRandomValues(e) {
    const t = new Uint32Array(e.buffer), n = (a) => {
      let s = 987654321;
      const o = 4294967295;
      return function() {
        return s = 36969 * (s & 65535) + (s >> 16) & o, a = 18e3 * (a & 65535) + (a >> 16) & o, (((s << 16) + a & o) / 4294967296 + 0.5) * (Math.random() > 0.5 ? 1 : -1);
      };
    };
    for (let a = 0, s; a < e.length; a += 4) {
      const o = n((s || Math.random()) * 4294967296);
      s = o() * 987654071, t[a / 4] = o() * 4294967296 | 0;
    }
    return e;
  }
}, $c = {};
$c.ctrGladman = class {
  constructor(e, t) {
    this._prf = e, this._initIv = t, this._iv = t;
  }
  reset() {
    this._iv = this._initIv;
  }
  /** Input some data to calculate.
   * @param {bitArray} data the data to process, it must be intergral multiple of 128 bits unless it's the last.
   */
  update(e) {
    return this.calculate(this._prf, e, this._iv);
  }
  incWord(e) {
    if ((e >> 24 & 255) === 255) {
      let t = e >> 16 & 255, n = e >> 8 & 255, a = e & 255;
      t === 255 ? (t = 0, n === 255 ? (n = 0, a === 255 ? a = 0 : ++a) : ++n) : ++t, e = 0, e += t << 16, e += n << 8, e += a;
    } else
      e += 1 << 24;
    return e;
  }
  incCounter(e) {
    (e[0] = this.incWord(e[0])) === 0 && (e[1] = this.incWord(e[1]));
  }
  calculate(e, t, n) {
    let a;
    if (!(a = t.length))
      return [];
    const s = nt.bitLength(t);
    for (let o = 0; o < a; o += 4) {
      this.incCounter(n);
      const i = e.encrypt(n);
      t[o] ^= i[0], t[o + 1] ^= i[1], t[o + 2] ^= i[2], t[o + 3] ^= i[3];
    }
    return nt.clamp(t, s);
  }
};
const Yn = {
  importKey(e) {
    return new Yn.hmacSha1(Cs.bytes.toBits(e));
  },
  pbkdf2(e, t, n, a) {
    if (n = n || 1e4, a < 0 || n < 0)
      throw new Error("invalid params to pbkdf2");
    const s = (a >> 5) + 1 << 2;
    let o, i, r, l, c;
    const u = new ArrayBuffer(s), p = new DataView(u);
    let m = 0;
    const v = nt;
    for (t = Cs.bytes.toBits(t), c = 1; m < (s || 1); c++) {
      for (o = i = e.encrypt(v.concat(t, [c])), r = 1; r < n; r++)
        for (i = e.encrypt(i), l = 0; l < i.length; l++)
          o[l] ^= i[l];
      for (r = 0; m < (s || 1) && r < o.length; r++)
        p.setInt32(m, o[r]), m += 4;
    }
    return u.slice(0, a / 8);
  }
};
Yn.hmacSha1 = class {
  constructor(e) {
    const t = this, n = t._hash = Wc.sha1, a = [[], []];
    t._baseHash = [new n(), new n()];
    const s = t._baseHash[0].blockSize / 32;
    e.length > s && (e = new n().update(e).finalize());
    for (let o = 0; o < s; o++)
      a[0][o] = e[o] ^ 909522486, a[1][o] = e[o] ^ 1549556828;
    t._baseHash[0].update(a[0]), t._baseHash[1].update(a[1]), t._resultHash = new n(t._baseHash[0]);
  }
  reset() {
    const e = this;
    e._resultHash = new e._hash(e._baseHash[0]), e._updated = !1;
  }
  update(e) {
    const t = this;
    t._updated = !0, t._resultHash.update(e);
  }
  digest() {
    const e = this, t = e._resultHash.finalize(), n = new e._hash(e._baseHash[1]).update(t).finalize();
    return e.reset(), n;
  }
  encrypt(e) {
    if (this._updated)
      throw new Error("encrypt on already updated hmac called!");
    return this.update(e), this.digest(e);
  }
};
const Jg = typeof crypto != Un && typeof crypto.getRandomValues == Ci, Jc = "Invalid password", qc = "Invalid signature", Xc = "zipjs-abort-check-password";
function Zc(e) {
  return Jg ? crypto.getRandomValues(e) : $g.getRandomValues(e);
}
const Xn = 16, qg = "raw", eu = { name: "PBKDF2" }, Xg = { name: "HMAC" }, Zg = "SHA-1", eh = Object.assign({ hash: Xg }, eu), Yo = Object.assign({ iterations: 1e3, hash: { name: Zg } }, eu), th = ["deriveBits"], Oa = [8, 12, 16], ga = [16, 24, 32], An = 10, nh = [0, 0, 0, 0], js = typeof crypto != Un, za = js && crypto.subtle, tu = js && typeof za != Un, Ht = Cs.bytes, ah = zc.aes, sh = $c.ctrGladman, oh = Yn.hmacSha1;
let Dr = js && tu && typeof za.importKey == Ci, Mr = js && tu && typeof za.deriveBits == Ci;
class ih extends TransformStream {
  constructor({ password: t, rawPassword: n, signed: a, encryptionStrength: s, checkPasswordOnly: o }) {
    super({
      start() {
        Object.assign(this, {
          ready: new Promise((i) => this.resolveReady = i),
          password: su(t, n),
          signed: a,
          strength: s - 1,
          pending: new Uint8Array()
        });
      },
      async transform(i, r) {
        const l = this, {
          password: c,
          strength: u,
          resolveReady: p,
          ready: m
        } = l;
        c ? (await lh(l, u, c, bt(i, 0, Oa[u] + 2)), i = bt(i, Oa[u] + 2), o ? r.error(new Error(Xc)) : p()) : await m;
        const v = new Uint8Array(i.length - An - (i.length - An) % Xn);
        r.enqueue(nu(l, i, v, 0, An, !0));
      },
      async flush(i) {
        const {
          signed: r,
          ctr: l,
          hmac: c,
          pending: u,
          ready: p
        } = this;
        if (c && l) {
          await p;
          const m = bt(u, 0, u.length - An), v = bt(u, u.length - An);
          let A = new Uint8Array();
          if (m.length) {
            const h = Ra(Ht, m);
            c.update(h);
            const d = l.update(h);
            A = Na(Ht, d);
          }
          if (r) {
            const h = bt(Na(Ht, c.digest()), 0, An);
            for (let d = 0; d < An; d++)
              if (h[d] != v[d])
                throw new Error(qc);
          }
          i.enqueue(A);
        }
      }
    });
  }
}
class rh extends TransformStream {
  constructor({ password: t, rawPassword: n, encryptionStrength: a }) {
    let s;
    super({
      start() {
        Object.assign(this, {
          ready: new Promise((o) => this.resolveReady = o),
          password: su(t, n),
          strength: a - 1,
          pending: new Uint8Array()
        });
      },
      async transform(o, i) {
        const r = this, {
          password: l,
          strength: c,
          resolveReady: u,
          ready: p
        } = r;
        let m = new Uint8Array();
        l ? (m = await ch(r, c, l), u()) : await p;
        const v = new Uint8Array(m.length + o.length - o.length % Xn);
        v.set(m, 0), i.enqueue(nu(r, o, v, m.length, 0));
      },
      async flush(o) {
        const {
          ctr: i,
          hmac: r,
          pending: l,
          ready: c
        } = this;
        if (r && i) {
          await c;
          let u = new Uint8Array();
          if (l.length) {
            const p = i.update(Ra(Ht, l));
            r.update(p), u = Na(Ht, p);
          }
          s.signature = Na(Ht, r.digest()).slice(0, An), o.enqueue(Bi(u, s.signature));
        }
      }
    }), s = this;
  }
}
function nu(e, t, n, a, s, o) {
  const {
    ctr: i,
    hmac: r,
    pending: l
  } = e, c = t.length - s;
  l.length && (t = Bi(l, t), n = fh(n, c - c % Xn));
  let u;
  for (u = 0; u <= c - Xn; u += Xn) {
    const p = Ra(Ht, bt(t, u, u + Xn));
    o && r.update(p);
    const m = i.update(p);
    o || r.update(m), n.set(Na(Ht, m), u + a);
  }
  return e.pending = bt(t, u), n;
}
async function lh(e, t, n, a) {
  const s = await au(e, t, n, bt(a, 0, Oa[t])), o = bt(a, Oa[t]);
  if (s[0] != o[0] || s[1] != o[1])
    throw new Error(Jc);
}
async function ch(e, t, n) {
  const a = Zc(new Uint8Array(Oa[t])), s = await au(e, t, n, a);
  return Bi(a, s);
}
async function au(e, t, n, a) {
  e.password = null;
  const s = await uh(qg, n, eh, !1, th), o = await dh(Object.assign({ salt: a }, Yo), s, 8 * (ga[t] * 2 + 2)), i = new Uint8Array(o), r = Ra(Ht, bt(i, 0, ga[t])), l = Ra(Ht, bt(i, ga[t], ga[t] * 2)), c = bt(i, ga[t] * 2);
  return Object.assign(e, {
    keys: {
      key: r,
      authentication: l,
      passwordVerification: c
    },
    ctr: new sh(new ah(r), Array.from(nh)),
    hmac: new oh(l)
  }), c;
}
async function uh(e, t, n, a, s) {
  if (Dr)
    try {
      return await za.importKey(e, t, n, a, s);
    } catch {
      return Dr = !1, Yn.importKey(t);
    }
  else
    return Yn.importKey(t);
}
async function dh(e, t, n) {
  if (Mr)
    try {
      return await za.deriveBits(e, t, n);
    } catch {
      return Mr = !1, Yn.pbkdf2(t, e.salt, Yo.iterations, n);
    }
  else
    return Yn.pbkdf2(t, e.salt, Yo.iterations, n);
}
function su(e, t) {
  return t === Ei ? zg(e) : t;
}
function Bi(e, t) {
  let n = e;
  return e.length + t.length && (n = new Uint8Array(e.length + t.length), n.set(e, 0), n.set(t, e.length)), n;
}
function fh(e, t) {
  if (t && t > e.length) {
    const n = e;
    e = new Uint8Array(t), e.set(n, 0);
  }
  return e;
}
function bt(e, t, n) {
  return e.subarray(t, n);
}
function Na(e, t) {
  return e.fromBits(t);
}
function Ra(e, t) {
  return e.toBits(t);
}
const Ia = 12;
class ph extends TransformStream {
  constructor({ password: t, passwordVerification: n, checkPasswordOnly: a }) {
    super({
      start() {
        Object.assign(this, {
          password: t,
          passwordVerification: n
        }), ou(this, t);
      },
      transform(s, o) {
        const i = this;
        if (i.password) {
          const r = Or(i, s.subarray(0, Ia));
          if (i.password = null, r.at(-1) != i.passwordVerification)
            throw new Error(Jc);
          s = s.subarray(Ia);
        }
        a ? o.error(new Error(Xc)) : o.enqueue(Or(i, s));
      }
    });
  }
}
class mh extends TransformStream {
  constructor({ password: t, passwordVerification: n }) {
    super({
      start() {
        Object.assign(this, {
          password: t,
          passwordVerification: n
        }), ou(this, t);
      },
      transform(a, s) {
        const o = this;
        let i, r;
        if (o.password) {
          o.password = null;
          const l = Zc(new Uint8Array(Ia));
          l[Ia - 1] = o.passwordVerification, i = new Uint8Array(a.length + l.length), i.set(Nr(o, l), 0), r = Ia;
        } else
          i = new Uint8Array(a.length), r = 0;
        i.set(Nr(o, a), r), s.enqueue(i);
      }
    });
  }
}
function Or(e, t) {
  const n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++)
    n[a] = iu(e) ^ t[a], Ii(e, n[a]);
  return n;
}
function Nr(e, t) {
  const n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++)
    n[a] = iu(e) ^ t[a], Ii(e, t[a]);
  return n;
}
function ou(e, t) {
  const n = [305419896, 591751049, 878082192];
  Object.assign(e, {
    keys: n,
    crcKey0: new Uo(n[0]),
    crcKey2: new Uo(n[2])
  });
  for (let a = 0; a < t.length; a++)
    Ii(e, t.charCodeAt(a));
}
function Ii(e, t) {
  let [n, a, s] = e.keys;
  e.crcKey0.append([t]), n = ~e.crcKey0.get(), a = Rr(Math.imul(Rr(a + ru(n)), 134775813) + 1), e.crcKey2.append([a >>> 24]), s = ~e.crcKey2.get(), e.keys = [n, a, s];
}
function iu(e) {
  const t = e.keys[2] | 2;
  return ru(Math.imul(t, t ^ 1) >>> 8);
}
function ru(e) {
  return e & 255;
}
function Rr(e) {
  return e & 4294967295;
}
const Ah = "Invalid uncompressed size", gh = "deflate-raw", hh = "deflate64-raw";
class vh extends TransformStream {
  constructor(t, { chunkSize: n, CompressionStreamZlib: a, CompressionStream: s }) {
    super({});
    const { compressed: o, encrypted: i, useCompressionStream: r, zipCrypto: l, signed: c, level: u } = t, p = this;
    let m, v, A = super.readable;
    (!i || l) && c && (m = new Kc(), A = Vt(A, m)), o && (A = cu(A, r, { level: u, chunkSize: n }, s, a, s)), i && (l ? A = Vt(A, new mh(t)) : (v = new rh(t), A = Vt(A, v))), lu(p, A, () => {
      let h;
      i && !l && (h = v.signature), (!i || l) && c && (h = new DataView(m.value.buffer).getUint32(0)), p.signature = h;
    });
  }
}
class bh extends TransformStream {
  constructor(t, { chunkSize: n, DecompressionStreamZlib: a, DecompressionStream: s }) {
    super({});
    const { zipCrypto: o, encrypted: i, signed: r, signature: l, compressed: c, useCompressionStream: u, deflate64: p } = t;
    let m, v, A = super.readable;
    i && (o ? A = Vt(A, new ph(t)) : (v = new ih(t), A = Vt(A, v))), c && (A = cu(A, u, { chunkSize: n, deflate64: p }, s, a, s)), (!i || o) && r && (m = new Kc(), A = Vt(A, m)), lu(this, A, () => {
      if ((!i || o) && r) {
        const h = new DataView(m.value.buffer);
        if (l != h.getUint32(0, !1))
          throw new Error(qc);
      }
    });
  }
}
function lu(e, t, n) {
  t = Vt(t, new TransformStream({ flush: n })), Object.defineProperty(e, "readable", {
    get() {
      return t;
    }
  });
}
function cu(e, t, n, a, s, o) {
  const i = t && a ? a : s || o, r = n.deflate64 ? hh : gh;
  try {
    e = Vt(e, new i(r, n));
  } catch (l) {
    if (t)
      if (s)
        e = Vt(e, new s(r, n));
      else if (o)
        e = Vt(e, new o(r, n));
      else
        throw l;
    else
      throw l;
  }
  return e;
}
function Vt(e, t) {
  return e.pipeThrough(t);
}
const xh = "deflate", yh = "inflate";
class B1 extends TransformStream {
  constructor(t, n) {
    super({});
    const a = this, { codecType: s } = t;
    let o;
    s.startsWith(xh) ? o = vh : s.startsWith(yh) && (o = bh), a.outputSize = 0;
    let i = 0;
    const r = new o(t, n), l = super.readable, c = new TransformStream({
      transform(p, m) {
        p && p.length && (i += p.length, m.enqueue(p));
      },
      flush() {
        Object.assign(a, {
          inputSize: i
        });
      }
    }), u = new TransformStream({
      transform(p, m) {
        if (p && p.length && (m.enqueue(p), a.outputSize += p.length, t.outputSize !== Ei && a.outputSize > t.outputSize))
          throw new Error(Ah);
      },
      flush() {
        const { signature: p } = r;
        Object.assign(a, {
          signature: p,
          inputSize: i
        });
      }
    });
    Object.defineProperty(a, "readable", {
      get() {
        return l.pipeThrough(c).pipeThrough(r).pipeThrough(u);
      }
    });
  }
}
class I1 extends TransformStream {
  constructor(t) {
    let n;
    super({
      transform: a,
      flush(s) {
        n && n.length && s.enqueue(n);
      }
    });
    function a(s, o) {
      if (n) {
        const i = new Uint8Array(n.length + s.length);
        i.set(n), i.set(s, n.length), s = i, n = null;
      }
      s.length > t ? (o.enqueue(s.slice(0, t)), a(s.slice(t), o)) : n = s;
    }
  }
}
class w1 extends TransformStream {
  constructor({ onstart: t, onprogress: n, size: a, onend: s }) {
    let o = 0;
    super({
      async start() {
        t && await lo(t, a);
      },
      async transform(i, r) {
        o += i.length, n && await lo(n, o, a), r.enqueue(i);
      },
      async flush() {
        s && await lo(s, o);
      }
    });
  }
}
async function lo(e, ...t) {
  try {
    await e(...t);
  } catch {
  }
}
const Eh = "Writer not initialized", Ch = "writable";
class Bh {
  constructor() {
    this.size = 0;
  }
  init() {
    this.initialized = !0;
  }
}
class Ih extends Bh {
  constructor() {
    super();
    const t = this, n = new WritableStream({
      write(a) {
        if (!t.initialized)
          throw new Error(Eh);
        return t.writeUint8Array(a);
      }
    });
    Object.defineProperty(t, Ch, {
      get() {
        return n;
      }
    });
  }
  writeUint8Array() {
  }
}
class wh extends Ih {
  init(t = 0) {
    Object.assign(this, {
      offset: 0,
      array: new Uint8Array(t)
    }), super.init();
  }
  writeUint8Array(t) {
    const n = this;
    if (n.offset + t.length > n.array.length) {
      const a = n.array;
      n.array = new Uint8Array(a.length + t.length), n.array.set(a);
    }
    n.array.set(t, n.offset), n.offset += t.length;
  }
  getData() {
    return this.array;
  }
}
const kh = "\0☺☻♥♦♣♠•◘○◙♂♀♪♫☼►◄↕‼¶§▬↨↑↓→←∟↔▲▼ !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~⌂ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ".split("");
kh.length == 256;
try {
  Gs({ baseURI: import.meta.url });
} catch {
}
const lt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function _h(e) {
  let t;
  e({ wasmURI: () => (t || (t = "data:application/wasm;base64," + ((n) => {
    n = ((i) => {
      const r = (i = (i + "").replace(/[^A-Za-z0-9+/=]/g, "")).length, l = [];
      for (let c = 0; r > c; c += 4) {
        const u = lt.indexOf(i[c]) << 18 | lt.indexOf(i[c + 1]) << 12 | (63 & lt.indexOf(i[c + 2])) << 6 | 63 & lt.indexOf(i[c + 3]);
        l.push(u >> 16 & 255), i[c + 2] !== "=" && l.push(u >> 8 & 255), i[c + 3] !== "=" && l.push(255 & u);
      }
      return new Uint8Array(l);
    })(n);
    let a = new Uint8Array(1024), s = 0;
    for (let i = 0; i < n.length; ) {
      const r = n[i++];
      if (128 & r) {
        const l = 3 + (127 & r), c = n[i++] << 8 | n[i++], u = s - c;
        o(s + l);
        for (let p = 0; l > p; p++) a[s++] = a[u + p];
      } else {
        const l = r;
        o(s + l);
        for (let c = 0; l > c && i < n.length; c++) a[s++] = n[i++];
      }
    }
    return ((i) => {
      let r = "";
      const l = i.length;
      let c = 0;
      for (; l > c + 2; c += 3) {
        const p = i[c] << 16 | i[c + 1] << 8 | i[c + 2];
        r += lt[p >> 18 & 63] + lt[p >> 12 & 63] + lt[p >> 6 & 63] + lt[63 & p];
      }
      const u = l - c;
      if (u === 1) {
        const p = i[c] << 16;
        r += lt[p >> 18 & 63] + lt[p >> 12 & 63] + "==";
      } else if (u === 2) {
        const p = i[c] << 16 | i[c + 1] << 8;
        r += lt[p >> 18 & 63] + lt[p >> 12 & 63] + lt[p >> 6 & 63] + "=";
      }
      return r;
    })(new Uint8Array(a.buffer.slice(0, s)));
    function o(i) {
      if (a.length < i) {
        let r = 2 * a.length;
        for (; i > r; ) r *= 2;
        const l = new Uint8Array(r);
        l.set(a.subarray(0, s)), a = l;
      }
    }
  })("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")), t) });
}
let Qe, co, ha, Pr;
function uu(e, t, n = {}) {
  const a = typeof n.level == "number" ? n.level : -1, s = typeof n.outBuffer == "number" ? n.outBuffer : 64 * 1024, o = typeof n.inBufferSize == "number" ? n.inBufferSize : 64 * 1024;
  return new TransformStream({
    start() {
      let i;
      if (this.out = co(s), this.in = co(o), this.inBufferSize = o, this._scratch = new Uint8Array(s), e ? (this._process = Qe.deflate_process, this._last_consumed = Qe.deflate_last_consumed, this._end = Qe.deflate_end, this.streamHandle = Qe.deflate_new(), t === "gzip" ? i = Qe.deflate_init_gzip(this.streamHandle, a) : t === "deflate-raw" ? i = Qe.deflate_init_raw(this.streamHandle, a) : i = Qe.deflate_init(this.streamHandle, a)) : t === "deflate64-raw" ? (this._process = Qe.inflate9_process, this._last_consumed = Qe.inflate9_last_consumed, this._end = Qe.inflate9_end, this.streamHandle = Qe.inflate9_new(), i = Qe.inflate9_init_raw(this.streamHandle)) : (this._process = Qe.inflate_process, this._last_consumed = Qe.inflate_last_consumed, this._end = Qe.inflate_end, this.streamHandle = Qe.inflate_new(), t === "deflate-raw" ? i = Qe.inflate_init_raw(this.streamHandle) : t === "gzip" ? i = Qe.inflate_init_gzip(this.streamHandle) : i = Qe.inflate_init(this.streamHandle)), i !== 0)
        throw new Error("init failed:" + i);
    },
    transform(i, r) {
      try {
        const l = i, c = new Uint8Array(Pr.buffer), u = this._process, p = this._last_consumed, m = this.out, v = this._scratch;
        let A = 0;
        for (; A < l.length; ) {
          const h = Math.min(l.length - A, 32768);
          (!this.in || this.inBufferSize < h) && (this.in, this.in = co(h), this.inBufferSize = h), c.set(l.subarray(A, A + h), this.in);
          const d = u(this.streamHandle, this.in, h, m, s, 0);
          if (!e && d < 0)
            throw new Error("process error:" + d);
          const f = d & 16777215;
          f && (v.set(c.subarray(m, m + f), 0), r.enqueue(v.slice(0, f)));
          const g = p(this.streamHandle);
          if (g === 0)
            break;
          A += g;
        }
      } catch (l) {
        this._end && this.streamHandle && this._end(this.streamHandle), this.in, this.out, r.error(l);
      }
    },
    flush(i) {
      try {
        const r = new Uint8Array(Pr.buffer), l = this._process, c = this.out, u = this._scratch;
        for (; ; ) {
          const p = l(this.streamHandle, 0, 0, c, s, 4);
          if (!e && p < 0)
            throw new Error("process error:" + p);
          const m = p & 16777215, v = p >> 24 & 255;
          if (m && (u.set(r.subarray(c, c + m), 0), i.enqueue(u.slice(0, m))), v === 1 || m === 0)
            break;
        }
      } catch (r) {
        i.error(r);
      } finally {
        if (this._end && this.streamHandle) {
          const r = this._end(this.streamHandle);
          r !== 0 && i.error(new Error("end error:" + r));
        }
        this.in, this.out;
      }
    }
  });
}
class Sh {
  constructor(t = "deflate", n) {
    return uu(!0, t, n);
  }
}
class Th {
  constructor(t = "deflate", n) {
    return uu(!1, t, n);
  }
}
_h(Gs);
Gs({
  CompressionStreamZlib: Sh,
  DecompressionStreamZlib: Th
});
const uo = {
  application: {
    "andrew-inset": "ez",
    annodex: "anx",
    "atom+xml": "atom",
    "atomcat+xml": "atomcat",
    "atomserv+xml": "atomsrv",
    bbolin: "lin",
    "cu-seeme": "cu",
    "davmount+xml": "davmount",
    dsptype: "tsp",
    ecmascript: [
      "es",
      "ecma"
    ],
    futuresplash: "spl",
    hta: "hta",
    "java-archive": "jar",
    "java-serialized-object": "ser",
    "java-vm": "class",
    m3g: "m3g",
    "mac-binhex40": "hqx",
    mathematica: [
      "nb",
      "ma",
      "mb"
    ],
    msaccess: "mdb",
    msword: [
      "doc",
      "dot",
      "wiz"
    ],
    mxf: "mxf",
    oda: "oda",
    ogg: "ogx",
    pdf: "pdf",
    "pgp-keys": "key",
    "pgp-signature": [
      "asc",
      "sig"
    ],
    "pics-rules": "prf",
    postscript: [
      "ps",
      "ai",
      "eps",
      "epsi",
      "epsf",
      "eps2",
      "eps3"
    ],
    rar: "rar",
    "rdf+xml": "rdf",
    "rss+xml": "rss",
    rtf: "rtf",
    "xhtml+xml": [
      "xhtml",
      "xht"
    ],
    xml: [
      "xml",
      "xsl",
      "xsd",
      "xpdl"
    ],
    "xspf+xml": "xspf",
    zip: "zip",
    "vnd.android.package-archive": "apk",
    "vnd.cinderella": "cdy",
    "vnd.google-earth.kml+xml": "kml",
    "vnd.google-earth.kmz": "kmz",
    "vnd.mozilla.xul+xml": "xul",
    "vnd.ms-excel": [
      "xls",
      "xlb",
      "xlt",
      "xlm",
      "xla",
      "xlc",
      "xlw"
    ],
    "vnd.ms-pki.seccat": "cat",
    "vnd.ms-pki.stl": "stl",
    "vnd.ms-powerpoint": [
      "ppt",
      "pps",
      "pot",
      "ppa",
      "pwz"
    ],
    "vnd.oasis.opendocument.chart": "odc",
    "vnd.oasis.opendocument.database": "odb",
    "vnd.oasis.opendocument.formula": "odf",
    "vnd.oasis.opendocument.graphics": "odg",
    "vnd.oasis.opendocument.graphics-template": "otg",
    "vnd.oasis.opendocument.image": "odi",
    "vnd.oasis.opendocument.presentation": "odp",
    "vnd.oasis.opendocument.presentation-template": "otp",
    "vnd.oasis.opendocument.spreadsheet": "ods",
    "vnd.oasis.opendocument.spreadsheet-template": "ots",
    "vnd.oasis.opendocument.text": "odt",
    "vnd.oasis.opendocument.text-master": [
      "odm",
      "otm"
    ],
    "vnd.oasis.opendocument.text-template": "ott",
    "vnd.oasis.opendocument.text-web": "oth",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
    "vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
    "vnd.openxmlformats-officedocument.presentationml.template": "potx",
    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
    "vnd.smaf": "mmf",
    "vnd.stardivision.calc": "sdc",
    "vnd.stardivision.chart": "sds",
    "vnd.stardivision.draw": "sda",
    "vnd.stardivision.impress": "sdd",
    "vnd.stardivision.math": [
      "sdf",
      "smf"
    ],
    "vnd.stardivision.writer": [
      "sdw",
      "vor"
    ],
    "vnd.stardivision.writer-global": "sgl",
    "vnd.sun.xml.calc": "sxc",
    "vnd.sun.xml.calc.template": "stc",
    "vnd.sun.xml.draw": "sxd",
    "vnd.sun.xml.draw.template": "std",
    "vnd.sun.xml.impress": "sxi",
    "vnd.sun.xml.impress.template": "sti",
    "vnd.sun.xml.math": "sxm",
    "vnd.sun.xml.writer": "sxw",
    "vnd.sun.xml.writer.global": "sxg",
    "vnd.sun.xml.writer.template": "stw",
    "vnd.symbian.install": [
      "sis",
      "sisx"
    ],
    "vnd.visio": [
      "vsd",
      "vst",
      "vss",
      "vsw",
      "vsdx",
      "vssx",
      "vstx",
      "vssm",
      "vstm"
    ],
    "vnd.wap.wbxml": "wbxml",
    "vnd.wap.wmlc": "wmlc",
    "vnd.wap.wmlscriptc": "wmlsc",
    "vnd.wordperfect": "wpd",
    "vnd.wordperfect5.1": "wp5",
    "x-123": "wk",
    "x-7z-compressed": "7z",
    "x-abiword": "abw",
    "x-apple-diskimage": "dmg",
    "x-bcpio": "bcpio",
    "x-bittorrent": "torrent",
    "x-cbr": [
      "cbr",
      "cba",
      "cbt",
      "cb7"
    ],
    "x-cbz": "cbz",
    "x-cdf": [
      "cdf",
      "cda"
    ],
    "x-cdlink": "vcd",
    "x-chess-pgn": "pgn",
    "x-cpio": "cpio",
    "x-csh": "csh",
    "x-director": [
      "dir",
      "dxr",
      "cst",
      "cct",
      "cxt",
      "w3d",
      "fgd",
      "swa"
    ],
    "x-dms": "dms",
    "x-doom": "wad",
    "x-dvi": "dvi",
    "x-httpd-eruby": "rhtml",
    "x-font": "pcf.Z",
    "x-freemind": "mm",
    "x-gnumeric": "gnumeric",
    "x-go-sgf": "sgf",
    "x-graphing-calculator": "gcf",
    "x-gtar": [
      "gtar",
      "taz"
    ],
    "x-hdf": "hdf",
    "x-httpd-php": [
      "phtml",
      "pht",
      "php"
    ],
    "x-httpd-php-source": "phps",
    "x-httpd-php3": "php3",
    "x-httpd-php3-preprocessed": "php3p",
    "x-httpd-php4": "php4",
    "x-httpd-php5": "php5",
    "x-ica": "ica",
    "x-info": "info",
    "x-internet-signup": [
      "ins",
      "isp"
    ],
    "x-iphone": "iii",
    "x-iso9660-image": "iso",
    "x-java-jnlp-file": "jnlp",
    "x-jmol": "jmz",
    "x-killustrator": "kil",
    "x-latex": "latex",
    "x-lyx": "lyx",
    "x-lzx": "lzx",
    "x-maker": [
      "frm",
      "fb",
      "fbdoc"
    ],
    "x-ms-wmd": "wmd",
    "x-msdos-program": [
      "com",
      "exe",
      "bat",
      "dll"
    ],
    "x-netcdf": [
      "nc"
    ],
    "x-ns-proxy-autoconfig": [
      "pac",
      "dat"
    ],
    "x-nwc": "nwc",
    "x-object": "o",
    "x-oz-application": "oza",
    "x-pkcs7-certreqresp": "p7r",
    "x-python-code": [
      "pyc",
      "pyo"
    ],
    "x-qgis": [
      "qgs",
      "shp",
      "shx"
    ],
    "x-quicktimeplayer": "qtl",
    "x-redhat-package-manager": [
      "rpm",
      "rpa"
    ],
    "x-ruby": "rb",
    "x-sh": "sh",
    "x-shar": "shar",
    "x-shockwave-flash": [
      "swf",
      "swfl"
    ],
    "x-silverlight": "scr",
    "x-stuffit": "sit",
    "x-sv4cpio": "sv4cpio",
    "x-sv4crc": "sv4crc",
    "x-tar": "tar",
    "x-tex-gf": "gf",
    "x-tex-pk": "pk",
    "x-texinfo": [
      "texinfo",
      "texi"
    ],
    "x-trash": [
      "~",
      "%",
      "bak",
      "old",
      "sik"
    ],
    "x-ustar": "ustar",
    "x-wais-source": "src",
    "x-wingz": "wz",
    "x-x509-ca-cert": [
      "crt",
      "der",
      "cer"
    ],
    "x-xcf": "xcf",
    "x-xfig": "fig",
    "x-xpinstall": "xpi",
    applixware: "aw",
    "atomsvc+xml": "atomsvc",
    "ccxml+xml": "ccxml",
    "cdmi-capability": "cdmia",
    "cdmi-container": "cdmic",
    "cdmi-domain": "cdmid",
    "cdmi-object": "cdmio",
    "cdmi-queue": "cdmiq",
    "docbook+xml": "dbk",
    "dssc+der": "dssc",
    "dssc+xml": "xdssc",
    "emma+xml": "emma",
    "epub+zip": "epub",
    exi: "exi",
    "font-tdpfr": "pfr",
    "gml+xml": "gml",
    "gpx+xml": "gpx",
    gxf: "gxf",
    hyperstudio: "stk",
    "inkml+xml": [
      "ink",
      "inkml"
    ],
    ipfix: "ipfix",
    "jsonml+json": "jsonml",
    "lost+xml": "lostxml",
    "mads+xml": "mads",
    marc: "mrc",
    "marcxml+xml": "mrcx",
    "mathml+xml": [
      "mathml",
      "mml"
    ],
    mbox: "mbox",
    "mediaservercontrol+xml": "mscml",
    "metalink+xml": "metalink",
    "metalink4+xml": "meta4",
    "mets+xml": "mets",
    "mods+xml": "mods",
    mp21: [
      "m21",
      "mp21"
    ],
    mp4: "mp4s",
    "oebps-package+xml": "opf",
    "omdoc+xml": "omdoc",
    onenote: [
      "onetoc",
      "onetoc2",
      "onetmp",
      "onepkg"
    ],
    oxps: "oxps",
    "patch-ops-error+xml": "xer",
    "pgp-encrypted": "pgp",
    pkcs10: "p10",
    "pkcs7-mime": [
      "p7m",
      "p7c"
    ],
    "pkcs7-signature": "p7s",
    pkcs8: "p8",
    "pkix-attr-cert": "ac",
    "pkix-crl": "crl",
    "pkix-pkipath": "pkipath",
    pkixcmp: "pki",
    "pls+xml": "pls",
    "prs.cww": "cww",
    "pskc+xml": "pskcxml",
    "reginfo+xml": "rif",
    "relax-ng-compact-syntax": "rnc",
    "resource-lists+xml": "rl",
    "resource-lists-diff+xml": "rld",
    "rls-services+xml": "rs",
    "rpki-ghostbusters": "gbr",
    "rpki-manifest": "mft",
    "rpki-roa": "roa",
    "rsd+xml": "rsd",
    "sbml+xml": "sbml",
    "scvp-cv-request": "scq",
    "scvp-cv-response": "scs",
    "scvp-vp-request": "spq",
    "scvp-vp-response": "spp",
    sdp: "sdp",
    "set-payment-initiation": "setpay",
    "set-registration-initiation": "setreg",
    "shf+xml": "shf",
    "sparql-query": "rq",
    "sparql-results+xml": "srx",
    srgs: "gram",
    "srgs+xml": "grxml",
    "sru+xml": "sru",
    "ssdl+xml": "ssdl",
    "ssml+xml": "ssml",
    "tei+xml": [
      "tei",
      "teicorpus"
    ],
    "thraud+xml": "tfi",
    "timestamped-data": "tsd",
    "vnd.3gpp.pic-bw-large": "plb",
    "vnd.3gpp.pic-bw-small": "psb",
    "vnd.3gpp.pic-bw-var": "pvb",
    "vnd.3gpp2.tcap": "tcap",
    "vnd.3m.post-it-notes": "pwn",
    "vnd.accpac.simply.aso": "aso",
    "vnd.accpac.simply.imp": "imp",
    "vnd.acucobol": "acu",
    "vnd.acucorp": [
      "atc",
      "acutc"
    ],
    "vnd.adobe.air-application-installer-package+zip": "air",
    "vnd.adobe.formscentral.fcdt": "fcdt",
    "vnd.adobe.fxp": [
      "fxp",
      "fxpl"
    ],
    "vnd.adobe.xdp+xml": "xdp",
    "vnd.adobe.xfdf": "xfdf",
    "vnd.ahead.space": "ahead",
    "vnd.airzip.filesecure.azf": "azf",
    "vnd.airzip.filesecure.azs": "azs",
    "vnd.amazon.ebook": "azw",
    "vnd.americandynamics.acc": "acc",
    "vnd.amiga.ami": "ami",
    "vnd.anser-web-certificate-issue-initiation": "cii",
    "vnd.anser-web-funds-transfer-initiation": "fti",
    "vnd.antix.game-component": "atx",
    "vnd.apple.installer+xml": "mpkg",
    "vnd.apple.mpegurl": "m3u8",
    "vnd.aristanetworks.swi": "swi",
    "vnd.astraea-software.iota": "iota",
    "vnd.audiograph": "aep",
    "vnd.blueice.multipass": "mpm",
    "vnd.bmi": "bmi",
    "vnd.businessobjects": "rep",
    "vnd.chemdraw+xml": "cdxml",
    "vnd.chipnuts.karaoke-mmd": "mmd",
    "vnd.claymore": "cla",
    "vnd.cloanto.rp9": "rp9",
    "vnd.clonk.c4group": [
      "c4g",
      "c4d",
      "c4f",
      "c4p",
      "c4u"
    ],
    "vnd.cluetrust.cartomobile-config": "c11amc",
    "vnd.cluetrust.cartomobile-config-pkg": "c11amz",
    "vnd.commonspace": "csp",
    "vnd.contact.cmsg": "cdbcmsg",
    "vnd.cosmocaller": "cmc",
    "vnd.crick.clicker": "clkx",
    "vnd.crick.clicker.keyboard": "clkk",
    "vnd.crick.clicker.palette": "clkp",
    "vnd.crick.clicker.template": "clkt",
    "vnd.crick.clicker.wordbank": "clkw",
    "vnd.criticaltools.wbs+xml": "wbs",
    "vnd.ctc-posml": "pml",
    "vnd.cups-ppd": "ppd",
    "vnd.curl.car": "car",
    "vnd.curl.pcurl": "pcurl",
    "vnd.dart": "dart",
    "vnd.data-vision.rdz": "rdz",
    "vnd.dece.data": [
      "uvf",
      "uvvf",
      "uvd",
      "uvvd"
    ],
    "vnd.dece.ttml+xml": [
      "uvt",
      "uvvt"
    ],
    "vnd.dece.unspecified": [
      "uvx",
      "uvvx"
    ],
    "vnd.dece.zip": [
      "uvz",
      "uvvz"
    ],
    "vnd.denovo.fcselayout-link": "fe_launch",
    "vnd.dna": "dna",
    "vnd.dolby.mlp": "mlp",
    "vnd.dpgraph": "dpg",
    "vnd.dreamfactory": "dfac",
    "vnd.ds-keypoint": "kpxx",
    "vnd.dvb.ait": "ait",
    "vnd.dvb.service": "svc",
    "vnd.dynageo": "geo",
    "vnd.ecowin.chart": "mag",
    "vnd.enliven": "nml",
    "vnd.epson.esf": "esf",
    "vnd.epson.msf": "msf",
    "vnd.epson.quickanime": "qam",
    "vnd.epson.salt": "slt",
    "vnd.epson.ssf": "ssf",
    "vnd.eszigno3+xml": [
      "es3",
      "et3"
    ],
    "vnd.ezpix-album": "ez2",
    "vnd.ezpix-package": "ez3",
    "vnd.fdf": "fdf",
    "vnd.fdsn.mseed": "mseed",
    "vnd.fdsn.seed": [
      "seed",
      "dataless"
    ],
    "vnd.flographit": "gph",
    "vnd.fluxtime.clip": "ftc",
    "vnd.framemaker": [
      "fm",
      "frame",
      "maker",
      "book"
    ],
    "vnd.frogans.fnc": "fnc",
    "vnd.frogans.ltf": "ltf",
    "vnd.fsc.weblaunch": "fsc",
    "vnd.fujitsu.oasys": "oas",
    "vnd.fujitsu.oasys2": "oa2",
    "vnd.fujitsu.oasys3": "oa3",
    "vnd.fujitsu.oasysgp": "fg5",
    "vnd.fujitsu.oasysprs": "bh2",
    "vnd.fujixerox.ddd": "ddd",
    "vnd.fujixerox.docuworks": "xdw",
    "vnd.fujixerox.docuworks.binder": "xbd",
    "vnd.fuzzysheet": "fzs",
    "vnd.genomatix.tuxedo": "txd",
    "vnd.geogebra.file": "ggb",
    "vnd.geogebra.tool": "ggt",
    "vnd.geometry-explorer": [
      "gex",
      "gre"
    ],
    "vnd.geonext": "gxt",
    "vnd.geoplan": "g2w",
    "vnd.geospace": "g3w",
    "vnd.gmx": "gmx",
    "vnd.grafeq": [
      "gqf",
      "gqs"
    ],
    "vnd.groove-account": "gac",
    "vnd.groove-help": "ghf",
    "vnd.groove-identity-message": "gim",
    "vnd.groove-injector": "grv",
    "vnd.groove-tool-message": "gtm",
    "vnd.groove-tool-template": "tpl",
    "vnd.groove-vcard": "vcg",
    "vnd.hal+xml": "hal",
    "vnd.handheld-entertainment+xml": "zmm",
    "vnd.hbci": "hbci",
    "vnd.hhe.lesson-player": "les",
    "vnd.hp-hpgl": "hpgl",
    "vnd.hp-hpid": "hpid",
    "vnd.hp-hps": "hps",
    "vnd.hp-jlyt": "jlt",
    "vnd.hp-pcl": "pcl",
    "vnd.hp-pclxl": "pclxl",
    "vnd.hydrostatix.sof-data": "sfd-hdstx",
    "vnd.ibm.minipay": "mpy",
    "vnd.ibm.modcap": [
      "afp",
      "listafp",
      "list3820"
    ],
    "vnd.ibm.rights-management": "irm",
    "vnd.ibm.secure-container": "sc",
    "vnd.iccprofile": [
      "icc",
      "icm"
    ],
    "vnd.igloader": "igl",
    "vnd.immervision-ivp": "ivp",
    "vnd.immervision-ivu": "ivu",
    "vnd.insors.igm": "igm",
    "vnd.intercon.formnet": [
      "xpw",
      "xpx"
    ],
    "vnd.intergeo": "i2g",
    "vnd.intu.qbo": "qbo",
    "vnd.intu.qfx": "qfx",
    "vnd.ipunplugged.rcprofile": "rcprofile",
    "vnd.irepository.package+xml": "irp",
    "vnd.is-xpr": "xpr",
    "vnd.isac.fcs": "fcs",
    "vnd.jam": "jam",
    "vnd.jcp.javame.midlet-rms": "rms",
    "vnd.jisp": "jisp",
    "vnd.joost.joda-archive": "joda",
    "vnd.kahootz": [
      "ktz",
      "ktr"
    ],
    "vnd.kde.karbon": "karbon",
    "vnd.kde.kchart": "chrt",
    "vnd.kde.kformula": "kfo",
    "vnd.kde.kivio": "flw",
    "vnd.kde.kontour": "kon",
    "vnd.kde.kpresenter": [
      "kpr",
      "kpt"
    ],
    "vnd.kde.kspread": "ksp",
    "vnd.kde.kword": [
      "kwd",
      "kwt"
    ],
    "vnd.kenameaapp": "htke",
    "vnd.kidspiration": "kia",
    "vnd.kinar": [
      "kne",
      "knp"
    ],
    "vnd.koan": [
      "skp",
      "skd",
      "skt",
      "skm"
    ],
    "vnd.kodak-descriptor": "sse",
    "vnd.las.las+xml": "lasxml",
    "vnd.llamagraphics.life-balance.desktop": "lbd",
    "vnd.llamagraphics.life-balance.exchange+xml": "lbe",
    "vnd.lotus-1-2-3": "123",
    "vnd.lotus-approach": "apr",
    "vnd.lotus-freelance": "pre",
    "vnd.lotus-notes": "nsf",
    "vnd.lotus-organizer": "org",
    "vnd.lotus-screencam": "scm",
    "vnd.lotus-wordpro": "lwp",
    "vnd.macports.portpkg": "portpkg",
    "vnd.mcd": "mcd",
    "vnd.medcalcdata": "mc1",
    "vnd.mediastation.cdkey": "cdkey",
    "vnd.mfer": "mwf",
    "vnd.mfmp": "mfm",
    "vnd.micrografx.flo": "flo",
    "vnd.micrografx.igx": "igx",
    "vnd.mif": "mif",
    "vnd.mobius.daf": "daf",
    "vnd.mobius.dis": "dis",
    "vnd.mobius.mbk": "mbk",
    "vnd.mobius.mqy": "mqy",
    "vnd.mobius.msl": "msl",
    "vnd.mobius.plc": "plc",
    "vnd.mobius.txf": "txf",
    "vnd.mophun.application": "mpn",
    "vnd.mophun.certificate": "mpc",
    "vnd.ms-artgalry": "cil",
    "vnd.ms-cab-compressed": "cab",
    "vnd.ms-excel.addin.macroenabled.12": "xlam",
    "vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb",
    "vnd.ms-excel.sheet.macroenabled.12": "xlsm",
    "vnd.ms-excel.template.macroenabled.12": "xltm",
    "vnd.ms-fontobject": "eot",
    "vnd.ms-htmlhelp": "chm",
    "vnd.ms-ims": "ims",
    "vnd.ms-lrm": "lrm",
    "vnd.ms-officetheme": "thmx",
    "vnd.ms-powerpoint.addin.macroenabled.12": "ppam",
    "vnd.ms-powerpoint.presentation.macroenabled.12": "pptm",
    "vnd.ms-powerpoint.slide.macroenabled.12": "sldm",
    "vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm",
    "vnd.ms-powerpoint.template.macroenabled.12": "potm",
    "vnd.ms-project": [
      "mpp",
      "mpt"
    ],
    "vnd.ms-word.document.macroenabled.12": "docm",
    "vnd.ms-word.template.macroenabled.12": "dotm",
    "vnd.ms-works": [
      "wps",
      "wks",
      "wcm",
      "wdb"
    ],
    "vnd.ms-wpl": "wpl",
    "vnd.ms-xpsdocument": "xps",
    "vnd.mseq": "mseq",
    "vnd.musician": "mus",
    "vnd.muvee.style": "msty",
    "vnd.mynfc": "taglet",
    "vnd.neurolanguage.nlu": "nlu",
    "vnd.nitf": [
      "ntf",
      "nitf"
    ],
    "vnd.noblenet-directory": "nnd",
    "vnd.noblenet-sealer": "nns",
    "vnd.noblenet-web": "nnw",
    "vnd.nokia.n-gage.data": "ngdat",
    "vnd.nokia.n-gage.symbian.install": "n-gage",
    "vnd.nokia.radio-preset": "rpst",
    "vnd.nokia.radio-presets": "rpss",
    "vnd.novadigm.edm": "edm",
    "vnd.novadigm.edx": "edx",
    "vnd.novadigm.ext": "ext",
    "vnd.oasis.opendocument.chart-template": "otc",
    "vnd.oasis.opendocument.formula-template": "odft",
    "vnd.oasis.opendocument.image-template": "oti",
    "vnd.olpc-sugar": "xo",
    "vnd.oma.dd2+xml": "dd2",
    "vnd.openofficeorg.extension": "oxt",
    "vnd.openxmlformats-officedocument.presentationml.slide": "sldx",
    "vnd.osgeo.mapguide.package": "mgp",
    "vnd.osgi.dp": "dp",
    "vnd.osgi.subsystem": "esa",
    "vnd.palm": [
      "pdb",
      "pqa",
      "oprc"
    ],
    "vnd.pawaafile": "paw",
    "vnd.pg.format": "str",
    "vnd.pg.osasli": "ei6",
    "vnd.picsel": "efif",
    "vnd.pmi.widget": "wg",
    "vnd.pocketlearn": "plf",
    "vnd.powerbuilder6": "pbd",
    "vnd.previewsystems.box": "box",
    "vnd.proteus.magazine": "mgz",
    "vnd.publishare-delta-tree": "qps",
    "vnd.pvi.ptid1": "ptid",
    "vnd.quark.quarkxpress": [
      "qxd",
      "qxt",
      "qwd",
      "qwt",
      "qxl",
      "qxb"
    ],
    "vnd.realvnc.bed": "bed",
    "vnd.recordare.musicxml": "mxl",
    "vnd.recordare.musicxml+xml": "musicxml",
    "vnd.rig.cryptonote": "cryptonote",
    "vnd.rn-realmedia": "rm",
    "vnd.rn-realmedia-vbr": "rmvb",
    "vnd.route66.link66+xml": "link66",
    "vnd.sailingtracker.track": "st",
    "vnd.seemail": "see",
    "vnd.sema": "sema",
    "vnd.semd": "semd",
    "vnd.semf": "semf",
    "vnd.shana.informed.formdata": "ifm",
    "vnd.shana.informed.formtemplate": "itp",
    "vnd.shana.informed.interchange": "iif",
    "vnd.shana.informed.package": "ipk",
    "vnd.simtech-mindmapper": [
      "twd",
      "twds"
    ],
    "vnd.smart.teacher": "teacher",
    "vnd.solent.sdkm+xml": [
      "sdkm",
      "sdkd"
    ],
    "vnd.spotfire.dxp": "dxp",
    "vnd.spotfire.sfs": "sfs",
    "vnd.stepmania.package": "smzip",
    "vnd.stepmania.stepchart": "sm",
    "vnd.sus-calendar": [
      "sus",
      "susp"
    ],
    "vnd.svd": "svd",
    "vnd.syncml+xml": "xsm",
    "vnd.syncml.dm+wbxml": "bdm",
    "vnd.syncml.dm+xml": "xdm",
    "vnd.tao.intent-module-archive": "tao",
    "vnd.tcpdump.pcap": [
      "pcap",
      "cap",
      "dmp"
    ],
    "vnd.tmobile-livetv": "tmo",
    "vnd.trid.tpt": "tpt",
    "vnd.triscape.mxs": "mxs",
    "vnd.trueapp": "tra",
    "vnd.ufdl": [
      "ufd",
      "ufdl"
    ],
    "vnd.uiq.theme": "utz",
    "vnd.umajin": "umj",
    "vnd.unity": "unityweb",
    "vnd.uoml+xml": "uoml",
    "vnd.vcx": "vcx",
    "vnd.visionary": "vis",
    "vnd.vsf": "vsf",
    "vnd.webturbo": "wtb",
    "vnd.wolfram.player": "nbp",
    "vnd.wqd": "wqd",
    "vnd.wt.stf": "stf",
    "vnd.xara": "xar",
    "vnd.xfdl": "xfdl",
    "vnd.yamaha.hv-dic": "hvd",
    "vnd.yamaha.hv-script": "hvs",
    "vnd.yamaha.hv-voice": "hvp",
    "vnd.yamaha.openscoreformat": "osf",
    "vnd.yamaha.openscoreformat.osfpvg+xml": "osfpvg",
    "vnd.yamaha.smaf-audio": "saf",
    "vnd.yamaha.smaf-phrase": "spf",
    "vnd.yellowriver-custom-menu": "cmp",
    "vnd.zul": [
      "zir",
      "zirz"
    ],
    "vnd.zzazz.deck+xml": "zaz",
    "voicexml+xml": "vxml",
    widget: "wgt",
    winhlp: "hlp",
    "wsdl+xml": "wsdl",
    "wspolicy+xml": "wspolicy",
    "x-ace-compressed": "ace",
    "x-authorware-bin": [
      "aab",
      "x32",
      "u32",
      "vox"
    ],
    "x-authorware-map": "aam",
    "x-authorware-seg": "aas",
    "x-blorb": [
      "blb",
      "blorb"
    ],
    "x-bzip": "bz",
    "x-bzip2": [
      "bz2",
      "boz"
    ],
    "x-cfs-compressed": "cfs",
    "x-chat": "chat",
    "x-conference": "nsc",
    "x-dgc-compressed": "dgc",
    "x-dtbncx+xml": "ncx",
    "x-dtbook+xml": "dtb",
    "x-dtbresource+xml": "res",
    "x-eva": "eva",
    "x-font-bdf": "bdf",
    "x-font-ghostscript": "gsf",
    "x-font-linux-psf": "psf",
    "x-font-pcf": "pcf",
    "x-font-snf": "snf",
    "x-font-ttf": [
      "ttf",
      "ttc"
    ],
    "x-font-type1": [
      "pfa",
      "pfb",
      "pfm",
      "afm"
    ],
    "x-freearc": "arc",
    "x-gca-compressed": "gca",
    "x-glulx": "ulx",
    "x-gramps-xml": "gramps",
    "x-install-instructions": "install",
    "x-lzh-compressed": [
      "lzh",
      "lha"
    ],
    "x-mie": "mie",
    "x-mobipocket-ebook": [
      "prc",
      "mobi"
    ],
    "x-ms-application": "application",
    "x-ms-shortcut": "lnk",
    "x-ms-xbap": "xbap",
    "x-msbinder": "obd",
    "x-mscardfile": "crd",
    "x-msclip": "clp",
    "application/x-ms-installer": "msi",
    "x-msmediaview": [
      "mvb",
      "m13",
      "m14"
    ],
    "x-msmetafile": [
      "wmf",
      "wmz",
      "emf",
      "emz"
    ],
    "x-msmoney": "mny",
    "x-mspublisher": "pub",
    "x-msschedule": "scd",
    "x-msterminal": "trm",
    "x-mswrite": "wri",
    "x-nzb": "nzb",
    "x-pkcs12": [
      "p12",
      "pfx"
    ],
    "x-pkcs7-certificates": [
      "p7b",
      "spc"
    ],
    "x-research-info-systems": "ris",
    "x-silverlight-app": "xap",
    "x-sql": "sql",
    "x-stuffitx": "sitx",
    "x-subrip": "srt",
    "x-t3vm-image": "t3",
    "x-tex-tfm": "tfm",
    "x-tgif": "obj",
    "x-xliff+xml": "xlf",
    "x-xz": "xz",
    "x-zmachine": [
      "z1",
      "z2",
      "z3",
      "z4",
      "z5",
      "z6",
      "z7",
      "z8"
    ],
    "xaml+xml": "xaml",
    "xcap-diff+xml": "xdf",
    "xenc+xml": "xenc",
    "xml-dtd": "dtd",
    "xop+xml": "xop",
    "xproc+xml": "xpl",
    "xslt+xml": "xslt",
    "xv+xml": [
      "mxml",
      "xhvml",
      "xvml",
      "xvm"
    ],
    yang: "yang",
    "yin+xml": "yin",
    envoy: "evy",
    fractals: "fif",
    "internet-property-stream": "acx",
    olescript: "axs",
    "vnd.ms-outlook": "msg",
    "vnd.ms-pkicertstore": "sst",
    "x-compress": "z",
    "x-perfmon": [
      "pma",
      "pmc",
      "pmr",
      "pmw"
    ],
    "ynd.ms-pkipko": "pko",
    gzip: [
      "gz",
      "tgz"
    ],
    "smil+xml": [
      "smi",
      "smil"
    ],
    "vnd.debian.binary-package": [
      "deb",
      "udeb"
    ],
    "vnd.hzn-3d-crossword": "x3d",
    "vnd.sqlite3": [
      "db",
      "sqlite",
      "sqlite3",
      "db-wal",
      "sqlite-wal",
      "db-shm",
      "sqlite-shm"
    ],
    "vnd.wap.sic": "sic",
    "vnd.wap.slc": "slc",
    "x-krita": [
      "kra",
      "krz"
    ],
    "x-perl": [
      "pm",
      "pl"
    ],
    yaml: [
      "yaml",
      "yml"
    ]
  },
  audio: {
    amr: "amr",
    "amr-wb": "awb",
    annodex: "axa",
    basic: [
      "au",
      "snd"
    ],
    flac: "flac",
    midi: [
      "mid",
      "midi",
      "kar",
      "rmi"
    ],
    mpeg: [
      "mpga",
      "mpega",
      "mp3",
      "m4a",
      "mp2a",
      "m2a",
      "m3a"
    ],
    mpegurl: "m3u",
    ogg: [
      "oga",
      "ogg",
      "spx"
    ],
    "prs.sid": "sid",
    "x-aiff": "aifc",
    "x-gsm": "gsm",
    "x-ms-wma": "wma",
    "x-ms-wax": "wax",
    "x-pn-realaudio": "ram",
    "x-realaudio": "ra",
    "x-sd2": "sd2",
    adpcm: "adp",
    mp4: "mp4a",
    s3m: "s3m",
    silk: "sil",
    "vnd.dece.audio": [
      "uva",
      "uvva"
    ],
    "vnd.digital-winds": "eol",
    "vnd.dra": "dra",
    "vnd.dts": "dts",
    "vnd.dts.hd": "dtshd",
    "vnd.lucent.voice": "lvp",
    "vnd.ms-playready.media.pya": "pya",
    "vnd.nuera.ecelp4800": "ecelp4800",
    "vnd.nuera.ecelp7470": "ecelp7470",
    "vnd.nuera.ecelp9600": "ecelp9600",
    "vnd.rip": "rip",
    webm: "weba",
    "x-caf": "caf",
    "x-matroska": "mka",
    "x-pn-realaudio-plugin": "rmp",
    xm: "xm",
    aac: "aac",
    aiff: [
      "aiff",
      "aif",
      "aff"
    ],
    opus: "opus",
    wav: "wav"
  },
  chemical: {
    "x-alchemy": "alc",
    "x-cache": [
      "cac",
      "cache"
    ],
    "x-cache-csf": "csf",
    "x-cactvs-binary": [
      "cbin",
      "cascii",
      "ctab"
    ],
    "x-cdx": "cdx",
    "x-chem3d": "c3d",
    "x-cif": "cif",
    "x-cmdf": "cmdf",
    "x-cml": "cml",
    "x-compass": "cpa",
    "x-crossfire": "bsd",
    "x-csml": [
      "csml",
      "csm"
    ],
    "x-ctx": "ctx",
    "x-cxf": [
      "cxf",
      "cef"
    ],
    "x-embl-dl-nucleotide": [
      "emb",
      "embl"
    ],
    "x-gamess-input": [
      "inp",
      "gam",
      "gamin"
    ],
    "x-gaussian-checkpoint": [
      "fch",
      "fchk"
    ],
    "x-gaussian-cube": "cub",
    "x-gaussian-input": [
      "gau",
      "gjc",
      "gjf"
    ],
    "x-gaussian-log": "gal",
    "x-gcg8-sequence": "gcg",
    "x-genbank": "gen",
    "x-hin": "hin",
    "x-isostar": [
      "istr",
      "ist"
    ],
    "x-jcamp-dx": [
      "jdx",
      "dx"
    ],
    "x-kinemage": "kin",
    "x-macmolecule": "mcm",
    "x-macromodel-input": "mmod",
    "x-mdl-molfile": "mol",
    "x-mdl-rdfile": "rd",
    "x-mdl-rxnfile": "rxn",
    "x-mdl-sdfile": "sd",
    "x-mdl-tgf": "tgf",
    "x-mmcif": "mcif",
    "x-mol2": "mol2",
    "x-molconn-Z": "b",
    "x-mopac-graph": "gpt",
    "x-mopac-input": [
      "mop",
      "mopcrt",
      "zmt"
    ],
    "x-mopac-out": "moo",
    "x-ncbi-asn1": "asn",
    "x-ncbi-asn1-ascii": [
      "prt",
      "ent"
    ],
    "x-ncbi-asn1-binary": "val",
    "x-rosdal": "ros",
    "x-swissprot": "sw",
    "x-vamas-iso14976": "vms",
    "x-vmd": "vmd",
    "x-xtel": "xtel",
    "x-xyz": "xyz"
  },
  font: {
    otf: "otf",
    woff: "woff",
    woff2: "woff2"
  },
  image: {
    gif: "gif",
    ief: "ief",
    jpeg: [
      "jpeg",
      "jpg",
      "jpe",
      "jfif",
      "jfif-tbnl",
      "jif"
    ],
    pcx: "pcx",
    png: "png",
    "svg+xml": [
      "svg",
      "svgz"
    ],
    tiff: [
      "tiff",
      "tif"
    ],
    "vnd.djvu": [
      "djvu",
      "djv"
    ],
    "vnd.wap.wbmp": "wbmp",
    "x-canon-cr2": "cr2",
    "x-canon-crw": "crw",
    "x-cmu-raster": "ras",
    "x-coreldraw": "cdr",
    "x-coreldrawpattern": "pat",
    "x-coreldrawtemplate": "cdt",
    "x-corelphotopaint": "cpt",
    "x-epson-erf": "erf",
    "x-icon": "ico",
    "x-jg": "art",
    "x-jng": "jng",
    "x-nikon-nef": "nef",
    "x-olympus-orf": "orf",
    "x-portable-anymap": "pnm",
    "x-portable-bitmap": "pbm",
    "x-portable-graymap": "pgm",
    "x-portable-pixmap": "ppm",
    "x-rgb": "rgb",
    "x-xbitmap": "xbm",
    "x-xpixmap": "xpm",
    "x-xwindowdump": "xwd",
    bmp: "bmp",
    cgm: "cgm",
    g3fax: "g3",
    ktx: "ktx",
    "prs.btif": "btif",
    sgi: "sgi",
    "vnd.dece.graphic": [
      "uvi",
      "uvvi",
      "uvg",
      "uvvg"
    ],
    "vnd.dwg": "dwg",
    "vnd.dxf": "dxf",
    "vnd.fastbidsheet": "fbs",
    "vnd.fpx": "fpx",
    "vnd.fst": "fst",
    "vnd.fujixerox.edmics-mmr": "mmr",
    "vnd.fujixerox.edmics-rlc": "rlc",
    "vnd.ms-modi": "mdi",
    "vnd.ms-photo": "wdp",
    "vnd.net-fpx": "npx",
    "vnd.xiff": "xif",
    webp: "webp",
    "x-3ds": "3ds",
    "x-cmx": "cmx",
    "x-freehand": [
      "fh",
      "fhc",
      "fh4",
      "fh5",
      "fh7"
    ],
    "x-pict": [
      "pic",
      "pct"
    ],
    "x-tga": "tga",
    "cis-cod": "cod",
    avif: "avifs",
    heic: [
      "heif",
      "heic"
    ],
    pjpeg: [
      "pjpg"
    ],
    "vnd.adobe.photoshop": "psd",
    "x-adobe-dng": "dng",
    "x-fuji-raf": "raf",
    "x-icns": "icns",
    "x-kodak-dcr": "dcr",
    "x-kodak-k25": "k25",
    "x-kodak-kdc": "kdc",
    "x-minolta-mrw": "mrw",
    "x-panasonic-raw": [
      "raw",
      "rw2",
      "rwl"
    ],
    "x-pentax-pef": [
      "pef",
      "ptx"
    ],
    "x-sigma-x3f": "x3f",
    "x-sony-arw": "arw",
    "x-sony-sr2": "sr2",
    "x-sony-srf": "srf"
  },
  message: {
    rfc822: [
      "eml",
      "mime",
      "mht",
      "mhtml",
      "nws"
    ]
  },
  model: {
    iges: [
      "igs",
      "iges"
    ],
    mesh: [
      "msh",
      "mesh",
      "silo"
    ],
    vrml: [
      "wrl",
      "vrml"
    ],
    "x3d+vrml": [
      "x3dv",
      "x3dvz"
    ],
    "x3d+xml": "x3dz",
    "x3d+binary": [
      "x3db",
      "x3dbz"
    ],
    "vnd.collada+xml": "dae",
    "vnd.dwf": "dwf",
    "vnd.gdl": "gdl",
    "vnd.gtw": "gtw",
    "vnd.mts": "mts",
    "vnd.usdz+zip": "usdz",
    "vnd.vtu": "vtu"
  },
  text: {
    "cache-manifest": [
      "manifest",
      "appcache"
    ],
    calendar: [
      "ics",
      "icz",
      "ifb"
    ],
    css: "css",
    csv: "csv",
    h323: "323",
    html: [
      "html",
      "htm",
      "shtml",
      "stm"
    ],
    iuls: "uls",
    plain: [
      "txt",
      "text",
      "brf",
      "conf",
      "def",
      "list",
      "log",
      "in",
      "bas",
      "diff",
      "ksh"
    ],
    richtext: "rtx",
    scriptlet: [
      "sct",
      "wsc"
    ],
    texmacs: "tm",
    "tab-separated-values": "tsv",
    "vnd.sun.j2me.app-descriptor": "jad",
    "vnd.wap.wml": "wml",
    "vnd.wap.wmlscript": "wmls",
    "x-bibtex": "bib",
    "x-boo": "boo",
    "x-c++hdr": [
      "h++",
      "hpp",
      "hxx",
      "hh"
    ],
    "x-c++src": [
      "c++",
      "cpp",
      "cxx",
      "cc"
    ],
    "x-component": "htc",
    "x-dsrc": "d",
    "x-diff": "patch",
    "x-haskell": "hs",
    "x-java": "java",
    "x-literate-haskell": "lhs",
    "x-moc": "moc",
    "x-pascal": [
      "p",
      "pas",
      "pp",
      "inc"
    ],
    "x-pcs-gcd": "gcd",
    "x-python": "py",
    "x-scala": "scala",
    "x-setext": "etx",
    "x-tcl": [
      "tcl",
      "tk"
    ],
    "x-tex": [
      "tex",
      "ltx",
      "sty",
      "cls"
    ],
    "x-vcalendar": "vcs",
    "x-vcard": "vcf",
    n3: "n3",
    "prs.lines.tag": "dsc",
    sgml: [
      "sgml",
      "sgm"
    ],
    troff: [
      "t",
      "tr",
      "roff",
      "man",
      "me",
      "ms"
    ],
    turtle: "ttl",
    "uri-list": [
      "uri",
      "uris",
      "urls"
    ],
    vcard: "vcard",
    "vnd.curl": "curl",
    "vnd.curl.dcurl": "dcurl",
    "vnd.curl.scurl": "scurl",
    "vnd.curl.mcurl": "mcurl",
    "vnd.dvb.subtitle": "sub",
    "vnd.fly": "fly",
    "vnd.fmi.flexstor": "flx",
    "vnd.graphviz": "gv",
    "vnd.in3d.3dml": "3dml",
    "vnd.in3d.spot": "spot",
    "x-asm": [
      "s",
      "asm"
    ],
    "x-c": [
      "c",
      "h",
      "dic"
    ],
    "x-fortran": [
      "f",
      "for",
      "f77",
      "f90"
    ],
    "x-opml": "opml",
    "x-nfo": "nfo",
    "x-sfv": "sfv",
    "x-uuencode": "uu",
    webviewhtml: "htt",
    javascript: "js",
    json: "json",
    markdown: [
      "md",
      "markdown",
      "mdown",
      "markdn"
    ],
    "vnd.wap.si": "si",
    "vnd.wap.sl": "sl"
  },
  video: {
    avif: "avif",
    "3gpp": "3gp",
    annodex: "axv",
    dl: "dl",
    dv: [
      "dif",
      "dv"
    ],
    fli: "fli",
    gl: "gl",
    mpeg: [
      "mpeg",
      "mpg",
      "mpe",
      "m1v",
      "m2v",
      "mp2",
      "mpa",
      "mpv2"
    ],
    mp4: [
      "mp4",
      "mp4v",
      "mpg4"
    ],
    quicktime: [
      "qt",
      "mov"
    ],
    ogg: "ogv",
    "vnd.mpegurl": [
      "mxu",
      "m4u"
    ],
    "x-flv": "flv",
    "x-la-asf": [
      "lsf",
      "lsx"
    ],
    "x-mng": "mng",
    "x-ms-asf": [
      "asf",
      "asx",
      "asr"
    ],
    "x-ms-wm": "wm",
    "x-ms-wmv": "wmv",
    "x-ms-wmx": "wmx",
    "x-ms-wvx": "wvx",
    "x-msvideo": "avi",
    "x-sgi-movie": "movie",
    "x-matroska": [
      "mpv",
      "mkv",
      "mk3d",
      "mks"
    ],
    "3gpp2": "3g2",
    h261: "h261",
    h263: "h263",
    h264: "h264",
    jpeg: "jpgv",
    jpm: [
      "jpm",
      "jpgm"
    ],
    mj2: [
      "mj2",
      "mjp2"
    ],
    "vnd.dece.hd": [
      "uvh",
      "uvvh"
    ],
    "vnd.dece.mobile": [
      "uvm",
      "uvvm"
    ],
    "vnd.dece.pd": [
      "uvp",
      "uvvp"
    ],
    "vnd.dece.sd": [
      "uvs",
      "uvvs"
    ],
    "vnd.dece.video": [
      "uvv",
      "uvvv"
    ],
    "vnd.dvb.file": "dvb",
    "vnd.fvt": "fvt",
    "vnd.ms-playready.media.pyv": "pyv",
    "vnd.uvvu.mp4": [
      "uvu",
      "uvvu"
    ],
    "vnd.vivo": "viv",
    webm: "webm",
    "x-f4v": "f4v",
    "x-m4v": "m4v",
    "x-ms-vob": "vob",
    "x-smv": "smv",
    mp2t: "ts"
  },
  "x-conference": {
    "x-cooltalk": "ice"
  },
  "x-world": {
    "x-vrml": [
      "vrm",
      "flr",
      "wrz",
      "xaf",
      "xof"
    ]
  }
};
(() => {
  const e = {};
  for (const t of Object.keys(uo))
    for (const n of Object.keys(uo[t])) {
      const a = uo[t][n];
      if (typeof a == "string")
        e[a] = t + "/" + n;
      else
        for (let s = 0; s < a.length; s++)
          e[a[s]] = t + "/" + n;
    }
  return e;
})();
Wg(Gs);
async function k1(e, t) {
  return e == null ? void 0 : e.getData(new wh(), {
    onprogress: t
  });
}
var Lh = /* @__PURE__ */ ((e) => (e[e.START = 900] = "START", e[e.PLAN = 901] = "PLAN", e[e.PRO = 902] = "PRO", e[e.DESIGN = 903] = "DESIGN", e[e.GUIDE_DIGITAL_DOC = 904] = "GUIDE_DIGITAL_DOC", e[e.GUIDE_DIGITAL_DOC_ENTERPRISE = 905] = "GUIDE_DIGITAL_DOC_ENTERPRISE", e[e.CAD = 906] = "CAD", e[e.CAD_PLUS = 907] = "CAD_PLUS", e[e.FULL_SUITE = 908] = "FULL_SUITE", e))(Lh || {});
const Dh = [
  [
    "FULL SUITE",
    908
    /* FULL_SUITE */
  ],
  [
    "CAD+",
    907
    /* CAD_PLUS */
  ],
  [
    "CAD",
    906
    /* CAD */
  ],
  // put before CAD+ to prevent false match
  [
    "GUIDE DIGITAL DOC ENTERPRISE",
    905
    /* GUIDE_DIGITAL_DOC_ENTERPRISE */
  ],
  [
    "GUIDE DIGITAL DOC",
    904
    /* GUIDE_DIGITAL_DOC */
  ],
  [
    "DESIGN",
    903
    /* DESIGN */
  ],
  [
    "PRO",
    902
    /* PRO */
  ],
  [
    "PLAN",
    901
    /* PLAN */
  ],
  [
    "START",
    900
    /* START */
  ]
];
function Mh(e) {
  if (typeof e != "string") {
    console.warn("Invalid input to getRealGuideConfigurationIdentifier:", e);
    return;
  }
  const t = e.trim().toUpperCase();
  for (const [n, a] of Dh)
    if (t.includes(n))
      return a;
}
var Oh = /* @__PURE__ */ ((e) => (e.REALGUIDE_3DIEMME = "00001", e._3P = "00002", e._8853 = "00003", e.AB_DENTAL = "00004", e.ACTEON = "00005", e.BIOMEC_OXY_IMPLANT = "00006", e.BTK = "00007", e.CEFLA_1 = "00008", e.CEFLA_2 = "00009", e.CEFLA_3 = "00010", e.CGM = "00011", e.IDI_EVOLUTION = "00012", e.IPD = "00013", e.IRES = "00014", e.ISOMED = "00015", e.ITAKA = "00016", e.JDENTALCARE = "00017", e.LEONE = "00018", e.MEDENTIS_MMEDICAL = "00019", e.MICERIUM = "00020", e.NEW_ANCORVIS = "00021", e.NORIS_MEDICAL = "00022", e.NSEQUENCE = "00023", e.ORANGE_DENTAL = "00024", e.PRODENT = "00025", e.PROFESSIONE_SORRISO = "00026", e.SWEDEN_MARTINA = "00027", e.TRIDENT = "00028", e.ZIMMERBIOMET_EU = "00029", e.ZIMMERBIOMET_US = "00030", e.ZIMMERBIOMET_LATAM = "00031", e.BREDENT = "00032", e.BIOMAX = "00033", e.ZIMVIE_CHINA = "00034", e.ZIMVIE_JAPAN = "00035", e))(Oh || {});
const Fr = [
  ["00001", ["RealGUIDE 3Diemme", "RealGUIDE", "realguide"]],
  ["00002", ["3P", "3P Guide", "3pguide", "3guide"]],
  ["00003", ["8853", "3DLynx", "3dlynx"]],
  ["00004", ["AB dental", "AB Guided Service"]],
  ["00005", ["Acteon", "AIS 3D APP", "acteon", "acteon-us"]],
  ["00006", ["Biomec - OXY Implant", "ODS Guide", "oxy"]],
  ["00007", ["BTK", "Opera", "btk"]],
  ["00008", ["Cefla", "MyRay 5", "cefla-myray"]],
  ["00009", ["Cefla 2", "cefla-neutral"]],
  ["00010", ["NewTom 5", "cefla-newtom"]],
  ["00011", ["CGM", "X-Ray", "cgm"]],
  ["00012", ["IDI Evolution", "IDI Double Guide", "idievolution"]],
  ["00013", ["IPD", "Model PRO", "ipd"]],
  ["00014", ["iRes", "SmartGuide", "ires"]],
  ["00015", ["Isomed", "IsoGUIDE", "isomed"]],
  ["00016", ["Itaka", "ITAKAD", "itaka", "itakad"]],
  ["00017", ["Jdentalcare", "JDigital Guide", "jdental"]],
  ["00018", ["Leone", "Leone 3D", "degis"]],
  ["00019", ["Medentis Mmedical", "MagellanX", "magellan"]],
  ["00020", ["Micerium", "Micos GUIDE", "micerium"]],
  ["00021", ["New Ancorvis"]],
  ["00022", ["Noris Medical", "EZPlan", "noris"]],
  ["00023", ["nSequence", "Maven PRO"]],
  ["00024", ["Orange Dental", "Byzz3D"]],
  ["00025", ["Prodent", "Prodent 3D", "prodent"]],
  ["00026", ["Professione sorriso", "Speedy3D", "speedy3d"]],
  ["00027", ["Sweden & Martina", "Archiplan 3D", "sweden-martina"]],
  ["00028", ["Trident", "Insight"]],
  ["00029", ["ZimmerBiomet EU", "ZimmerBiomet/ZimVie EU", "ZimVie EU", "zimmer-eu", "zimvie"]],
  ["00030", ["ZimmerBiomet US", "ZimmerBiomet/ZimVie US", "ZimVie US", "zimmer-us", "realguide-na"]],
  ["00031", ["ZimmerBiomet LATAM", "ZimmerBiomet/ZimVie LATAM", "ZimVie LATAM", "zimmer-latam"]],
  ["00032", ["bredent", "SKY Pro plan GUIDE", "bredent"]],
  ["00033", ["Biomax", "Biomax Digital Suite", "biomax"]],
  ["00034", ["ZimVie China", "zimmer-chinese"]],
  ["00035", ["ZimVie Japan", "zimmer-jpn"]]
];
function fo(e) {
  return e.trim().toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ");
}
function _1(e) {
  if (typeof e != "string")
    return;
  const t = fo(e);
  for (const [n, a] of Fr)
    for (const s of a)
      if (t === fo(s))
        return n;
  for (const [n, a] of Fr)
    for (const s of a)
      if (t.includes(fo(s)))
        return n;
}
function Qr(e, t) {
  return e ? e.split(";").filter(Boolean).some((n) => {
    const [a, s] = n.split("=");
    return a === t && s === "1";
  }) : !1;
}
const Nh = ["src"], Rh = ["src"], S1 = /* @__PURE__ */ Y({
  __name: "MButtonMenu",
  props: {
    tabMenuItems: { required: !0 },
    tabMenuItemsModifiers: {},
    tabIndex: { required: !0 },
    tabIndexModifiers: {},
    selectedTab: { required: !1 },
    selectedTabModifiers: {},
    disabled: { type: Boolean, required: !1, default: !1 },
    disabledModifiers: {},
    showArrows: { type: Boolean, required: !1, default: !1 },
    showArrowsModifiers: {},
    isVertical: { type: Boolean, required: !1, default: !1 },
    isVerticalModifiers: {}
  },
  emits: ["update:tabMenuItems", "update:tabIndex", "update:selectedTab", "update:disabled", "update:showArrows", "update:isVertical"],
  setup(e) {
    const t = ye(e, "tabMenuItems"), n = ye(e, "tabIndex"), a = ye(e, "selectedTab"), s = ye(e, "disabled"), o = ye(e, "showArrows"), i = ye(e, "isVertical"), r = (p) => n.value === p ? "project-item-menu-btn-selected" : "p-button-outlined", l = F(() => o.value ? "gap-4 w-full" : "gap-2 w-full"), c = F(() => o.value ? "gap-4 grow" : "grow");
    F(() => "flex-col");
    const u = (p, m) => {
      n.value = p, a.value = m;
    };
    return (p, m) => {
      const v = ne("Button");
      return i.value ? (y(), G(k(ma), {
        key: 0,
        class: "gap-4"
      }, {
        default: T(() => [
          (y(!0), M(fe, null, He(t.value, (A, h) => (y(), G(te, {
            class: J([c.value]),
            key: A.label
          }, {
            default: T(() => {
              var d;
              return [
                (y(), G(v, {
                  id: `btnMenu${A.id ?? A.label.replaceAll(" ", "")}`,
                  class: J(["project-item-menu-btn w-full", r(h)]),
                  badge: (d = A.badge) == null ? void 0 : d.toString(),
                  key: h,
                  label: A.label,
                  disabled: s.value,
                  onClick: (f) => u(h, A.label)
                }, null, 8, ["id", "badge", "class", "label", "disabled", "onClick"])),
                o.value && h !== t.value.length - 1 ? (y(), M("img", {
                  key: 0,
                  src: k(vs)("rg_chevron_right")
                }, null, 8, Nh)) : W("", !0)
              ];
            }),
            _: 2
          }, 1032, ["class"]))), 128))
        ]),
        _: 1
      })) : (y(), G(te, {
        key: 1,
        class: J([l.value])
      }, {
        default: T(() => [
          (y(!0), M(fe, null, He(t.value, (A, h) => (y(), G(te, {
            class: J([c.value]),
            key: A.label
          }, {
            default: T(() => {
              var d;
              return [
                (y(), G(v, {
                  id: `btnMenu${A.id ?? A.label.replaceAll(" ", "")}`,
                  class: J(["project-item-menu-btn w-full", r(h)]),
                  badge: (d = A.badge) == null ? void 0 : d.toString(),
                  key: h,
                  label: A.label,
                  disabled: s.value,
                  onClick: (f) => u(h, A.label)
                }, null, 8, ["id", "badge", "class", "label", "disabled", "onClick"])),
                o.value && h !== t.value.length - 1 ? (y(), M("img", {
                  key: 0,
                  src: k(vs)("rg_chevron_right")
                }, null, 8, Rh)) : W("", !0)
              ];
            }),
            _: 2
          }, 1032, ["class"]))), 128))
        ]),
        _: 1
      }, 8, ["class"]));
    };
  }
}), Ph = {}, Fh = { class: "flex justify-center items-center select-none w-10/12 h-10 rounded-lg border-2 border-gray-700 text-2xl text-gray-500 hover:border-gray-500 hover:text-gray-400" };
function Qh(e, t) {
  return y(), M("button", Fh, " ✕ ");
}
const T1 = /* @__PURE__ */ le(Ph, [["render", Qh]]), Uh = ["src", "height", "alt"], Yh = /* @__PURE__ */ Y({
  __name: "MIconButton",
  props: {
    iconType: { default: de.TOP_NAVBAR_ICON },
    iconPos: { default: hn.LEFT },
    icon: { default: "icon_export" },
    label: {},
    disabled: { type: Boolean },
    tooltipBottom: {}
  },
  setup(e) {
    const t = e, n = Sn(), a = F(() => n.getAssetUrl(`/icons/${t.icon}.svg`)), s = F(() => t.iconType === de.TOP_NAVBAR_ICON || t.iconType === de.BUTTON_ICON || t.iconType === de.TOP_NAVBAR_MOBILE_ICON || t.iconType === de.TOP_NAVBAR_ICON_LABEL ? "order: 1" : "order: 1; margin-top: 0.3rem;"), o = F(() => t.iconType === de.TOP_NAVBAR_ICON || t.iconType === de.TOP_NAVBAR_MOBILE_ICON || t.iconType === de.TOP_NAVBAR_ICON_LABEL ? "web-rg-navbar-btn" : ""), i = F(() => {
      if (t.label)
        if (t.iconType === de.TOP_NAVBAR_ICON || t.iconType === de.TOP_NAVBAR_MOBILE_ICON || t.iconType === de.TOP_NAVBAR_ICON_LABEL) {
          const p = "top-navbar-hide-sm top-navbar-text-color whitespace-nowrap";
          return t.iconPos == hn.LEFT ? p + " ml-2" : t.iconPos == hn.TOP ? p + " mt-2" : p;
        } else return t.iconType === de.BUTTON_ICON_NO_LABEL ? "" : "btn-text-14 whitespace-nowrap";
      else return "";
    }), r = F(() => {
      if (t.iconType !== de.TOP_NAVBAR_MOBILE_ICON)
        return t.iconType === de.TOP_NAVBAR_ICON || t.iconType === de.TOP_NAVBAR_ICON_LABEL ? "top-nav-height" : "px-2";
    }), l = F(() => {
      if (t.iconType === de.TOP_NAVBAR_MOBILE_ICON)
        return (t.icon ?? "").includes("logout"), 22;
    }), c = F(() => {
      switch (t.iconType) {
        case de.BUTTON_ICON:
        case de.BUTTON_ICON_NO_LABEL:
          return "h-2-5rem";
        case de.TOP_NAVBAR_ICON_LABEL:
          return typeof window < "u" && window.innerWidth < 1200 ? "ipad-top-nav-btn-padding" : "top-nav-height";
        default:
          return "";
      }
    }), u = F(() => {
      switch (t.iconType) {
        case de.TOP_NAVBAR_ICON:
          return "svg-icon-color";
        case de.TOP_NAVBAR_MOBILE_ICON:
          return "svg-icon-color;";
        case de.BUTTON_ICON:
          return "width: 1.5rem; height: 2.2rem !important;";
        case de.BUTTON_ICON_NO_LABEL:
          return "width: 1.5rem; height: 2.2rem !important;";
        case de.TOP_NAVBAR_ICON_LABEL:
          return "";
        default:
          return "width: 4.5rem; max-height: 20px;";
      }
    });
    return (p, m) => {
      const v = Sa("tooltip");
      return Qt((y(), M("button", {
        class: J(["m-u-button", [{ "m-u-button-disabled": e.disabled }, t.iconPos, o.value, r.value, c.value]]),
        style: Se({ pointerEvents: t.disabled ? "none" : "auto" }),
        type: "button"
      }, [
        b("span", {
          style: Se(s.value),
          class: J([t.iconType === k(de).TOP_NAVBAR_ICON ? "navbar-icon-wrapper" : ""])
        }, [
          b("img", {
            class: J(t.iconType),
            src: a.value,
            height: l.value,
            style: Se([u.value]),
            alt: t.label,
            draggable: "false"
          }, null, 14, Uh)
        ], 6),
        b("span", {
          class: J([i.value]),
          style: { "min-width": "0", overflow: "hidden", "text-overflow": "ellipsis" }
        }, [
          q(p.$slots, "default", {}, void 0, !0),
          ke(" " + R(t.label), 1)
        ], 2)
      ], 6)), [
        [
          v,
          t.label ?? t.tooltipBottom,
          void 0,
          { bottom: !0 }
        ]
      ]);
    };
  }
}), ds = /* @__PURE__ */ le(Yh, [["__scopeId", "data-v-164b54a6"]]), Gh = Y({
  props: {
    src: String,
    // <img :src="src" ... >
    faIcon: String,
    // fontawesome icon name, has to be added to library in main.ts
    cIcon: String,
    // custom icons located in assets/icons/
    scale: {
      type: Boolean,
      default: !1
    },
    colorClass: {
      type: String,
      default: "svg-icon-color"
    },
    width: {
      type: Number,
      default: 19
    },
    height: {
      type: Number,
      default: 19
    },
    label: {
      type: String
    },
    isMenuIcon: {
      type: Boolean,
      default: !1
    },
    iconType: {
      type: String,
      default: de.TOP_NAVBAR_ICON
    }
  },
  setup(e) {
    const t = F(() => {
      switch (e.iconType) {
        case de.OBJECT_LIST_ICON:
          return de.OBJECT_LIST_ICON.toString();
        case de.BUTTON_ICON:
          return "";
      }
      return e.colorClass;
    }), n = Sn();
    return {
      cIconSrc: L(n.getAssetUrl(`/icons/${e.cIcon}.svg`)),
      colClass: t
    };
  }
}), jh = { style: { display: "inline-flex", "margin-top": "2%" } }, Hh = ["src"], Vh = ["height", "src", "width"], Kh = {
  key: 2,
  class: "flex w-full h-full justify-center items-center pointer-events-none"
}, Wh = { style: { display: "contents" } }, zh = { style: { "margin-top": "2px", "margin-left": "2px" } };
function $h(e, t, n, a, s, o) {
  const i = ne("font-awesome-icon");
  return y(), M("span", jh, [
    e.src ? (y(), M("img", {
      key: 0,
      class: J([[e.scale ? "object-contain" : "object-scale-down"], "w-full h-full object-contain pointer-events-none"]),
      src: e.src,
      draggable: "false"
    }, null, 10, Hh)) : e.cIcon ? (y(), M("img", {
      key: 1,
      class: J([e.scale ? "object-scale-down" : "object-contain", e.colClass]),
      height: e.height,
      src: e.cIconSrc,
      style: Se([e.isMenuIcon ? "max-width:19px; max-height:19px; border-style: none" : "border-style: none"]),
      width: e.width,
      draggable: "false"
    }, null, 14, Vh)) : e.faIcon ? (y(), M("div", Kh, [
      w(i, {
        icon: e.faIcon,
        style: Se([e.scale ? "width: 100%" : ""]),
        class: "w-full h-full pointer-events-none"
      }, null, 8, ["icon", "style"])
    ])) : W("", !0),
    b("span", Wh, [
      b("span", zh, R(e.label), 1)
    ])
  ]);
}
const wi = /* @__PURE__ */ le(Gh, [["render", $h]]), Jh = ["disabled"], qh = { class: "flex flex-col items-center" }, Xh = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }, L1 = /* @__PURE__ */ Y({
  __name: "MLargeIconButton",
  props: {
    icon: {},
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { disabled: n, icon: a } = at(t);
    return (s, o) => (y(), M("button", {
      class: J([{ "text-gray-500 cursor-default": k(n) }, "w-24 h-16 p-1 text-xs"]),
      disabled: k(n)
    }, [
      b("div", qh, [
        w(wi, {
          src: k(a),
          class: "w-8/12 h-8"
        }, null, 8, ["src"]),
        b("div", Xh, [
          q(s.$slots, "default")
        ])
      ])
    ], 10, Jh));
  }
}), Zh = {}, e0 = { class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-12 rounded" };
function t0(e, t) {
  return y(), M("button", e0, [
    q(e.$slots, "default")
  ]);
}
const D1 = /* @__PURE__ */ le(Zh, [["render", t0]]), n0 = /* @__PURE__ */ Y({
  __name: "MToggleButton",
  props: {
    checked: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = L(e.checked);
    return (a, s) => {
      const o = ne("ToggleButton");
      return y(), G(o, {
        modelValue: n.value,
        "onUpdate:modelValue": s[0] || (s[0] = (i) => n.value = i),
        "off-icon": "pi pi-times",
        "on-icon": "pi pi-check"
      }, null, 8, ["modelValue"]);
    };
  }
}), a0 = ["disabled"], s0 = { class: "flex items-center" }, o0 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }, M1 = /* @__PURE__ */ Y({
  __name: "MToolbarButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    icon: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (y(), M("button", {
      class: J([{ "text-gray-500": e.disabled }, "h-6 text-xs bg-inactive-tabs"]),
      disabled: e.disabled
    }, [
      b("div", s0, [
        w(wi, {
          src: t.icon,
          class: "w-6/12 h-6"
        }, null, 8, ["src"]),
        b("div", o0, [
          q(n.$slots, "default")
        ])
      ])
    ], 10, a0));
  }
});
function i0(e, t) {
  return !(t.value === e.target || t.value && t.value.contains(e.target));
}
function Hs(e, t, n) {
  const a = (s) => {
    i0(s, e) && t();
  };
  n ? (Ae(n, () => {
    n.value ? document.addEventListener("click", a) : document.removeEventListener("click", a);
  }), n.value && document.addEventListener("click", a)) : Ls(() => document.addEventListener("click", a)), wn(() => document.removeEventListener("click", a));
}
const r0 = ["src"], l0 = /* @__PURE__ */ Y({
  __name: "MUButton",
  props: /* @__PURE__ */ pt({
    label: {},
    icon: {},
    iconSrc: {},
    iconRight: { type: Boolean },
    iconAbove: { type: Boolean },
    previewSrc: {},
    outlined: { type: Boolean },
    disabled: { type: Boolean },
    background: { type: Boolean, default: !0 },
    iconFont: {},
    labelFont: {},
    iconSrcHeight: {},
    iconSrcWidth: {},
    iconSrcMaxWidth: {},
    iconSrcPadding: {},
    iconSrcObjectFit: {},
    customInput: { type: Boolean },
    dropdown: { type: Boolean },
    dropdownLocationTop: { type: Boolean },
    dropdownLocationTopLeft: { type: Boolean },
    togglable: { type: Boolean },
    isToolbarButton: { type: Boolean, default: !1 },
    ignoreSvgFilter: { type: Boolean, default: !1 },
    tooltip: {},
    dynamicButton: { type: Boolean },
    addEnterListener: { type: Boolean, default: !1 }
  }, {
    dropdownState: { type: Boolean, default: !1, required: !1 },
    dropdownStateModifiers: {},
    toggled: { type: Boolean, default: !1, required: !1 },
    toggledModifiers: {}
  }),
  emits: /* @__PURE__ */ pt(["click", "toggledChange", "closedByClickOutside"], ["update:dropdownState", "update:toggled"]),
  setup(e, { emit: t }) {
    const n = ye(e, "dropdownState"), a = ye(e, "toggled"), s = e, o = t, i = Sn(), r = F(() => s.iconSrc ? i.getAssetUrl(`${s.iconSrc}`) : s.previewSrc ? s.previewSrc : ""), l = () => {
      if (!s.disabled)
        if ((s.dropdown || s.customInput) && !s.dynamicButton) {
          n.value = !n.value;
          return;
        } else s.togglable && !s.dynamicButton ? (a.value = !a.value, o("toggledChange", a.value)) : o("click");
    }, c = L();
    return Hs(c, () => {
      n.value && (n.value = !1, o("closedByClickOutside"));
    }), (u, p) => {
      const m = Sa("tooltip");
      return Qt((y(), M("button", {
        class: J(["m-u-button", {
          "m-u-button-outlined": s.outlined,
          "flex-row": !s.iconAbove,
          "flex-col": s.iconAbove,
          "m-u-button-disabled": e.disabled,
          "m-u-button-background": s.background,
          "m-u-button-no-background": !s.background,
          "m-u-button-toggled": a.value && s.background,
          "m-u-button-ignore-svg-filter": s.ignoreSvgFilter,
          "m-u-no-button-toolbar": !s.isToolbarButton,
          "m-u-button-toolbar": s.isToolbarButton,
          "m-u-cursor-default": !s.togglable
        }]),
        ref_key: "menuButton",
        ref: c,
        type: "button",
        onClick: l,
        onKeydown: p[0] || (p[0] = Ta((v) => s.addEnterListener && o("click"), ["enter"]))
      }, [
        s.icon ? (y(), M("i", {
          key: 0,
          class: J(["h-full flex justify-center", [s.icon, s.label && !s.iconAbove ? "ml-2" : ""]]),
          style: Se([{ "align-items": "center" }, {
            fontSize: s.iconFont,
            order: s.iconAbove ? 0 : s.iconRight ? 2 : 0
          }])
        }, null, 6)) : W("", !0),
        s.iconSrc || s.previewSrc ? (y(), M("img", {
          key: 1,
          draggable: "false",
          src: r.value,
          alt: "icon",
          class: J(["svg-filter h-full flex justify-content-center"]),
          style: Se([{ "align-items": "center" }, {
            order: s.iconAbove ? 0 : s.iconRight ? 2 : 0,
            height: s.iconSrcHeight + " !important",
            width: s.iconSrcWidth + " !important",
            maxWidth: s.iconSrcMaxWidth + " !important",
            padding: s.iconSrcPadding,
            objectFit: s.iconSrcObjectFit
          }])
        }, null, 12, r0)) : W("", !0),
        s.label ? (y(), M("span", {
          key: 2,
          class: J([["flex justify-content-center", !s.isToolbarButton && !s.iconAbove ? "mr-2 ml-2" : "", s.iconAbove ? "mt-2" : ""], "h-full"]),
          style: Se({
            whiteSpace: "nowrap",
            alignItems: "center",
            order: "1",
            fontSize: s.labelFont
          })
        }, R(s.label), 7)) : W("", !0),
        n.value ? (y(), M("div", {
          key: 3,
          class: J({
            "dropdown-container": !0,
            "dropdown-menu-bottom": s.dropdown && !s.dropdownLocationTop && !s.dropdownLocationTopLeft,
            "dropdown-menu-top": s.dropdown && s.dropdownLocationTop,
            "dropdown-menu-top-left": s.dropdown && s.dropdownLocationTopLeft,
            "custom-input-menu": s.customInput
          })
        }, [
          q(u.$slots, "default", {}, void 0, !0)
        ], 2)) : W("", !0)
      ], 34)), [
        [
          m,
          { value: s.tooltip, showDelay: 500, hideDelay: 200 },
          void 0,
          { bottom: !0 }
        ]
      ]);
    };
  }
}), ft = /* @__PURE__ */ le(l0, [["__scopeId", "data-v-72965138"]]), c0 = ["type", "min", "max", "step", "placeholder"], u0 = /* @__PURE__ */ Y({
  __name: "MUInput",
  props: {
    type: { default: "number" },
    min: { default: "0" },
    max: { default: "999999" },
    step: { default: "0.01" },
    placeholder: { default: "Custom (mm)" },
    focused: { type: Boolean, default: !1 }
  },
  emits: ["customSelected", "onBlur", "update:focused"],
  setup(e, { emit: t }) {
    const n = e, a = t, { focused: s } = at(n), o = L(), i = L();
    Ae(s, () => {
      var p;
      s.value && ((p = i.value) == null || p.focus());
    }), s.value && setTimeout(() => {
      var p;
      (p = i.value) == null || p.focus();
    }, 0);
    let r = !1;
    const l = () => {
      r = !0, i.value && i.value.blur();
    }, c = () => {
      o.value != null && a("customSelected", o.value);
    }, u = () => {
      o.value != null ? a("onBlur", o.value, r) : a("onBlur", 0, !0), r = !1;
    };
    return (p, m) => Qt((y(), M("input", {
      "onUpdate:modelValue": m[0] || (m[0] = (v) => o.value = v),
      ref_key: "customInputEl",
      ref: i,
      type: e.type,
      min: e.min,
      max: e.max,
      step: e.step,
      placeholder: e.placeholder,
      class: "custom-input",
      onBlur: u,
      onClick: m[1] || (m[1] = xt(() => {
      }, ["stop"])),
      onKeydown: [
        Ta(l, ["esc"]),
        m[2] || (m[2] = xt(() => {
        }, ["stop"]))
      ],
      onKeyup: m[3] || (m[3] = xt(() => {
      }, ["stop"])),
      onKeypress: [
        Ta(c, ["enter"]),
        m[4] || (m[4] = xt(() => {
        }, ["stop"]))
      ]
    }, null, 40, c0)), [
      [
        Ad,
        o.value,
        void 0,
        { number: !0 }
      ]
    ]);
  }
}), d0 = ["onClick"], f0 = {
  key: 0,
  class: "menu-item"
}, O1 = /* @__PURE__ */ Y({
  __name: "MUDropdown",
  props: {
    dropdownItems: {},
    customInput: { type: Boolean }
  },
  emits: ["selected", "customSelected"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = (i) => {
      a("selected", i);
    }, o = (i) => {
      i != null && a("customSelected", i);
    };
    return (i, r) => (y(), M(fe, null, [
      (y(!0), M(fe, null, He(e.dropdownItems, (l, c) => (y(), M("div", {
        key: c,
        class: "menu-item",
        onClick: (u) => s(l)
      }, R(l.label), 9, d0))), 128)),
      n.customInput ? (y(), M("div", f0, [
        w(u0, { onCustomSelected: o })
      ])) : W("", !0)
    ], 64));
  }
}), p0 = /* @__PURE__ */ Y({
  __name: "MDialogCancelButton",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = ne("Button");
      return y(), G(o, {
        class: "p-button-outlined",
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "border-radius": "16px", "min-width": "114px !important", background: "rgba(255, 255, 255, 0.06)", border: "1px var(--p-rg-border-color) solid !important", color: "var(--p-rg-component-text-color) !important" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), Bs = /* @__PURE__ */ Y({
  __name: "MDialogCancelButtonRedesign",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = ne("Button");
      return y(), G(o, {
        class: "p-button-outlined",
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "border-radius": "16px", "min-width": "114px !important", background: "rgba(255, 255, 255, 0.06)", border: "1px var(--p-rg-border-color) solid !important", color: "var(--p-rg-component-text-color) !important" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), m0 = /* @__PURE__ */ Y({
  __name: "MDialogConfirmButton",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = ne("Button");
      return y(), G(o, {
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "min-width": "114px !important", "border-radius": "16px" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), Vs = /* @__PURE__ */ Y({
  __name: "MDialogConfirmButtonRedesign",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = ne("Button");
      return y(), G(o, {
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "min-width": "114px !important", "border-radius": "16px" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), A0 = () => ({
  order: {
    caseIdIncludesUser: !1,
    requireStatusStepConfirmation: !1,
    defaultOrdersPageSize: 500
  },
  enabledFunctionality: {
    materialLibrary: !0,
    openTicket: !1,
    remoteSupport: !1,
    eLearning: !1
  },
  ui: {
    dialogButtons: {
      okCancelLayout: "win"
    }
  }
}), ct = A0(), fa = Yl({
  ...ct,
  order: { ...ct.order },
  enabledFunctionality: { ...ct.enabledFunctionality }
}), g0 = F(() => {
  var e, t;
  return (((t = (e = fa.value.ui) == null ? void 0 : e.dialogButtons) == null ? void 0 : t.okCancelLayout) ?? "win") === "win";
}), h0 = F(() => {
  var e;
  return ((e = fa.value.enabledFunctionality) == null ? void 0 : e.openTicket) ?? !1;
}), v0 = F(() => {
  var e;
  return ((e = fa.value.enabledFunctionality) == null ? void 0 : e.remoteSupport) ?? !1;
}), b0 = F(() => {
  var e;
  return ((e = fa.value.enabledFunctionality) == null ? void 0 : e.eLearning) ?? !1;
});
let po = null;
function x0(e) {
  var t;
  return e ? {
    ...ct,
    ...e,
    order: {
      ...ct.order,
      ...e.order ?? {}
    },
    enabledFunctionality: {
      ...ct.enabledFunctionality,
      ...e.enabledFunctionality ?? {}
    },
    ui: {
      ...ct.ui,
      ...e.ui ?? {},
      dialogButtons: {
        ...ct.ui.dialogButtons,
        ...((t = e.ui) == null ? void 0 : t.dialogButtons) ?? {}
      }
    }
  } : {
    ...ct,
    order: { ...ct.order },
    enabledFunctionality: { ...ct.enabledFunctionality },
    ui: {
      ...ct.ui,
      dialogButtons: { ...ct.ui.dialogButtons }
    }
  };
}
async function y0() {
  try {
    const e = globalThis.__APP_SETTINGS_URL ?? (typeof document < "u" ? new URL("resources/app-settings.json", document.baseURI).toString() : "/resources/app-settings.json"), t = await fetch(e, {
      cache: "no-store"
    });
    return t.ok ? await t.json() : (console.warn(`Failed to load app-settings.json. Status: ${t.status}`), null);
  } catch (e) {
    return console.warn("Failed to load app-settings.json", e), null;
  }
}
async function E0() {
  return po || (po = (async () => {
    const e = await y0(), t = x0(e);
    return fa.value = t, t;
  })()), po;
}
function Ur() {
  return {
    appSettings: fa,
    isWinLayout: g0,
    hasOpenTicket: h0,
    hasRemoteSupport: v0,
    hasELearning: b0,
    loadAppSettings: E0
  };
}
const du = /* @__PURE__ */ Y({
  __name: "MDialogFooter",
  props: {
    acceptLabel: { default: "OK" },
    rejectLabel: { default: void 0 },
    acceptIcon: { default: "pi pi-check" },
    rejectIcon: { default: "pi pi-times" },
    gap: { default: "gap-2" },
    align: { default: "center" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["accept", "reject"],
  setup(e, { emit: t }) {
    const { appSettings: n } = Ur(), a = e, { acceptLabel: s, rejectLabel: o, acceptIcon: i, rejectIcon: r, gap: l, align: c, disabled: u } = at(a), p = t, { isWinLayout: m } = Ur(), v = {
      height: "49px",
      minWidth: "114px",
      borderRadius: "16px"
    }, A = F(() => ({ ...v })), h = F(() => ({
      ...v,
      background: "rgba(255, 255, 255, 0.06)",
      border: "1px var(--p-rg-border-color) solid !important",
      color: "var(--p-rg-component-text-color)"
    })), d = F(() => `justify-${c.value}`), f = F(() => o.value ?? Ce("shared.cancel"));
    return (g, B) => (y(), G(k(cn), {
      class: J(["action-row", [k(l), d.value, { "action-row--reverse": !k(m) }]])
    }, {
      default: T(() => [
        w(k(m0), {
          label: k(s),
          icon: k(i),
          disabled: k(u),
          onClick: B[0] || (B[0] = (E) => p("accept")),
          class: "action-btn action-btn--accept",
          style: Se(A.value)
        }, null, 8, ["label", "icon", "disabled", "style"]),
        w(k(p0), {
          label: f.value,
          icon: k(r),
          onClick: B[1] || (B[1] = (E) => p("reject")),
          class: "action-btn action-btn--reject p-button-outlined",
          style: Se(h.value)
        }, null, 8, ["label", "icon", "style"])
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
var It = /* @__PURE__ */ ((e) => (e.SHOW_ONLY_LOGO = "showOnlyLogo", e.SHOW_ONLY_PC_NAME = "showOnlyPCName", e.SHOW_NAVBAR = "showNavbar", e.HIDE_NAVBAR = "hideNavbar", e.ENABLE_NAVBAR_BUTTONS = "enableNavbarButtons", e.DISABLE_NAVBAR_BUTTONS = "disableNavbarButtons", e.ADD_TOOLTIPS = "addTooltips", e.UPDATE_NAVBAR = "updateNavbar", e.SHOW_PROJECT_NAME = "showProjectName", e.TOGGLE_CAD_MODE = "toggleCadMode", e.SHOW_UNVERIFIED_ADDRESS = "showUnverifiedAddress", e))(It || {}), zn = /* @__PURE__ */ ((e) => (e.NAVBAR_BUTTON_CLICKED = "onNavbarButtonClicked", e.USER_EMAIL_NOTIFICATION_CLICKED = "onUserEmailNotificationClicked", e.USER_CHAT_EMAIL_NOTIFICATION_CLICKED = "onUserChatEmailNotificationClicked", e.PROJECT_UNVERIFIED_ADDRESS_CLICKED = "onProjectUnverifiedAddressClicked", e))(zn || {});
const we = Os();
class C0 {
  showOnlyLogo() {
    we.emit(
      "showOnlyLogo"
      /* SHOW_ONLY_LOGO */
    );
  }
  showOnlyPCName(t) {
    we.emit("showOnlyPCName", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  showNavbar(t) {
    we.emit("showNavbar", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  hideNavbar() {
    we.emit("hideNavbar", {
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  enableNavbarButtons(t) {
    we.emit("enableNavbarButtons", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  disableNavbarButtons(t) {
    we.emit("disableNavbarButtons", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  addTooltips(t) {
    we.emit("addTooltips", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  updateNavbar(t) {
    we.emit("updateNavbar", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  showProjectOnNavbar(t) {
    we.emit("showProjectName", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  setCadMode(t) {
    we.emit("toggleCadMode", {
      flag: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  showUnverifiedAddress(t) {
    we.emit("showUnverifiedAddress", {
      flag: t,
      resolve: () => {
      }
    });
  }
}
var U = /* @__PURE__ */ ((e) => (e[e.RG_LOGO_ONLY = 100] = "RG_LOGO_ONLY", e[e.SETTINGS = 0] = "SETTINGS", e[e.MATERIAL_LIBRARY = 1] = "MATERIAL_LIBRARY", e[e.ADD_PATIENT = 2] = "ADD_PATIENT", e[e.NOTIFICATIONS = 3] = "NOTIFICATIONS", e[e.SUPPORT = 4] = "SUPPORT", e[e.EXIT = 5] = "EXIT", e[e.LOGOUT = 6] = "LOGOUT", e[e.SCREENSHOT = 7] = "SCREENSHOT", e[e.RULER = 8] = "RULER", e[e.INSPECT = 9] = "INSPECT", e[e.RESET = 10] = "RESET", e[e.LAYOUT = 11] = "LAYOUT", e[e.SAVE = 12] = "SAVE", e[e.SAVE_AS = 13] = "SAVE_AS", e[e.W_L = 14] = "W_L", e[e.HELP = 15] = "HELP", e[e.UNDO = 16] = "UNDO", e[e.REDO = 17] = "REDO", e[e.INFO = 19] = "INFO", e[e.PROFILE = 20] = "PROFILE", e[e.PC_SETTINGS = 21] = "PC_SETTINGS", e[e.USER_SETTINGS = 22] = "USER_SETTINGS", e[e.RULER_DISTANCE = 23] = "RULER_DISTANCE", e[e.RULER_ANGLE = 24] = "RULER_ANGLE", e[e.RULER_ANNOTATION = 25] = "RULER_ANNOTATION", e[e.RULER_ROI = 26] = "RULER_ROI", e[e.RULER_CLEAR = 27] = "RULER_CLEAR", e[e.RG_LOGO = 28] = "RG_LOGO", e[e.ZIMVIE_LOGO = 29] = "ZIMVIE_LOGO", e[e.DISTANCE_UNIT_MM = 30] = "DISTANCE_UNIT_MM", e[e.DISTANCE_UNIT_INCH = 31] = "DISTANCE_UNIT_INCH", e[e.ADD_DOCTOR = 31] = "ADD_DOCTOR", e[e.SHOW_DOCTOR_PATIENT_LIST = 32] = "SHOW_DOCTOR_PATIENT_LIST", e[e.TESTING_VIEW = 33] = "TESTING_VIEW", e[e.RULER_SPHERE = 34] = "RULER_SPHERE", e[e.RULER_PLANE = 35] = "RULER_PLANE", e[e.RULER_TETRAHEDRON = 36] = "RULER_TETRAHEDRON", e[e.RULER_LANDMARK = 37] = "RULER_LANDMARK", e[e.RULER_CLEAR_EXCEPT = 38] = "RULER_CLEAR_EXCEPT", e[e.PC_SELECTION = 39] = "PC_SELECTION", e[e.PROFILE_INFO = 40] = "PROFILE_INFO", e[e.PC_LIST = 41] = "PC_LIST", e[e.RG_WEB = 42] = "RG_WEB", e[e.RESET_PASSWORD = 43] = "RESET_PASSWORD", e[e.VIDEO_TUTORIAL = 44] = "VIDEO_TUTORIAL", e[e.E_LEARNING = 45] = "E_LEARNING", e[e.OPEN_TICKET = 46] = "OPEN_TICKET", e[e.REMOTE_SUPPORT = 47] = "REMOTE_SUPPORT", e))(U || {}), ya = /* @__PURE__ */ ((e) => (e[e.Mm = 0] = "Mm", e[e.Inch = 1] = "Inch", e))(ya || {});
const B0 = _n("userStore", {
  state: () => ({
    user: {},
    userAddressId: 0,
    billingData: [],
    shippingData: [],
    users: [],
    userAddressMap: /* @__PURE__ */ new Map(),
    usersBillingData: [],
    usersShippingData: [],
    hasUnverifiedAddressInfo: !1,
    translationMessages: {},
    weblinkMessages: {}
  }),
  actions: {
    async updateUsers(e, t) {
      if (t)
        try {
          const { data: n } = await this.api.getUserByKeyword(t, e);
          this.users = n.filter((a) => a.username !== "prodcenteruser");
        } catch {
          Te(this.weblinkMessages.thereWasAProblemWithLoadingUsers || "There was a problem with loading users");
        }
      else
        try {
          const { data: n } = await this.api.getUsers(e);
          this.users = n.filter((a) => a.username !== "prodcenteruser");
        } catch {
          Te(this.weblinkMessages.thereWasAProblemWithLoadingUsers || "There was a problem with loading users");
        }
    },
    async getUserAddresses(e, t, n = !1) {
      if (this.userAddressMap.has(t) && !n)
        return this.userAddressMap.get(t);
      try {
        const { data: a } = await this.api.getUserAddressesById(e, t);
        this.userAddressMap.set(t, a), this.usersBillingData = a.billingList, this.usersShippingData = a.shippingList, this.userAddressId = t;
        const s = e === 1 || e === 29;
        return this.hasUnverifiedAddressInfo = s && (this.usersBillingData.some((o) => !o.verified) || this.usersShippingData.some((o) => !o.verified)), a;
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithLoadingUserAddresses || "There was a problem with loading user addresses");
      }
      return null;
    },
    async updateData() {
      try {
        const { data: e } = await this.api.getUserAddresses();
        return this.billingData = e.billingList.map((t) => ({
          ...t,
          data: { ...t.data, optionLabel: es(t) }
        })), this.shippingData = e.shippingList.map((t) => ({
          ...t,
          data: { ...t.data, optionLabel: es(t) }
        })), !0;
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithLoadingUserAddressesUpdateData || "There was a problem with loading user addresses (update data)");
      }
    },
    async updateBellatekAddress(e) {
      try {
        const { data: t } = await this.api.getUserAddresses();
        this.billingData = t.billingList.filter((n) => n.bellatekAddressType == (e ? 2 : 1)).map((n) => ({
          ...n,
          data: { ...n.data, optionLabel: es(n) }
        })), this.shippingData = t.shippingList.filter((n) => n.bellatekAddressType == (e ? 2 : 1)).map((n) => ({
          ...n,
          data: { ...n.data, optionLabel: es(n) }
        }));
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithLoadingUserAddresses || "There was a problem with loading user addresses");
      }
    },
    async upsertShippingAddress(e) {
      try {
        (await this.api.upsertUserShippingAddress(e)).status === 200 && Ge("User data address updated!");
        const n = this.shippingData.findIndex((a) => a.id === e.id);
        n != -1 ? this.shippingData[n] = e : this.shippingData.push(e), await this.updateData();
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating billing address");
      }
    },
    async upsertBillingAddress(e) {
      try {
        (await this.api.upsertUserBillingAddress(e)).status === 200 && Ge("User billing address updated!");
        const n = this.billingData.findIndex((a) => a.id === e.id);
        n != -1 ? this.billingData[n] = e : this.billingData.push(e), await this.updateData();
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating billing address");
      }
    },
    async createPCUserBillingAddress(e) {
      try {
        const t = await this.api.createProductionCenterUserBillingAddress(e);
        return t.status === 200 && (Ge("User Billing address created!"), await this.getUserAddresses(e.productionCenterId, e.uid, !0)), t;
      } catch (t) {
        return Te(this.weblinkMessages.thereWasAProblemWithCreatingBillingAddress || "There was a problem with creating Billing address"), t;
      }
    },
    async updatePCUserBillingAddress(e) {
      try {
        const t = await this.api.updateProductionCenterUserBillingAddress(e);
        return t.status === 200 && Ge("User Billing address updated!"), t;
      } catch (t) {
        return Te(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating Billing address"), t;
      }
    },
    async deletePCUserBillingAddress(e) {
      try {
        (await this.api.deleteProductionCenterUserBillingAddress(e)).status === 200 && Ge("User Billing address removed!");
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithRemovingBillingAddress || "There was a problem with removing Billing address");
      }
    },
    async updateBillingAddress(e) {
      try {
        (await this.api.updateUserBillingAddress(e)).status === 200 && Ge("User Billing address updated!");
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating Billing address");
      }
    },
    async verifyProductionCenterUserBillingAddress(e) {
      try {
        (await this.api.verifyProductionCenterUserBillingAddress(e)).status === 200 && (await this.getUserAddresses(e.pcid, e.uid, !0), Ge("User Billing address verified!"));
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithVerifyingBillingAddress || "There was a problem with verifying Billing address");
      }
    },
    async createPCUserShippingAddress(e) {
      try {
        const t = await this.api.createProductionCenterUserShippingAddress(e);
        return t.status === 200 && Ge("User Shipping address created!"), t;
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithCreatingShippingAddress || "There was a problem with creating Shipping address");
      }
    },
    async updatePCUserShippingAddress(e) {
      try {
        const t = await this.api.updateProductionCenterUserShippingAddress(e);
        return t.status === 200 && Ge("User Shipping address updated!"), t;
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithUpdatingShippingAddress || "There was a problem with updating Shipping address");
      }
    },
    async deletePCUserShippingAddress(e) {
      try {
        const t = await this.api.deleteProductionCenterUserShippingAddress(e);
        if (t.status === 200)
          return Ge("User Shipping address removed!"), t.status === 200;
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithRemovingShippingAddress || "There was a problem with removing Shipping address");
      }
    },
    async verifyProductionCenterUserShippingAddress(e) {
      try {
        (await this.api.verifyProductionCenterUserShippingAddress(e)).status === 200 && (await this.getUserAddresses(e.pcid, e.uid, !0), Ge("User Shipping address verified!"));
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithVerifyingShippingAddress || "There was a problem with verifying Shipping address");
      }
    },
    async deleteShippingAddress(e) {
      try {
        (await this.api.deleteUserShippingAddress(e)).status === 200 && Ge("User Shipping address deleted!");
        const n = this.shippingData.findIndex((a) => a.id === e);
        this.shippingData.splice(n, 1);
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithDeletingShippingAddress || "There was a problem with deleting Shipping address");
      }
    },
    async deleteBillingData(e) {
      try {
        (await this.api.deleteUserBillingAddress(e)).status === 200 && Ge("User shipping address deleted!");
        const n = this.billingData.findIndex((a) => a.id === e);
        this.billingData.splice(n, 1);
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithDeletingShippingAddress || "There was a problem with deleting shipping address");
      }
    },
    async updateEmailNotificationPrescriptionChange(e) {
      try {
        (await this.api.updateUserNotificationsPrescriptionUpdate(e)).status === 200 && Ge("User notifications updated!");
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithUpdatingUserNotifications || "There was a problem with updating user notifications");
      }
    },
    async updateChatEmailNotificationChange(e) {
      try {
        (await this.api.updateUserChatNotificationsUpdate(e)).status === 200 && Ge("User notifications updated!");
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithUpdatingUserNotifications || "There was a problem with updating user notifications");
      }
    },
    async getUserSessionToken() {
      try {
        const { data: e } = await this.api.getUserSessionToken();
        return e.id;
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithGettingUserSessionToken || "There was a problem with getting user session token");
      }
    },
    async saveUserSettings(e, t) {
      try {
        await this.api.postUserSettingsKey(e, t);
      } catch {
        Te(this.weblinkMessages.thereWasAProblemWithSavingUserSettings || "There was a problem with saving user settings");
      }
    },
    async updateTranslationMessages(e) {
      this.translationMessages = e, this.weblinkMessages = e.weblink;
    },
    async setUserTimezone(e) {
      try {
        await this.api.setUserTimezone(e), Ge("User timezone updated!");
      } catch {
        Te("There was a problem with saving user timezone");
      }
    }
  }
}), I0 = {
  VIDEO_TUTORIAL: oc,
  REMOTE_SUPPORT: ic
}, fu = _n("utilStore", {
  state: () => {
    const e = L(window.innerWidth), t = L(window.innerHeight), n = L(i()), a = L(l()), s = L(r());
    window.addEventListener("resize", o), Ae(e, o);
    function o() {
      e.value = window.innerWidth, c.isMobileView = e.value < 520, c.isTabletView = e.value < 1e3, c.screenSIze = e.value, c.screenType = i();
    }
    function i() {
      return e.value < 520 ? "sm" : e.value > 520 && e.value < 1500 ? "md" : "lg";
    }
    function r() {
      return e.value < 745 ? "sm" : e.value > 745 && e.value < 1180 ? "md" : "lg";
    }
    function l() {
      return Math.round((window.innerHeight - 384) / 45 + 2);
    }
    const c = Kt({
      isMobileView: e.value < 520,
      isTabletView: e.value < 1e3,
      screenType: n.value,
      screenSIze: e,
      screenHeight: t,
      dataTableRowCount: a,
      rgScreenType: s
    });
    return c;
  },
  actions: {
    async getInfoUrl(e, t = !0) {
      try {
        const { data: n } = await this.api.getInfoUrls([e]), a = n.find((s) => s.kind === e && s.url);
        if (a != null && a.url)
          return a.url;
      } catch {
      }
      return t ? I0[e] : void 0;
    }
  }
}), N1 = _n("guiConfigurationStore", {
  state: () => {
    const e = Zl(), t = Kt({
      colorScheme: e.colorScheme,
      componentTheme: e.componentTheme,
      theme: e.theme,
      topbarTheme: e.topbarTheme
    });
    return Ae(e, () => {
      t.colorScheme = e.colorScheme, t.theme = e.theme, t.componentTheme = e.componentTheme, t.topbarTheme = e.topbarTheme;
    }), t;
  }
}), w0 = new Set(Object.values(j)), k0 = {
  cz: j.CS,
  cn: j.ZH_HANS,
  zh: j.ZH_HANS
}, _0 = {
  [j.CS]: "cz",
  [j.ZH_HANS]: "zh"
}, S0 = {
  [j.ZH_HANS]: "webcad_translations_zh_Hans.json"
};
function Yr(e) {
  return S0[e] ?? `webcad_translations_${e}.json`;
}
const T0 = {
  [j.EN]: async () => import("./webcad_translations_en-BFC28RVN.js"),
  [j.IT]: async () => import("./webcad_translations_it-CvRD50QI.js"),
  [j.BG]: async () => import("./webcad_translations_bg-D7pAjsRi.js"),
  [j.CS]: async () => import("./webcad_translations_cs-DjWw6Iqb.js"),
  [j.DA]: async () => import("./webcad_translations_da-DEzcvajQ.js"),
  [j.DE]: async () => import("./webcad_translations_de-CcJHeVN4.js"),
  [j.ES]: async () => import("./webcad_translations_es-DxqO7_uH.js"),
  [j.FR]: async () => import("./webcad_translations_fr-Cq8KmUjo.js"),
  [j.HR]: async () => import("./webcad_translations_hr-DjWw6Iqb.js"),
  [j.HU]: async () => import("./webcad_translations_hu-CZjt6O7f.js"),
  [j.JA]: async () => import("./webcad_translations_ja-DjWw6Iqb.js"),
  [j.KO]: async () => import("./webcad_translations_ko-DjWw6Iqb.js"),
  [j.LT]: async () => import("./webcad_translations_lt-Cp7sT-Sz.js"),
  [j.NL]: async () => import("./webcad_translations_nl-DjWw6Iqb.js"),
  [j.PL]: async () => import("./webcad_translations_pl-DjWw6Iqb.js"),
  [j.PT]: async () => import("./webcad_translations_pt-u8EqXWtf.js"),
  [j.RO]: async () => import("./webcad_translations_ro-J5iAqKSu.js"),
  [j.SK]: async () => import("./webcad_translations_sk-BPlOru9I.js"),
  [j.SL]: async () => import("./webcad_translations_sl-DjWw6Iqb.js"),
  [j.SV]: async () => import("./webcad_translations_sv-9q-F0M4Y.js"),
  [j.TR]: async () => import("./webcad_translations_tr-BDMct_Gn.js"),
  [j.ZH_HANS]: async () => import("./webcad_translations_zh_Hans-DjWw6Iqb.js")
}, Gr = {};
async function jr(e) {
  const t = Gr[e];
  if (t)
    return t;
  const a = (await T0[e]()).default ?? {};
  return Gr[e] = a, a;
}
function jt(e) {
  if (typeof e != "string")
    return j.EN;
  const t = e.trim().replaceAll("-", "_").toLowerCase(), n = k0[t];
  return n || (w0.has(t) ? t : j.EN);
}
function L0(e) {
  const t = jt(e);
  return _0[t] ?? t;
}
const D0 = _n("localizationStore", {
  state: () => ({
    loading: !1
  }),
  actions: {
    async getWebcadTranslations(e) {
      const t = jt(e);
      try {
        return await jr(t);
      } catch (n) {
        console.error(`Translation load failed for ${Yr(t)} – falling back to en:`, n);
      }
      if (t === j.EN)
        return {};
      try {
        return await jr(j.EN);
      } catch (n) {
        return console.error(`Translation fallback load failed for ${Yr(j.EN)}:`, n), {};
      }
    },
    async setAppLanguage(e) {
      const t = jt(e);
      localStorage.setItem("langApp", JSON.stringify(t));
    },
    getAppLanguage() {
      const e = localStorage.getItem("langApp");
      if (!e)
        return localStorage.setItem("langApp", JSON.stringify(j.EN)), j.EN;
      try {
        const t = JSON.parse(e), n = jt(t);
        return t !== n && localStorage.setItem("langApp", JSON.stringify(n)), n;
      } catch {
        return localStorage.setItem("langApp", JSON.stringify(j.EN)), j.EN;
      }
    }
  }
}), R1 = _n("stlLibraryStore", {
  state: () => ({
    cachedResponse: void 0
  }),
  actions: {
    async loadSTLLibrary() {
      this.cachedResponse = (await this.stlApi.getAllObjects()).data;
    }
  }
}), P1 = _n("testingProtocolStore", {
  state: () => ({
    loading: !1
  }),
  actions: {
    async getTestingScriptFromSauron(e, t, n) {
      try {
        return (await this.api.getPoolAsset(e, t, n)).data;
      } catch (a) {
        console.log("error at getTestingScriptFromSauron: ", a);
      }
    },
    async uploadTestingScriptToSauron(e, t) {
      try {
        await this.api.uploadPoolAsset(e, t);
      } catch (n) {
        console.log("error at uploadTestingScriptToSauron: ", n);
      }
    },
    async getAllTestingReports(e) {
      try {
        return (await this.api.getPoolAssetList(e)).data.filter((n) => n.name.includes("report"));
      } catch (t) {
        console.log("error at getAllTestingReports: ", t);
      }
    },
    async deleteTestingReport(e, t) {
      try {
        await this.api.deletePoolAsset(e, t);
      } catch (n) {
        console.log("error at deleteTestingReport: ", n);
      }
    }
  }
});
/*!
  * shared v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Wt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Hr = {};
function M0(e) {
  Hr[e] || (Hr[e] = !0, Wt(e));
}
const ln = typeof window < "u";
let dt, Gn;
if (process.env.NODE_ENV !== "production") {
  const e = ln && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (dt = (t) => {
    e.mark(t);
  }, Gn = (t, n, a) => {
    e.measure(t, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const O0 = /\{([0-9a-zA-Z]+)\}/g;
function Ks(e, ...t) {
  return t.length === 1 && he(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(O0, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const fn = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), N0 = (e, t, n) => R0({ l: e, k: t, s: n }), R0 = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), je = (e) => typeof e == "number" && isFinite(e), P0 = (e) => ki(e) === "[object Date]", Is = (e) => ki(e) === "[object RegExp]", Ws = (e) => ge(e) && Object.keys(e).length === 0, Ve = Object.assign, F0 = Object.create, Be = (e = null) => F0(e);
let Vr;
const Rn = () => Vr || (Vr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Be());
function Kr(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Wr(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Q0(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (a, s, o) => `${s}="${Wr(o)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (a, s, o) => `${s}='${Wr(o)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && Wt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((a) => {
    e = e.replace(a, "$1javascript&#58;");
  }), e;
}
const U0 = Object.prototype.hasOwnProperty;
function _t(e, t) {
  return U0.call(e, t);
}
const Oe = Array.isArray, De = (e) => typeof e == "function", K = (e) => typeof e == "string", Me = (e) => typeof e == "boolean", he = (e) => e !== null && typeof e == "object", Y0 = (e) => he(e) && De(e.then) && De(e.catch), pu = Object.prototype.toString, ki = (e) => pu.call(e), ge = (e) => ki(e) === "[object Object]", G0 = (e) => e == null ? "" : Oe(e) || ge(e) && e.toString === pu ? JSON.stringify(e, null, 2) : String(e);
function _i(e, t = "") {
  return e.reduce((n, a, s) => s === 0 ? n + a : n + t + a, "");
}
const zr = 2;
function j0(e, t = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let s = 0;
  const o = [];
  for (let i = 0; i < a.length; i++)
    if (s += a[i].length + 1, s >= t) {
      for (let r = i - zr; r <= i + zr || n > s; r++) {
        if (r < 0 || r >= a.length)
          continue;
        const l = r + 1;
        o.push(`${l}${" ".repeat(3 - String(l).length)}|  ${a[r]}`);
        const c = a[r].length;
        if (r === i) {
          const u = t - (s - c) + 1, p = Math.max(1, n > s ? c - u : n - t);
          o.push("   |  " + " ".repeat(u) + "^".repeat(p));
        } else if (r > i) {
          if (n > s) {
            const u = Math.max(Math.min(n - s, c), 1);
            o.push("   |  " + "^".repeat(u));
          }
          s += c + 1;
        }
      }
      break;
    }
  return o.join(`
`);
}
function H0() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const s = e.get(n);
      s && s.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const s = e.get(n);
      s && s.splice(s.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((s) => s(a)), (e.get("*") || []).slice().map((s) => s(n, a));
    }
  };
}
const ts = (e) => !he(e) || Oe(e);
function fs(e, t) {
  if (ts(e) || ts(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: a, des: s } = n.pop();
    Object.keys(a).forEach((o) => {
      o !== "__proto__" && (he(a[o]) && !he(s[o]) && (s[o] = Array.isArray(a[o]) ? [] : Be()), ts(s[o]) || ts(a[o]) ? s[o] = a[o] : n.push({ src: a[o], des: s[o] }));
    });
  }
}
/*!
  * message-compiler v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function V0(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Go(e, t, n) {
  return { start: e, end: t };
}
const ee = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, K0 = 17, W0 = {
  // tokenizer error messages
  [ee.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [ee.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [ee.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [ee.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [ee.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [ee.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [ee.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [ee.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [ee.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [ee.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [ee.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [ee.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [ee.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [ee.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [ee.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [ee.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function pa(e, t, n = {}) {
  const { domain: a, messages: s, args: o } = n, i = process.env.NODE_ENV !== "production" ? Ks((s || W0)[e] || "", ...o || []) : e, r = new SyntaxError(String(i));
  return r.code = e, t && (r.location = t), r.domain = a, r;
}
function z0(e) {
  throw e;
}
const $0 = /<\/?[\w\s="/.':;#-\/]+>/, J0 = (e) => $0.test(e), Rt = " ", q0 = "\r", Xe = `
`, X0 = "\u2028", Z0 = "\u2029";
function ev(e) {
  const t = e;
  let n = 0, a = 1, s = 1, o = 0;
  const i = (S) => t[S] === q0 && t[S + 1] === Xe, r = (S) => t[S] === Xe, l = (S) => t[S] === Z0, c = (S) => t[S] === X0, u = (S) => i(S) || r(S) || l(S) || c(S), p = () => n, m = () => a, v = () => s, A = () => o, h = (S) => i(S) || l(S) || c(S) ? Xe : t[S], d = () => h(n), f = () => h(n + o);
  function g() {
    return o = 0, u(n) && (a++, s = 0), i(n) && n++, n++, s++, t[n];
  }
  function B() {
    return i(n + o) && o++, o++, t[n + o];
  }
  function E() {
    n = 0, a = 1, s = 1, o = 0;
  }
  function _(S = 0) {
    o = S;
  }
  function O() {
    const S = n + o;
    for (; S !== n; )
      g();
    o = 0;
  }
  return {
    index: p,
    line: m,
    column: v,
    peekOffset: A,
    charAt: h,
    currentChar: d,
    currentPeek: f,
    next: g,
    peek: B,
    reset: E,
    resetPeek: _,
    skipToPeek: O
  };
}
const en = void 0, tv = ".", $r = "'", nv = "tokenizer";
function av(e, t = {}) {
  const n = t.location !== !1, a = ev(e), s = () => a.index(), o = () => V0(a.line(), a.column(), a.index()), i = o(), r = s(), l = {
    currentType: 13,
    offset: r,
    startLoc: i,
    endLoc: i,
    lastType: 13,
    lastOffset: r,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: u } = t;
  function p(x, I, N, ...V) {
    const xe = c();
    if (I.column += N, I.offset += N, u) {
      const Ie = n ? Go(xe.startLoc, I) : null, ie = pa(x, Ie, {
        domain: nv,
        args: V
      });
      u(ie);
    }
  }
  function m(x, I, N) {
    x.endLoc = o(), x.currentType = I;
    const V = { type: I };
    return n && (V.loc = Go(x.startLoc, x.endLoc)), N != null && (V.value = N), V;
  }
  const v = (x) => m(
    x,
    13
    /* TokenTypes.EOF */
  );
  function A(x, I) {
    return x.currentChar() === I ? (x.next(), I) : (p(ee.EXPECTED_TOKEN, o(), 0, I), "");
  }
  function h(x) {
    let I = "";
    for (; x.currentPeek() === Rt || x.currentPeek() === Xe; )
      I += x.currentPeek(), x.peek();
    return I;
  }
  function d(x) {
    const I = h(x);
    return x.skipToPeek(), I;
  }
  function f(x) {
    if (x === en)
      return !1;
    const I = x.charCodeAt(0);
    return I >= 97 && I <= 122 || // a-z
    I >= 65 && I <= 90 || // A-Z
    I === 95;
  }
  function g(x) {
    if (x === en)
      return !1;
    const I = x.charCodeAt(0);
    return I >= 48 && I <= 57;
  }
  function B(x, I) {
    const { currentType: N } = I;
    if (N !== 2)
      return !1;
    h(x);
    const V = f(x.currentPeek());
    return x.resetPeek(), V;
  }
  function E(x, I) {
    const { currentType: N } = I;
    if (N !== 2)
      return !1;
    h(x);
    const V = x.currentPeek() === "-" ? x.peek() : x.currentPeek(), xe = g(V);
    return x.resetPeek(), xe;
  }
  function _(x, I) {
    const { currentType: N } = I;
    if (N !== 2)
      return !1;
    h(x);
    const V = x.currentPeek() === $r;
    return x.resetPeek(), V;
  }
  function O(x, I) {
    const { currentType: N } = I;
    if (N !== 7)
      return !1;
    h(x);
    const V = x.currentPeek() === ".";
    return x.resetPeek(), V;
  }
  function S(x, I) {
    const { currentType: N } = I;
    if (N !== 8)
      return !1;
    h(x);
    const V = f(x.currentPeek());
    return x.resetPeek(), V;
  }
  function H(x, I) {
    const { currentType: N } = I;
    if (!(N === 7 || N === 11))
      return !1;
    h(x);
    const V = x.currentPeek() === ":";
    return x.resetPeek(), V;
  }
  function z(x, I) {
    const { currentType: N } = I;
    if (N !== 9)
      return !1;
    const V = () => {
      const Ie = x.currentPeek();
      return Ie === "{" ? f(x.peek()) : Ie === "@" || Ie === "|" || Ie === ":" || Ie === "." || Ie === Rt || !Ie ? !1 : Ie === Xe ? (x.peek(), V()) : re(x, !1);
    }, xe = V();
    return x.resetPeek(), xe;
  }
  function X(x) {
    h(x);
    const I = x.currentPeek() === "|";
    return x.resetPeek(), I;
  }
  function re(x, I = !0) {
    const N = (xe = !1, Ie = "") => {
      const ie = x.currentPeek();
      return ie === "{" || ie === "@" || !ie ? xe : ie === "|" ? !(Ie === Rt || Ie === Xe) : ie === Rt ? (x.peek(), N(!0, Rt)) : ie === Xe ? (x.peek(), N(!0, Xe)) : !0;
    }, V = N();
    return I && x.resetPeek(), V;
  }
  function se(x, I) {
    const N = x.currentChar();
    return N === en ? en : I(N) ? (x.next(), N) : null;
  }
  function ve(x) {
    const I = x.charCodeAt(0);
    return I >= 97 && I <= 122 || // a-z
    I >= 65 && I <= 90 || // A-Z
    I >= 48 && I <= 57 || // 0-9
    I === 95 || // _
    I === 36;
  }
  function Re(x) {
    return se(x, ve);
  }
  function Z(x) {
    const I = x.charCodeAt(0);
    return I >= 97 && I <= 122 || // a-z
    I >= 65 && I <= 90 || // A-Z
    I >= 48 && I <= 57 || // 0-9
    I === 95 || // _
    I === 36 || // $
    I === 45;
  }
  function ce(x) {
    return se(x, Z);
  }
  function be(x) {
    const I = x.charCodeAt(0);
    return I >= 48 && I <= 57;
  }
  function gt(x) {
    return se(x, be);
  }
  function Ue(x) {
    const I = x.charCodeAt(0);
    return I >= 48 && I <= 57 || // 0-9
    I >= 65 && I <= 70 || // A-F
    I >= 97 && I <= 102;
  }
  function Pe(x) {
    return se(x, Ue);
  }
  function Ye(x) {
    let I = "", N = "";
    for (; I = gt(x); )
      N += I;
    return N;
  }
  function Je(x) {
    let I = "";
    for (; ; ) {
      const N = x.currentChar();
      if (N === "{" || N === "}" || N === "@" || N === "|" || !N)
        break;
      if (N === Rt || N === Xe)
        if (re(x))
          I += N, x.next();
        else {
          if (X(x))
            break;
          I += N, x.next();
        }
      else
        I += N, x.next();
    }
    return I;
  }
  function Ke(x) {
    d(x);
    let I = "", N = "";
    for (; I = ce(x); )
      N += I;
    const V = x.currentChar();
    if (V && V !== "}" && V !== en && V !== Rt && V !== Xe && V !== "　") {
      const xe = Jt(x);
      return p(ee.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, N + xe), N + xe;
    }
    return x.currentChar() === en && p(ee.UNTERMINATED_CLOSING_BRACE, o(), 0), N;
  }
  function tt(x) {
    d(x);
    let I = "";
    return x.currentChar() === "-" ? (x.next(), I += `-${Ye(x)}`) : I += Ye(x), x.currentChar() === en && p(ee.UNTERMINATED_CLOSING_BRACE, o(), 0), I;
  }
  function st(x) {
    return x !== $r && x !== Xe;
  }
  function Dt(x) {
    d(x), A(x, "'");
    let I = "", N = "";
    for (; I = se(x, st); )
      I === "\\" ? N += Mt(x) : N += I;
    const V = x.currentChar();
    return V === Xe || V === en ? (p(ee.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, o(), 0), V === Xe && (x.next(), A(x, "'")), N) : (A(x, "'"), N);
  }
  function Mt(x) {
    const I = x.currentChar();
    switch (I) {
      case "\\":
      case "'":
        return x.next(), `\\${I}`;
      case "u":
        return ot(x, I, 4);
      case "U":
        return ot(x, I, 6);
      default:
        return p(ee.UNKNOWN_ESCAPE_SEQUENCE, o(), 0, I), "";
    }
  }
  function ot(x, I, N) {
    A(x, I);
    let V = "";
    for (let xe = 0; xe < N; xe++) {
      const Ie = Pe(x);
      if (!Ie) {
        p(ee.INVALID_UNICODE_ESCAPE_SEQUENCE, o(), 0, `\\${I}${V}${x.currentChar()}`);
        break;
      }
      V += Ie;
    }
    return `\\${I}${V}`;
  }
  function Et(x) {
    return x !== "{" && x !== "}" && x !== Rt && x !== Xe;
  }
  function Jt(x) {
    d(x);
    let I = "", N = "";
    for (; I = se(x, Et); )
      N += I;
    return N;
  }
  function qt(x) {
    let I = "", N = "";
    for (; I = Re(x); )
      N += I;
    return N;
  }
  function Mn(x) {
    const I = (N) => {
      const V = x.currentChar();
      return V === "{" || V === "@" || V === "|" || V === "(" || V === ")" || !V || V === Rt ? N : (N += V, x.next(), I(N));
    };
    return I("");
  }
  function pe(x) {
    d(x);
    const I = A(
      x,
      "|"
      /* TokenChars.Pipe */
    );
    return d(x), I;
  }
  function Xt(x, I) {
    let N = null;
    switch (x.currentChar()) {
      case "{":
        return I.braceNest >= 1 && p(ee.NOT_ALLOW_NEST_PLACEHOLDER, o(), 0), x.next(), N = m(
          I,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), d(x), I.braceNest++, N;
      case "}":
        return I.braceNest > 0 && I.currentType === 2 && p(ee.EMPTY_PLACEHOLDER, o(), 0), x.next(), N = m(
          I,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), I.braceNest--, I.braceNest > 0 && d(x), I.inLinked && I.braceNest === 0 && (I.inLinked = !1), N;
      case "@":
        return I.braceNest > 0 && p(ee.UNTERMINATED_CLOSING_BRACE, o(), 0), N = Ct(x, I) || v(I), I.braceNest = 0, N;
      default: {
        let xe = !0, Ie = !0, ie = !0;
        if (X(x))
          return I.braceNest > 0 && p(ee.UNTERMINATED_CLOSING_BRACE, o(), 0), N = m(I, 1, pe(x)), I.braceNest = 0, I.inLinked = !1, N;
        if (I.braceNest > 0 && (I.currentType === 4 || I.currentType === 5 || I.currentType === 6))
          return p(ee.UNTERMINATED_CLOSING_BRACE, o(), 0), I.braceNest = 0, Ot(x, I);
        if (xe = B(x, I))
          return N = m(I, 4, Ke(x)), d(x), N;
        if (Ie = E(x, I))
          return N = m(I, 5, tt(x)), d(x), N;
        if (ie = _(x, I))
          return N = m(I, 6, Dt(x)), d(x), N;
        if (!xe && !Ie && !ie)
          return N = m(I, 12, Jt(x)), p(ee.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, N.value), d(x), N;
        break;
      }
    }
    return N;
  }
  function Ct(x, I) {
    const { currentType: N } = I;
    let V = null;
    const xe = x.currentChar();
    switch ((N === 7 || N === 8 || N === 11 || N === 9) && (xe === Xe || xe === Rt) && p(ee.INVALID_LINKED_FORMAT, o(), 0), xe) {
      case "@":
        return x.next(), V = m(
          I,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), I.inLinked = !0, V;
      case ".":
        return d(x), x.next(), m(
          I,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return d(x), x.next(), m(
          I,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return X(x) ? (V = m(I, 1, pe(x)), I.braceNest = 0, I.inLinked = !1, V) : O(x, I) || H(x, I) ? (d(x), Ct(x, I)) : S(x, I) ? (d(x), m(I, 11, qt(x))) : z(x, I) ? (d(x), xe === "{" ? Xt(x, I) || V : m(I, 10, Mn(x))) : (N === 7 && p(ee.INVALID_LINKED_FORMAT, o(), 0), I.braceNest = 0, I.inLinked = !1, Ot(x, I));
    }
  }
  function Ot(x, I) {
    let N = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (I.braceNest > 0)
      return Xt(x, I) || v(I);
    if (I.inLinked)
      return Ct(x, I) || v(I);
    switch (x.currentChar()) {
      case "{":
        return Xt(x, I) || v(I);
      case "}":
        return p(ee.UNBALANCED_CLOSING_BRACE, o(), 0), x.next(), m(
          I,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ct(x, I) || v(I);
      default: {
        if (X(x))
          return N = m(I, 1, pe(x)), I.braceNest = 0, I.inLinked = !1, N;
        if (re(x))
          return m(I, 0, Je(x));
        break;
      }
    }
    return N;
  }
  function Zt() {
    const { currentType: x, offset: I, startLoc: N, endLoc: V } = l;
    return l.lastType = x, l.lastOffset = I, l.lastStartLoc = N, l.lastEndLoc = V, l.offset = s(), l.startLoc = o(), a.currentChar() === en ? m(
      l,
      13
      /* TokenTypes.EOF */
    ) : Ot(a, l);
  }
  return {
    nextToken: Zt,
    currentOffset: s,
    currentPosition: o,
    context: c
  };
}
const sv = "parser", ov = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function iv(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function rv(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function a(f, g, B, E, ..._) {
    const O = f.currentPosition();
    if (O.offset += E, O.column += E, n) {
      const S = t ? Go(B, O) : null, H = pa(g, S, {
        domain: sv,
        args: _
      });
      n(H);
    }
  }
  function s(f, g, B) {
    const E = { type: f };
    return t && (E.start = g, E.end = g, E.loc = { start: B, end: B }), E;
  }
  function o(f, g, B, E) {
    t && (f.end = g, f.loc && (f.loc.end = B));
  }
  function i(f, g) {
    const B = f.context(), E = s(3, B.offset, B.startLoc);
    return E.value = g, o(E, f.currentOffset(), f.currentPosition()), E;
  }
  function r(f, g) {
    const B = f.context(), { lastOffset: E, lastStartLoc: _ } = B, O = s(5, E, _);
    return O.index = parseInt(g, 10), f.nextToken(), o(O, f.currentOffset(), f.currentPosition()), O;
  }
  function l(f, g) {
    const B = f.context(), { lastOffset: E, lastStartLoc: _ } = B, O = s(4, E, _);
    return O.key = g, f.nextToken(), o(O, f.currentOffset(), f.currentPosition()), O;
  }
  function c(f, g) {
    const B = f.context(), { lastOffset: E, lastStartLoc: _ } = B, O = s(9, E, _);
    return O.value = g.replace(ov, iv), f.nextToken(), o(O, f.currentOffset(), f.currentPosition()), O;
  }
  function u(f) {
    const g = f.nextToken(), B = f.context(), { lastOffset: E, lastStartLoc: _ } = B, O = s(8, E, _);
    return g.type !== 11 ? (a(f, ee.UNEXPECTED_EMPTY_LINKED_MODIFIER, B.lastStartLoc, 0), O.value = "", o(O, E, _), {
      nextConsumeToken: g,
      node: O
    }) : (g.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, B.lastStartLoc, 0, Pt(g)), O.value = g.value || "", o(O, f.currentOffset(), f.currentPosition()), {
      node: O
    });
  }
  function p(f, g) {
    const B = f.context(), E = s(7, B.offset, B.startLoc);
    return E.value = g, o(E, f.currentOffset(), f.currentPosition()), E;
  }
  function m(f) {
    const g = f.context(), B = s(6, g.offset, g.startLoc);
    let E = f.nextToken();
    if (E.type === 8) {
      const _ = u(f);
      B.modifier = _.node, E = _.nextConsumeToken || f.nextToken();
    }
    switch (E.type !== 9 && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(E)), E = f.nextToken(), E.type === 2 && (E = f.nextToken()), E.type) {
      case 10:
        E.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(E)), B.key = p(f, E.value || "");
        break;
      case 4:
        E.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(E)), B.key = l(f, E.value || "");
        break;
      case 5:
        E.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(E)), B.key = r(f, E.value || "");
        break;
      case 6:
        E.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(E)), B.key = c(f, E.value || "");
        break;
      default: {
        a(f, ee.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const _ = f.context(), O = s(7, _.offset, _.startLoc);
        return O.value = "", o(O, _.offset, _.startLoc), B.key = O, o(B, _.offset, _.startLoc), {
          nextConsumeToken: E,
          node: B
        };
      }
    }
    return o(B, f.currentOffset(), f.currentPosition()), {
      node: B
    };
  }
  function v(f) {
    const g = f.context(), B = g.currentType === 1 ? f.currentOffset() : g.offset, E = g.currentType === 1 ? g.endLoc : g.startLoc, _ = s(2, B, E);
    _.items = [];
    let O = null;
    do {
      const z = O || f.nextToken();
      switch (O = null, z.type) {
        case 0:
          z.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(z)), _.items.push(i(f, z.value || ""));
          break;
        case 5:
          z.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(z)), _.items.push(r(f, z.value || ""));
          break;
        case 4:
          z.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(z)), _.items.push(l(f, z.value || ""));
          break;
        case 6:
          z.value == null && a(f, ee.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Pt(z)), _.items.push(c(f, z.value || ""));
          break;
        case 7: {
          const X = m(f);
          _.items.push(X.node), O = X.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const S = g.currentType === 1 ? g.lastOffset : f.currentOffset(), H = g.currentType === 1 ? g.lastEndLoc : f.currentPosition();
    return o(_, S, H), _;
  }
  function A(f, g, B, E) {
    const _ = f.context();
    let O = E.items.length === 0;
    const S = s(1, g, B);
    S.cases = [], S.cases.push(E);
    do {
      const H = v(f);
      O || (O = H.items.length === 0), S.cases.push(H);
    } while (_.currentType !== 13);
    return O && a(f, ee.MUST_HAVE_MESSAGES_IN_PLURAL, B, 0), o(S, f.currentOffset(), f.currentPosition()), S;
  }
  function h(f) {
    const g = f.context(), { offset: B, startLoc: E } = g, _ = v(f);
    return g.currentType === 13 ? _ : A(f, B, E, _);
  }
  function d(f) {
    const g = av(f, Ve({}, e)), B = g.context(), E = s(0, B.offset, B.startLoc);
    return t && E.loc && (E.loc.source = f), E.body = h(g), e.onCacheKey && (E.cacheKey = e.onCacheKey(f)), B.currentType !== 13 && a(g, ee.UNEXPECTED_LEXICAL_ANALYSIS, B.lastStartLoc, 0, f[B.offset] || ""), o(E, g.currentOffset(), g.currentPosition()), E;
  }
  return { parse: d };
}
function Pt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function lv(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (o) => (n.helpers.add(o), o) };
}
function Jr(e, t) {
  for (let n = 0; n < e.length; n++)
    Si(e[n], t);
}
function Si(e, t) {
  switch (e.type) {
    case 1:
      Jr(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Jr(e.items, t);
      break;
    case 6: {
      Si(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function cv(e, t = {}) {
  const n = lv(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Si(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function uv(e) {
  const t = e.body;
  return t.type === 2 ? qr(t) : t.cases.forEach((n) => qr(n)), e;
}
function qr(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = _i(t);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const dv = "minifier";
function $n(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      $n(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let a = 0; a < n.length; a++)
        $n(n[a]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let a = 0; a < n.length; a++)
        $n(n[a]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      $n(t.key), t.k = t.key, delete t.key, t.modifier && ($n(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw pa(ee.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: dv,
          args: [e.type]
        });
  }
  delete e.type;
}
const fv = "parser";
function pv(e, t) {
  const { filename: n, breakLineCode: a, needIndent: s } = t, o = t.location !== !1, i = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: s,
    indentLevel: 0
  };
  o && e.loc && (i.source = e.loc.source);
  const r = () => i;
  function l(h, d) {
    i.code += h;
  }
  function c(h, d = !0) {
    const f = d ? a : "";
    l(s ? f + "  ".repeat(h) : f);
  }
  function u(h = !0) {
    const d = ++i.indentLevel;
    h && c(d);
  }
  function p(h = !0) {
    const d = --i.indentLevel;
    h && c(d);
  }
  function m() {
    c(i.indentLevel);
  }
  return {
    context: r,
    push: l,
    indent: u,
    deindent: p,
    newline: m,
    helper: (h) => `_${h}`,
    needIndent: () => i.needIndent
  };
}
function mv(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), sa(e, t.key), t.modifier ? (e.push(", "), sa(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Av(e, t) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const s = t.items.length;
  for (let o = 0; o < s && (sa(e, t.items[o]), o !== s - 1); o++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function gv(e, t) {
  const { helper: n, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const s = t.cases.length;
    for (let o = 0; o < s && (sa(e, t.cases[o]), o !== s - 1); o++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function hv(e, t) {
  t.body ? sa(e, t.body) : e.push("null");
}
function sa(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      hv(e, t);
      break;
    case 1:
      gv(e, t);
      break;
    case 2:
      Av(e, t);
      break;
    case 6:
      mv(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw pa(ee.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: fv,
          args: [t.type]
        });
  }
}
const vv = (e, t = {}) => {
  const n = K(t.mode) ? t.mode : "normal", a = K(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], r = pv(e, {
    filename: a,
    breakLineCode: s,
    needIndent: o
  });
  r.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), r.indent(o), i.length > 0 && (r.push(`const { ${_i(i.map((u) => `${u}: _${u}`), ", ")} } = ctx`), r.newline()), r.push("return "), sa(r, e), r.deindent(o), r.push("}"), delete e.helpers;
  const { code: l, map: c } = r.context();
  return {
    ast: e,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function bv(e, t = {}) {
  const n = Ve({}, t), a = !!n.jit, s = !!n.minify, o = n.optimize == null ? !0 : n.optimize, r = rv(n).parse(e);
  return a ? (o && uv(r), s && $n(r), { ast: r, code: "" }) : (cv(r, n), vv(r, n));
}
/*!
  * core-base v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function xv() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Rn().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Rn().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function St(e) {
  return he(e) && Ti(e) === 0 && (_t(e, "b") || _t(e, "body"));
}
const mu = ["b", "body"];
function yv(e) {
  return Tn(e, mu);
}
const Au = ["c", "cases"];
function Ev(e) {
  return Tn(e, Au, []);
}
const gu = ["s", "static"];
function Cv(e) {
  return Tn(e, gu);
}
const hu = ["i", "items"];
function Bv(e) {
  return Tn(e, hu, []);
}
const vu = ["t", "type"];
function Ti(e) {
  return Tn(e, vu);
}
const bu = ["v", "value"];
function ns(e, t) {
  const n = Tn(e, bu);
  if (n != null)
    return n;
  throw Pa(t);
}
const xu = ["m", "modifier"];
function Iv(e) {
  return Tn(e, xu);
}
const yu = ["k", "key"];
function wv(e) {
  const t = Tn(e, yu);
  if (t)
    return t;
  throw Pa(
    6
    /* NodeTypes.Linked */
  );
}
function Tn(e, t, n) {
  for (let a = 0; a < t.length; a++) {
    const s = t[a];
    if (_t(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const Eu = [
  ...mu,
  ...Au,
  ...gu,
  ...hu,
  ...yu,
  ...xu,
  ...bu,
  ...vu
];
function Pa(e) {
  return new Error(`unhandled node type: ${e}`);
}
function mo(e) {
  return (n) => kv(n, e);
}
function kv(e, t) {
  const n = yv(t);
  if (n == null)
    throw Pa(
      0
      /* NodeTypes.Resource */
    );
  if (Ti(n) === 1) {
    const o = Ev(n);
    return e.plural(o.reduce((i, r) => [
      ...i,
      Xr(e, r)
    ], []));
  } else
    return Xr(e, n);
}
function Xr(e, t) {
  const n = Cv(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = Bv(t).reduce((s, o) => [...s, jo(e, o)], []);
    return e.normalize(a);
  }
}
function jo(e, t) {
  const n = Ti(t);
  switch (n) {
    case 3:
      return ns(t, n);
    case 9:
      return ns(t, n);
    case 4: {
      const a = t;
      if (_t(a, "k") && a.k)
        return e.interpolate(e.named(a.k));
      if (_t(a, "key") && a.key)
        return e.interpolate(e.named(a.key));
      throw Pa(n);
    }
    case 5: {
      const a = t;
      if (_t(a, "i") && je(a.i))
        return e.interpolate(e.list(a.i));
      if (_t(a, "index") && je(a.index))
        return e.interpolate(e.list(a.index));
      throw Pa(n);
    }
    case 6: {
      const a = t, s = Iv(a), o = wv(a);
      return e.linked(jo(e, o), s ? jo(e, s) : void 0, e.type);
    }
    case 7:
      return ns(t, n);
    case 8:
      return ns(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const _v = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Sv(e, t) {
  t && J0(e) && Wt(Ks(_v, { source: e }));
}
const Tv = (e) => e;
let as = Be();
function Lv(e, t = {}) {
  let n = !1;
  const a = t.onError || z0;
  return t.onError = (s) => {
    n = !0, a(s);
  }, { ...bv(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Dv(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && K(e)) {
    const n = Me(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Sv(e, n);
    const s = (t.onCacheKey || Tv)(e), o = as[s];
    if (o)
      return o;
    const { ast: i, detectError: r } = Lv(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = mo(i);
    return r ? l : as[s] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !St(e))
      return Wt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => e);
    const n = e.cacheKey;
    if (n) {
      const a = as[n];
      return a || (as[n] = mo(e));
    } else
      return mo(e);
  }
}
let Fa = null;
function Mv(e) {
  Fa = e;
}
function Ov(e, t, n) {
  Fa && Fa.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Nv = /* @__PURE__ */ Rv("function:translate");
function Rv(e) {
  return (t) => Fa && Fa.emit(e, t);
}
const Ze = {
  INVALID_ARGUMENT: K0,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Pv = 24;
function nn(e) {
  return pa(e, null, process.env.NODE_ENV !== "production" ? { messages: Fv } : void 0);
}
const Fv = {
  [Ze.INVALID_ARGUMENT]: "Invalid arguments",
  [Ze.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Ze.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Ze.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Ze.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Ze.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Ze.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Li(e, t) {
  return t.locale != null ? Zr(t.locale) : Zr(e.locale);
}
let Ao;
function Zr(e) {
  if (K(e))
    return e;
  if (De(e)) {
    if (e.resolvedOnce && Ao != null)
      return Ao;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Y0(t))
        throw nn(Ze.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ao = t;
    } else
      throw nn(Ze.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw nn(Ze.NOT_SUPPORT_LOCALE_TYPE);
}
function Qv(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Oe(t) ? t : he(t) ? Object.keys(t) : K(t) ? [t] : [n]
  ])];
}
function Cu(e, t, n) {
  const a = K(n) ? n : ws, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let o = s.__localeChainCache.get(a);
  if (!o) {
    o = [];
    let i = [n];
    for (; Oe(i); )
      i = el(o, i, t);
    const r = Oe(t) || !ge(t) ? t : t.default ? t.default : null;
    i = K(r) ? [r] : r, Oe(i) && el(o, i, !1), s.__localeChainCache.set(a, o);
  }
  return o;
}
function el(e, t, n) {
  let a = !0;
  for (let s = 0; s < t.length && Me(a); s++) {
    const o = t[s];
    K(o) && (a = Uv(e, t[s], n));
  }
  return a;
}
function Uv(e, t, n) {
  let a;
  const s = t.split("-");
  do {
    const o = s.join("-");
    a = Yv(e, o, n), s.splice(-1, 1);
  } while (s.length && a === !0);
  return a;
}
function Yv(e, t, n) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (Oe(n) || ge(n)) && n[s] && (a = n[s]);
  }
  return a;
}
const Ln = [];
Ln[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ln[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ln[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Ln[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Ln[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Ln[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Ln[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Gv = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function jv(e) {
  return Gv.test(e);
}
function Hv(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Vv(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function Kv(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : jv(t) ? Hv(t) : "*" + t;
}
function Wv(e) {
  const t = [];
  let n = -1, a = 0, s = 0, o, i, r, l, c, u, p;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = r : i += r;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), s++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, a = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, i === void 0 || (i = Kv(i), i === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function v() {
    const A = e[n + 1];
    if (a === 5 && A === "'" || a === 6 && A === '"')
      return n++, r = "\\" + A, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, o = e[n], !(o === "\\" && v())) {
      if (l = Vv(o), p = Ln[a], c = p[l] || p.l || 8, c === 8 || (a = c[0], c[1] !== void 0 && (u = m[c[1]], u && (r = o, u() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const tl = /* @__PURE__ */ new Map();
function zv(e, t) {
  return he(e) ? e[t] : null;
}
function $v(e, t) {
  if (!he(e))
    return null;
  let n = tl.get(t);
  if (n || (n = Wv(t), n && tl.set(t, n)), !n)
    return null;
  const a = n.length;
  let s = e, o = 0;
  for (; o < a; ) {
    const i = n[o];
    if (Eu.includes(i) && St(s))
      return null;
    const r = s[i];
    if (r === void 0 || De(s))
      return null;
    s = r, o++;
  }
  return s;
}
const rt = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Jv = 8, qv = {
  [rt.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [rt.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [rt.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [rt.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [rt.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [rt.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [rt.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function jn(e, ...t) {
  return Ks(qv[e], ...t);
}
const Xv = "11.1.12", zs = -1, ws = "en-US", ks = "", nl = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Zv() {
  return {
    upper: (e, t) => t === "text" && K(e) ? e.toUpperCase() : t === "vnode" && he(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && K(e) ? e.toLowerCase() : t === "vnode" && he(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && K(e) ? nl(e) : t === "vnode" && he(e) && "__v_isVNode" in e ? nl(e.children) : e
  };
}
let Bu;
function eb(e) {
  Bu = e;
}
let Iu;
function tb(e) {
  Iu = e;
}
let wu;
function nb(e) {
  wu = e;
}
let ku = null;
const ab = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ku = e;
}, sb = /* @__NO_SIDE_EFFECTS__ */ () => ku;
let _u = null;
const al = (e) => {
  _u = e;
}, ob = () => _u;
let sl = 0;
function ib(e = {}) {
  const t = De(e.onWarn) ? e.onWarn : Wt, n = K(e.version) ? e.version : Xv, a = K(e.locale) || De(e.locale) ? e.locale : ws, s = De(a) ? ws : a, o = Oe(e.fallbackLocale) || ge(e.fallbackLocale) || K(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, i = ge(e.messages) ? e.messages : go(s), r = ge(e.datetimeFormats) ? e.datetimeFormats : go(s), l = ge(e.numberFormats) ? e.numberFormats : go(s), c = Ve(Be(), e.modifiers, Zv()), u = e.pluralRules || Be(), p = De(e.missing) ? e.missing : null, m = Me(e.missingWarn) || Is(e.missingWarn) ? e.missingWarn : !0, v = Me(e.fallbackWarn) || Is(e.fallbackWarn) ? e.fallbackWarn : !0, A = !!e.fallbackFormat, h = !!e.unresolving, d = De(e.postTranslation) ? e.postTranslation : null, f = ge(e.processor) ? e.processor : null, g = Me(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, B = !!e.escapeParameter, E = De(e.messageCompiler) ? e.messageCompiler : Bu;
  process.env.NODE_ENV !== "production" && De(e.messageCompiler) && M0(jn(rt.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const _ = De(e.messageResolver) ? e.messageResolver : Iu || zv, O = De(e.localeFallbacker) ? e.localeFallbacker : wu || Qv, S = he(e.fallbackContext) ? e.fallbackContext : void 0, H = e, z = he(H.__datetimeFormatters) ? H.__datetimeFormatters : /* @__PURE__ */ new Map(), X = he(H.__numberFormatters) ? H.__numberFormatters : /* @__PURE__ */ new Map(), re = he(H.__meta) ? H.__meta : {};
  sl++;
  const se = {
    version: n,
    cid: sl,
    locale: a,
    fallbackLocale: o,
    messages: i,
    modifiers: c,
    pluralRules: u,
    missing: p,
    missingWarn: m,
    fallbackWarn: v,
    fallbackFormat: A,
    unresolving: h,
    postTranslation: d,
    processor: f,
    warnHtmlMessage: g,
    escapeParameter: B,
    messageCompiler: E,
    messageResolver: _,
    localeFallbacker: O,
    fallbackContext: S,
    onWarn: t,
    __meta: re
  };
  return se.datetimeFormats = r, se.numberFormats = l, se.__datetimeFormatters = z, se.__numberFormatters = X, process.env.NODE_ENV !== "production" && (se.__v_emitter = H.__v_emitter != null ? H.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Ov(se, n, re), se;
}
const go = (e) => ({ [e]: Be() });
function $s(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Su(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Di(e, t, n, a, s) {
  const { missing: o, onWarn: i } = e;
  if (process.env.NODE_ENV !== "production") {
    const r = e.__v_emitter;
    r && r.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (o !== null) {
    const r = o(e, n, t, s);
    return K(r) ? r : t;
  } else
    return process.env.NODE_ENV !== "production" && Su(a, t) && i(jn(rt.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function va(e, t, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Tu(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function rb(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let a = n + 1; a < t.length; a++)
    if (Tu(e, t[a]))
      return !0;
  return !1;
}
const ol = typeof Intl < "u", Lu = {
  dateTimeFormat: ol && typeof Intl.DateTimeFormat < "u",
  numberFormat: ol && typeof Intl.NumberFormat < "u"
};
function il(e, ...t) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: s, onWarn: o, localeFallbacker: i } = e, { __datetimeFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !Lu.dateTimeFormat)
    return o(jn(rt.CANNOT_FORMAT_DATE)), ks;
  const [l, c, u, p] = Ho(...t), m = Me(u.missingWarn) ? u.missingWarn : e.missingWarn, v = Me(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, A = !!u.part, h = Li(e, u), d = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    h
  );
  if (!K(l) || l === "")
    return new Intl.DateTimeFormat(h, p).format(c);
  let f = {}, g, B = null, E = h, _ = null;
  const O = "datetime format";
  for (let z = 0; z < d.length; z++) {
    if (g = _ = d[z], process.env.NODE_ENV !== "production" && h !== g && $s(v, l) && o(jn(rt.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && h !== g) {
      const X = e.__v_emitter;
      X && X.emit("fallback", {
        type: O,
        key: l,
        from: E,
        to: _,
        groupId: `${O}:${l}`
      });
    }
    if (f = n[g] || {}, B = f[l], ge(B))
      break;
    Di(e, l, g, m, O), E = _;
  }
  if (!ge(B) || !K(g))
    return a ? zs : l;
  let S = `${g}__${l}`;
  Ws(p) || (S = `${S}__${JSON.stringify(p)}`);
  let H = r.get(S);
  return H || (H = new Intl.DateTimeFormat(g, Ve({}, B, p)), r.set(S, H)), A ? H.formatToParts(c) : H.format(c);
}
const Du = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Ho(...e) {
  const [t, n, a, s] = e, o = Be();
  let i = Be(), r;
  if (K(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw nn(Ze.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    r = new Date(c);
    try {
      r.toISOString();
    } catch {
      throw nn(Ze.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (P0(t)) {
    if (isNaN(t.getTime()))
      throw nn(Ze.INVALID_DATE_ARGUMENT);
    r = t;
  } else if (je(t))
    r = t;
  else
    throw nn(Ze.INVALID_ARGUMENT);
  return K(n) ? o.key = n : ge(n) && Object.keys(n).forEach((l) => {
    Du.includes(l) ? i[l] = n[l] : o[l] = n[l];
  }), K(a) ? o.locale = a : ge(a) && (i = a), ge(s) && (i = s), [o.key || "", r, o, i];
}
function rl(e, t, n) {
  const a = e;
  for (const s in n) {
    const o = `${t}__${s}`;
    a.__datetimeFormatters.has(o) && a.__datetimeFormatters.delete(o);
  }
}
function ll(e, ...t) {
  const { numberFormats: n, unresolving: a, fallbackLocale: s, onWarn: o, localeFallbacker: i } = e, { __numberFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !Lu.numberFormat)
    return o(jn(rt.CANNOT_FORMAT_NUMBER)), ks;
  const [l, c, u, p] = Vo(...t), m = Me(u.missingWarn) ? u.missingWarn : e.missingWarn, v = Me(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, A = !!u.part, h = Li(e, u), d = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    h
  );
  if (!K(l) || l === "")
    return new Intl.NumberFormat(h, p).format(c);
  let f = {}, g, B = null, E = h, _ = null;
  const O = "number format";
  for (let z = 0; z < d.length; z++) {
    if (g = _ = d[z], process.env.NODE_ENV !== "production" && h !== g && $s(v, l) && o(jn(rt.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && h !== g) {
      const X = e.__v_emitter;
      X && X.emit("fallback", {
        type: O,
        key: l,
        from: E,
        to: _,
        groupId: `${O}:${l}`
      });
    }
    if (f = n[g] || {}, B = f[l], ge(B))
      break;
    Di(e, l, g, m, O), E = _;
  }
  if (!ge(B) || !K(g))
    return a ? zs : l;
  let S = `${g}__${l}`;
  Ws(p) || (S = `${S}__${JSON.stringify(p)}`);
  let H = r.get(S);
  return H || (H = new Intl.NumberFormat(g, Ve({}, B, p)), r.set(S, H)), A ? H.formatToParts(c) : H.format(c);
}
const Mu = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Vo(...e) {
  const [t, n, a, s] = e, o = Be();
  let i = Be();
  if (!je(t))
    throw nn(Ze.INVALID_ARGUMENT);
  const r = t;
  return K(n) ? o.key = n : ge(n) && Object.keys(n).forEach((l) => {
    Mu.includes(l) ? i[l] = n[l] : o[l] = n[l];
  }), K(a) ? o.locale = a : ge(a) && (i = a), ge(s) && (i = s), [o.key || "", r, o, i];
}
function cl(e, t, n) {
  const a = e;
  for (const s in n) {
    const o = `${t}__${s}`;
    a.__numberFormatters.has(o) && a.__numberFormatters.delete(o);
  }
}
const lb = (e) => e, cb = (e) => "", ub = "text", db = (e) => e.length === 0 ? "" : _i(e), fb = G0;
function ul(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function pb(e) {
  const t = je(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (je(e.named.count) || je(e.named.n)) ? je(e.named.count) ? e.named.count : je(e.named.n) ? e.named.n : t : t;
}
function mb(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Ab(e = {}) {
  const t = e.locale, n = pb(e), a = he(e.pluralRules) && K(t) && De(e.pluralRules[t]) ? e.pluralRules[t] : ul, s = he(e.pluralRules) && K(t) && De(e.pluralRules[t]) ? ul : void 0, o = (f) => f[a(n, f.length, s)], i = e.list || [], r = (f) => i[f], l = e.named || Be();
  je(e.pluralIndex) && mb(n, l);
  const c = (f) => l[f];
  function u(f, g) {
    const B = De(e.messages) ? e.messages(f, !!g) : he(e.messages) ? e.messages[f] : !1;
    return B || (e.parent ? e.parent.message(f) : cb);
  }
  const p = (f) => e.modifiers ? e.modifiers[f] : lb, m = ge(e.processor) && De(e.processor.normalize) ? e.processor.normalize : db, v = ge(e.processor) && De(e.processor.interpolate) ? e.processor.interpolate : fb, A = ge(e.processor) && K(e.processor.type) ? e.processor.type : ub, d = {
    list: r,
    named: c,
    plural: o,
    linked: (f, ...g) => {
      const [B, E] = g;
      let _ = "text", O = "";
      g.length === 1 ? he(B) ? (O = B.modifier || O, _ = B.type || _) : K(B) && (O = B || O) : g.length === 2 && (K(B) && (O = B || O), K(E) && (_ = E || _));
      const S = u(f, !0)(d), H = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        _ === "vnode" && Oe(S) && O ? S[0] : S
      );
      return O ? p(O)(H, _) : H;
    },
    message: u,
    type: A,
    interpolate: v,
    normalize: m,
    values: Ve(Be(), i, l)
  };
  return d;
}
const dl = () => "", vt = (e) => De(e);
function fl(e, ...t) {
  const { fallbackFormat: n, postTranslation: a, unresolving: s, messageCompiler: o, fallbackLocale: i, messages: r } = e, [l, c] = Ko(...t), u = Me(c.missingWarn) ? c.missingWarn : e.missingWarn, p = Me(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, m = Me(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, v = !!c.resolvedMessage, A = K(c.default) || Me(c.default) ? Me(c.default) ? o ? l : () => l : c.default : n ? o ? l : () => l : null, h = n || A != null && (K(A) || De(A)), d = Li(e, c);
  m && gb(c);
  let [f, g, B] = v ? [
    l,
    d,
    r[d] || Be()
  ] : Ou(e, l, d, i, p, u), E = f, _ = l;
  if (!v && !(K(E) || St(E) || vt(E)) && h && (E = A, _ = E), !v && (!(K(E) || St(E) || vt(E)) || !K(g)))
    return s ? zs : l;
  if (process.env.NODE_ENV !== "production" && K(E) && e.messageCompiler == null)
    return Wt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let O = !1;
  const S = () => {
    O = !0;
  }, H = vt(E) ? E : Nu(e, l, g, E, _, S);
  if (O)
    return E;
  const z = xb(e, g, B, c), X = Ab(z), re = hb(e, H, X);
  let se = a ? a(re, l) : re;
  if (m && K(se) && (se = Q0(se)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const ve = {
      timestamp: Date.now(),
      key: K(l) ? l : vt(E) ? E.key : "",
      locale: g || (vt(E) ? E.locale : ""),
      format: K(E) ? E : vt(E) ? E.source : "",
      message: se
    };
    ve.meta = Ve({}, e.__meta, /* @__PURE__ */ sb() || {}), Nv(ve);
  }
  return se;
}
function gb(e) {
  Oe(e.list) ? e.list = e.list.map((t) => K(t) ? Kr(t) : t) : he(e.named) && Object.keys(e.named).forEach((t) => {
    K(e.named[t]) && (e.named[t] = Kr(e.named[t]));
  });
}
function Ou(e, t, n, a, s, o) {
  const { messages: i, onWarn: r, messageResolver: l, localeFallbacker: c } = e, u = c(e, a, n);
  let p = Be(), m, v = null, A = n, h = null;
  const d = "translate";
  for (let f = 0; f < u.length; f++) {
    if (m = h = u[f], process.env.NODE_ENV !== "production" && n !== m && !Tu(n, m) && $s(s, t) && r(jn(rt.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && n !== m) {
      const _ = e.__v_emitter;
      _ && _.emit("fallback", {
        type: d,
        key: t,
        from: A,
        to: h,
        groupId: `${d}:${t}`
      });
    }
    p = i[m] || Be();
    let g = null, B, E;
    if (process.env.NODE_ENV !== "production" && ln && (g = window.performance.now(), B = "intlify-message-resolve-start", E = "intlify-message-resolve-end", dt && dt(B)), (v = l(p, t)) === null && (v = p[t]), process.env.NODE_ENV !== "production" && ln) {
      const _ = window.performance.now(), O = e.__v_emitter;
      O && g && v && O.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: v,
        time: _ - g,
        groupId: `${d}:${t}`
      }), B && E && dt && Gn && (dt(E), Gn("intlify message resolve", B, E));
    }
    if (K(v) || St(v) || vt(v))
      break;
    if (!rb(m, u)) {
      const _ = Di(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        o,
        d
      );
      _ !== t && (v = _);
    }
    A = h;
  }
  return [v, m, p];
}
function Nu(e, t, n, a, s, o) {
  const { messageCompiler: i, warnHtmlMessage: r } = e;
  if (vt(a)) {
    const m = a;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (i == null) {
    const m = (() => a);
    return m.locale = n, m.key = t, m;
  }
  let l = null, c, u;
  process.env.NODE_ENV !== "production" && ln && (l = window.performance.now(), c = "intlify-message-compilation-start", u = "intlify-message-compilation-end", dt && dt(c));
  const p = i(a, vb(e, n, s, a, r, o));
  if (process.env.NODE_ENV !== "production" && ln) {
    const m = window.performance.now(), v = e.__v_emitter;
    v && l && v.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: m - l,
      groupId: `translate:${t}`
    }), c && u && dt && Gn && (dt(u), Gn("intlify message compilation", c, u));
  }
  return p.locale = n, p.key = t, p.source = a, p;
}
function hb(e, t, n) {
  let a = null, s, o;
  process.env.NODE_ENV !== "production" && ln && (a = window.performance.now(), s = "intlify-message-evaluation-start", o = "intlify-message-evaluation-end", dt && dt(s));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && ln) {
    const r = window.performance.now(), l = e.__v_emitter;
    l && a && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: r - a,
      groupId: `translate:${t.key}`
    }), s && o && dt && Gn && (dt(o), Gn("intlify message evaluation", s, o));
  }
  return i;
}
function Ko(...e) {
  const [t, n, a] = e, s = Be();
  if (!K(t) && !je(t) && !vt(t) && !St(t))
    throw nn(Ze.INVALID_ARGUMENT);
  const o = je(t) ? String(t) : (vt(t), t);
  return je(n) ? s.plural = n : K(n) ? s.default = n : ge(n) && !Ws(n) ? s.named = n : Oe(n) && (s.list = n), je(a) ? s.plural = a : K(a) ? s.default = a : ge(a) && Ve(s, a), [o, s];
}
function vb(e, t, n, a, s, o) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (i) => {
      if (o && o(i), process.env.NODE_ENV !== "production") {
        const r = bb(a), l = `Message compilation error: ${i.message}`, c = i.location && r && j0(r, i.location.start.offset, i.location.end.offset), u = e.__v_emitter;
        u && r && u.emit("compile-error", {
          message: r,
          error: i.message,
          start: i.location && i.location.start.offset,
          end: i.location && i.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw i;
    },
    onCacheKey: (i) => N0(t, n, i)
  };
}
function bb(e) {
  if (K(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function xb(e, t, n, a) {
  const { modifiers: s, pluralRules: o, messageResolver: i, fallbackLocale: r, fallbackWarn: l, missingWarn: c, fallbackContext: u } = e, m = {
    locale: t,
    modifiers: s,
    pluralRules: o,
    messages: (v, A) => {
      let h = i(n, v);
      if (h == null && (u || A)) {
        const [, , d] = Ou(
          u || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          v,
          t,
          r,
          l,
          c
        );
        h = i(d, v);
      }
      if (K(h) || St(h)) {
        let d = !1;
        const g = Nu(e, v, t, h, v, () => {
          d = !0;
        });
        return d ? dl : g;
      } else return vt(h) ? h : dl;
    }
  };
  return e.processor && (m.processor = e.processor), a.list && (m.list = a.list), a.named && (m.named = a.named), je(a.plural) && (m.pluralIndex = a.plural), m;
}
xv();
/*!
  * vue-i18n v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const yb = "11.1.12";
function Eb() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Rn().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Rn().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Rn().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Rn().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const $e = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Pv,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Qa(e, ...t) {
  return pa(e, null, process.env.NODE_ENV !== "production" ? { messages: Cb, args: t } : void 0);
}
const Cb = {
  [$e.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [$e.INVALID_ARGUMENT]: "Invalid argument",
  [$e.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [$e.NOT_INSTALLED]: "Need to install with `app.use` function",
  [$e.UNEXPECTED_ERROR]: "Unexpected error",
  [$e.REQUIRED_VALUE]: "Required in value: {0}",
  [$e.INVALID_VALUE]: "Invalid value",
  [$e.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [$e.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [$e.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [$e.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Wo = /* @__PURE__ */ fn("__translateVNode"), zo = /* @__PURE__ */ fn("__datetimeParts"), $o = /* @__PURE__ */ fn("__numberParts"), Jo = /* @__PURE__ */ fn("__enableEmitter"), qo = /* @__PURE__ */ fn("__disableEmitter"), Bb = fn("__setPluralRules"), Ru = /* @__PURE__ */ fn("__injectWithOption"), Xo = /* @__PURE__ */ fn("__dispose"), Ft = {
  FALLBACK_TO_ROOT: Jv,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, Ib = {
  [Ft.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ft.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Ft.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ft.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ft.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Ft.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function _s(e, ...t) {
  return Ks(Ib[e], ...t);
}
function Ua(e) {
  if (!he(e) || St(e))
    return e;
  for (const t in e)
    if (_t(e, t))
      if (!t.includes("."))
        he(e[t]) && Ua(e[t]);
      else {
        const n = t.split("."), a = n.length - 1;
        let s = e, o = !1;
        for (let i = 0; i < a; i++) {
          if (n[i] === "__proto__")
            throw new Error(`unsafe key: ${n[i]}`);
          if (n[i] in s || (s[n[i]] = Be()), !he(s[n[i]])) {
            process.env.NODE_ENV !== "production" && Wt(_s(Ft.IGNORE_OBJ_FLATTEN, {
              key: n[i]
            })), o = !0;
            break;
          }
          s = s[n[i]];
        }
        if (o || (St(s) ? Eu.includes(n[a]) || delete e[t] : (s[n[a]] = e[t], delete e[t])), !St(s)) {
          const i = s[n[a]];
          he(i) && Ua(i);
        }
      }
  return e;
}
function Pu(e, t) {
  const { messages: n, __i18n: a, messageResolver: s, flatJson: o } = t, i = ge(n) ? n : Oe(a) ? Be() : { [e]: Be() };
  if (Oe(a) && a.forEach((r) => {
    if ("locale" in r && "resource" in r) {
      const { locale: l, resource: c } = r;
      l ? (i[l] = i[l] || Be(), fs(c, i[l])) : fs(c, i);
    } else
      K(r) && fs(JSON.parse(r), i);
  }), s == null && o)
    for (const r in i)
      _t(i, r) && Ua(i[r]);
  return i;
}
function Fu(e) {
  return e.type;
}
function wb(e, t, n) {
  let a = he(t.messages) ? t.messages : Be();
  "__i18nGlobal" in n && (a = Pu(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(a);
  s.length && s.forEach((o) => {
    e.mergeLocaleMessage(o, a[o]);
  });
  {
    if (he(t.datetimeFormats)) {
      const o = Object.keys(t.datetimeFormats);
      o.length && o.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (he(t.numberFormats)) {
      const o = Object.keys(t.numberFormats);
      o.length && o.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function pl(e) {
  return w(gd, null, e, 0);
}
const ml = "__INTLIFY_META__", Al = () => [], kb = () => !1;
let gl = 0;
function hl(e) {
  return ((t, n, a, s) => e(n, a, ta() || void 0, s));
}
const _b = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ta();
  let t = null;
  return e && (t = Fu(e)[ml]) ? { [ml]: t } : null;
};
function Sb(e = {}) {
  const { __root: t, __injectWithOption: n } = e, a = t === void 0, s = e.flatJson, o = ln ? L : Yl;
  let i = Me(e.inheritLocale) ? e.inheritLocale : !0;
  const r = o(
    // prettier-ignore
    t && i ? t.locale.value : K(e.locale) ? e.locale : ws
  ), l = o(
    // prettier-ignore
    t && i ? t.fallbackLocale.value : K(e.fallbackLocale) || Oe(e.fallbackLocale) || ge(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r.value
  ), c = o(Pu(r.value, e)), u = o(ge(e.datetimeFormats) ? e.datetimeFormats : { [r.value]: {} }), p = o(ge(e.numberFormats) ? e.numberFormats : { [r.value]: {} });
  let m = t ? t.missingWarn : Me(e.missingWarn) || Is(e.missingWarn) ? e.missingWarn : !0, v = t ? t.fallbackWarn : Me(e.fallbackWarn) || Is(e.fallbackWarn) ? e.fallbackWarn : !0, A = t ? t.fallbackRoot : Me(e.fallbackRoot) ? e.fallbackRoot : !0, h = !!e.fallbackFormat, d = De(e.missing) ? e.missing : null, f = De(e.missing) ? hl(e.missing) : null, g = De(e.postTranslation) ? e.postTranslation : null, B = t ? t.warnHtmlMessage : Me(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, E = !!e.escapeParameter;
  const _ = t ? t.modifiers : ge(e.modifiers) ? e.modifiers : {};
  let O = e.pluralRules || t && t.pluralRules, S;
  S = (() => {
    a && al(null);
    const D = {
      version: yb,
      locale: r.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: _,
      pluralRules: O,
      missing: f === null ? void 0 : f,
      missingWarn: m,
      fallbackWarn: v,
      fallbackFormat: h,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: B,
      escapeParameter: E,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    D.datetimeFormats = u.value, D.numberFormats = p.value, D.__datetimeFormatters = ge(S) ? S.__datetimeFormatters : void 0, D.__numberFormatters = ge(S) ? S.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (D.__v_emitter = ge(S) ? S.__v_emitter : void 0);
    const C = ib(D);
    return a && al(C), C;
  })(), va(S, r.value, l.value);
  function z() {
    return [
      r.value,
      l.value,
      c.value,
      u.value,
      p.value
    ];
  }
  const X = F({
    get: () => r.value,
    set: (D) => {
      S.locale = D, r.value = D;
    }
  }), re = F({
    get: () => l.value,
    set: (D) => {
      S.fallbackLocale = D, l.value = D, va(S, r.value, D);
    }
  }), se = F(() => c.value), ve = /* @__PURE__ */ F(() => u.value), Re = /* @__PURE__ */ F(() => p.value);
  function Z() {
    return De(g) ? g : null;
  }
  function ce(D) {
    g = D, S.postTranslation = D;
  }
  function be() {
    return d;
  }
  function gt(D) {
    D !== null && (f = hl(D)), d = D, S.missing = f;
  }
  function Ue(D, C) {
    return D !== "translate" || !C.resolvedMessage;
  }
  const Pe = (D, C, Q, ae, me, it) => {
    z();
    let We;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (S.fallbackContext = t ? ob() : void 0), We = D(S);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (S.fallbackContext = void 0);
    }
    if (Q !== "translate exists" && // for not `te` (e.g `t`)
    je(We) && We === zs || Q === "translate exists" && !We) {
      const [Bt, $a] = C();
      if (process.env.NODE_ENV !== "production" && t && K(Bt) && Ue(Q, $a) && (A && ($s(v, Bt) || Su(m, Bt)) && Wt(_s(Ft.FALLBACK_TO_ROOT, {
        key: Bt,
        type: Q
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ue } = S;
        ue && A && ue.emit("fallback", {
          type: Q,
          key: Bt,
          to: "global",
          groupId: `${Q}:${Bt}`
        });
      }
      return t && A ? ae(t) : me(Bt);
    } else {
      if (it(We))
        return We;
      throw Qa($e.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Ye(...D) {
    return Pe((C) => Reflect.apply(fl, null, [C, ...D]), () => Ko(...D), "translate", (C) => Reflect.apply(C.t, C, [...D]), (C) => C, (C) => K(C));
  }
  function Je(...D) {
    const [C, Q, ae] = D;
    if (ae && !he(ae))
      throw Qa($e.INVALID_ARGUMENT);
    return Ye(C, Q, Ve({ resolvedMessage: !0 }, ae || {}));
  }
  function Ke(...D) {
    return Pe((C) => Reflect.apply(il, null, [C, ...D]), () => Ho(...D), "datetime format", (C) => Reflect.apply(C.d, C, [...D]), () => ks, (C) => K(C) || Oe(C));
  }
  function tt(...D) {
    return Pe((C) => Reflect.apply(ll, null, [C, ...D]), () => Vo(...D), "number format", (C) => Reflect.apply(C.n, C, [...D]), () => ks, (C) => K(C) || Oe(C));
  }
  function st(D) {
    return D.map((C) => K(C) || je(C) || Me(C) ? pl(String(C)) : C);
  }
  const Mt = {
    normalize: st,
    interpolate: (D) => D,
    type: "vnode"
  };
  function ot(...D) {
    return Pe((C) => {
      let Q;
      const ae = C;
      try {
        ae.processor = Mt, Q = Reflect.apply(fl, null, [ae, ...D]);
      } finally {
        ae.processor = null;
      }
      return Q;
    }, () => Ko(...D), "translate", (C) => C[Wo](...D), (C) => [pl(C)], (C) => Oe(C));
  }
  function Et(...D) {
    return Pe((C) => Reflect.apply(ll, null, [C, ...D]), () => Vo(...D), "number format", (C) => C[$o](...D), Al, (C) => K(C) || Oe(C));
  }
  function Jt(...D) {
    return Pe((C) => Reflect.apply(il, null, [C, ...D]), () => Ho(...D), "datetime format", (C) => C[zo](...D), Al, (C) => K(C) || Oe(C));
  }
  function qt(D) {
    O = D, S.pluralRules = O;
  }
  function Mn(D, C) {
    return Pe(() => {
      if (!D)
        return !1;
      const Q = K(C) ? C : r.value, ae = Ct(Q), me = S.messageResolver(ae, D);
      return St(me) || vt(me) || K(me);
    }, () => [D], "translate exists", (Q) => Reflect.apply(Q.te, Q, [D, C]), kb, (Q) => Me(Q));
  }
  function pe(D) {
    let C = null;
    const Q = Cu(S, l.value, r.value);
    for (let ae = 0; ae < Q.length; ae++) {
      const me = c.value[Q[ae]] || {}, it = S.messageResolver(me, D);
      if (it != null) {
        C = it;
        break;
      }
    }
    return C;
  }
  function Xt(D) {
    const C = pe(D);
    return C ?? (t ? t.tm(D) || {} : {});
  }
  function Ct(D) {
    return c.value[D] || {};
  }
  function Ot(D, C) {
    if (s) {
      const Q = { [D]: C };
      for (const ae in Q)
        _t(Q, ae) && Ua(Q[ae]);
      C = Q[D];
    }
    c.value[D] = C, S.messages = c.value;
  }
  function Zt(D, C) {
    c.value[D] = c.value[D] || {};
    const Q = { [D]: C };
    if (s)
      for (const ae in Q)
        _t(Q, ae) && Ua(Q[ae]);
    C = Q[D], fs(C, c.value[D]), S.messages = c.value;
  }
  function x(D) {
    return u.value[D] || {};
  }
  function I(D, C) {
    u.value[D] = C, S.datetimeFormats = u.value, rl(S, D, C);
  }
  function N(D, C) {
    u.value[D] = Ve(u.value[D] || {}, C), S.datetimeFormats = u.value, rl(S, D, C);
  }
  function V(D) {
    return p.value[D] || {};
  }
  function xe(D, C) {
    p.value[D] = C, S.numberFormats = p.value, cl(S, D, C);
  }
  function Ie(D, C) {
    p.value[D] = Ve(p.value[D] || {}, C), S.numberFormats = p.value, cl(S, D, C);
  }
  gl++, t && ln && (Ae(t.locale, (D) => {
    i && (r.value = D, S.locale = D, va(S, r.value, l.value));
  }), Ae(t.fallbackLocale, (D) => {
    i && (l.value = D, S.fallbackLocale = D, va(S, r.value, l.value));
  }));
  const ie = {
    id: gl,
    locale: X,
    fallbackLocale: re,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(D) {
      i = D, D && t && (r.value = t.locale.value, l.value = t.fallbackLocale.value, va(S, r.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: se,
    get modifiers() {
      return _;
    },
    get pluralRules() {
      return O || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(D) {
      m = D, S.missingWarn = m;
    },
    get fallbackWarn() {
      return v;
    },
    set fallbackWarn(D) {
      v = D, S.fallbackWarn = v;
    },
    get fallbackRoot() {
      return A;
    },
    set fallbackRoot(D) {
      A = D;
    },
    get fallbackFormat() {
      return h;
    },
    set fallbackFormat(D) {
      h = D, S.fallbackFormat = h;
    },
    get warnHtmlMessage() {
      return B;
    },
    set warnHtmlMessage(D) {
      B = D, S.warnHtmlMessage = D;
    },
    get escapeParameter() {
      return E;
    },
    set escapeParameter(D) {
      E = D, S.escapeParameter = D;
    },
    t: Ye,
    getLocaleMessage: Ct,
    setLocaleMessage: Ot,
    mergeLocaleMessage: Zt,
    getPostTranslationHandler: Z,
    setPostTranslationHandler: ce,
    getMissingHandler: be,
    setMissingHandler: gt,
    [Bb]: qt
  };
  return ie.datetimeFormats = ve, ie.numberFormats = Re, ie.rt = Je, ie.te = Mn, ie.tm = Xt, ie.d = Ke, ie.n = tt, ie.getDateTimeFormat = x, ie.setDateTimeFormat = I, ie.mergeDateTimeFormat = N, ie.getNumberFormat = V, ie.setNumberFormat = xe, ie.mergeNumberFormat = Ie, ie[Ru] = n, ie[Wo] = ot, ie[zo] = Jt, ie[$o] = Et, process.env.NODE_ENV !== "production" && (ie[Jo] = (D) => {
    S.__v_emitter = D;
  }, ie[qo] = () => {
    S.__v_emitter = void 0;
  }), ie;
}
function vl(e, t) {
}
const Mi = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Tb({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, s) => [
    ...a,
    // prettier-ignore
    ...s.type === fe ? s.children : [s]
  ], []) : t.reduce((n, a) => {
    const s = e[a];
    return s && (n[a] = s()), n;
  }, Be());
}
function Qu() {
  return fe;
}
Ve({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => je(e) || !isNaN(e)
  }
}, Mi);
function Lb(e) {
  return Oe(e) && !K(e[0]);
}
function Uu(e, t, n, a) {
  const { slots: s, attrs: o } = t;
  return () => {
    const i = { part: !0 };
    let r = Be();
    e.locale && (i.locale = e.locale), K(e.format) ? i.key = e.format : he(e.format) && (K(e.format.key) && (i.key = e.format.key), r = Object.keys(e.format).reduce((m, v) => n.includes(v) ? Ve(Be(), m, { [v]: e.format[v] }) : m, Be()));
    const l = a(e.value, i, r);
    let c = [i.key];
    Oe(l) ? c = l.map((m, v) => {
      const A = s[m.type], h = A ? A({ [m.type]: m.value, index: v, parts: l }) : [m.value];
      return Lb(h) && (h[0].key = `${m.type}-${v}`), h;
    }) : K(l) && (c = [l]);
    const u = Ve(Be(), o), p = K(e.tag) || he(e.tag) ? e.tag : Qu();
    return Ts(p, u, c);
  };
}
Ve({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Mi);
const Db = /* @__PURE__ */ fn("global-vue-i18n");
function pn(e = {}) {
  const t = ta();
  if (t == null)
    throw Qa($e.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Qa($e.NOT_INSTALLED);
  const n = Mb(t), a = Nb(n), s = Fu(t), o = Ob(e, s);
  if (o === "global")
    return wb(a, e, s), a;
  if (o === "parent") {
    let l = Rb(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Wt(_s(Ft.NOT_FOUND_PARENT_SCOPE)), l = a), l;
  }
  const i = n;
  let r = i.__getInstance(t);
  if (r == null) {
    const l = Ve({}, e);
    "__i18n" in s && (l.__i18n = s.__i18n), a && (l.__root = a), r = Sb(l), i.__composerExtend && (r[Xo] = i.__composerExtend(r)), Fb(i, t, r), i.__setInstance(t, r);
  } else
    process.env.NODE_ENV !== "production" && o === "local" && Wt(_s(Ft.DUPLICATE_USE_I18N_CALLING));
  return r;
}
function Mb(e) {
  const t = Lt(e.isCE ? Db : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Qa(e.isCE ? $e.NOT_INSTALLED_WITH_PROVIDE : $e.UNEXPECTED_ERROR);
  return t;
}
function Ob(e, t) {
  return Ws(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Nb(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Rb(e, t, n = !1) {
  let a = null;
  const s = t.root;
  let o = Pb(t, n);
  for (; o != null; ) {
    const i = e;
    if (e.mode === "composition")
      a = i.__getInstance(o);
    else if (__VUE_I18N_LEGACY_API__) {
      const r = i.__getInstance(o);
      r != null && (a = r.__composer, n && a && !a[Ru] && (a = null));
    }
    if (a != null || s === o)
      break;
    o = o.parent;
  }
  return a;
}
function Pb(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Fb(e, t, n) {
  let a = null;
  Ne(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, a = H0();
      const s = n;
      s[Jo] && s[Jo](a), a.on("*", vl);
    }
  }, t), wn(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", vl), s[qo] && s[qo](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const o = s[Xo];
    o && (o(), delete s[Xo]);
  }, t);
}
Ve({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Mi);
Eb();
eb(Dv);
tb($v);
nb(Cu);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Rn();
  e.__INTLIFY__ = !0, Mv(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const ea = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Cn = globalThis, wa = "10.29.0";
function Yu() {
  return Oi(Cn), Cn;
}
function Oi(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || wa, t[wa] = t[wa] || {};
}
function Ni(e, t, n = Cn) {
  const a = n.__SENTRY__ = n.__SENTRY__ || {}, s = a[wa] = a[wa] || {};
  return s[e] || (s[e] = t());
}
const Qb = "Sentry Logger ", bl = {};
function Ub(e) {
  if (!("console" in Cn))
    return e();
  const t = Cn.console, n = {}, a = Object.keys(bl);
  a.forEach((s) => {
    const o = bl[s];
    n[s] = t[s], t[s] = o;
  });
  try {
    return e();
  } finally {
    a.forEach((s) => {
      t[s] = n[s];
    });
  }
}
function Yb() {
  Pi().enabled = !0;
}
function Gb() {
  Pi().enabled = !1;
}
function Gu() {
  return Pi().enabled;
}
function jb(...e) {
  Ri("log", ...e);
}
function Hb(...e) {
  Ri("warn", ...e);
}
function Vb(...e) {
  Ri("error", ...e);
}
function Ri(e, ...t) {
  ea && Gu() && Ub(() => {
    Cn.console[e](`${Qb}[${e}]:`, ...t);
  });
}
function Pi() {
  return ea ? Ni("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const ps = {
  /** Enable logging. */
  enable: Yb,
  /** Disable logging. */
  disable: Gb,
  /** Check if logging is enabled. */
  isEnabled: Gu,
  /** Log a message. */
  log: jb,
  /** Log a warning. */
  warn: Hb,
  /** Log an error. */
  error: Vb
}, Kb = Object.prototype.toString;
function Wb(e, t) {
  return Kb.call(e) === `[object ${t}]`;
}
function zb(e) {
  return Wb(e, "Object");
}
function $b(e) {
  return !!(e != null && e.then && typeof e.then == "function");
}
function Jb(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    ea && ps.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function qb(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function Xb() {
  const e = Cn;
  return e.crypto || e.msCrypto;
}
let ho;
function Zb() {
  return Math.random() * 16;
}
function ka(e = Xb()) {
  try {
    if (e != null && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
  } catch {
  }
  return ho || (ho = "10000000100040008000" + 1e11), ho.replace(
    /[018]/g,
    (t) => (
      // eslint-disable-next-line no-bitwise
      (t ^ (Zb() & 15) >> t / 4).toString(16)
    )
  );
}
const ju = 1e3;
function Hu() {
  return Date.now() / ju;
}
function ex() {
  const { performance: e } = Cn;
  if (!(e != null && e.now) || !e.timeOrigin)
    return Hu;
  const t = e.timeOrigin;
  return () => (t + e.now()) / ju;
}
let xl;
function tx() {
  return (xl ?? (xl = ex()))();
}
function nx(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || tx(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : ka()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function Vu(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const a = { ...e };
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && (a[s] = Vu(a[s], t[s], n - 1));
  return a;
}
function yl() {
  return ka();
}
const Zo = "_sentrySpan";
function El(e, t) {
  t ? Jb(e, Zo, t) : delete e[Zo];
}
function Cl(e) {
  return e[Zo];
}
const ax = 100;
class Hn {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Attributes */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._attributes = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: yl(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new Hn();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._attributes = { ...this._attributes }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, El(t, Cl(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && nx(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, n) {
    return this.setTags({ [t]: n });
  }
  /**
   * Sets attributes onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   clicked_products: [130, 554, 292],
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */
  setAttributes(t) {
    return this._attributes = {
      ...this._attributes,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets an attribute onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('clicked_products', [130, 554, 292]);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setAttribute(t, n) {
    return this.setAttributes({ [t]: n });
  }
  /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */
  removeAttribute(t) {
    return t in this._attributes && (delete this._attributes[t], this._notifyScopeListeners()), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, a = n instanceof Hn ? n.getScopeData() : zb(n) ? t : void 0, {
      tags: s,
      attributes: o,
      extra: i,
      user: r,
      contexts: l,
      level: c,
      fingerprint: u = [],
      propagationContext: p
    } = a || {};
    return this._tags = { ...this._tags, ...s }, this._attributes = { ...this._attributes, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...l }, r && Object.keys(r).length && (this._user = r), c && (this._level = c), u.length && (this._fingerprint = u), p && (this._propagationContext = p), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._attributes = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, El(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: yl(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, n) {
    var o;
    const a = typeof n == "number" ? n : ax;
    if (a <= 0)
      return this;
    const s = {
      timestamp: Hu(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? qb(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(s), this._breadcrumbs.length > a && (this._breadcrumbs = this._breadcrumbs.slice(-a), (o = this._client) == null || o.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      attributes: this._attributes,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Cl(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = Vu(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, n) {
    const a = (n == null ? void 0 : n.event_id) || ka();
    if (!this._client)
      return ea && ps.warn("No client configured on scope - will not capture exception!"), a;
    const s = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: s,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, n, a) {
    const s = (a == null ? void 0 : a.event_id) || ka();
    if (!this._client)
      return ea && ps.warn("No client configured on scope - will not capture message!"), s;
    const o = (a == null ? void 0 : a.syntheticException) ?? new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: o,
        ...a,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, n) {
    const a = (n == null ? void 0 : n.event_id) || ka();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: a }, this), a) : (ea && ps.warn("No client configured on scope - will not capture event!"), a);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function sx() {
  return Ni("defaultCurrentScope", () => new Hn());
}
function ox() {
  return Ni("defaultIsolationScope", () => new Hn());
}
class ix {
  constructor(t, n) {
    let a;
    t ? a = t : a = new Hn();
    let s;
    n ? s = n : s = new Hn(), this._stack = [{ scope: a }], this._isolationScope = s;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let a;
    try {
      a = t(n);
    } catch (s) {
      throw this._popScope(), s;
    }
    return $b(a) ? a.then(
      (s) => (this._popScope(), s),
      (s) => {
        throw this._popScope(), s;
      }
    ) : (this._popScope(), a);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function oa() {
  const e = Yu(), t = Oi(e);
  return t.stack = t.stack || new ix(sx(), ox());
}
function rx(e) {
  return oa().withScope(e);
}
function lx(e, t) {
  const n = oa();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function Bl(e) {
  return oa().withScope(() => e(oa().getIsolationScope()));
}
function cx() {
  return {
    withIsolationScope: Bl,
    withScope: rx,
    withSetScope: lx,
    withSetIsolationScope: (e, t) => Bl(t),
    getCurrentScope: () => oa().getScope(),
    getIsolationScope: () => oa().getIsolationScope()
  };
}
function ux(e) {
  const t = Oi(e);
  return t.acs ? t.acs : cx();
}
function dx() {
  const e = Yu();
  return ux(e).getIsolationScope();
}
function Il(e) {
  dx().setUser(e);
}
var fx = /* @__PURE__ */ ((e) => (e[e.CD_VIEWER = 1] = "CD_VIEWER", e[e.NORMAL = 2] = "NORMAL", e[e.START = 4] = "START", e[e.PRO = 8] = "PRO", e[e.DOUBLE_SCAN = 16] = "DOUBLE_SCAN", e[e.CAD = 32] = "CAD", e[e.SUBSCRIPTION = 64] = "SUBSCRIPTION", e[e.READ_ONLY = 128] = "READ_ONLY", e[e.PLAN = 256] = "PLAN", e))(fx || {}), px = /* @__PURE__ */ ((e) => (e.SESSION_MODIFIED = "auth:session-modified", e))(px || {});
const ss = Os();
class mx {
  constructor(t, n = "SESSION_KEY") {
    oe(this, "sessionKey", "SESSION_KEY");
    oe(this, "authApi");
    oe(this, "sessionId");
    oe(this, "user");
    oe(this, "productionCenterId");
    oe(this, "loginTokenRef");
    oe(this, "fallbackUser", {
      id: 0,
      username: "",
      name: "",
      lang: "en",
      additionalData: {
        language: "en",
        timezone: "UTC"
      }
    });
    oe(this, "GetParam", (t, n) => {
      const a = t + "=";
      let s = n.indexOf(a);
      if (s == -1)
        return "";
      s += a.length;
      let o = n.indexOf(";", s);
      return o == -1 && (o = n.length), n.substring(s, o + 1);
    });
    this.sessionKey = n, this.authApi = t, this.loadSession(), this.loginTokenRef = jf("PRESCRIPTION_LOGIN_TOKEN", null);
  }
  setProductionCenterId(t) {
    this.productionCenterId = t;
  }
  async login(t, n, a, s, o, i) {
    try {
      const { status: r, data: l } = await this.authApi.login(t, n, this.productionCenterId, a, s, o, i);
      if (r == 200 && l.success)
        return this.sessionId = l.sessionid, this.user = l.user, this.user.weblinkRole = l.weblinkRole, this.user.weblinkPermissions = l.weblinkPermissions, this.user.timezone = l.user.additionalData.timezone, this.user.lang = jt(l.user.additionalData.language), this.user.isElearningEnabled = l.isElearningEnabled, this.user.elearningURL = l.elearningURL, this.user.legacyProductionCenterEnabled = l.legacyProductionCenterEnabled, this.user.legacyProductionCenterAllowAddPc = l.legacyProductionCenterAllowAddPc, this.saveSession(this.sessionId), ss.emit("auth:session-modified", this.user.username), !0;
    } catch (r) {
      console.error("Login error:", r);
    }
    return !1;
  }
  async loginWithToken(t) {
    const { status: n, data: a } = await this.authApi.getSessionFromToken(t);
    try {
      if (n == 200 && a.success)
        return this.sessionId = a.sessionid, this.user = a.user, this.user.timezone = a.user.additionalData.timezone, this.user.lang = jt(a.user.additionalData.language), this.user.isElearningEnabled = a.isElearningEnabled, this.user.elearningURL = a.elearningURL, this.user.legacyProductionCenterEnabled = a.legacyProductionCenterEnabled, this.user.legacyProductionCenterAllowAddPc = a.legacyProductionCenterAllowAddPc, this.setLoginToken(t), this.saveSession(this.sessionId), ss.emit("auth:session-modified", this.user.username), !0;
    } catch (s) {
      console.error("Login error:", s);
    }
    return !1;
  }
  setExternalSession(t) {
    this.sessionId = t;
  }
  async logout() {
    if (!this.sessionId) {
      console.error("Logout error: no session ID");
      return;
    }
    try {
      await this.authApi.logout(this.sessionId), this.clearSession();
    } catch (t) {
      console.error("Logout error:", t);
    }
  }
  async checkSession(t) {
    var n;
    if (!this.sessionId)
      return !1;
    try {
      const { data: a } = await this.authApi.checkSession(this.sessionId, this.productionCenterId, t);
      let s = !1;
      return this.user !== a.user && (s = !0), this.user = a.user, this.user.weblinkRole = a.weblinkRole, this.user.weblinkPermissions = a.weblinkPermissions, this.user.timezone = a.user.additionalData.timezone, this.user.lang = jt(a.user.additionalData.language), this.user.isElearningEnabled = a.isElearningEnabled, this.user.elearningURL = a.elearningURL, this.user.legacyProductionCenterEnabled = a.legacyProductionCenterEnabled, this.user.legacyProductionCenterAllowAddPc = a.legacyProductionCenterAllowAddPc, s && this.sessionModified(), a.success;
    } catch (a) {
      console.error("Session error:", a);
      const s = (n = a == null ? void 0 : a.response) == null ? void 0 : n.status;
      return (s === 401 || s === 403) && this.clearSession(), !1;
    }
  }
  getSessionLicence() {
    if (!this.user)
      return;
    const t = this.user.licenseRemainingDays < 1;
    t && console.error("License Remaining Days is 0");
    const n = this.user.licenseExtraParams;
    let a = this.user.licenseType;
    t && (a = "START"), this.GetParam("ITAKA_VERSION", n) == "1" && a == "PLAN" && (a = "START");
    let s = 1;
    return a == "START" || a == "MOBILE" || a == "CAD" ? s = 68 : a == "PRO" ? s = 72 : a == "PLAN" ? s = 320 : a == "PRO" ? s = 72 : (a == "DESIGN" || a == "CAD+") && (s = 66), (a == "CAD" || a == "CAD+") && (s += 32), { versionType: s, licenseType: a, licenseExtraParams: this.user.licenseExtraParams };
  }
  hasEditableAsPro() {
    if (!this.user)
      return;
    this.user.licenseRemainingDays < 1 && console.error("License Remaining Days is 0");
    const t = this.user.licenseExtraParams, n = this.user.licenseType, a = n === "DESIGN" || n === "CAD+", s = Qr(t, "CAN_SHARE_PRO");
    return a && s;
  }
  hasOpenAllProjectsParam() {
    if (!this.user)
      return;
    this.user.licenseRemainingDays < 1 && console.error("License Remaining Days is 0");
    const t = this.user.licenseExtraParams;
    return Qr(t, "OPEN_ALL_PROJECT");
  }
  async getNumberOfExportsTokens(t = wd.PLANNER) {
    if (await this.checkSession(t), !this.user)
      return 0;
    const n = this.user.licenseExtraParams, a = this.GetParam("STL_EXPORTS_AVAILABLE", n);
    return parseInt(a);
  }
  async createLoginToken() {
    const { data: t } = await this.authApi.getLoginToken();
    return t.id;
  }
  isAuthenticated() {
    return this.sessionId != null;
  }
  loadSession() {
    const t = localStorage.getItem(this.sessionKey);
    t ? this.sessionId = t : this.sessionId = void 0, this.sessionModified();
  }
  clearSession() {
    localStorage.removeItem(this.sessionKey), this.loginTokenRef.value = null, this.sessionId = void 0, this.user = void 0, this.sessionModified();
  }
  saveSession(t) {
    localStorage.setItem(this.sessionKey, t);
  }
  getUser() {
    if (this.user)
      return this.user;
    if (this.sessionId)
      return this.fallbackUser;
    throw Error("User is not authenticated!");
  }
  async updateUserLang(t) {
    if (!this.user)
      return;
    const n = jt(t), a = L0(n);
    this.user.lang = n, this.user.additionalData.language = a;
    try {
      await this.authApi.updateUserData(this.user.additionalData), Ge("User application language updated!");
    } catch {
      Te("Error setting language!");
    }
  }
  updateUserSetttings(t) {
    t && (this.user ? (Object.assign(this.user, t), t.additionalData && (this.user.additionalData = { ...this.user.additionalData || {}, ...t.additionalData }), t.settings && typeof t.settings == "object" && !Array.isArray(t.settings) && (this.user.settings = { ...this.user.settings || {}, ...t.settings })) : this.user = t);
  }
  getSessionId() {
    if (!this.sessionId) throw Error("Session id is null!");
    if (!this.isAuthenticated()) throw Error("Not authenticated!");
    return this.sessionId;
  }
  getLoginToken() {
    return this.loginTokenRef.value;
  }
  testPrescription(t, n) {
    this.setLoginToken(t), this.saveSession(n);
  }
  requestPasswordReset(t) {
    return this.authApi.requestPasswordReset(t);
  }
  setLoginToken(t) {
    this.loginTokenRef.value = t;
  }
  sessionModified() {
    var n;
    const t = this.isAuthenticated() ? (n = this.user) == null ? void 0 : n.username : null;
    console.log("Setting Sentry user: ", t), Il(t ? {
      username: t
    } : null), ss.emit("auth:session-modified", t);
  }
  getEventBus() {
    return ss;
  }
}
const Ax = {
  symbol: Symbol(),
  install(e, t) {
    const n = new kd(t.axiosInstance), a = new mx(n, t.authSessionKey);
    e.config.globalProperties.$auth = a, e.provide(this.symbol, a);
  }
};
function Ku() {
  const e = Lt(Ax.symbol);
  if (!e) throw new Error("AuthPlugin is null!");
  return e;
}
const gx = { class: "app-language-grid" }, hx = ["for"], Fi = /* @__PURE__ */ Y({
  __name: "AppLanguageComponent",
  setup(e) {
    const t = D0(), n = [
      j.EN,
      j.IT,
      j.DE,
      j.ES,
      j.FR,
      j.PT,
      j.HR,
      j.SL,
      j.BG,
      j.HU,
      j.RO,
      j.DA,
      j.SV,
      j.SK,
      j.LT
    ], a = pn(), s = L(jt(a.locale.value)), o = Ku(), i = async (r) => {
      const l = await t.getWebcadTranslations(r);
      await o.updateUserLang(r), l && (a.setLocaleMessage(r, l), a.locale.value = r, t.setAppLanguage(r), typeof window < "u" && window.dispatchEvent(new CustomEvent("app-language-changed", { detail: r })));
    };
    return Ae(
      () => a.locale.value,
      (r) => {
        s.value = jt(r);
      },
      { immediate: !0 }
    ), (r, l) => {
      const c = ne("RadioButton");
      return y(), M("div", gx, [
        (y(), M(fe, null, He(n, (u) => b("div", {
          class: "p-field-radiobutton app-language-option",
          key: u
        }, [
          w(c, {
            inputId: `lang-${u}`,
            modelValue: s.value,
            "onUpdate:modelValue": l[0] || (l[0] = (p) => s.value = p),
            name: "langMode",
            value: u,
            onChange: (p) => i(u)
          }, null, 8, ["inputId", "modelValue", "value", "onChange"]),
          b("label", {
            for: `lang-${u}`
          }, R(k(Lp)(u)), 9, hx)
        ])), 64))
      ]);
    };
  }
}), ze = Kt({
  preset: "Aura",
  primary: "emerald",
  surface: null,
  darkTheme: !0,
  menuMode: "static"
}), Ee = Kt({
  staticMenuDesktopInactive: !1,
  overlayMenuActive: !1,
  rightMenuActive: !1,
  configSidebarVisible: !0,
  staticMenuMobileActive: !1,
  menuHoverActive: !1,
  sidebarActive: !1,
  anchored: !1,
  activeMenuItem: null,
  overlaySubmenuActive: !1,
  rightMenuVisible: !1,
  searchBarActive: !1
}), Wn = L(null);
function vx() {
  const e = (Z) => {
    ze.primary = Z;
  }, t = (Z) => {
    console.log("settan surface: ", Z), ze.surface = Z;
  }, n = (Z) => {
    ze.preset = Z;
  }, a = (Z) => {
    console.log("layout.js setMenuMode mode: ", Z), Z.value, ze.menuMode = Z, console.log("layoutConfig.menuMode: ", ze.menuMode), Z === "static" && (Ee.staticMenuDesktopInactive = !1);
  }, s = () => {
    Ee.configSidebarVisible = !0;
  }, o = () => {
    Ee.rightMenuVisible = !0;
  }, i = (Z) => {
    const ce = document.getElementsByTagName("html")[0];
    localStorage.setItem("colorScheme", JSON.stringify(Z.value ? na.DARK : na.LIGHT)), ce.classList.toggle("p-dark");
  }, r = (Z) => {
    Ee.activeMenuItem = Z.value || Z;
  }, l = (Z) => {
    Ee.overlaySubmenuActive = Z, Ee.menuHoverActive = Z;
  }, c = () => {
    Ee.staticMenuMobileActive = !Ee.staticMenuMobileActive;
  }, u = () => {
    Ae(B, (Z) => {
      Z ? h() : d();
    });
  }, p = () => {
    ze.menuMode === "overlay" && (Ee.overlayMenuActive = !Ee.overlayMenuActive), window.innerWidth > 991 ? Ee.staticMenuDesktopInactive = !Ee.staticMenuDesktopInactive : Ee.staticMenuMobileActive = !Ee.staticMenuMobileActive;
  }, m = () => {
    B.value && (g(), d()), Ee.configSidebarVisible = !Ee.configSidebarVisible;
  }, v = (Z) => {
    Ee.sidebarActive = Z;
  }, A = () => {
    Ee.anchored = !Ee.anchored;
  }, h = () => {
    Wn.value || (Wn.value = (Z) => {
      f(Z) && g();
    }, document.addEventListener("click", Wn.value));
  }, d = () => {
    Wn.value && (document.removeEventListener("click", Wn.value), Wn.value = null);
  }, f = (Z) => {
    const ce = document.querySelector(".layout-sidebar"), be = document.querySelector(".topbar-start > button");
    return !(ce != null && ce.isSameNode(Z.target) || ce != null && ce.contains(Z.target) || be != null && be.isSameNode(Z.target) || be != null && be.contains(Z.target));
  }, g = () => {
    Ee.overlayMenuActive = !1, Ee.overlaySubmenuActive = !1, Ee.staticMenuMobileActive = !1, Ee.menuHoverActive = !1, Ee.configSidebarVisible = !1;
  }, B = F(() => Ee.overlayMenuActive || Ee.staticMenuMobileActive || Ee.overlaySubmenuActive), E = F(() => window.innerWidth > 991), _ = F(() => ze.menuMode === "slim"), O = F(() => ze.menuMode === "slim-plus"), S = F(() => ze.menuMode === "static"), H = F(() => ze.menuMode === "horizontal"), z = F(() => ze.menuMode === "overlay"), X = F(() => ze.menuMode === "drawer"), re = F(() => ze.menuMode === "reveal"), se = F(() => ze.darkTheme), ve = F(() => ze.primary), Re = F(() => ze.surface);
  return {
    layoutConfig: ze,
    layoutState: Ee,
    getPrimary: ve,
    getSurface: Re,
    isDarkTheme: se,
    setPrimary: e,
    setSurface: t,
    setPreset: n,
    setMenuMode: a,
    toggleDarkMode: i,
    onMenuToggle: p,
    setMenuStates: l,
    setStaticMenuMobile: c,
    watchSidebarActive: u,
    isSidebarActive: B,
    setActiveMenuItem: r,
    onConfigSidebarToggle: m,
    onSidebarToggle: v,
    onAnchorToggle: A,
    isSlim: _,
    isSlimPlus: O,
    isStatic: S,
    isDrawer: X,
    isReveal: re,
    isHorizontal: H,
    isDesktop: E,
    isOverlay: z,
    showConfigSidebar: s,
    showSidebar: o,
    unbindOutsideClickListener: d
  };
}
const bx = { class: "flex flex-col gap-4" }, Qi = /* @__PURE__ */ Y({
  __name: "AppThemeConfigComponent",
  props: {
    showOnlyColors: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { layoutConfig: t, setPrimary: n } = vx();
    L([
      { name: "Light", value: !1 },
      { name: "Dark", value: !0 }
    ]), L(localStorage.getItem("colorScheme") === '"dark"'), L([
      { name: "Sidebar", value: Ut.SIDEBAR },
      { name: "Horizontal", value: Ut.HORIZONTAL }
    ]), L(localStorage.getItem("navBarPos") === '"sidebar"' ? Ut.SIDEBAR : Ut.HORIZONTAL);
    const a = L([
      { name: "noir", palette: {} },
      {
        name: "emerald",
        palette: {
          50: "#ecfdf5",
          100: "#d1fae5",
          200: "#a7f3d0",
          300: "#6ee7b7",
          400: "#34d399",
          500: "#10b981",
          600: "#059669",
          700: "#047857",
          800: "#065f46",
          900: "#064e3b",
          950: "#022c22"
        }
      },
      {
        name: "green",
        palette: {
          50: "#f0fdf4",
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#22c55e",
          600: "#16a34a",
          700: "#15803d",
          800: "#166534",
          900: "#14532d",
          950: "#052e16"
        }
      },
      {
        name: "lime",
        palette: {
          50: "#f7fee7",
          100: "#ecfccb",
          200: "#d9f99d",
          300: "#bef264",
          400: "#a3e635",
          500: "#84cc16",
          600: "#65a30d",
          700: "#4d7c0f",
          800: "#3f6212",
          900: "#365314",
          950: "#1a2e05"
        }
      },
      {
        name: "orange",
        palette: {
          50: "#fff7ed",
          100: "#ffedd5",
          200: "#fed7aa",
          300: "#fdba74",
          400: "#fb923c",
          500: "#f97316",
          600: "#ea580c",
          700: "#c2410c",
          800: "#9a3412",
          900: "#7c2d12",
          950: "#431407"
        }
      },
      {
        name: "amber",
        palette: {
          50: "#fffbeb",
          100: "#fef3c7",
          200: "#fde68a",
          300: "#fcd34d",
          400: "#fbbf24",
          500: "#f59e0b",
          600: "#d97706",
          700: "#b45309",
          800: "#92400e",
          900: "#78350f",
          950: "#451a03"
        }
      },
      {
        name: "yellow",
        palette: {
          50: "#fefce8",
          100: "#fef9c3",
          200: "#fef08a",
          300: "#fde047",
          400: "#facc15",
          500: "#eab308",
          600: "#ca8a04",
          700: "#a16207",
          800: "#854d0e",
          900: "#713f12",
          950: "#422006"
        }
      },
      {
        name: "teal",
        palette: {
          50: "#f0fdfa",
          100: "#ccfbf1",
          200: "#99f6e4",
          300: "#5eead4",
          400: "#2dd4bf",
          500: "#14b8a6",
          600: "#0d9488",
          700: "#0f766e",
          800: "#115e59",
          900: "#134e4a",
          950: "#042f2e"
        }
      },
      {
        name: "cyan",
        palette: {
          50: "#ecfeff",
          100: "#cffafe",
          200: "#a5f3fc",
          300: "#67e8f9",
          400: "#22d3ee",
          500: "#06b6d4",
          600: "#0891b2",
          700: "#0e7490",
          800: "#155e75",
          900: "#164e63",
          950: "#083344"
        }
      },
      {
        name: "sky",
        palette: {
          50: "#f0f9ff",
          100: "#e0f2fe",
          200: "#bae6fd",
          300: "#7dd3fc",
          400: "#38bdf8",
          500: "#0ea5e9",
          600: "#0284c7",
          700: "#0369a1",
          800: "#075985",
          900: "#0c4a6e",
          950: "#082f49"
        }
      },
      {
        name: "blue",
        palette: {
          50: "#eff6ff",
          100: "#dbeafe",
          200: "#bfdbfe",
          300: "#93c5fd",
          400: "#60a5fa",
          500: "#3b82f6",
          600: "#2563eb",
          700: "#1d4ed8",
          800: "#1e40af",
          900: "#1e3a8a",
          950: "#172554"
        }
      },
      {
        name: "indigo",
        palette: {
          50: "#eef2ff",
          100: "#e0e7ff",
          200: "#c7d2fe",
          300: "#a5b4fc",
          400: "#818cf8",
          500: "#6366f1",
          600: "#4f46e5",
          700: "#4338ca",
          800: "#3730a3",
          900: "#312e81",
          950: "#1e1b4b"
        }
      },
      {
        name: "violet",
        palette: {
          50: "#f5f3ff",
          100: "#ede9fe",
          200: "#ddd6fe",
          300: "#c4b5fd",
          400: "#a78bfa",
          500: "#8b5cf6",
          600: "#7c3aed",
          700: "#6d28d9",
          800: "#5b21b6",
          900: "#4c1d95",
          950: "#2e1065"
        }
      },
      {
        name: "purple",
        palette: {
          50: "#faf5ff",
          100: "#f3e8ff",
          200: "#e9d5ff",
          300: "#d8b4fe",
          400: "#c084fc",
          500: "#a855f7",
          600: "#9333ea",
          700: "#7e22ce",
          800: "#6b21a8",
          900: "#581c87",
          950: "#3b0764"
        }
      },
      {
        name: "fuchsia",
        palette: {
          50: "#fdf4ff",
          100: "#fae8ff",
          200: "#f5d0fe",
          300: "#f0abfc",
          400: "#e879f9",
          500: "#d946ef",
          600: "#c026d3",
          700: "#a21caf",
          800: "#86198f",
          900: "#701a75",
          950: "#4a044e"
        }
      },
      {
        name: "pink",
        palette: {
          50: "#fdf2f8",
          100: "#fce7f3",
          200: "#fbcfe8",
          300: "#f9a8d4",
          400: "#f472b6",
          500: "#ec4899",
          600: "#db2777",
          700: "#be185d",
          800: "#9d174d",
          900: "#831843",
          950: "#500724"
        }
      },
      {
        name: "rose",
        palette: {
          50: "#fff1f2",
          100: "#ffe4e6",
          200: "#fecdd3",
          300: "#fda4af",
          400: "#fb7185",
          500: "#f43f5e",
          600: "#e11d48",
          700: "#be123c",
          800: "#9f1239",
          900: "#881337",
          950: "#4c0519"
        }
      }
    ]);
    L([
      {
        name: "slate",
        palette: {
          0: "#ffffff",
          50: "#f8fafc",
          100: "#f1f5f9",
          200: "#e2e8f0",
          300: "#cbd5e1",
          400: "#94a3b8",
          500: "#64748b",
          600: "#475569",
          700: "#334155",
          800: "#1e293b",
          900: "#0f172a",
          950: "#020617"
        }
      },
      {
        name: "gray",
        palette: {
          0: "#ffffff",
          50: "#f9fafb",
          100: "#f3f4f6",
          200: "#e5e7eb",
          300: "#d1d5db",
          400: "#9ca3af",
          500: "#6b7280",
          600: "#4b5563",
          700: "#374151",
          800: "#1f2937",
          900: "#111827",
          950: "#030712"
        }
      },
      {
        name: "zinc",
        palette: {
          0: "#ffffff",
          50: "#fafafa",
          100: "#f4f4f5",
          200: "#e4e4e7",
          300: "#d4d4d8",
          400: "#a1a1aa",
          500: "#71717a",
          600: "#52525b",
          700: "#3f3f46",
          800: "#27272a",
          900: "#18181b",
          950: "#09090b"
        }
      },
      {
        name: "neutral",
        palette: {
          0: "#ffffff",
          50: "#fafafa",
          100: "#f5f5f5",
          200: "#e5e5e5",
          300: "#d4d4d4",
          400: "#a3a3a3",
          500: "#737373",
          600: "#525252",
          700: "#404040",
          800: "#262626",
          900: "#171717",
          950: "#0a0a0a"
        }
      },
      {
        name: "stone",
        palette: {
          0: "#ffffff",
          50: "#fafaf9",
          100: "#f5f5f4",
          200: "#e7e5e4",
          300: "#d6d3d1",
          400: "#a8a29e",
          500: "#78716c",
          600: "#57534e",
          700: "#44403c",
          800: "#292524",
          900: "#1c1917",
          950: "#0c0a09"
        }
      },
      {
        name: "soho",
        palette: {
          0: "#ffffff",
          50: "#f4f4f4",
          100: "#e8e9e9",
          200: "#d2d2d4",
          300: "#bbbcbe",
          400: "#a5a5a9",
          500: "#8e8f93",
          600: "#77787d",
          700: "#616268",
          800: "#4a4b52",
          900: "#34343d",
          950: "#1d1e27"
        }
      },
      {
        name: "viva",
        palette: {
          0: "#ffffff",
          50: "#f3f3f3",
          100: "#e7e7e8",
          200: "#cfd0d0",
          300: "#b7b8b9",
          400: "#9fa1a1",
          500: "#87898a",
          600: "#6e7173",
          700: "#565a5b",
          800: "#3e4244",
          900: "#262b2c",
          950: "#0e1315"
        }
      },
      {
        name: "ocean",
        palette: {
          0: "#ffffff",
          50: "#fbfcfc",
          100: "#F7F9F8",
          200: "#EFF3F2",
          300: "#DADEDD",
          400: "#B1B7B6",
          500: "#828787",
          600: "#5F7274",
          700: "#415B61",
          800: "#29444E",
          900: "#183240",
          950: "#0c1920"
        }
      }
    ]);
    function s() {
      const l = a.value.find((c) => c.name === t.primary);
      return (l == null ? void 0 : l.name) === "noir" ? {
        semantic: {
          primary: {
            50: "{surface.50}",
            100: "{surface.100}",
            200: "{surface.200}",
            300: "{surface.300}",
            400: "{surface.400}",
            500: "{surface.500}",
            600: "{surface.600}",
            700: "{surface.700}",
            800: "{surface.800}",
            900: "{surface.900}",
            950: "{surface.950}"
          },
          colorScheme: {
            light: {
              primary: {
                color: "{primary.950}",
                contrastColor: "#ffffff",
                hoverColor: "{primary.800}",
                activeColor: "{primary.700}"
              },
              highlight: {
                background: "{primary.950}",
                focusBackground: "{primary.700}",
                color: "#ffffff",
                focusColor: "#ffffff"
              }
            },
            dark: {
              primary: {
                color: "{primary.50}",
                contrastColor: "{primary.950}",
                hoverColor: "{primary.200}",
                activeColor: "{primary.300}"
              },
              highlight: {
                background: "{primary.50}",
                focusBackground: "{primary.300}",
                color: "{primary.950}",
                focusColor: "{primary.950}"
              }
            }
          }
        }
      } : {
        semantic: {
          primary: l == null ? void 0 : l.palette,
          colorScheme: {
            light: {
              primary: {
                color: "{primary.500}",
                contrastColor: "#ffffff",
                hoverColor: "{primary.600}",
                activeColor: "{primary.700}"
              },
              highlight: {
                background: "{primary.50}",
                focusBackground: "{primary.100}",
                color: "{primary.700}",
                focusColor: "{primary.800}"
              }
            },
            dark: {
              primary: {
                color: "{primary.400}",
                contrastColor: "{surface.900}",
                hoverColor: "{primary.300}",
                activeColor: "{primary.200}"
              },
              highlight: {
                background: "color-mix(in srgb, {primary.400}, transparent 84%)",
                focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)",
                color: "rgba(255,255,255,.87)",
                focusColor: "rgba(255,255,255,.87)"
              }
            }
          }
        }
      };
    }
    function o(l, c) {
      n(c.name), i();
    }
    function i(l, c) {
      Hf(s());
    }
    const r = L({
      root: {
        border: {
          radius: "50% !important"
        }
      }
    });
    return (l, c) => (ne("SelectButton"), y(), M("div", bx, [
      b("div", null, [
        w(k(cn), { class: "p-2 pt-4 pb-1 items-center gap-2" }, {
          default: T(() => [
            (y(!0), M(fe, null, He(a.value, (u) => (y(), G(k(gn), {
              key: u.name,
              rounded: "",
              onClick: (p) => o("primary", u),
              class: J([
                "cursor-pointer w-6 h-6 rounded-full flex flex-shrink-0 items-center justify-center p-0 outline-none outline-offset-1",
                { "outline-primary": k(t).primary === u.name }
              ]),
              dt: r.value,
              style: Se({
                width: "1.5rem !important",
                height: "1.5rem !important",
                backgroundColor: `${u.name === "noir" ? "var(--text-color)" : u.palette[500]}`,
                borderColor: `${u.name === "noir" ? "var(--text-color)" : u.palette[500]}`
              })
            }, null, 8, ["onClick", "class", "dt", "style"]))), 128))
          ]),
          _: 1
        })
      ]),
      W("", !0)
    ]));
  }
}), xx = {}, yx = { class: "flex grow" };
function Ex(e, t) {
  return y(), M("div", yx, [
    q(e.$slots, "default")
  ]);
}
const On = /* @__PURE__ */ le(xx, [["render", Ex]]), Cx = {}, Bx = { class: "flex flex-col" };
function Ix(e, t) {
  return y(), M("div", Bx, [
    q(e.$slots, "default")
  ]);
}
const ma = /* @__PURE__ */ le(Cx, [["render", Ix]]), wx = {}, kx = { class: "flex flex-row-wrap w-full" };
function _x(e, t) {
  return y(), M("div", kx, [
    q(e.$slots, "default")
  ]);
}
const cn = /* @__PURE__ */ le(wx, [["render", _x]]), Wu = /* @__PURE__ */ Y({
  __name: "UserSettingsDialog",
  setup(e) {
    const t = L(!1);
    return (n, a) => (y(), G(ma, { class: "gap-16px" }, {
      default: T(() => [
        w(k(kl), {
          header: n.$t("medic-web-framework.theme"),
          isCollapsed: t.value,
          "onUpdate:isCollapsed": a[0] || (a[0] = (s) => t.value = s)
        }, {
          default: T(() => [
            w(Qi)
          ]),
          _: 1
        }, 8, ["header", "isCollapsed"]),
        w(k(kl), {
          header: n.$t("medic-web-framework.language"),
          isCollapsed: t.value,
          "onUpdate:isCollapsed": a[1] || (a[1] = (s) => t.value = s)
        }, {
          default: T(() => [
            w(cn, { class: "rg-panel mt-4" }, {
              default: T(() => [
                w(Fi)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["header", "isCollapsed"])
      ]),
      _: 1
    }));
  }
}), Sx = { class: "p-12px" }, Tx = { class: "top-nav-bar flex items-center" }, Lx = ["src"], Dx = { class: "p-12px" }, Mx = { class: "top-nav-bar flex items-center" }, Ox = ["src"], Nx = { key: 0 }, Rx = {
  key: 0,
  class: "gap-3",
  style: { display: "flex", "justify-content": "space-between", "align-items": "center", padding: "0.75rem 1rem" }
}, Px = { style: { display: "flex" } }, Fx = { class: "wiz-project-name" }, Qx = { class: "navbar-project-meta-label" }, Ux = { class: "navbar-project-meta-value" }, Yx = { class: "navbar-project-meta-label" }, Gx = { class: "navbar-project-meta-value" }, jx = ["src"], Hx = { class: "wiz-project-name" }, Vx = { key: 0 }, Kx = { class: "p-card-title text-xl font-bold" }, Wx = { class: "grid w-full" }, zx = { key: 0 }, $x = ["src"], Jx = {
  key: 0,
  class: "topbar-dropdown-label"
}, qx = ["onClick"], Xx = ["src"], Zx = ["src"], ey = ["onClick"], ty = ["src"], ny = /* @__PURE__ */ Y({
  __name: "RgGlobalNavbar",
  setup(e) {
    const t = Jl(), { t: n } = pn(), a = L(!1), s = L([]), o = L([]), i = L(""), r = L(!1), l = L(!1), c = L(""), u = L(null), p = L(!1), m = L(!1), v = L(), A = L(), h = L(!1), d = L(), f = L(""), g = L(""), B = L(""), E = L(!1), _ = L(null), O = L(!1), S = L(), H = L(!1), z = L(!1), X = L([]), re = L(!1), se = L(""), ve = L(!1), Re = L(""), Z = L(), ce = L(), be = L(!1), gt = fu(), Ue = L(), Pe = L(), Ye = L([
      // ButtonEnum.SAVE,
      U.SAVE_AS,
      U.RESET,
      U.LAYOUT,
      U.SCREENSHOT,
      U.W_L,
      U.RULER,
      U.ADD_PATIENT,
      U.ADD_DOCTOR,
      U.NOTIFICATIONS,
      U.MATERIAL_LIBRARY,
      U.INSPECT,
      r.value ? "" : U.SETTINGS,
      r.value ? "" : U.PC_SETTINGS
    ]), Je = L([
      U.PC_LIST,
      U.RG_WEB,
      U.PROFILE,
      U.USER_SETTINGS,
      U.LOGOUT,
      U.UNDO,
      U.REDO,
      U.INFO,
      r.value ? U.SETTINGS : "",
      U.HELP,
      U.SUPPORT,
      U.EXIT
    ]), Ke = L([]), tt = F(() => typeof navigator > "u" ? !1 : /Android.*Mobile|iPhone|iPod|Windows Phone|IEMobile|BlackBerry|Opera Mini/i.test(navigator.userAgent)), st = F(() => !tt.value), Dt = F(() => gt.isMobileView);
    function Mt(C, Q) {
      const ae = new Set(Q);
      return C.filter((me) => ae.has(me));
    }
    we.on(It.SHOW_ONLY_LOGO, () => {
      a.value = !1, p.value = !0;
    }), we.on(It.TOGGLE_CAD_MODE, (C) => {
      if (console.log("Toggle cad mode in navbar", C.flag), re.value = C.flag, re.value) {
        const Q = Ye.value.findIndex((ae) => ae === U.SCREENSHOT);
        Q !== -1 && Ye.value.splice(Q, 1);
      } else
        Ye.value.push(U.SCREENSHOT);
    }), we.on(It.SHOW_UNVERIFIED_ADDRESS, (C) => {
      var ae;
      const Q = typeof C.flag == "boolean" ? C.flag : !!((ae = C.flag) != null && ae.flag);
      be.value = Q;
    }), we.on(It.SHOW_NAVBAR, (C) => {
      s.value = C.options.buttons ?? [], o.value = Mt(Ye.value, C.options.buttons ?? []), i.value = C.options.username ?? "", c.value = C.options.buildId ?? "", se.value = C.options.pcName ?? "", ve.value = C.options.isElearningEnabled ?? C.options.isElarningEnabled ?? !1, Re.value = C.options.elearningURL ?? "", r.value = C.options.isWizard ?? !1, l.value = C.options.showZimvieLogo ?? !1, m.value = C.options.showNavbarPosition ?? !1, v.value = C.options.pcStatuses, A.value = C.options.userStatuses ?? [], H.value = C.options.userChatNotifications, z.value = C.options.hasPcSettingsAccess ?? !1, C.options.showDoctors !== void 0 && (O.value = !1), S.value = C.options.showDoctors, h.value = C.options.showMeasurementUnit ?? !1, C.options.showMeasurementUnit && (d.value = C.options.measurementUnit), r.value ? (Je.value.push(U.SETTINGS), Ye.value = Ye.value.filter((Q) => Q !== U.SETTINGS)) : (Ye.value.push(U.SETTINGS), Je.value = Je.value.filter((Q) => Q !== U.SETTINGS)), i.value == "test_admin_1" && Je.value.push(U.TESTING_VIEW), a.value = !0;
    }), we.on(It.HIDE_NAVBAR, () => {
      a.value = !1, p.value = !1;
    }), we.on(It.UPDATE_NAVBAR, (C) => {
      s.value = C.options.buttons ?? [], a.value = !0;
    }), we.on(It.ENABLE_NAVBAR_BUTTONS, (C) => {
      C.options.forEach((Q) => {
        Ke.value = Ke.value.filter((ae) => ae !== Q);
      });
    }), we.on(It.DISABLE_NAVBAR_BUTTONS, (C) => {
      C.options.forEach((Q) => {
        Ke.value.push(Q);
      });
    }), we.on(It.ADD_TOOLTIPS, (C) => {
      C.options.forEach((Q) => {
        Q.tooltip && (u.value = { [Q.button]: Q.tooltip });
      });
    }), we.on(It.SHOW_PROJECT_NAME, (C) => {
      if (typeof C.options == "string") {
        f.value = C.options, g.value = "", B.value = "", E.value = !1, _.value = null;
        return;
      }
      f.value = C.options.projectName ?? "", g.value = C.options.caseId ?? "", B.value = C.options.user ?? "", E.value = C.options.hasUnverifiedAddressWarning ?? !1, be.value = C.options.hasUnverifiedAddressWarning ?? !1, _.value = C.options.unverifiedAddressUserId ?? null;
    });
    function ot(C) {
      return C.split("_").map((me, it) => it === 0 ? me.toLowerCase() : me.charAt(0).toUpperCase() + me.slice(1).toLowerCase()).join("");
    }
    function Et(C) {
      return C === U.PC_LIST && se.value === "" ? "shared.weblink" : `shared.${ot(U[C].toString())}`;
    }
    async function Jt(C) {
      we.emit(zn.NAVBAR_BUTTON_CLICKED, C);
    }
    function qt() {
      _.value !== null && we.emit(zn.PROJECT_UNVERIFIED_ADDRESS_CLICKED, _.value);
    }
    function Mn() {
      t.open(Wu, {
        props: {
          closable: !0,
          modal: !0,
          header: Ce("shared.settings"),
          style: { width: "60vw", minHeight: "70vh", maxHeight: "95vh" }
        }
      });
    }
    const pe = (C) => {
      var Q, ae;
      if (C === U.E_LEARNING) {
        const me = Re.value.trim();
        me.length > 0 && window.open(me, "_blank", "noopener,noreferrer");
        return;
      }
      if (Jt(C), C === U.RULER) {
        const me = Ue.value;
        me && event && me[0].toggle(event);
      } else if (C == U.RULER_DISTANCE || C == U.RULER_ANGLE || C == U.RULER_ANNOTATION || C == U.RULER_ROI || C == U.RULER_CLEAR) {
        const me = Ue.value;
        me && event && me[0].toggle(event);
      } else C === U.PROFILE ? Mn() : C === U.W_L ? (Q = document.getElementById("btn_w_l")) == null || Q.classList.toggle("btn-clicked") : C === U.INFO ? (ae = document.getElementById("btn_info")) == null || ae.classList.toggle("btn-clicked") : C === U.DISTANCE_UNIT_MM ? d.value = ya.Mm : C === U.DISTANCE_UNIT_INCH && (d.value = ya.Inch);
    }, Xt = F(() => re.value ? [
      {
        id: "plane",
        label: Ce("implant-planner.plane"),
        command: () => {
          pe(U.RULER_PLANE);
        }
      },
      {
        id: "sphere",
        label: Ce("implant-planner.sphere"),
        command: () => {
          pe(U.RULER_SPHERE);
        }
      },
      {
        id: "tetrahedron",
        label: Ce("implant-planner.tetrahedron"),
        command: () => {
          pe(U.RULER_TETRAHEDRON);
        }
      },
      {
        id: "ruler_distance",
        label: Ce("shared.distance"),
        command: () => {
          pe(U.RULER_DISTANCE);
        }
      },
      {
        id: "ruler_angle",
        label: Ce("shared.angle"),
        command: () => {
          pe(U.RULER_ANGLE);
        }
      },
      {
        id: "landmark",
        label: Ce("implant-planner.landmark"),
        command: () => {
          pe(U.RULER_LANDMARK);
        }
      },
      {
        id: "ruler_annotation",
        label: Ce("shared.rulerAnnotation"),
        command: () => {
          pe(U.RULER_ANNOTATION);
        }
      },
      {
        id: "ruler_roi",
        label: Ce("shared.roi"),
        command: () => {
          pe(U.RULER_ROI);
        }
      },
      {
        id: "ruler_clear",
        label: Ce("shared.rulerClear"),
        command: () => {
          pe(U.RULER_CLEAR);
        }
      },
      {
        id: "ruler_clear",
        label: Ce("implant-planner.clearAllExceptAnnotation"),
        command: () => {
          pe(U.RULER_CLEAR_EXCEPT);
        }
      }
    ] : [
      {
        id: "ruler_distance",
        label: Ce("shared.distance"),
        command: () => {
          pe(U.RULER_DISTANCE);
        }
      },
      {
        id: "ruler_angle",
        label: Ce("shared.angle"),
        command: () => {
          pe(U.RULER_ANGLE);
        }
      },
      {
        id: "ruler_annotation",
        label: Ce("shared.rulerAnnotation"),
        command: () => {
          pe(U.RULER_ANNOTATION);
        }
      },
      {
        id: "ruler_roi",
        label: Ce("shared.roi"),
        command: () => {
          pe(U.RULER_ROI);
        }
      },
      {
        id: "ruler_clear",
        label: Ce("shared.rulerClear"),
        command: () => {
          pe(U.RULER_CLEAR);
        }
      }
    ]), Ct = F(() => {
      var C;
      return v.value ? ((C = v.value) == null ? void 0 : C.length) > 0 : !1;
    }), Ot = F(() => !r.value && (g.value.length > 0 || B.value.length > 0)), Zt = F(() => {
      var ae, me, it;
      let C = L(
        (ae = A.value) == null ? void 0 : ae.filter(function(We) {
          return We != "";
        })
      );
      const Q = (me = v.value) == null ? void 0 : me.map((We) => ({
        ...We,
        selected: !1
      }));
      return Q && ((it = C.value) == null || it.forEach((We) => {
        Q[Q.findIndex((Bt) => Bt.name == We)].selected = !0;
      })), Q;
    }), x = async (C) => {
      var Q, ae, me;
      if (C.selected)
        (Q = A.value) == null || Q.push(C.name), we.emit(zn.USER_EMAIL_NOTIFICATION_CLICKED, A.value);
      else {
        let it = (ae = A.value) == null ? void 0 : ae.findIndex((We) => We == C.name);
        it && ((me = A.value) == null || me.splice(it, 1), we.emit(zn.USER_EMAIL_NOTIFICATION_CLICKED, A.value));
      }
    }, I = async (C) => {
      H.value = C, we.emit(zn.USER_CHAT_EMAIL_NOTIFICATION_CLICKED, H.value);
    }, N = async () => {
      await Jt(U.SHOW_DOCTOR_PATIENT_LIST);
    }, V = F(() => ve.value && Re.value.trim().length > 0), xe = F(() => {
      const C = [
        {
          label: n("shared.videoTutorial"),
          icon: "icon_top_nav_video_tutorial",
          button: U.VIDEO_TUTORIAL
        }
      ];
      return V.value && C.push({
        label: n("shared.eLearning"),
        icon: "icon_top_nav_e_learning",
        button: U.E_LEARNING
      }), s.value.includes(U.OPEN_TICKET) && C.push({
        label: n("shared.openTicket"),
        icon: "icon_top_nav_open_ticket",
        button: U.OPEN_TICKET
      }), s.value.includes(U.REMOTE_SUPPORT) && C.push({
        label: n("shared.remoteSupport"),
        icon: "icon_top_nav_remote_support",
        button: U.REMOTE_SUPPORT
      }), C;
    }), Ie = (C) => {
      ce.value[0].toggle(C);
    }, ie = F(() => {
      if (r.value)
        return [
          {
            items: [
              {
                label: n("shared.exit"),
                icon: "icon_top_nav_logout",
                button: U.EXIT
              }
            ]
          }
        ];
      const C = [
        {
          label: n("shared.userAccount"),
          icon: "rg_profile_info",
          button: U.PROFILE_INFO
        },
        {
          label: n("shared.resetPassword"),
          icon: "rg_reset_password",
          button: U.RESET_PASSWORD
        },
        {
          label: n("shared.settings"),
          icon: "settings_white",
          button: U.USER_SETTINGS
        },
        {
          label: n("shared.logout"),
          icon: "icon_top_nav_logout",
          button: U.LOGOUT
        }
      ];
      return z.value && C.splice(3, 0, {
        label: n("shared.pcSettings"),
        icon: "settings_white",
        button: U.PC_SETTINGS
      }), [
        {
          items: C
        }
      ];
    }), D = (C) => {
      Z.value[0].toggle(C);
    };
    return Ne(() => {
      Dp();
    }), (C, Q) => {
      const ae = ne("TieredMenu"), me = ne("AccordionTab"), it = ne("Accordion"), We = ne("Menu"), Bt = Sa("tooltip"), $a = Sa("ripple");
      return y(), M(fe, null, [
        Qt(b("div", Sx, [
          b("nav", Tx, [
            w(te, { class: "flex-row grow align-center items-center" }, {
              default: T(() => [
                w(te, { class: "justify-center items-center w-full" }, {
                  default: T(() => [
                    b("a", {
                      id: "logoContainer",
                      class: "cursor-pointer logo-wrapper flex items-center",
                      style: Se(tt.value ? "width: 90px !important" : ""),
                      onClick: Q[0] || (Q[0] = (ue) => pe(k(U).RG_LOGO))
                    }, [
                      b("img", {
                        alt: "RG Logo",
                        src: k(bo)("rg_logo_official"),
                        class: "object-contain",
                        draggable: "false"
                      }, null, 8, Lx)
                    ], 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 512), [
          [vo, p.value && !a.value]
        ]),
        Qt(b("div", Dx, [
          b("nav", Mx, [
            w(te, {
              class: J(["flex-row grow align-center items-center", { "ml-3": !Dt.value }])
            }, {
              default: T(() => [
                w(te, { class: "gap-8 justify-start" }, {
                  default: T(() => [
                    b("a", {
                      id: "navbar_rg_logo",
                      class: "cursor-pointer logo-wrapper flex items-center",
                      style: Se(tt.value ? "width: 90px !important" : ""),
                      onClick: Q[1] || (Q[1] = (ue) => pe(k(U).RG_LOGO))
                    }, [
                      b("img", {
                        alt: "RG Logo",
                        src: k(bo)("rg_logo_official"),
                        class: "object-contain",
                        draggable: "false",
                        style: { "max-height": "40px !important" }
                      }, null, 8, Ox)
                    ], 4)
                  ]),
                  _: 1
                }),
                w(te, {
                  class: "justify-start gap-2 pl-4",
                  style: { flex: "1 1 0" }
                }, {
                  default: T(() => [
                    (y(!0), M(fe, null, He(o.value, (ue) => (y(), M(fe, { key: ue }, [
                      Ye.value.includes(ue) ? (y(), M("a", Nx, [
                        w(ds, {
                          class: "padding-top-nav",
                          id: `btn_${k(U)[ue].toLowerCase()}`,
                          icon: `icon_top_nav_${k(U)[ue].toLowerCase()}`,
                          iconPos: k(hn).TOP,
                          iconType: k(de).TOP_NAVBAR_ICON,
                          disabled: Ke.value.includes(ue),
                          tooltipBottom: C.$t(Et(ue)),
                          onClick: (Fe) => pe(ue)
                        }, null, 8, ["id", "icon", "iconPos", "iconType", "disabled", "tooltipBottom", "onClick"]),
                        k(U)[ue].toLowerCase() === "ruler" ? (y(), G(k(La), {
                          key: 0,
                          id: "overlay_ruler_panel",
                          ref_for: !0,
                          ref_key: "opRuler",
                          ref: Ue,
                          showCloseIcon: !1,
                          appendTo: "body",
                          style: { "max-width": "350px" }
                        }, {
                          default: T(() => [
                            w(ae, { model: Xt.value }, null, 8, ["model"]),
                            h.value ? (y(), M("div", Rx, [
                              ke(R(C.$t("shared.measurementUnit")) + " ", 1),
                              b("div", Px, [
                                (y(), G(k(gn), {
                                  class: "h-2-2rem",
                                  key: d.value,
                                  disabled: d.value == k(ya).Mm,
                                  label: C.$t("shared.mm"),
                                  onClick: Q[2] || (Q[2] = (Fe) => pe(k(U).DISTANCE_UNIT_MM))
                                }, null, 8, ["disabled", "label"])),
                                (y(), G(k(gn), {
                                  class: "h-2-2rem",
                                  key: d.value,
                                  disabled: d.value == k(ya).Inch,
                                  label: C.$t("shared.in"),
                                  style: { "margin-left": "0.25rem" },
                                  onClick: Q[3] || (Q[3] = (Fe) => pe(k(U).DISTANCE_UNIT_INCH))
                                }, null, 8, ["disabled", "label"]))
                              ])
                            ])) : W("", !0)
                          ]),
                          _: 1
                        }, 512)) : W("", !0)
                      ])) : W("", !0)
                    ], 64))), 128))
                  ]),
                  _: 1
                }),
                r.value && !se.value ? (y(), G(te, {
                  key: 0,
                  title: f.value,
                  style: { cursor: "pointer", "justify-content": "center", flex: "1 1 0", "min-width": "0" }
                }, {
                  default: T(() => [
                    b("span", Fx, R(f.value), 1)
                  ]),
                  _: 1
                }, 8, ["title"])) : (y(), G(ma, {
                  key: 1,
                  class: "justify-center items-center centered-x",
                  style: { cursor: "pointer", flex: "1 1 0", "min-width": "0" }
                }, {
                  default: T(() => [
                    Ot.value ? (y(), G(cn, {
                      key: 0,
                      class: "justify-center items-center gap-2 navbar-project-meta-row"
                    }, {
                      default: T(() => [
                        g.value ? (y(), G(te, {
                          key: 0,
                          class: "navbar-project-meta-chip gap-2",
                          title: `${C.$t("weblink.caseId")}: ${g.value}`
                        }, {
                          default: T(() => [
                            b("span", Qx, R(C.$t("weblink.caseId")) + ":", 1),
                            b("span", Ux, R(g.value), 1),
                            Q[8] || (Q[8] = b("span", null, "//", -1))
                          ]),
                          _: 1
                        }, 8, ["title"])) : W("", !0),
                        B.value ? (y(), G(te, {
                          key: 1,
                          class: "navbar-project-meta-chip gap-2",
                          title: `${C.$t("shared.user")}: ${B.value}`
                        }, {
                          default: T(() => [
                            b("span", Yx, R(C.$t("shared.user")) + ":", 1),
                            b("span", Gx, R(B.value), 1),
                            be.value ? Qt((y(), M("img", {
                              key: 0,
                              src: k(vs)("rg_warning"),
                              class: "navbar-project-meta-warning cursor-pointer",
                              onClick: xt(qt, ["stop"])
                            }, null, 8, jx)), [
                              [
                                Bt,
                                C.$t("medic-web-framework.unverifiedUserAddress"),
                                void 0,
                                { bottom: !0 }
                              ]
                            ]) : W("", !0)
                          ]),
                          _: 1
                        }, 8, ["title"])) : W("", !0)
                      ]),
                      _: 1
                    })) : W("", !0),
                    r.value ? (y(), G(cn, {
                      key: 1,
                      class: "justify-center"
                    }, {
                      default: T(() => [
                        b("span", Hx, R(f.value), 1)
                      ]),
                      _: 1
                    })) : W("", !0)
                  ]),
                  _: 1
                })),
                w(te, {
                  class: "justify-end",
                  style: { flex: "1 1 0" }
                }, {
                  default: T(() => [
                    Q[12] || (Q[12] = b("div", { class: "grid flex-column align-center mr-3 top-navbar-hide-sm" }, null, -1)),
                    r.value ? (y(), G(te, {
                      key: 0,
                      class: "align-center gap-2 mr-3",
                      style: { flex: "3 1 0", "justify-content": "end" }
                    }, {
                      default: T(() => [
                        (y(!0), M(fe, null, He(s.value, (ue) => (y(), M(fe, { key: ue }, [
                          Je.value.includes(ue) ? (y(), M("a", Vx, [
                            w(ds, {
                              class: "padding-top-nav",
                              id: `btn_${k(U)[ue].toLowerCase()}`,
                              icon: `icon_top_nav_${k(U)[ue].toLowerCase()}`,
                              iconPos: k(hn).TOP,
                              iconType: k(de).TOP_NAVBAR_ICON,
                              disabled: Ke.value.includes(ue),
                              tooltipBottom: C.$t(Et(ue)),
                              onClick: (Fe) => pe(ue)
                            }, null, 8, ["id", "icon", "iconPos", "iconType", "disabled", "tooltipBottom", "onClick"]),
                            k(U)[ue].toLowerCase() == "profile" || k(U)[ue].toLowerCase() == "user_settings" ? (y(), G(k(La), {
                              key: 0,
                              id: "overlay_profile_panel",
                              ref_for: !0,
                              ref_key: "opProfile",
                              ref: Pe,
                              showCloseIcon: !0,
                              appendTo: "body",
                              class: "all-radius w-3/12 md:w-4/12 sm:w-5/12"
                            }, {
                              default: T(() => [
                                b("div", Kx, R(C.$t("shared.userSettings")), 1),
                                w(it, {
                                  "active-index": 0,
                                  class: "mt-2"
                                }, {
                                  default: T(() => [
                                    Ct.value ? (y(), G(me, {
                                      key: 0,
                                      header: C.$t("shared.notifications")
                                    }, {
                                      default: T(() => [
                                        w(II, {
                                          "status-list": Zt.value,
                                          "onUpdate:statusList": Q[4] || (Q[4] = (Fe) => Zt.value = Fe),
                                          "email-chat-notification": H.value,
                                          "onUpdate:emailChatNotification": Q[5] || (Q[5] = (Fe) => H.value = Fe),
                                          "email-status-notification": X.value,
                                          "onUpdate:emailStatusNotification": Q[6] || (Q[6] = (Fe) => X.value = Fe),
                                          onUpdateStatusNotification: x,
                                          onUpdateEmailChatNotification: I
                                        }, null, 8, ["status-list", "email-chat-notification", "email-status-notification"])
                                      ]),
                                      _: 1
                                    }, 8, ["header"])) : W("", !0),
                                    w(me, {
                                      header: C.$t("medic-web-framework.theme")
                                    }, {
                                      default: T(() => [
                                        w(Qi, { showOnlyColors: !1 })
                                      ]),
                                      _: 1
                                    }, 8, ["header"]),
                                    w(me, {
                                      header: C.$t("medic-web-framework.language")
                                    }, {
                                      default: T(() => [
                                        w(Fi)
                                      ]),
                                      _: 1
                                    }, 8, ["header"]),
                                    O.value ? (y(), G(me, {
                                      key: 1,
                                      header: C.$t("medic-web-framework.patientListSettings")
                                    }, {
                                      default: T(() => [
                                        w(te, { class: "w-full status-step-container" }, {
                                          default: T(() => [
                                            b("div", Wx, [
                                              w(te, { class: "flex-row w-full mt-4" }, {
                                                default: T(() => [
                                                  w(On, { class: "gap-2" }, {
                                                    default: T(() => [
                                                      Q[9] || (Q[9] = b("span", { class: "flex pi pi-users align-center" }, null, -1)),
                                                      b("span", null, R(C.$t("medic-web-framework.showDoctorsOnPatientList")), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  w(te, null, {
                                                    default: T(() => [
                                                      w(ls, {
                                                        id: "switchShowDoctors",
                                                        state: S.value,
                                                        "onUpdate:state": Q[7] || (Q[7] = (Fe) => S.value = Fe),
                                                        onChange: N
                                                      }, null, 8, ["state"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["header"])) : W("", !0)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512)) : W("", !0)
                          ])) : W("", !0)
                        ], 64))), 128))
                      ]),
                      _: 1
                    })) : W("", !0),
                    r.value ? W("", !0) : (y(), G(te, {
                      key: 1,
                      class: "align-center gap-2 mr-2 justify-end",
                      style: { "margin-right": "15px !important", flex: "1 1 0" }
                    }, {
                      default: T(() => [
                        (y(!0), M(fe, null, He(s.value, (ue) => (y(), M(fe, { key: ue }, [
                          Je.value.includes(ue) ? (y(), M("a", zx, [
                            ue === k(U).USER_SETTINGS ? (y(), M(fe, { key: 0 }, [
                              w(k(gn), {
                                type: "button",
                                class: J([
                                  "m-u-button web-rg-navbar-btn w-full navbar-btn p-12px gap-16px topbar-dropdown-trigger",
                                  { "min-w-150px": !tt.value }
                                ]),
                                onClick: D,
                                "aria-haspopup": "true",
                                "aria-controls": "overlay_menu"
                              }, {
                                default: T(() => [
                                  b("img", {
                                    src: k(Ja)("rg_account_circle")
                                  }, null, 8, $x),
                                  st.value ? (y(), M("span", Jx, R(i.value), 1)) : W("", !0),
                                  Q[10] || (Q[10] = b("i", { class: "pi pi-chevron-down" }, null, -1))
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              w(We, {
                                ref_for: !0,
                                ref_key: "menu",
                                ref: Z,
                                id: "overlay_menu",
                                model: ie.value,
                                popup: !0
                              }, {
                                item: T(({ item: Fe }) => {
                                  var Aa;
                                  return [
                                    Qt((y(), M("span", {
                                      class: J(["p-menu-item-rg w-150px gap-16px", { "opacity-50 pointer-events-none": (Aa = Ke.value) == null ? void 0 : Aa.includes(ue) }]),
                                      onClick: (fd) => pe(Fe.button)
                                    }, [
                                      b("img", {
                                        src: k(Ja)(Fe.icon || "")
                                      }, null, 8, Xx),
                                      b("span", null, R(Fe.label), 1)
                                    ], 10, qx)), [
                                      [$a]
                                    ])
                                  ];
                                }),
                                _: 2
                              }, 1032, ["model"])
                            ], 64)) : ue === k(U).HELP ? (y(), M(fe, { key: 1 }, [
                              w(k(gn), {
                                type: "button",
                                class: "m-u-button web-rg-navbar-btn w-full navbar-btn p-12px gap-16px topbar-dropdown-trigger",
                                onClick: Ie,
                                "aria-haspopup": "true",
                                "aria-controls": "overlay_menu"
                              }, {
                                default: T(() => [
                                  b("img", {
                                    src: k(Ja)("icon_top_nav_support")
                                  }, null, 8, Zx),
                                  Q[11] || (Q[11] = b("i", { class: "pi pi-chevron-down" }, null, -1))
                                ]),
                                _: 1
                              }),
                              w(We, {
                                ref_for: !0,
                                ref_key: "menuHelp",
                                ref: ce,
                                id: "overlay_menu",
                                model: xe.value,
                                popup: !0
                              }, {
                                item: T(({ item: Fe }) => {
                                  var Aa;
                                  return [
                                    Qt((y(), M("span", {
                                      class: J(["p-menu-item-rg w-150px gap-16px", { "opacity-50 pointer-events-none": (Aa = Ke.value) == null ? void 0 : Aa.includes(ue) }]),
                                      onClick: (fd) => pe(Fe.button)
                                    }, [
                                      b("img", {
                                        src: k(Ja)(Fe.icon || "")
                                      }, null, 8, ty),
                                      b("span", null, R(Fe.label), 1)
                                    ], 10, ey)), [
                                      [$a]
                                    ])
                                  ];
                                }),
                                _: 2
                              }, 1032, ["model"])
                            ], 64)) : (y(), G(ds, {
                              key: 2,
                              class: "padding-top-nav h-49px topbar-dropdown-trigger",
                              id: `btn_${k(U)[ue].toLowerCase()}`,
                              icon: `icon_top_nav_${k(U)[ue].toLowerCase()}`,
                              iconPos: k(hn).TOP,
                              iconType: k(de).TOP_NAVBAR_ICON,
                              disabled: Ke.value.includes(ue),
                              tooltipBottom: C.$t(Et(ue)),
                              onClick: (Fe) => pe(ue)
                            }, null, 8, ["id", "icon", "iconPos", "iconType", "disabled", "tooltipBottom", "onClick"]))
                          ])) : W("", !0)
                        ], 64))), 128))
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ], 512), [
          [vo, a.value]
        ])
      ], 64);
    };
  }
}), F1 = /* @__PURE__ */ le(ny, [["__scopeId", "data-v-6bb92a57"]]), ay = { class: "text-sm text-gray-500" }, sy = { class: "p-card-title text-xl font-bold" }, Q1 = /* @__PURE__ */ Y({
  __name: "UserProfileDropdown",
  props: {
    username: {},
    usernameModifiers: {}
  },
  emits: ["update:username"],
  setup(e) {
    const t = ye(e, "username"), n = L(), a = (s) => {
      n.value.toggle(s);
    };
    return (s, o) => {
      const i = ne("AccordionTab"), r = ne("Accordion");
      return y(), M(fe, null, [
        w(te, {
          class: "cursor-pointer p-2 h-56 grow",
          style: { border: "1px var(--p-rg-outlined-button-border-color) solid", "border-radius": "16px" },
          onClick: a
        }, {
          default: T(() => [
            w(On, null, {
              default: T(() => [
                w(ma, { class: "ml-2" }, {
                  default: T(() => [
                    b("span", null, R(t.value), 1),
                    b("span", ay, R(t.value) + "@3diemme.it", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            w(te, { class: "align-center mr-4" }, {
              default: T(() => [...o[0] || (o[0] = [
                b("span", { class: "pi pi-chevron-down" }, null, -1)
              ])]),
              _: 1
            })
          ]),
          _: 1
        }),
        w(k(La), {
          id: "popover_profile_panel",
          ref_key: "popoverProfile",
          ref: n,
          showCloseIcon: !0,
          appendTo: "body",
          class: "w-3/12 md:w-4/12 sm:w-5/12"
        }, {
          default: T(() => [
            b("div", sy, R(s.$t("shared.userSettings")), 1),
            w(r, {
              "active-index": 0,
              class: "mt-2"
            }, {
              default: T(() => [
                w(i, {
                  header: s.$t("medic-web-framework.theme")
                }, {
                  default: T(() => [
                    w(Qi, { showOnlyColors: !1 })
                  ]),
                  _: 1
                }, 8, ["header"]),
                w(i, {
                  header: s.$t("medic-web-framework.language")
                }, {
                  default: T(() => [
                    w(Fi)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ], 64);
    };
  }
}), oy = {
  id: "navbar_rg_logo",
  class: "cursor-pointer flex items-center ml-4",
  style: { width: "160px" }
}, iy = ["src"], U1 = /* @__PURE__ */ Y({
  __name: "RgLogoUserDropdown",
  props: {
    username: {},
    usernameModifiers: {}
  },
  emits: ["update:username"],
  setup(e) {
    return ye(e, "username"), (t, n) => (y(), G(te, {
      class: "gap-8 h-56 gap-4-md-screen",
      style: "width: 100%; max-width: 550px !important;"
    }, {
      default: T(() => [
        b("a", oy, [
          b("img", {
            alt: "RG Logo",
            src: k(bo)("rg_logo_official"),
            class: "object-contain w-full",
            draggable: "false"
          }, null, 8, iy)
        ])
      ]),
      _: 1
    }));
  }
}), Y1 = /* @__PURE__ */ Y({
  __name: "UserProfileTemp",
  setup(e) {
    const t = Jl(), n = () => {
      t.open(Wu, {
        props: {
          closable: !0,
          modal: !0,
          header: Ce("shared.settings"),
          style: { width: "60vw", minHeight: "70vh", maxHeight: "95vh" }
        }
      });
    };
    return (a, s) => (y(), G(ds, {
      class: "mt-0 web-rg-icon-btn",
      id: "btn_user_settings",
      icon: "icon_top_nav_user_settings",
      iconPos: k(hn).TOP,
      iconType: k(de).TOP_NAVBAR_ICON,
      onClick: n,
      style: { height: "56px !important", width: "56px !important" }
    }, null, 8, ["iconPos", "iconType"]));
  }
}), G1 = /* @__PURE__ */ Y({
  __name: "MCard",
  props: {
    flex: { type: Boolean }
  },
  setup(e) {
    const t = e, n = F(() => t.flex ? "flex" : "flex-none");
    return (a, s) => (y(), M("div", {
      class: J([[n.value], "card menu-item-tab-background margin-t-30 margin-l-20px"])
    }, [
      q(a.$slots, "default")
    ], 2));
  }
}), j1 = /* @__PURE__ */ Y({
  __name: "MGridItem",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = F(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (y(), M("div", {
      class: J([[n.value], "flex items-center"])
    }, [
      q(a.$slots, "default")
    ], 2));
  }
}), H1 = /* @__PURE__ */ Y({
  __name: "MGridItemCenter",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = F(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (y(), M("div", {
      class: J([[n.value], "flex justify-center items-center"])
    }, [
      q(a.$slots, "default")
    ], 2));
  }
}), V1 = /* @__PURE__ */ Y({
  __name: "MGridItemEnd",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = F(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (y(), M("div", {
      class: J([[n.value], "col flex justify-end items-center"])
    }, [
      q(a.$slots, "default")
    ], 2));
  }
}), ry = {}, ly = {
  class: "col",
  style: { "flex-grow": "10" }
};
function cy(e, t) {
  return y(), M("div", ly, [
    q(e.$slots, "default")
  ]);
}
const K1 = /* @__PURE__ */ le(ry, [["render", cy]]), W1 = /* @__PURE__ */ Y({
  __name: "MGridItemStart",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = F(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (y(), M("div", {
      class: J([[n.value], "flex justify-start items-center"])
    }, [
      q(a.$slots, "default")
    ], 2));
  }
}), z1 = /* @__PURE__ */ Y({
  __name: "MGridRow",
  props: {
    noPadding: { type: Boolean, default: !1 },
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = F(() => t.noPadding ? "grid-nogutter" : ""), a = F(() => t.width > 0 ? "col-" + t.width : "");
    return (s, o) => (y(), M("div", {
      class: J([[n.value, a.value], "flex flex-row-wrap"])
    }, [
      q(s.$slots, "default"),
      q(s.$slots, "item")
    ], 2));
  }
}), uy = {}, dy = { style: { color: "#a5a5a5" } };
function fy(e, t) {
  return y(), M("div", dy, [
    q(e.$slots, "default")
  ]);
}
const $1 = /* @__PURE__ */ le(uy, [["render", fy]]), J1 = /* @__PURE__ */ Y({
  __name: "RgTitle",
  props: {
    sizeClass: { default: "text-4xl" }
  },
  setup(e) {
    const t = e;
    return (n, a) => (y(), M("div", {
      class: J(t.sizeClass)
    }, [
      q(n.$slots, "default")
    ], 2));
  }
}), py = {}, my = { class: "text-xl" };
function Ay(e, t) {
  return y(), M("div", my, [
    q(e.$slots, "default")
  ]);
}
const q1 = /* @__PURE__ */ le(py, [["render", Ay]]);
function Js(e, t, n) {
  const a = (s) => {
    t(s);
  };
  n ? (Ae(n, () => {
    n.value ? document.addEventListener(e, a) : document.removeEventListener(e, a);
  }), n.value && document.addEventListener(e, a)) : Ls(
    () => document.addEventListener(e, a)
  ), wn(
    () => document.removeEventListener(e, a)
  );
}
let os = 0, an;
const zu = () => (an || (an = document.createElement("div"), document.body.append(an)), an), wl = () => an || zu(), gy = () => {
  an == null || an.remove(), an = null;
};
function Ui() {
  return Ls(() => {
    os === 0 && zu(), os++;
  }), wn(() => {
    os--, os === 0 && gy();
  }), {
    getElement: () => wl(),
    createChildElement: () => {
      const n = document.createElement("div");
      return wl().append(n), n;
    }
  };
}
const hy = { class: "modalBackground" }, vy = {
  class: "p-dialog-header",
  style: { "border-top-right-radius": "20px", "border-top-left-radius": "20px" }
}, by = { class: "p-dialog-title" }, xy = { class: "p-dialog-content" }, yy = { class: "p-dialog-footer" }, Kn = /* @__PURE__ */ Y({
  __name: "MModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: { default: "" },
    text: { default: "" },
    onClose: {},
    onClickOutside: {}
  },
  setup(e) {
    const t = e, { visible: n, onClose: a, onClickOutside: s } = at(t), i = Ui().getElement(), r = (c) => {
      var u;
      c.key === "Escape" && ((u = a == null ? void 0 : a.value) == null || u.call(a));
    };
    a != null && a.value && Js("keyup", r, n);
    const l = L(null);
    return s != null && s.value && Hs(
      l,
      () => {
        var c;
        n.value && ((c = s.value) == null || c.call(s));
      },
      n
    ), (c, u) => k(n) ? (y(), G(hd, {
      key: 0,
      to: k(i)
    }, [
      b("div", hy, [
        b("div", {
          ref_key: "modalDiv",
          ref: l,
          class: "p-dialog p-component",
          style: { "user-select": "none" }
        }, [
          b("div", vy, [
            b("span", by, [
              q(c.$slots, "header", {}, () => [
                ke(R(e.header), 1)
              ])
            ]),
            k(a) ? (y(), M("button", {
              key: 0,
              class: "p-dialog-header-icon p-dialog-header-close p-link",
              onClick: u[0] || (u[0] = //@ts-ignore
              (...p) => k(a) && k(a)(...p))
            }, "✕")) : W("", !0)
          ]),
          b("div", xy, [
            q(c.$slots, "default", {}, () => [
              ke(R(e.text), 1)
            ])
          ]),
          b("div", yy, [
            b("div", null, [
              q(c.$slots, "actions")
            ])
          ])
        ], 512)
      ])
    ], 8, ["to"])) : W("", !0);
  }
}), Ey = {}, Cy = {
  class: "p-button p-component p-button-text p-button-outlined",
  style: { display: "flex", "justify-content": "center", "align-items": "center" }
};
function By(e, t) {
  return y(), M("button", Cy, [
    q(e.$slots, "default")
  ]);
}
const Bn = /* @__PURE__ */ le(Ey, [["render", By]]), Iy = { style: { display: "flex", "justify-content": "center" } }, wy = /* @__PURE__ */ Y({
  __name: "MColorPickerModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    defaultColor: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s, defaultColor: o } = at(n), i = L({
      r: o.value[0],
      g: o.value[1],
      b: o.value[2]
    }), r = () => {
      a("confirm", [i.value.r, i.value.g, i.value.b]);
    }, l = () => {
      a("cancel");
    }, c = L(null);
    return Ae(s, async () => {
      var u;
      s.value && (await kn(), (u = c.value) == null || u.$el.focus());
    }), Ne(() => {
      var u;
      s.value && ((u = c.value) == null || u.$el.focus());
    }), (u, p) => {
      const m = ne("font-awesome-icon");
      return y(), G(Kn, {
        onClose: l,
        visible: k(s)
      }, {
        header: T(() => [
          q(u.$slots, "header", {}, () => [
            ke(R(e.header), 1)
          ])
        ]),
        default: T(() => [
          w(k(si), {
            modelValue: i.value,
            "onUpdate:modelValue": p[0] || (p[0] = (v) => i.value = v),
            inline: !0,
            format: "rgb"
          }, null, 8, ["modelValue"])
        ]),
        actions: T(() => [
          b("div", Iy, [
            w(Bn, {
              ref_key: "okButtonRef",
              ref: c,
              onClick: r
            }, {
              default: T(() => [
                w(m, { icon: "check" }),
                ke(" " + R(u.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512),
            w(Bn, { onClick: l }, {
              default: T(() => [
                w(m, { icon: "times" }),
                ke(" " + R(u.$t("shared.cancel")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), ky = { style: { display: "flex", "justify-content": "center" } }, _y = /* @__PURE__ */ Y({
  __name: "MConfirmModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    text: {}
  },
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = at(n), o = () => {
      a(
        "confirm"
        /* CONFIRM */
      );
    }, i = () => {
      a(
        "cancel"
        /* CANCEL */
      );
    }, r = L(null);
    return Ae(s, async () => {
      var l;
      s.value && (await kn(), (l = r.value) == null || l.$el.focus());
    }), Ne(() => {
      var l;
      s.value && ((l = r.value) == null || l.$el.focus());
    }), (l, c) => {
      const u = ne("font-awesome-icon");
      return y(), G(Kn, {
        onClose: i,
        visible: k(s)
      }, {
        header: T(() => [
          q(l.$slots, "header", {}, () => [
            ke(R(e.header), 1)
          ])
        ]),
        default: T(() => [
          q(l.$slots, "default", {}, () => [
            ke(R(e.text), 1)
          ])
        ]),
        actions: T(() => [
          b("div", ky, [
            w(Bn, {
              ref_key: "okButtonRef",
              ref: r,
              onClick: o
            }, {
              default: T(() => [
                w(u, { icon: "check" }),
                ke(" " + R(l.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512),
            w(Bn, { onClick: i }, {
              default: T(() => [
                w(u, { icon: "times" }),
                ke(" " + R(l.$t("shared.cancel")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), Sy = { key: 0 }, Ty = /* @__PURE__ */ Y({
  __name: "MDialog",
  props: {
    modelValue: {},
    visible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = L(e.modelValue), a = L(n.value.visible), s = () => {
      a.value = !0;
    }, o = () => {
      a.value = !1;
    }, i = F(() => n.value.btnModalCSS ? n.value.btnModalCSS !== "hidden" : !1);
    return (r, l) => (y(), M(fe, null, [
      i.value ? (y(), M("div", Sy, [
        w(Ep, {
          class: "menu-item-tab-button-lg margin-t-10 test-NN",
          onClick: s
        }, {
          default: T(() => {
            var c;
            return [
              ke(R((c = n.value) == null ? void 0 : c.buttonLabel), 1)
            ];
          }),
          _: 1
        })
      ])) : W("", !0),
      w(k(Vl), {
        visible: a.value,
        "onUpdate:visible": l[0] || (l[0] = (c) => a.value = c),
        breakpoints: { "960px": "75vw" },
        style: { width: "50vw" },
        header: r.$t("medic-web-framework.header")
      }, {
        footer: T(() => [
          w(k(gn), {
            class: "p-button-text",
            icon: "pi pi-times",
            label: r.$t("medic-web-framework.no"),
            onClick: o
          }, null, 8, ["label"]),
          w(k(gn), {
            autofocus: "",
            icon: "pi pi-check",
            label: r.$t("medic-web-framework.yes"),
            onClick: o
          }, null, 8, ["label"])
        ]),
        default: T(() => [
          b("p", null, [
            q(r.$slots, "default", {}, void 0, !0)
          ])
        ]),
        _: 3
      }, 8, ["visible", "header"])
    ], 64));
  }
}), X1 = /* @__PURE__ */ le(Ty, [["__scopeId", "data-v-06912748"]]), Ly = { style: { display: "flex", "justify-content": "center" } }, Dy = /* @__PURE__ */ Y({
  __name: "MInfoModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    text: {}
  },
  emits: ["confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = at(n), o = () => {
      a("confirm");
    }, i = L(null);
    return Ae(s, async () => {
      var r;
      s.value && (await kn(), (r = i.value) == null || r.$el.focus());
    }), Ne(() => {
      var r;
      s.value && ((r = i.value) == null || r.$el.focus());
    }), (r, l) => {
      const c = ne("font-awesome-icon");
      return y(), G(Kn, {
        onClose: o,
        visible: k(s)
      }, {
        header: T(() => [
          q(r.$slots, "header", {}, () => [
            ke(R(e.header), 1)
          ])
        ]),
        default: T(() => [
          q(r.$slots, "default", {}, () => [
            ke(R(e.text), 1)
          ])
        ]),
        actions: T(() => [
          b("div", Ly, [
            w(Bn, {
              ref_key: "okButtonRef",
              ref: i,
              onClick: o
            }, {
              default: T(() => [
                w(c, { icon: "check" }),
                ke(" " + R(r.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), My = {
  class: "flex flex-row",
  style: { "justify-content": "space-around", "align-items": "baseline" }
}, Oy = {
  key: 0,
  class: "flex"
}, Ny = { style: { display: "flex", "justify-content": "center" } }, Ry = /* @__PURE__ */ Y({
  __name: "MTextInputModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    text: {},
    label: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = at(n), o = L(n.text), i = L(null), r = () => {
      a("confirm", o.value);
    }, l = () => {
      a("cancel");
    }, c = L(null);
    return Ae(s, async () => {
      var u, p;
      s.value && (await kn(), ((u = i.value) == null ? void 0 : u.firstChild).focus(), ((p = i.value) == null ? void 0 : p.firstChild).select());
    }), Ne(() => {
      var u, p;
      s.value && (((u = i.value) == null ? void 0 : u.firstChild).focus(), ((p = i.value) == null ? void 0 : p.firstChild).select());
    }), (u, p) => (y(), G(Kn, {
      onClose: l,
      visible: k(s)
    }, {
      header: T(() => [
        q(u.$slots, "header", {}, () => [
          ke(R(e.header), 1)
        ])
      ]),
      default: T(() => [
        b("div", My, [
          n.label ? (y(), M("div", Oy, [
            q(u.$slots, "label", {}, () => [
              ke(R(e.label), 1)
            ])
          ])) : W("", !0),
          b("div", {
            class: "flex",
            ref_key: "textInputRef",
            ref: i
          }, [
            w(k(oi), {
              modelValue: o.value,
              "onUpdate:modelValue": p[0] || (p[0] = (m) => o.value = m),
              type: "text"
            }, null, 8, ["modelValue"])
          ], 512)
        ])
      ]),
      actions: T(() => [
        b("div", Ny, [
          w(ft, {
            class: "btn-wizard-md mr-2",
            icon: "pi pi-check",
            ref_key: "okButtonRef",
            ref: c,
            onClick: r,
            label: u.$t("shared.ok")
          }, null, 8, ["label"]),
          w(ft, {
            class: "btn-wizard-md p-button-text",
            background: !1,
            outlined: !0,
            icon: "pi pi-times",
            label: u.$t("shared.cancel"),
            onClick: l
          }, null, 8, ["label"])
        ])
      ]),
      _: 3
    }, 8, ["visible"]));
  }
}), Py = { style: { "font-weight": "bold" } }, Fy = { style: { "font-weight": "bold" } }, Qy = { style: { display: "flex", "justify-content": "center" } }, Uy = /* @__PURE__ */ Y({
  __name: "MViewerHelpModal",
  props: {
    visible: { type: Boolean, default: !1 }
  },
  emits: ["confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = at(n), o = () => {
      a("confirm");
    }, i = L(null);
    return Ae(s, async () => {
      var r;
      s.value && (await kn(), (r = i.value) == null || r.$el.focus());
    }), Ne(() => {
      var r;
      s.value && ((r = i.value) == null || r.$el.focus());
    }), (r, l) => {
      const c = ne("font-awesome-icon");
      return y(), G(Kn, {
        onClose: o,
        visible: k(s)
      }, {
        header: T(() => [
          q(r.$slots, "header", {}, () => [
            ke(R(r.$t("shared.help")), 1)
          ])
        ]),
        default: T(() => [
          b("div", null, [
            b("p", Py, R(r.$t("medic-web-framework.commonCommands")), 1),
            b("p", null, R(r.$t("medic-web-framework.leftMouseDragRotate")), 1),
            b("p", null, R(r.$t("medic-web-framework.mouseWheelZoom")), 1),
            b("p", null, R(r.$t("medic-web-framework.rightMouseDragZoom")), 1),
            b("p", null, R(r.$t("medic-web-framework.middleMouseDragPan")), 1),
            b("p", null, R(r.$t("medic-web-framework.leftRightMouseDragPan")), 1),
            b("p", null, R(r.$t("medic-web-framework.middleMouseClickCenter")), 1),
            b("p", null, R(r.$t("medic-web-framework.rightMouseClickObjectMenu")), 1),
            l[0] || (l[0] = b("br", null, null, -1)),
            b("p", Fy, R(r.$t("medic-web-framework.inspectionMode")), 1),
            b("p", null, R(r.$t("medic-web-framework.leftMouseClickCenter")), 1),
            b("p", null, R(r.$t("medic-web-framework.mouseWheelOnInspectionWindowChangePlane")), 1),
            b("p", null, R(r.$t("medic-web-framework.clickOnObjectListItemCenter")), 1),
            b("p", null, R(r.$t("medic-web-framework.dragTheEdgesOfTheInspectionIndicatorToRotateThePlaneDragTheBlueArrowInTheTopRightCornerOfTheInspectionIndicatorToChangePlane")), 1),
            b("p", null, R(r.$t("medic-web-framework.gridSizeOnTheInspectionWindowIsMm")), 1),
            l[1] || (l[1] = b("br", null, null, -1)),
            b("p", null, R(r.$t("medic-web-framework.clickTheOrientationHeadIndicatorInTheBottomLeftCornerToChangeTheOrientation")), 1)
          ])
        ]),
        actions: T(() => [
          b("div", Qy, [
            w(Bn, {
              ref_key: "okButtonRef",
              ref: i,
              onClick: o
            }, {
              default: T(() => [
                w(c, { icon: "check" }),
                ke(" " + R(r.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), Yy = /* @__PURE__ */ Y({
  __name: "MUErrorModal",
  emits: ["confirm", "reject", "cancel"],
  setup(e, { emit: t }) {
    const n = Lt("dialogRef"), a = n.value.data, s = t, o = L(Ce("shared.ok")), i = L(!0), r = L(!0), l = L(Ce("shared.cancel")), c = L(Ce("shared.cancel"));
    Ne(() => {
      a.showYesNo && (o.value = Ce("medic-web-framework.yes"), l.value = Ce("medic-web-framework.no")), a.showCancel || (i.value = !1), a.showAll || (r.value = !1);
    });
    const u = () => {
      s("confirm"), n.value.close();
    }, p = () => {
      s("reject"), n.value.close();
    }, m = () => {
      s("cancel"), n.value.close();
    };
    return (v, A) => (y(), M(fe, null, [
      w(te, { style: { "flex-direction": "column" } }, {
        default: T(() => [
          w(te, { style: { "white-space": "pre-wrap", "justify-content": "start", "padding-bottom": "2rem", "padding-top": "2rem" } }, {
            default: T(() => [
              q(v.$slots, "default", {}, () => [
                ke(R(k(a).message), 1)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      w(te, { class: "p-dialog-footer justify-center" }, {
        default: T(() => [
          w(k(Vs), {
            autofocus: "",
            class: "mt-6",
            label: o.value,
            onClick: A[0] || (A[0] = (h) => u())
          }, null, 8, ["label"]),
          i.value ? (y(), G(k(Bs), {
            key: 0,
            class: "mt-6",
            label: l.value,
            onClick: p
          }, null, 8, ["label"])) : W("", !0),
          r.value ? (y(), G(k(Bs), {
            key: 1,
            class: "mt-6",
            label: c.value,
            onClick: m
          }, null, 8, ["label"])) : W("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), Z1 = /* @__PURE__ */ Y({
  __name: "MUSelectModal",
  emits: ["confirm", "reject"],
  setup(e, { emit: t }) {
    const n = Lt("dialogRef"), a = n.value.data, s = t, { t: o } = pn(), i = L("OK"), r = L(!0), l = L("Cancel"), c = L(a.options.length > 0 ? a.options[0] : "");
    Ne(() => {
      a.showYesNo && (i.value = o("medic-web-framework.yes"), l.value = o("medic-web-framework.no")), a.showCancel || (r.value = !1);
    });
    const u = () => {
      s("confirm", c.value), n.value.close();
    }, p = () => {
      s("reject"), n.value.close();
    };
    return (m, v) => (y(), M(fe, null, [
      w(te, { style: { "flex-direction": "column" } }, {
        default: T(() => [
          w(k(Ms), {
            modelValue: c.value,
            "onUpdate:modelValue": v[0] || (v[0] = (A) => c.value = A),
            options: k(a).options,
            class: "grow mt-1 w-full"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      w(te, { class: "p-dialog-footer justify-center" }, {
        default: T(() => [
          w(k(Bs), {
            autofocus: "",
            class: "mt-6",
            label: i.value,
            onClick: v[1] || (v[1] = (A) => u())
          }, null, 8, ["label"]),
          r.value ? (y(), G(k(Vs), {
            key: 0,
            class: "mt-6",
            label: l.value,
            onClick: p
          }, null, 8, ["label"])) : W("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), ms = Os();
class Gy {
  async input(t) {
    return new Promise((n) => {
      ms.emit("show", {
        options: t,
        resolve: n
      });
    });
  }
}
const jy = {
  key: 0,
  class: "p-error"
}, eS = /* @__PURE__ */ Y({
  __name: "InputDialog",
  setup(e) {
    const t = L(!1);
    let n = Kt({
      title: "",
      message: "",
      acceptLabel: "",
      rejectLabel: "",
      inputValue: "",
      showing: !1,
      okCancelLayout: void 0,
      dismissableMask: void 0
    }), a = null;
    function s(l) {
      a && (a(l), a = null), n.inputValue = "", t.value = !1;
    }
    async function o(l) {
      ms.emit("validate-input", l);
    }
    async function i() {
      s(n.inputValue || "");
    }
    function r() {
      s();
    }
    return ms.on("show", (l) => {
      t.value = !0, Object.assign(n, l.options), a = l.resolve;
    }), ms.on("validate-result", (l) => {
      try {
        n.invalid = !l.valid, n.invalidMsg = l.message;
      } catch {
        throw Error("Check InputEventBus.on function in InputDialog.vue");
      }
    }), Ae(
      () => t.value,
      () => {
        t.value == !1 && a && s();
      }
    ), (l, c) => {
      const u = ne("InputText"), p = ne("Dialog");
      return y(), G(p, {
        visible: t.value,
        "onUpdate:visible": c[1] || (c[1] = (m) => t.value = m),
        header: k(n).title,
        modal: !0,
        dismissableMask: k(n).dismissableMask ?? !1,
        onKeyup: Ta(i, ["enter"])
      }, {
        footer: T(() => [
          w(du, {
            acceptLabel: k(n).acceptLabel,
            rejectLabel: k(n).rejectLabel,
            disabled: k(n).invalid,
            onAccept: i,
            onReject: r
          }, null, 8, ["acceptLabel", "rejectLabel", "disabled"])
        ]),
        default: T(() => [
          w(ma, { class: "gap-16px" }, {
            default: T(() => [
              b("span", null, R(k(n).message), 1),
              w(u, {
                modelValue: k(n).inputValue,
                "onUpdate:modelValue": c[0] || (c[0] = (m) => k(n).inputValue = m),
                class: J([k(n).invalid ? "p-invalid" : ""]),
                autofocus: "true",
                onInput: o
              }, null, 8, ["modelValue", "class"]),
              k(n).invalid ? (y(), M("small", jy, R(k(n).invalidMsg), 1)) : W("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible", "header", "dismissableMask"]);
    };
  }
}), Hy = {}, Vy = { class: "w-full h-full flex justify-center items-center" }, Ky = { class: "flex flex-col" }, Wy = { class: "text-white text-3xl font-bold pt-12" };
function zy(e, t) {
  return y(), M("div", Vy, [
    b("div", Ky, [
      b("div", Wy, [
        q(e.$slots, "default")
      ])
    ])
  ]);
}
const tS = /* @__PURE__ */ le(Hy, [["render", zy]]), $y = Y({
  name: "MColorPicker",
  props: {
    color: {
      type: String,
      required: !0
    }
  },
  emits: ["colorValueChanged"],
  components: {
    ColorPicker: si
  },
  setup(e, { emit: t }) {
    const n = L(e.color);
    return {
      colorPicker: n,
      getColorValue: () => {
        t("colorValueChanged", n.value);
      }
    };
  }
});
function Jy(e, t, n, a, s, o) {
  const i = ne("ColorPicker");
  return y(), G(i, {
    modelValue: e.colorPicker,
    "onUpdate:modelValue": t[0] || (t[0] = (r) => e.colorPicker = r),
    defaultColor: "ff0000",
    onChange: e.getColorValue
  }, null, 8, ["modelValue", "onChange"]);
}
const nS = /* @__PURE__ */ le($y, [["render", Jy]]), qy = {}, Xy = { class: "flex split" };
function Zy(e, t) {
  return y(), M("div", Xy, [
    q(e.$slots, "default")
  ]);
}
const aS = /* @__PURE__ */ le(qy, [["render", Zy]]), eE = { class: "font-semibold" }, tE = { class: "mt-6 mb-0" }, nE = /* @__PURE__ */ Y({
  __name: "MFileUpload",
  props: /* @__PURE__ */ pt({
    multiple: { type: Boolean, default: !1 },
    fileLimit: { default: 1e7 },
    placeholder: { default: "Drag and drop files to here to add object." },
    accept: { default: ".stl,.ply,.obj,.estl,.xstl,.png,.jpg,.jpeg" },
    maxFileSize: { default: 1e8 },
    showUploadButton: { type: Boolean, default: !1 },
    showRemoveButton: { type: Boolean, default: !1 }
  }, {
    removeFiles: { type: Boolean, required: !1, default: !1 },
    removeFilesModifiers: {}
  }),
  emits: /* @__PURE__ */ pt(["fileSelection", "removeSelection", "uploadEvent"], ["update:removeFiles"]),
  setup(e, { emit: t }) {
    const n = e, a = t, s = ye(e, "removeFiles"), o = L([]), i = L(0), r = L(0), l = L(0), c = () => {
      i.value = 0, l.value = 0;
    }, u = (A, h, d) => {
      h(d), i.value -= parseInt(Zi(A.size)), l.value = i.value / 10, o.value = [], r.value = Math.random() * 100, a("removeSelection");
    }, p = (A) => {
      o.value = A.files, a("fileSelection", o.value);
    }, m = () => {
      a("uploadEvent", o.value);
    };
    Ae(s, () => {
      s.value && (o.value = [], r.value = Math.random() * 100);
    });
    const v = F(() => o.value ? o.value.length > 0 : 0);
    return (A, h) => {
      const d = ne("Button"), f = ne("FileUpload");
      return y(), G(f, {
        name: "demo[]",
        customUpload: !0,
        onUpload: c,
        multiple: n.multiple,
        fileLimit: n.fileLimit,
        accept: n.accept,
        "max-file-size": n.maxFileSize,
        onSelect: p,
        key: r.value
      }, {
        header: T(({ chooseCallback: g, clearCallback: B, files: E }) => [
          w(te, { class: "flex-wrap justify-between items-center flex-1 gap-2" }, {
            default: T(() => [
              w(te, { class: "gap-2 -mt-1 -ml-1" }, {
                default: T(() => [
                  w(d, {
                    onClick: (_) => g(),
                    icon: "pi pi-plus",
                    class: J([v.value ? "opacity-40 pointer-events-none" : "", "p-button-rounded"])
                  }, null, 8, ["onClick", "class"]),
                  n.showUploadButton ? (y(), G(d, {
                    key: 0,
                    onClick: m,
                    icon: "pi pi-cloud-upload",
                    class: "p-button-rounded p-button-success",
                    disabled: !E || !v.value
                  }, null, 8, ["disabled"])) : W("", !0),
                  n.showRemoveButton ? (y(), G(d, {
                    key: 1,
                    onClick: (_) => B(),
                    icon: "pi pi-times",
                    class: "p-button-rounded p-button-danger",
                    disabled: !E || !v.value
                  }, null, 8, ["onClick", "disabled"])) : W("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        content: T(({ files: g, removeUploadedFileCallback: B }) => [
          v.value ? (y(), G(te, {
            key: 0,
            class: "justify-center items-center h-full"
          }, {
            default: T(() => [
              w(te, { class: "flex-wrap p-0 sm:p-20 gap-20 justify-center" }, {
                default: T(() => [
                  (y(!0), M(fe, null, He(g, (E, _) => (y(), G(te, {
                    key: E.name + E.type + E.size,
                    class: "card m-0 px-12 flex-col border border-surface items-center gap-6 mt-2",
                    style: { background: "#ffffff0d !important" }
                  }, {
                    default: T(() => [
                      b("span", eE, R(E.name), 1),
                      b("div", null, R(k(Zi)(E.size)), 1),
                      w(d, {
                        icon: "pi pi-times",
                        onClick: (O) => u(E, B, _),
                        class: "p-button-outlined p-button-danger p-button-rounded"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)) : W("", !0)
        ]),
        empty: T(() => [
          w(te, { class: "items-center justify-center flex-col mt-6" }, {
            default: T(() => [
              h[0] || (h[0] = b("i", {
                class: "pi pi-cloud-upload border-2 rounded-full",
                style: { "font-size": "5rem", padding: "2.5rem" }
              }, null, -1)),
              b("p", tE, R(n.placeholder), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["multiple", "fileLimit", "accept", "max-file-size"]);
    };
  }
}), sS = /* @__PURE__ */ le(nE, [["__scopeId", "data-v-d4c7e5cc"]]), aE = Y({
  props: {
    title: String
  }
}), sE = { class: "min-w-0 text-xs" }, oE = { class: "border-b whitespace-nowrap overflow-hidden overflow-ellipsis" }, iE = { class: "h-4 overflow-hidden overflow-ellipsis" };
function rE(e, t, n, a, s, o) {
  return y(), M("div", sE, [
    b("div", oE, R(e.title), 1),
    b("div", iE, [
      q(e.$slots, "default")
    ])
  ]);
}
const oS = /* @__PURE__ */ le(aE, [["render", rE]]), iS = /* @__PURE__ */ Y({
  __name: "MInputNumber",
  props: {
    modelValue: { default: 0 },
    cssClass: { default: "" },
    mode: { default: "decimal" },
    step: { default: 1 },
    min: { default: 0 },
    max: { default: 1e4 },
    showButtons: { type: Boolean, default: !0 },
    useGrouping: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { modelValue: s, mode: o, step: i, min: r, max: l, showButtons: c, cssClass: u } = at(n), p = (m) => {
      a("update:modelValue", m);
    };
    return (m, v) => (y(), G(k(Ds), {
      class: J(k(u)),
      max: k(l),
      min: k(r),
      mode: k(o),
      modelValue: k(s),
      showButtons: k(c),
      step: k(i),
      "use-grouping": e.useGrouping,
      "onUpdate:modelValue": p
    }, null, 8, ["class", "max", "min", "mode", "modelValue", "showButtons", "step", "use-grouping"]));
  }
}), lE = /* @__PURE__ */ Y({
  __name: "MListComponent",
  props: {
    model: {},
    modelValue: {},
    listStyle: {},
    filterPlaceholder: {},
    disableScrollIntoView: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "userChange"],
  setup(e, { emit: t }) {
    const n = L(null), a = e, s = t, { model: o, disableScrollIntoView: i } = at(a), r = L(null);
    bn(() => {
      r.value = a.modelValue ?? null, a.modelValue && !i.value && l();
    });
    function l() {
      const u = n.value, p = o.value.findIndex((m) => {
        var v;
        return m.name === ((v = a.modelValue) == null ? void 0 : v.name);
      });
      u && p !== -1 && kn(() => {
        var v;
        let m = (v = u.list) == null ? void 0 : v.children;
        if (m) {
          const A = m[p];
          A && A.scrollIntoView({ behavior: "auto", block: "start", container: "nearest" });
        }
      });
    }
    Ae(r, () => {
      s("input", k(r.value)), s("update:modelValue", k(r.value));
    });
    function c() {
      s("userChange", k(r.value));
    }
    return (u, p) => (y(), G(k($l), {
      modelValue: r.value,
      "onUpdate:modelValue": p[0] || (p[0] = (m) => r.value = m),
      filter: !0,
      "list-style": a.listStyle,
      options: k(o),
      class: "list-box",
      filterPlaceholder: a.filterPlaceholder,
      optionLabel: "name",
      ref_key: "listBoxRef",
      ref: n,
      style: { background: "var(--p-rg-component-background-color) !important" },
      onKeydown: p[1] || (p[1] = xt(() => {
      }, ["stop"])),
      onKeypress: p[2] || (p[2] = xt(() => {
      }, ["stop"])),
      onChange: c
    }, {
      loader: T(() => [
        b("span", null, R(u.$t("shared.loading")), 1)
      ]),
      empty: T(() => [
        q(u.$slots, "empty", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["modelValue", "list-style", "options", "filterPlaceholder"]));
  }
}), rS = /* @__PURE__ */ le(lE, [["__scopeId", "data-v-212c786f"]]), cE = { class: "w-full h-full flex justify-center items-center vertical-center horizontal-center" }, uE = { class: "flex flex-col" }, dE = { class: "w-full text-2xl text-bold font-bold pt-12" }, lS = /* @__PURE__ */ Y({
  __name: "MLoading",
  props: {
    strokeWidth: {},
    hideSpinner: { type: Boolean }
  },
  setup(e) {
    const t = e;
    let n = L(2);
    return bn(() => {
      t.strokeWidth && (n.value = t.strokeWidth);
    }), (a, s) => (y(), M("div", cE, [
      b("div", uE, [
        e.hideSpinner ? W("", !0) : (y(), G(k(Kf), {
          key: 0,
          animationDuration: "0.6s",
          class: "p-progress-spinner-circle",
          strokeWidth: k(n).toString()
        }, null, 8, ["strokeWidth"])),
        b("div", dE, [
          q(a.$slots, "default")
        ])
      ])
    ]));
  }
}), fE = Y({
  props: {
    value: Number,
    animate: Boolean,
    showValue: Boolean
  }
});
function pE(e, t, n, a, s, o) {
  const i = ne("ProgressBar");
  return y(), G(i, {
    "show-value": e.showValue,
    value: e.value,
    pt: { value: { style: { transition: "none" } } }
  }, null, 8, ["show-value", "value"]);
}
const cS = /* @__PURE__ */ le(fE, [["render", pE]]), mE = Y({
  props: {
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = L(!1), a = () => {
      n.value = !1;
    }, s = () => {
      n.value = !n.value;
    }, o = L(null);
    Hs(o, a, n), Js(
      "keyup",
      (u) => {
        u.key === "Escape" && a();
      },
      n
    );
    const i = () => {
      e.disabled || s();
    }, r = (u) => {
      t("update:modelValue", u), a();
    }, l = L(null), c = F(() => l.value ? "calc(100vh - " + l.value.getBoundingClientRect().bottom + "px - 2px)" : "");
    return {
      root: o,
      select: l,
      menuVisible: n,
      onClick: i,
      onSelect: r,
      dropdownMaxHeight: c
    };
  }
}), AE = {
  ref: "root",
  class: "relative w-48"
}, gE = { class: "overflow-hidden overflow-ellipsis whitespace-nowrap" }, hE = ["onClick"], vE = { class: "overflow-hidden overflow-ellipsis whitespace-nowrap" };
function bE(e, t, n, a, s, o) {
  const i = ne("font-awesome-icon");
  return y(), M("div", AE, [
    b("div", {
      ref: "select",
      class: J([{ "border-gray-300 text-gray-300": e.disabled }, "h-8 border px-2 py-1 flex justify-between items-center"]),
      onClick: t[0] || (t[0] = (r) => e.onClick())
    }, [
      b("div", gE, R(e.modelValue), 1),
      w(i, {
        class: "ml-1",
        icon: "caret-down"
      })
    ], 2),
    e.menuVisible ? (y(), M("div", {
      key: 0,
      style: Se({ maxHeight: e.dropdownMaxHeight }),
      class: "absolute inset-x-0 z-10 border border-t-0 overflow-y-auto select-none"
    }, [
      (y(!0), M(fe, null, He(e.options, (r, l) => (y(), M("div", {
        key: l,
        class: "flex items-center w-full min-w-0 px-2 py-1 bg-not-selected hover:bg-selected",
        onClick: (c) => e.onSelect(r)
      }, [
        b("div", vE, R(r), 1)
      ], 8, hE))), 128))
    ], 4)) : W("", !0)
  ], 512);
}
const uS = /* @__PURE__ */ le(mE, [["render", bE]]), xE = {
  class: "flex flex-row gap-3",
  style: { "align-items": "center" }
}, yE = {
  key: 3,
  class: "flex",
  style: { "flex-grow": "1", "flex-shrink": "1", "flex-basis": "60px" }
}, EE = /* @__PURE__ */ Y({
  __name: "MSlider",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: {},
    disabled: { type: Boolean, default: !1 },
    hideValueInput: { type: Boolean, default: !1 },
    scrollable: { type: Boolean },
    fractionDigits: {},
    showButtons: { type: Boolean },
    label: {},
    unitLabel: {},
    textSizeClass: {},
    smallFont: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, a = L(0), s = t;
    function o(A) {
      return Number(nc(A));
    }
    const { fractionDigits: i, step: r } = at(n), l = F(() => i.value != null ? i.value : o(r.value));
    bn(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), Ne(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), Ae(
      () => a,
      () => {
        s("update:modelValue", a.value), c(a.value);
      },
      { deep: !0 }
    );
    const c = (A) => {
      s("change", A);
    }, u = Math.floor(n.step) === n.step ? 0 : n.step.toString().split(".")[1].length || 0, p = (A) => {
      n.scrollable && A.deltaY !== 0 && (A.deltaY < 0 ? m() : v(), A.preventDefault());
    }, m = () => {
      a.value = Number(Math.min(a.value + n.step, n.max).toFixed(u)), c(a.value);
    }, v = () => {
      a.value = Number(Math.max(a.value - n.step, n.min).toFixed(u)), c(a.value);
    };
    return (A, h) => (y(), M("div", xE, [
      n.label ? (y(), G(te, { key: 0 }, {
        default: T(() => [
          b("span", {
            class: J([n.textSizeClass ? e.textSizeClass : "text-sm", "ml-1"]),
            style: { "user-select": "none" }
          }, R(n.label), 3)
        ]),
        _: 1
      })) : W("", !0),
      n.showButtons ? (y(), G(ft, {
        key: 1,
        disabled: n.disabled,
        "is-toolbar-button": !0,
        icon: "pi pi-minus",
        onClick: v,
        iconFont: "1.3rem",
        style: { height: "24px !important", width: "24px !important", "border-radius": "8px", padding: "0" }
      }, null, 8, ["disabled"])) : W("", !0),
      b("div", ni(Gl({ wheel: e.scrollable ? p : null }, !0), { style: { display: "flex", "align-items": "center", "flex-grow": "5", "flex-shrink": "1", "flex-basis": "0" } }), [
        w(k(ii), {
          modelValue: a.value,
          "onUpdate:modelValue": h[0] || (h[0] = (d) => a.value = d),
          max: n.max,
          min: n.min,
          step: n.step,
          class: "w-full",
          disabled: n.disabled,
          onChange: c
        }, null, 8, ["modelValue", "max", "min", "step", "disabled"])
      ], 16),
      n.showButtons ? (y(), G(ft, {
        key: 2,
        disabled: n.disabled,
        "is-toolbar-button": !0,
        icon: "pi pi-plus",
        onClick: m,
        iconFont: "1.3rem",
        style: { height: "24px !important", width: "24px !important", "border-radius": "8px", padding: "0" }
      }, null, 8, ["disabled"])) : W("", !0),
      n.hideValueInput ? W("", !0) : (y(), M("div", yE, [
        w(k(Ds), {
          modelValue: a.value,
          "onUpdate:modelValue": h[1] || (h[1] = (d) => a.value = d),
          step: n.step,
          disabled: n.disabled,
          min: n.min,
          max: n.max,
          suffix: e.unitLabel,
          "min-fraction-digits": l.value,
          "max-fraction-digits": l.value,
          fluid: "",
          pt: {
            pcInputText: {
              root: {
                style: {
                  height: "28px !important",
                  fontSize: e.smallFont ? "0.75rem" : "0.875rem",
                  lineSize: "1.25rem"
                }
              }
            }
          },
          style: { height: "28px !important" }
        }, null, 8, ["modelValue", "step", "disabled", "min", "max", "suffix", "min-fraction-digits", "max-fraction-digits", "pt"])
      ]))
    ]));
  }
}), dS = /* @__PURE__ */ le(EE, [["__scopeId", "data-v-7a2824fe"]]), CE = {
  class: "flex flex-row gap-1",
  style: { "align-items": "center" }
}, BE = {
  key: 1,
  class: "flex",
  style: { "flex-grow": "1", "flex-shrink": "1", "flex-basis": "35px" }
}, IE = /* @__PURE__ */ Y({
  __name: "MSliderFixedWidth",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: {},
    disabled: { type: Boolean, default: !1 },
    hideValueInput: { type: Boolean, default: !1 },
    scrollable: { type: Boolean },
    fractionDigits: {},
    showButtons: { type: Boolean },
    label: {},
    unitLabel: {},
    textSizeClass: {},
    longStrings: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, a = L(0), s = t;
    function o(m) {
      return Number(nc(m));
    }
    const i = L(n.fractionDigits != null ? n.fractionDigits : o(n.step));
    bn(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), Ne(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), Ae(
      () => a,
      () => {
        s("update:modelValue", a.value);
      },
      { deep: !0 }
    );
    const r = (m) => {
      s("change", m);
    }, l = Math.floor(n.step) === n.step ? 0 : n.step.toString().split(".")[1].length || 0, c = (m) => {
      n.scrollable && m.deltaY !== 0 && (m.deltaY < 0 ? u() : p());
    }, u = () => {
      a.value = Number(Math.min(a.value + n.step, n.max).toFixed(l)), r(a.value);
    }, p = () => {
      a.value = Number(Math.max(a.value - n.step, n.min).toFixed(l)), r(a.value);
    };
    return (m, v) => (y(), M("div", CE, [
      n.label ? (y(), G(te, {
        key: 0,
        class: J([(e.longStrings, "col-4 no-padding")])
      }, {
        default: T(() => [
          b("span", {
            class: J([n.textSizeClass ? e.textSizeClass : "text-sm", "ml-1"]),
            style: { "user-select": "none" }
          }, R(n.label), 3)
        ]),
        _: 1
      }, 8, ["class"])) : W("", !0),
      w(te, {
        class: J([(e.longStrings, "col-4")])
      }, {
        default: T(() => [
          n.showButtons ? (y(), G(ft, {
            key: 0,
            disabled: n.disabled,
            "is-toolbar-button": !0,
            icon: "pi pi-minus",
            onClick: p,
            "icon-src-height": "21px",
            "icon-src-width": "21px",
            style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
          }, null, 8, ["disabled"])) : W("", !0),
          b("div", ni(Gl({ wheel: e.scrollable ? c : null }, !0), { style: { display: "flex", "align-items": "center", "flex-grow": "5", "flex-shrink": "1", "flex-basis": "0" } }), [
            w(k(ii), {
              modelValue: a.value,
              "onUpdate:modelValue": v[0] || (v[0] = (A) => a.value = A),
              max: n.max,
              min: n.min,
              step: n.step,
              class: "w-full",
              disabled: n.disabled,
              onChange: r
            }, null, 8, ["modelValue", "max", "min", "step", "disabled"])
          ], 16),
          n.showButtons ? (y(), G(ft, {
            key: 1,
            disabled: n.disabled,
            "is-toolbar-button": !0,
            icon: "pi pi-plus",
            onClick: u,
            "icon-src-height": "21px",
            "icon-src-width": "21px",
            style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
          }, null, 8, ["disabled"])) : W("", !0)
        ]),
        _: 1
      }, 8, ["class"]),
      n.hideValueInput ? W("", !0) : (y(), M("div", BE, [
        w(k(Ds), {
          modelValue: a.value,
          "onUpdate:modelValue": v[1] || (v[1] = (A) => a.value = A),
          step: n.step,
          disabled: n.disabled,
          min: n.min,
          max: n.max,
          suffix: e.unitLabel,
          "min-fraction-digits": i.value,
          "max-fraction-digits": i.value,
          fluid: "",
          pt: {
            pcInputText: {
              root: {
                style: {
                  height: "28px !important",
                  fontSize: "0.875rem",
                  lineSize: "1.25rem"
                }
              }
            }
          },
          style: { height: "28px !important" }
        }, null, 8, ["modelValue", "step", "disabled", "min", "max", "suffix", "min-fraction-digits", "max-fraction-digits"])
      ]))
    ]));
  }
}), fS = /* @__PURE__ */ le(IE, [["__scopeId", "data-v-2743cac1"]]), wE = { class: "items-center justify-center flex mt-1 text-light-gray" }, pS = /* @__PURE__ */ Y({
  __name: "MStepper",
  props: {
    steps: { required: !0 },
    stepsModifiers: {},
    activeStepSortOrder: { required: !1, default: 1 },
    activeStepSortOrderModifiers: {}
  },
  emits: ["update:steps", "update:activeStepSortOrder"],
  setup(e) {
    const t = ye(e, "steps"), n = ye(e, "activeStepSortOrder");
    return console.log("MStepper steps: ", t.value), (a, s) => {
      const o = ne("Divider");
      return y(), G(k($f), { value: n.value }, {
        default: T(() => [
          w(k(Wf), {
            class: "w-full grow flex",
            pt: { root: { "data-pc-name": "wkStepList" } },
            "data-cy": "wkStepList"
          }, {
            default: T(() => [
              (y(!0), M(fe, null, He(t.value, (i, r) => (y(), G(k(zf), {
                disabled: !0,
                asChild: "",
                value: i.id,
                key: i.id
              }, {
                default: T(() => [
                  w(te, null, {
                    default: T(() => [
                      w(ma, null, {
                        default: T(() => [
                          s[0] || (s[0] = b("button", { class: "px-4" }, [
                            b("span", {
                              class: J([
                                "rounded-full border-2 w-12 h-12 inline-flex items-center justify-center",
                                {
                                  "text-primary-contrast border-primary": !0
                                }
                              ])
                            }, [
                              b("span", { class: "circle" })
                            ])
                          ], -1)),
                          b("span", wE, R(i.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      r + 1 != t.value.length ? (y(), G(o, {
                        key: 0,
                        class: J(["-mt-2", (t.value.length ?? 0) > 4 ? "w-70px" : "w-120px"]),
                        style: { color: "var(--primary-color)" }
                      }, null, 8, ["class"])) : W("", !0)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]);
    };
  }
}), mS = /* @__PURE__ */ Y({
  __name: "MSwitch",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = ye(e, "modelValue");
    return (n, a) => {
      const s = ne("InputSwitch");
      return y(), M("div", null, [
        w(s, {
          modelValue: t.value.state,
          "onUpdate:modelValue": a[0] || (a[0] = (o) => t.value.state = o),
          disabled: t.value.disabled,
          onClick: a[1] || (a[1] = (o) => t.value.clicked = !0)
        }, null, 8, ["modelValue", "disabled"])
      ]);
    };
  }
}), kE = /* @__PURE__ */ Y({
  __name: "MSwitchStyled",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    ai((a) => ({
      e53cb5bc: n.value
    }));
    const t = ye(e, "modelValue"), n = F(() => t.value.state ? "#43c261" : "var(--webcad-primary-text-color)");
    return (a, s) => (y(), M("div", null, [
      w(k(zl), {
        modelValue: t.value.state,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => t.value.state = o),
        disabled: t.value.disabled
      }, null, 8, ["modelValue", "disabled"])
    ]));
  }
}), AS = /* @__PURE__ */ le(kE, [["__scopeId", "data-v-f8baae53"]]), _E = {}, SE = { class: "card flex" }, TE = { class: "flex flex-col w-full h-full" };
function LE(e, t) {
  return y(), M("div", SE, [
    b("div", TE, [
      q(e.$slots, "header"),
      q(e.$slots, "tabs"),
      q(e.$slots, "default")
    ])
  ]);
}
const gS = /* @__PURE__ */ le(_E, [["render", LE]]), DE = {
  class: "m-tab-item-link",
  role: "presentation"
}, ME = { class: "m-tab-item-text" }, hS = /* @__PURE__ */ Y({
  __name: "MTabItem",
  props: /* @__PURE__ */ pt({
    index: {}
  }, {
    state: { required: !0 },
    stateModifiers: {}
  }),
  emits: ["update:state"],
  setup(e) {
    const t = e, n = ye(e, "state"), a = () => {
      n.value = t.index;
    };
    return (s, o) => (y(), M("li", {
      class: J([{ "m-tab-item-selected": n.value === t.index }, "m-tab-item"]),
      role: "tab",
      onClick: a
    }, [
      b("a", DE, [
        b("span", ME, [
          q(s.$slots, "default")
        ]),
        b("span", null, [
          q(s.$slots, "after")
        ])
      ])
    ], 2));
  }
}), OE = Y({
  props: {
    // eslint-disable-next-line no-undef
    id: {
      type: Number,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    imgSrc: {
      type: String,
      required: !0
    },
    index: Number,
    selected: Boolean
  },
  setup(e, { emit: t }) {
    const n = L("bg-purple-500"), a = F(() => e.imgSrc);
    return bn(() => {
      e.id == e.index ? n.value = "p-highlight" : n.value = "";
    }), {
      cssClass: n,
      cIconSrc: a,
      onClick: () => {
        t("update:modelValue", e.index);
      }
    };
  }
}), NE = { class: "product-item" }, RE = { class: "image-container" }, PE = ["src"], FE = { class: "product-list-detail" }, QE = { class: "flex justify-center flex-wrap text-3xl font-semibold text-center" };
function UE(e, t, n, a, s, o) {
  return y(), M("li", {
    class: J([{ "p-highlight": e.selected }, "p-orderlist-item pointer"]),
    "aria-selected": "false",
    role: "option",
    tabindex: "0"
  }, [
    b("div", NE, [
      b("div", RE, [
        b("img", {
          isMenuIcon: !0,
          src: e.cIconSrc,
          draggable: "false"
        }, null, 8, PE)
      ]),
      b("div", FE, [
        b("span", QE, R(e.name), 1)
      ])
    ]),
    t[0] || (t[0] = b("span", {
      class: "p-ink",
      style: { height: "2085px", width: "2085px", top: "-967.667px", left: "-635.5px" }
    }, null, -1))
  ], 2);
}
const YE = /* @__PURE__ */ le(OE, [["render", UE]]), GE = { class: "p-orderlist p-component h-full" }, jE = {
  key: 0,
  class: "p-orderlist-controls"
}, HE = { class: "p-orderlist-list-container h-full" }, VE = {
  key: 0,
  class: "p-orderlist-header"
}, KE = {
  "aria-multiselectable": !0,
  class: "p-orderlist-list",
  role: "listbox"
}, vS = /* @__PURE__ */ Y({
  __name: "MTemplates",
  props: {
    templates: {},
    showControls: { type: Boolean, default: !0 },
    header: { default: "" }
  },
  emits: ["selectionChanged"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = L(), o = (l, c) => {
      s.value !== c && (s.value = c, a("selectionChanged", l ?? {}));
    }, i = (l, c) => {
      o(l, c);
    }, { templates: r } = at(n);
    return (l, c) => (y(), M("div", GE, [
      e.showControls ? (y(), M("div", jE, [...c[0] || (c[0] = [
        vd('<button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-up p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button><button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-double-up p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button><button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-down p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button><button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-double-down p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button>', 4)
      ])])) : W("", !0),
      b("div", HE, [
        e.header ? (y(), M("div", VE, R(e.header), 1)) : W("", !0),
        b("ul", KE, [
          (y(!0), M(fe, null, He(k(r), (u) => (y(), G(YE, {
            key: u.id,
            id: Number(u.id),
            imgSrc: u.image ?? "",
            name: u.name,
            selected: u.id == s.value,
            onClick: (p) => i(u, Number(u.id))
          }, null, 8, ["id", "imgSrc", "name", "selected", "onClick"]))), 128))
        ])
      ])
    ]));
  }
}), WE = { class: "flex items-center gap-2" }, zE = { class: "text-2xl" }, $E = ["src", "alt"], kl = /* @__PURE__ */ Y({
  __name: "MTogglePanel",
  props: /* @__PURE__ */ pt({
    header: { default: "" }
  }, {
    isCollapsed: { default: !0 },
    isCollapsedModifiers: {}
  }),
  emits: ["update:isCollapsed"],
  setup(e) {
    const t = ye(e, "isCollapsed"), n = e;
    function a() {
      t.value = !t.value;
    }
    return (s, o) => {
      const i = ne("Panel");
      return y(), G(i, {
        collapsed: t.value,
        "onUpdate:collapsed": o[0] || (o[0] = (r) => t.value = r),
        class: "w-full"
      }, {
        header: T(() => [
          b("div", WE, [
            b("span", zE, R(n.header), 1)
          ])
        ]),
        icons: T(() => [
          b("img", {
            class: "cursor-pointer",
            src: k(vs)("rg_expand_circle_down"),
            alt: s.$t("shared.expandPanel"),
            onClick: a
          }, null, 8, $E)
        ]),
        default: T(() => [
          q(s.$slots, "default")
        ]),
        _: 3
      }, 8, ["collapsed"]);
    };
  }
}), JE = Y({
  props: {
    text: String
  }
}), qE = { class: "h-6 w-max bg-black bg-opacity-50 text-white text-xs flex items-center px-2" };
function XE(e, t, n, a, s, o) {
  return y(), M("div", qE, [
    q(e.$slots, "default", {}, () => [
      ke(R(e.text), 1)
    ])
  ]);
}
const ZE = /* @__PURE__ */ le(JE, [["render", XE]]), eC = {
  symbol: Symbol(),
  install(e) {
    const t = new C0();
    e.config.globalProperties.$navbar = t, e.provide(this.symbol, t);
  }
};
function tC() {
  return li(eC.symbol);
}
const nC = { class: "unsupported-browser-card" }, aC = { class: "unsupported-browser-title" }, sC = { class: "unsupported-browser-subtitle" }, oC = { class: "unsupported-browser-steps" }, iC = { class: "unsupported-browser-url-row" }, rC = ["value"], lC = { class: "unsupported-browser-actions" }, bS = /* @__PURE__ */ Y({
  __name: "MUnsupportedBrowser",
  setup(e) {
    const t = Jf(), n = tC(), { t: a } = pn();
    Ne(() => {
      n.showOnlyLogo();
    });
    const s = F(() => {
      const r = t.query.targetUrl;
      return typeof r == "string" && r.length > 0 ? r : Array.isArray(r) && typeof r[0] == "string" && r[0].length > 0 ? r[0] : window.location.href;
    }), o = async () => {
      var l;
      const r = s.value;
      try {
        if ((l = navigator.clipboard) != null && l.writeText)
          await navigator.clipboard.writeText(r);
        else {
          const c = document.createElement("textarea");
          c.value = r, c.setAttribute("readonly", ""), c.style.position = "absolute", c.style.left = "-9999px", document.body.appendChild(c), c.select(), document.execCommand("copy"), document.body.removeChild(c);
        }
        Ge(a("weblink.copiedToClipboard"));
      } catch (c) {
        console.error(c);
      }
    }, i = () => {
      const r = s.value;
      try {
        const l = new URL(r, window.location.origin);
        l.searchParams.set("allowUnsupportedBrowser", "1"), window.location.href = l.toString();
      } catch {
        const l = r.includes("?") ? "&" : "?";
        window.location.href = `${r}${l}allowUnsupportedBrowser=1`;
      }
    };
    return (r, l) => {
      const c = ne("Divider");
      return y(), G(cn, { class: "unsupported-browser-page" }, {
        default: T(() => [
          b("section", nC, [
            w(cn, { class: "items-center gap-2" }, {
              default: T(() => [
                l[0] || (l[0] = b("i", {
                  class: "pi pi-info-circle pc-coming-soon-icon",
                  "aria-hidden": "true",
                  style: { "font-size": "2.05rem" }
                }, null, -1)),
                b("h1", aC, R(k(a)("shared.unsupportedBrowser")), 1)
              ]),
              _: 1
            }),
            w(c),
            b("p", sC, R(k(a)("shared.rgWebIsOfficiallySupportedOnlyOnGoogleChrome")), 1),
            b("ol", oC, [
              b("li", null, R(k(a)("shared.forTheBestExperienceAndFullFunctionalityPleaseUseGoogleChrome")), 1)
            ]),
            b("div", iC, [
              b("input", {
                value: s.value,
                readonly: "",
                class: "unsupported-browser-url-input pc-settings-input"
              }, null, 8, rC),
              w(ft, {
                class: "h-51px all-radius-16",
                label: k(a)("shared.copyUrl"),
                icon: "pi pi-copy",
                style: { color: "var(--p-text-color)", background: "var(--primary-color) !important" },
                onClick: o
              }, null, 8, ["label"])
            ]),
            b("div", lC, [
              w(ft, {
                class: "h-51px all-radius-16 unsupported-browser-open-anyway-button",
                label: k(a)("shared.openProjectAnyway"),
                icon: "pi pi-external-link",
                style: { color: "var(--p-text-color)" },
                onClick: i
              }, null, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      });
    };
  }
}), cC = { class: "flex flex-col" }, uC = { class: "pb-2 pt-2" }, dC = /* @__PURE__ */ Y({
  __name: "SendMediaMessageDialog",
  props: {
    visible: { type: Boolean },
    model: {},
    confirmEvent: { type: Function }
  },
  setup(e) {
    const t = L(""), n = L(!1), a = {
      width: "40vw",
      maxWidth: "95vw"
    }, s = {
      "1800px": "50vw",
      "960px": "75vw",
      "640px": "95vw"
    }, o = e;
    Ae(
      () => o.visible,
      () => {
        t.value = "", n.value = o.visible;
      }
    );
    function i() {
      n.value = !1;
    }
    function r() {
      n.value = !1, o.confirmEvent && o.confirmEvent(o.model, t.value);
    }
    const l = F(() => {
      var u;
      const c = (((u = o.model) == null ? void 0 : u.filename) ?? "").toLowerCase();
      return c.endsWith(".pdf") || c.endsWith(".txt") || c.endsWith(".xml") || c.endsWith(".pts") || c.endsWith(".constructioninfo") || c.endsWith(".docx") || c.endsWith(".xlsx") || c.endsWith(".zip") ? "p-img-document" : "p-img-image p-img-image-custom";
    });
    return (c, u) => {
      const p = ne("InputText"), m = ne("Dialog");
      return y(), G(m, {
        visible: n.value,
        "onUpdate:visible": u[1] || (u[1] = (v) => n.value = v),
        modal: !0,
        header: c.$t("medic-web-framework.sendMessage"),
        style: a,
        breakpoints: s,
        onKeyup: Ta(r, ["enter"])
      }, {
        footer: T(() => [
          w(du, {
            acceptLabel: c.$t("medic-web-framework.send"),
            rejectLabel: c.$t("shared.cancel"),
            onAccept: r,
            onReject: i
          }, null, 8, ["acceptLabel", "rejectLabel"])
        ]),
        default: T(() => [
          b("div", cC, [
            w(k(Wl), {
              src: e.model.thumbnailImageSrc,
              imageClass: l.value,
              class: "w-280px"
            }, null, 8, ["src", "imageClass"]),
            b("span", uC, R(c.$t("medic-web-framework.enterAMessage")), 1),
            w(p, {
              modelValue: t.value,
              "onUpdate:modelValue": u[0] || (u[0] = (v) => t.value = v),
              autofocus: "true"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "header"]);
    };
  }
}), xS = /* @__PURE__ */ le(dC, [["__scopeId", "data-v-92cd45a3"]]), fC = { id: "dropAreaWrapper" }, pC = {
  key: 0,
  class: "flex flex-col gap-6 items-center justify-center",
  id: "dropArea",
  style: {
    position: "absolute",
    inset: "0px",
    background: "rgba(91, 91, 91, 0.5)",
    zIndex: "10000",
    pointerEvents: "none"
  }
}, mC = { class: "upload-container w-2/12 flex flex-col items-center justify-center gap-6" }, AC = {
  class: "text-4xl bold mt-6",
  style: { "text-align": "center", color: "var(--webcad-primary-color-darker)" }
}, gC = { class: "mb-6" }, hC = ["src"], vC = /* @__PURE__ */ Y({
  __name: "MUploadDropArea",
  props: /* @__PURE__ */ pt({
    iconSrc: {},
    accept: { default: "" }
  }, {
    enabled: { type: Boolean, required: !0 },
    enabledModifiers: {}
  }),
  emits: /* @__PURE__ */ pt(["filesDropped", "invalidFileType"], ["update:enabled"]),
  setup(e, { emit: t }) {
    const n = ye(e, "enabled"), a = e, s = t, o = Sn(), i = F(() => o.getAssetUrl(`${a.iconSrc}`)), r = L(!1);
    let l = 0;
    return Ne(() => {
      window.addEventListener("dragenter", function(c) {
        if (l++, c.dataTransfer && c.dataTransfer.items) {
          for (let u = 0; u < c.dataTransfer.items.length; u++)
            if (c.dataTransfer.items[u].kind === "file" && n.value) {
              r.value || (r.value = !0), c.preventDefault();
              return;
            }
        }
      }), window.addEventListener("dragover", function(c) {
        n.value && c.preventDefault();
      }), window.addEventListener("dragleave", function(c) {
        l--, console.log("dragleave"), l === 0 && n.value && (r.value = !1, c.preventDefault());
      }), document.addEventListener("drop", function(c) {
        var u;
        if (l = 0, n.value && r.value) {
          r.value = !1, c.preventDefault();
          const p = Array.from(((u = c.dataTransfer) == null ? void 0 : u.files) || []);
          ac(
            p.map((m) => m.name),
            a.accept != "" ? a.accept : void 0
          ) ? s("invalidFileType") : s("filesDropped", p);
        }
      });
    }), (c, u) => (y(), M("div", fC, [
      r.value ? (y(), M("div", pC, [
        b("div", mC, [
          b("span", AC, R(c.$t("medic-web-framework.dropFilesForUpload")), 1),
          b("div", gC, [
            b("img", {
              src: i.value,
              style: Se([{
                height: "5vh !important",
                width: "5vw !important",
                filter: "invert(100%)"
              }, { "align-items": "center", display: "flex" }]),
              alt: "icon",
              class: "h-full",
              draggable: "false"
            }, null, 8, hC)
          ])
        ])
      ])) : W("", !0)
    ]));
  }
}), yS = /* @__PURE__ */ le(vC, [["__scopeId", "data-v-3b53436b"]]), bC = ["disabled"], xC = ["src"], yC = { class: "flex ml-2" }, ES = /* @__PURE__ */ Y({
  __name: "MChooseFolderButton",
  props: {
    iconSrc: {},
    rawUpload: { type: Boolean },
    borderRadius: {},
    disabled: { type: Boolean }
  },
  emits: ["folderSelected", "folderSelectedRaw"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = Sn(), o = F(() => s.getAssetUrl(`${n.iconSrc}`)), i = (r) => {
      if (n.rawUpload) {
        a("folderSelectedRaw", r);
        return;
      }
      const l = r.target;
      let c = [];
      l.files && (c = Array.from(l.files)), a("folderSelected", c);
    };
    return (r, l) => (y(), G(k(te), null, {
      default: T(() => [
        b("input", {
          type: "file",
          id: "filePickerImportProject",
          name: "fileList",
          class: "hidden",
          webkitdirectory: "",
          onChange: i,
          disabled: n.disabled
        }, null, 40, bC),
        b("label", {
          class: "p-button btn-wizard-md p-component p-fileupload-choose flex flex-row",
          style: Se({ verticalAlign: "middle", borderRadius: n.borderRadius ?? void 0 }),
          for: "filePickerImportProject"
        }, [
          b("img", {
            src: o.value,
            style: Se([{
              height: "14px !important",
              width: "14px !important"
            }, { "align-items": "center" }]),
            alt: "icon",
            class: "h-full flex",
            draggable: "false"
          }, null, 8, xC),
          b("span", yC, R(r.$t("web-rg.chooseFolder")), 1)
        ], 4)
      ]),
      _: 1
    }));
  }
}), CS = /* @__PURE__ */ Y({
  __name: "MUploadFileButton",
  props: {
    accept: {},
    chooseLabel: {},
    class: {},
    disabled: { type: Boolean },
    showOnlyIcon: { type: Boolean }
  },
  emits: ["filesSelected", "invalidFileType"],
  setup(e, { emit: t }) {
    const { t: n } = pn(), a = e, s = F(() => a.showOnlyIcon ?? !1), o = F(() => s.value ? "" : a.chooseLabel !== void 0 ? a.chooseLabel : n("web-rg.chooseFile")), i = F(() => a.class ?? ""), r = F(() => a.disabled ?? !1), l = t, c = (u) => {
      ac(
        u.files.map((p) => p.name),
        a.accept !== "" ? a.accept : void 0
      ) ? l("invalidFileType") : l("filesSelected", u.files);
    };
    return (u, p) => {
      const m = ne("FileUpload");
      return y(), G(m, {
        customUpload: !0,
        accept: a.accept,
        disabled: r.value,
        onUploader: c,
        maxFileSize: 1e9,
        auto: !0,
        mode: "basic",
        multiple: !0,
        showUploadButton: !1,
        showCancelButton: !1,
        chooseLabel: o.value,
        class: J(i.value),
        pt: {
          chooseButton: {
            class: ["btn-wizard-md", { "p-button-icon-only": s.value }]
          }
        }
      }, null, 8, ["accept", "disabled", "chooseLabel", "class", "pt"]);
    };
  }
}), EC = { style: { position: "relative" } }, CC = { style: { "z-index": "1000", position: "absolute", "margin-top": "0.5rem", "margin-left": "0.75rem", display: "inline-block" } }, BC = {
  key: 0,
  class: "pi pi-check bold",
  style: { color: "var(--webcad-primary-color)" }
}, IC = { class: "ml-2 font-bold text-xl" }, wC = /* @__PURE__ */ Y({
  __name: "ImageListItem",
  props: /* @__PURE__ */ pt({
    item: {}
  }, {
    itemSelected: { type: Boolean, required: !0 },
    itemSelectedModifiers: {}
  }),
  emits: ["update:itemSelected"],
  setup(e) {
    const t = ye(e, "itemSelected"), n = e, { item: a } = at(n);
    function s(o) {
      t.value = !t.value, o.stopPropagation();
    }
    return (o, i) => {
      const r = ne("Image");
      return y(), M("div", EC, [
        b("div", CC, [
          k(a).selected ? (y(), M("i", BC)) : W("", !0),
          b("span", IC, R(k(a).name), 1)
        ]),
        w(r, {
          alt: k(a).name,
          src: k(a).preview,
          class: J("flex w-full h-full object-contain img-card-size"),
          imageClass: [k(a).selected ? "border-2 border-round-xl" : ""],
          style: { "object-fit": "cover", height: "100% !important" },
          pt: {
            image: {
              style: {
                background: "transparent !important",
                maxHeight: "17rem",
                borderRadius: "8px"
              }
            },
            previewMask: {
              style: {
                borderRadius: "8px"
              }
            }
          },
          preview: ""
        }, {
          indicatoricon: T(() => [
            b("div", {
              class: "w-full h-full flex flex-col justify-start",
              onClick: i[0] || (i[0] = (l) => s(l))
            })
          ]),
          _: 1
        }, 8, ["alt", "src", "imageClass"]),
        q(o.$slots, "default", {}, void 0, !0)
      ]);
    };
  }
}), kC = /* @__PURE__ */ le(wC, [["__scopeId", "data-v-ff30e3c7"]]), BS = /* @__PURE__ */ Y({
  __name: "ImageList",
  props: /* @__PURE__ */ pt({
    singleSelected: { type: Boolean }
  }, {
    items: { required: !0 },
    itemsModifiers: {}
  }),
  emits: ["update:items"],
  setup(e) {
    const t = ye(e, "items"), n = e, a = (s) => {
      if (n.singleSelected) {
        t.value.forEach((i) => i.selected = !1);
        const o = t.value.find((i) => i == s);
        o && (o.selected = !0);
      }
    };
    return (s, o) => (y(!0), M(fe, null, He(t.value, (i, r) => (y(), M("div", { key: r }, [
      w(kC, {
        item: i,
        itemSelected: i.selected,
        "onUpdate:itemSelected": [(l) => i.selected = l, (l) => a(i)]
      }, {
        default: T(() => [
          q(s.$slots, "default")
        ]),
        _: 3
      }, 8, ["item", "itemSelected", "onUpdate:itemSelected"])
    ]))), 128));
  }
}), _C = /* @__PURE__ */ Y({
  __name: "MUSwitch",
  props: {
    state: { type: Boolean, required: !0 },
    stateModifiers: {},
    disabled: { type: Boolean },
    disabledModifiers: {}
  },
  emits: ["update:state", "update:disabled"],
  setup(e) {
    ai((c) => ({
      v7ddbcbb3: i.value,
      v2196a6bc: o.value,
      df2d356e: r.value,
      v65423b8a: s.value,
      c7d5c86e: l.value
    }));
    const t = ye(e, "state"), n = ye(e, "disabled"), a = () => {
      t.value = !t.value;
    }, s = F(() => t.value ? "#43c261" : "var(--p-text-color)"), o = F(() => "var(--p-text-color)"), i = F(() => t.value ? "var(--p-primary-color)" : "transparent"), r = F(() => t.value ? "#0096a5" : "rgba(200,200,200,0.3)"), l = F(() => t.value ? "16px" : "2px");
    return (c, u) => (y(), G(te, {
      class: "flex-row",
      style: { "align-items": "center" }
    }, {
      default: T(() => [
        q(c.$slots, "falseLabel", {}, void 0, !0),
        b("div", {
          class: J(["switch", { disabled: n.value, "switch-on": t.value, "switch-off": !t.value }]),
          onClick: a
        }, [...u[0] || (u[0] = [
          b("div", { class: "switch__dot" }, null, -1)
        ])], 2),
        q(c.$slots, "trueLabel", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), IS = /* @__PURE__ */ le(_C, [["__scopeId", "data-v-23e49f8f"]]), SC = { class: "flex flex-wrap gap-6" }, TC = { class: "flex items-center" }, LC = {
  for: "ingredient1",
  class: "ml-2"
}, DC = { class: "flex items-center" }, MC = {
  for: "ingredient2",
  class: "ml-2"
}, OC = { class: "flex items-center" }, NC = {
  for: "ingredient3",
  class: "ml-2"
}, RC = { style: { display: "flex", "justify-content": "center" } }, PC = /* @__PURE__ */ Y({
  __name: "MTransparencyModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    transparency: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const a = L(e.transparency), s = t, o = () => {
      s("confirm", a.value);
    }, i = () => {
      s("cancel");
    }, r = L(null);
    return (l, c) => {
      const u = ne("RadioButton"), p = ne("font-awesome-icon");
      return y(), G(Kn, {
        onClose: i,
        visible: e.visible
      }, {
        header: T(() => [
          q(l.$slots, "header", {}, () => [
            ke(R(e.header), 1)
          ])
        ]),
        default: T(() => [
          b("div", SC, [
            b("div", TC, [
              w(u, {
                modelValue: a.value,
                "onUpdate:modelValue": c[0] || (c[0] = (m) => a.value = m),
                inputId: "transparency1",
                name: "transparency"
              }, null, 8, ["modelValue"]),
              b("label", LC, R(l.$t("shared.")), 1)
            ]),
            b("div", DC, [
              w(u, {
                modelValue: a.value,
                "onUpdate:modelValue": c[1] || (c[1] = (m) => a.value = m),
                inputId: "transparency2",
                name: "transparency"
              }, null, 8, ["modelValue"]),
              b("label", MC, R(l.$t("shared.")), 1)
            ]),
            b("div", OC, [
              w(u, {
                modelValue: a.value,
                "onUpdate:modelValue": c[2] || (c[2] = (m) => a.value = m),
                inputId: "transparency3",
                name: "transparency"
              }, null, 8, ["modelValue"]),
              b("label", NC, R(l.$t("shared.")), 1)
            ])
          ])
        ]),
        actions: T(() => [
          b("div", RC, [
            w(Bn, {
              ref_key: "okButtonRef",
              ref: r,
              onClick: o
            }, {
              default: T(() => [
                w(p, { icon: "check" }),
                ke(" " + R(l.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512),
            w(Bn, { onClick: i }, {
              default: T(() => [
                w(p, { icon: "times" }),
                ke(" " + R(l.$t("shared.cancel")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
});
function mt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Vn(e) {
  var t = mt(e).Element;
  return e instanceof t || e instanceof Element;
}
function yt(e) {
  var t = mt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Yi(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = mt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
var Pn = Math.max, Ss = Math.min, ia = Math.round;
function ei() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function $u() {
  return !/^((?!chrome|android).)*safari/i.test(ei());
}
function ra(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var a = e.getBoundingClientRect(), s = 1, o = 1;
  t && yt(e) && (s = e.offsetWidth > 0 && ia(a.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && ia(a.height) / e.offsetHeight || 1);
  var i = Vn(e) ? mt(e) : window, r = i.visualViewport, l = !$u() && n, c = (a.left + (l && r ? r.offsetLeft : 0)) / s, u = (a.top + (l && r ? r.offsetTop : 0)) / o, p = a.width / s, m = a.height / o;
  return {
    width: p,
    height: m,
    top: u,
    right: c + p,
    bottom: u + m,
    left: c,
    x: c,
    y: u
  };
}
function Gi(e) {
  var t = mt(e), n = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function FC(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function QC(e) {
  return e === mt(e) || !yt(e) ? Gi(e) : FC(e);
}
function zt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Dn(e) {
  return ((Vn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ji(e) {
  return ra(Dn(e)).left + Gi(e).scrollLeft;
}
function un(e) {
  return mt(e).getComputedStyle(e);
}
function Hi(e) {
  var t = un(e), n = t.overflow, a = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + a);
}
function UC(e) {
  var t = e.getBoundingClientRect(), n = ia(t.width) / e.offsetWidth || 1, a = ia(t.height) / e.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function YC(e, t, n) {
  n === void 0 && (n = !1);
  var a = yt(t), s = yt(t) && UC(t), o = Dn(t), i = ra(e, s, n), r = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((zt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Hi(o)) && (r = QC(t)), yt(t) ? (l = ra(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = ji(o))), {
    x: i.left + r.scrollLeft - l.x,
    y: i.top + r.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function Ju(e) {
  var t = ra(e), n = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}
function qs(e) {
  return zt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Yi(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Dn(e)
  );
}
function qu(e) {
  return ["html", "body", "#document"].indexOf(zt(e)) >= 0 ? e.ownerDocument.body : yt(e) && Hi(e) ? e : qu(qs(e));
}
function _a(e, t) {
  var n;
  t === void 0 && (t = []);
  var a = qu(e), s = a === ((n = e.ownerDocument) == null ? void 0 : n.body), o = mt(a), i = s ? [o].concat(o.visualViewport || [], Hi(a) ? a : []) : a, r = t.concat(i);
  return s ? r : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    r.concat(_a(qs(i)))
  );
}
function GC(e) {
  return ["table", "td", "th"].indexOf(zt(e)) >= 0;
}
function _l(e) {
  return !yt(e) || // https://github.com/popperjs/popper-core/issues/837
  un(e).position === "fixed" ? null : e.offsetParent;
}
function jC(e) {
  var t = /firefox/i.test(ei()), n = /Trident/i.test(ei());
  if (n && yt(e)) {
    var a = un(e);
    if (a.position === "fixed")
      return null;
  }
  var s = qs(e);
  for (Yi(s) && (s = s.host); yt(s) && ["html", "body"].indexOf(zt(s)) < 0; ) {
    var o = un(s);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function Xs(e) {
  for (var t = mt(e), n = _l(e); n && GC(n) && un(n).position === "static"; )
    n = _l(n);
  return n && (zt(n) === "html" || zt(n) === "body" && un(n).position === "static") ? t : n || jC(e) || t;
}
var Tt = "top", $t = "bottom", In = "right", sn = "left", Vi = "auto", Zs = [Tt, $t, In, sn], la = "start", Ya = "end", HC = "clippingParents", Xu = "viewport", ba = "popper", VC = "reference", Sl = /* @__PURE__ */ Zs.reduce(function(e, t) {
  return e.concat([t + "-" + la, t + "-" + Ya]);
}, []), KC = /* @__PURE__ */ [].concat(Zs, [Vi]).reduce(function(e, t) {
  return e.concat([t, t + "-" + la, t + "-" + Ya]);
}, []), WC = "beforeRead", zC = "read", $C = "afterRead", JC = "beforeMain", qC = "main", XC = "afterMain", ZC = "beforeWrite", eB = "write", tB = "afterWrite", nB = [WC, zC, $C, JC, qC, XC, ZC, eB, tB];
function aB(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function s(o) {
    n.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(r) {
      if (!n.has(r)) {
        var l = t.get(r);
        l && s(l);
      }
    }), a.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || s(o);
  }), a;
}
function sB(e) {
  var t = aB(e);
  return nB.reduce(function(n, a) {
    return n.concat(t.filter(function(s) {
      return s.phase === a;
    }));
  }, []);
}
function oB(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function iB(e) {
  var t = e.reduce(function(n, a) {
    var s = n[a.name];
    return n[a.name] = s ? Object.assign({}, s, a, {
      options: Object.assign({}, s.options, a.options),
      data: Object.assign({}, s.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
function rB(e, t) {
  var n = mt(e), a = Dn(e), s = n.visualViewport, o = a.clientWidth, i = a.clientHeight, r = 0, l = 0;
  if (s) {
    o = s.width, i = s.height;
    var c = $u();
    (c || !c && t === "fixed") && (r = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: r + ji(e),
    y: l
  };
}
function lB(e) {
  var t, n = Dn(e), a = Gi(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, o = Pn(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), i = Pn(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), r = -a.scrollLeft + ji(e), l = -a.scrollTop;
  return un(s || n).direction === "rtl" && (r += Pn(n.clientWidth, s ? s.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: r,
    y: l
  };
}
function cB(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Yi(n)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function ti(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function uB(e, t) {
  var n = ra(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Tl(e, t, n) {
  return t === Xu ? ti(rB(e, n)) : Vn(t) ? uB(t, n) : ti(lB(Dn(e)));
}
function dB(e) {
  var t = _a(qs(e)), n = ["absolute", "fixed"].indexOf(un(e).position) >= 0, a = n && yt(e) ? Xs(e) : e;
  return Vn(a) ? t.filter(function(s) {
    return Vn(s) && cB(s, a) && zt(s) !== "body";
  }) : [];
}
function fB(e, t, n, a) {
  var s = t === "clippingParents" ? dB(e) : [].concat(t), o = [].concat(s, [n]), i = o[0], r = o.reduce(function(l, c) {
    var u = Tl(e, c, a);
    return l.top = Pn(u.top, l.top), l.right = Ss(u.right, l.right), l.bottom = Ss(u.bottom, l.bottom), l.left = Pn(u.left, l.left), l;
  }, Tl(e, i, a));
  return r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
function vn(e) {
  return e.split("-")[0];
}
function ca(e) {
  return e.split("-")[1];
}
function Zu(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function ed(e) {
  var t = e.reference, n = e.element, a = e.placement, s = a ? vn(a) : null, o = a ? ca(a) : null, i = t.x + t.width / 2 - n.width / 2, r = t.y + t.height / 2 - n.height / 2, l;
  switch (s) {
    case Tt:
      l = {
        x: i,
        y: t.y - n.height
      };
      break;
    case $t:
      l = {
        x: i,
        y: t.y + t.height
      };
      break;
    case In:
      l = {
        x: t.x + t.width,
        y: r
      };
      break;
    case sn:
      l = {
        x: t.x - n.width,
        y: r
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = s ? Zu(s) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case la:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case Ya:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function td() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function pB(e) {
  return Object.assign({}, td(), e);
}
function mB(e, t) {
  return t.reduce(function(n, a) {
    return n[a] = e, n;
  }, {});
}
function Ki(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, s = a === void 0 ? e.placement : a, o = n.strategy, i = o === void 0 ? e.strategy : o, r = n.boundary, l = r === void 0 ? HC : r, c = n.rootBoundary, u = c === void 0 ? Xu : c, p = n.elementContext, m = p === void 0 ? ba : p, v = n.altBoundary, A = v === void 0 ? !1 : v, h = n.padding, d = h === void 0 ? 0 : h, f = pB(typeof d != "number" ? d : mB(d, Zs)), g = m === ba ? VC : ba, B = e.rects.popper, E = e.elements[A ? g : m], _ = fB(Vn(E) ? E : E.contextElement || Dn(e.elements.popper), l, u, i), O = ra(e.elements.reference), S = ed({
    reference: O,
    element: B,
    placement: s
  }), H = ti(Object.assign({}, B, S)), z = m === ba ? H : O, X = {
    top: _.top - z.top + f.top,
    bottom: z.bottom - _.bottom + f.bottom,
    left: _.left - z.left + f.left,
    right: z.right - _.right + f.right
  }, re = e.modifiersData.offset;
  if (m === ba && re) {
    var se = re[s];
    Object.keys(X).forEach(function(ve) {
      var Re = [In, $t].indexOf(ve) >= 0 ? 1 : -1, Z = [Tt, $t].indexOf(ve) >= 0 ? "y" : "x";
      X[ve] += se[Z] * Re;
    });
  }
  return X;
}
var Ll = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Dl() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function AB(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, a = n === void 0 ? [] : n, s = t.defaultOptions, o = s === void 0 ? Ll : s;
  return function(r, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ll, o),
      modifiersData: {},
      elements: {
        reference: r,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], m = !1, v = {
      state: u,
      setOptions: function(f) {
        var g = typeof f == "function" ? f(u.options) : f;
        h(), u.options = Object.assign({}, o, u.options, g), u.scrollParents = {
          reference: Vn(r) ? _a(r) : r.contextElement ? _a(r.contextElement) : [],
          popper: _a(l)
        };
        var B = sB(iB([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = B.filter(function(E) {
          return E.enabled;
        }), A(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var f = u.elements, g = f.reference, B = f.popper;
          if (Dl(g, B)) {
            u.rects = {
              reference: YC(g, Xs(B), u.options.strategy === "fixed"),
              popper: Ju(B)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(X) {
              return u.modifiersData[X.name] = Object.assign({}, X.data);
            });
            for (var E = 0; E < u.orderedModifiers.length; E++) {
              if (u.reset === !0) {
                u.reset = !1, E = -1;
                continue;
              }
              var _ = u.orderedModifiers[E], O = _.fn, S = _.options, H = S === void 0 ? {} : S, z = _.name;
              typeof O == "function" && (u = O({
                state: u,
                options: H,
                name: z,
                instance: v
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: oB(function() {
        return new Promise(function(d) {
          v.forceUpdate(), d(u);
        });
      }),
      destroy: function() {
        h(), m = !0;
      }
    };
    if (!Dl(r, l))
      return v;
    v.setOptions(c).then(function(d) {
      !m && c.onFirstUpdate && c.onFirstUpdate(d);
    });
    function A() {
      u.orderedModifiers.forEach(function(d) {
        var f = d.name, g = d.options, B = g === void 0 ? {} : g, E = d.effect;
        if (typeof E == "function") {
          var _ = E({
            state: u,
            name: f,
            instance: v,
            options: B
          }), O = function() {
          };
          p.push(_ || O);
        }
      });
    }
    function h() {
      p.forEach(function(d) {
        return d();
      }), p = [];
    }
    return v;
  };
}
var is = {
  passive: !0
};
function gB(e) {
  var t = e.state, n = e.instance, a = e.options, s = a.scroll, o = s === void 0 ? !0 : s, i = a.resize, r = i === void 0 ? !0 : i, l = mt(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, is);
  }), r && l.addEventListener("resize", n.update, is), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, is);
    }), r && l.removeEventListener("resize", n.update, is);
  };
}
const hB = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: gB,
  data: {}
};
function vB(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = ed({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const bB = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: vB,
  data: {}
};
var xB = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function yB(e, t) {
  var n = e.x, a = e.y, s = t.devicePixelRatio || 1;
  return {
    x: ia(n * s) / s || 0,
    y: ia(a * s) / s || 0
  };
}
function Ml(e) {
  var t, n = e.popper, a = e.popperRect, s = e.placement, o = e.variation, i = e.offsets, r = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, p = e.isFixed, m = i.x, v = m === void 0 ? 0 : m, A = i.y, h = A === void 0 ? 0 : A, d = typeof u == "function" ? u({
    x: v,
    y: h
  }) : {
    x: v,
    y: h
  };
  v = d.x, h = d.y;
  var f = i.hasOwnProperty("x"), g = i.hasOwnProperty("y"), B = sn, E = Tt, _ = window;
  if (c) {
    var O = Xs(n), S = "clientHeight", H = "clientWidth";
    if (O === mt(n) && (O = Dn(n), un(O).position !== "static" && r === "absolute" && (S = "scrollHeight", H = "scrollWidth")), O = O, s === Tt || (s === sn || s === In) && o === Ya) {
      E = $t;
      var z = p && O === _ && _.visualViewport ? _.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[S]
      );
      h -= z - a.height, h *= l ? 1 : -1;
    }
    if (s === sn || (s === Tt || s === $t) && o === Ya) {
      B = In;
      var X = p && O === _ && _.visualViewport ? _.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[H]
      );
      v -= X - a.width, v *= l ? 1 : -1;
    }
  }
  var re = Object.assign({
    position: r
  }, c && xB), se = u === !0 ? yB({
    x: v,
    y: h
  }, mt(n)) : {
    x: v,
    y: h
  };
  if (v = se.x, h = se.y, l) {
    var ve;
    return Object.assign({}, re, (ve = {}, ve[E] = g ? "0" : "", ve[B] = f ? "0" : "", ve.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + h + "px)" : "translate3d(" + v + "px, " + h + "px, 0)", ve));
  }
  return Object.assign({}, re, (t = {}, t[E] = g ? h + "px" : "", t[B] = f ? v + "px" : "", t.transform = "", t));
}
function EB(e) {
  var t = e.state, n = e.options, a = n.gpuAcceleration, s = a === void 0 ? !0 : a, o = n.adaptive, i = o === void 0 ? !0 : o, r = n.roundOffsets, l = r === void 0 ? !0 : r, c = {
    placement: vn(t.placement),
    variation: ca(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Ml(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Ml(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const CB = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: EB,
  data: {}
};
function BB(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var a = t.styles[n] || {}, s = t.attributes[n] || {}, o = t.elements[n];
    !yt(o) || !zt(o) || (Object.assign(o.style, a), Object.keys(s).forEach(function(i) {
      var r = s[i];
      r === !1 ? o.removeAttribute(i) : o.setAttribute(i, r === !0 ? "" : r);
    }));
  });
}
function IB(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var s = t.elements[a], o = t.attributes[a] || {}, i = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : n[a]), r = i.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !yt(s) || !zt(s) || (Object.assign(s.style, r), Object.keys(o).forEach(function(l) {
        s.removeAttribute(l);
      }));
    });
  };
}
const wB = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: BB,
  effect: IB,
  requires: ["computeStyles"]
};
var kB = [hB, bB, CB, wB], Wi = /* @__PURE__ */ AB({
  defaultModifiers: kB
}), _B = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function As(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return _B[t];
  });
}
var SB = {
  start: "end",
  end: "start"
};
function Ol(e) {
  return e.replace(/start|end/g, function(t) {
    return SB[t];
  });
}
function TB(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, s = n.boundary, o = n.rootBoundary, i = n.padding, r = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? KC : l, u = ca(a), p = u ? r ? Sl : Sl.filter(function(A) {
    return ca(A) === u;
  }) : Zs, m = p.filter(function(A) {
    return c.indexOf(A) >= 0;
  });
  m.length === 0 && (m = p);
  var v = m.reduce(function(A, h) {
    return A[h] = Ki(e, {
      placement: h,
      boundary: s,
      rootBoundary: o,
      padding: i
    })[vn(h)], A;
  }, {});
  return Object.keys(v).sort(function(A, h) {
    return v[A] - v[h];
  });
}
function LB(e) {
  if (vn(e) === Vi)
    return [];
  var t = As(e);
  return [Ol(e), t, Ol(t)];
}
function DB(e) {
  var t = e.state, n = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var s = n.mainAxis, o = s === void 0 ? !0 : s, i = n.altAxis, r = i === void 0 ? !0 : i, l = n.fallbackPlacements, c = n.padding, u = n.boundary, p = n.rootBoundary, m = n.altBoundary, v = n.flipVariations, A = v === void 0 ? !0 : v, h = n.allowedAutoPlacements, d = t.options.placement, f = vn(d), g = f === d, B = l || (g || !A ? [As(d)] : LB(d)), E = [d].concat(B).reduce(function(tt, st) {
      return tt.concat(vn(st) === Vi ? TB(t, {
        placement: st,
        boundary: u,
        rootBoundary: p,
        padding: c,
        flipVariations: A,
        allowedAutoPlacements: h
      }) : st);
    }, []), _ = t.rects.reference, O = t.rects.popper, S = /* @__PURE__ */ new Map(), H = !0, z = E[0], X = 0; X < E.length; X++) {
      var re = E[X], se = vn(re), ve = ca(re) === la, Re = [Tt, $t].indexOf(se) >= 0, Z = Re ? "width" : "height", ce = Ki(t, {
        placement: re,
        boundary: u,
        rootBoundary: p,
        altBoundary: m,
        padding: c
      }), be = Re ? ve ? In : sn : ve ? $t : Tt;
      _[Z] > O[Z] && (be = As(be));
      var gt = As(be), Ue = [];
      if (o && Ue.push(ce[se] <= 0), r && Ue.push(ce[be] <= 0, ce[gt] <= 0), Ue.every(function(tt) {
        return tt;
      })) {
        z = re, H = !1;
        break;
      }
      S.set(re, Ue);
    }
    if (H)
      for (var Pe = A ? 3 : 1, Ye = function(st) {
        var Dt = E.find(function(Mt) {
          var ot = S.get(Mt);
          if (ot)
            return ot.slice(0, st).every(function(Et) {
              return Et;
            });
        });
        if (Dt)
          return z = Dt, "break";
      }, Je = Pe; Je > 0; Je--) {
        var Ke = Ye(Je);
        if (Ke === "break") break;
      }
    t.placement !== z && (t.modifiersData[a]._skip = !0, t.placement = z, t.reset = !0);
  }
}
const zi = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: DB,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function MB(e) {
  return e === "x" ? "y" : "x";
}
function gs(e, t, n) {
  return Pn(e, Ss(t, n));
}
function OB(e, t, n) {
  var a = gs(e, t, n);
  return a > n ? n : a;
}
function NB(e) {
  var t = e.state, n = e.options, a = e.name, s = n.mainAxis, o = s === void 0 ? !0 : s, i = n.altAxis, r = i === void 0 ? !1 : i, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, p = n.padding, m = n.tether, v = m === void 0 ? !0 : m, A = n.tetherOffset, h = A === void 0 ? 0 : A, d = Ki(t, {
    boundary: l,
    rootBoundary: c,
    padding: p,
    altBoundary: u
  }), f = vn(t.placement), g = ca(t.placement), B = !g, E = Zu(f), _ = MB(E), O = t.modifiersData.popperOffsets, S = t.rects.reference, H = t.rects.popper, z = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, X = typeof z == "number" ? {
    mainAxis: z,
    altAxis: z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, z), re = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, se = {
    x: 0,
    y: 0
  };
  if (O) {
    if (o) {
      var ve, Re = E === "y" ? Tt : sn, Z = E === "y" ? $t : In, ce = E === "y" ? "height" : "width", be = O[E], gt = be + d[Re], Ue = be - d[Z], Pe = v ? -H[ce] / 2 : 0, Ye = g === la ? S[ce] : H[ce], Je = g === la ? -H[ce] : -S[ce], Ke = t.elements.arrow, tt = v && Ke ? Ju(Ke) : {
        width: 0,
        height: 0
      }, st = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : td(), Dt = st[Re], Mt = st[Z], ot = gs(0, S[ce], tt[ce]), Et = B ? S[ce] / 2 - Pe - ot - Dt - X.mainAxis : Ye - ot - Dt - X.mainAxis, Jt = B ? -S[ce] / 2 + Pe + ot + Mt + X.mainAxis : Je + ot + Mt + X.mainAxis, qt = t.elements.arrow && Xs(t.elements.arrow), Mn = qt ? E === "y" ? qt.clientTop || 0 : qt.clientLeft || 0 : 0, pe = (ve = re == null ? void 0 : re[E]) != null ? ve : 0, Xt = be + Et - pe - Mn, Ct = be + Jt - pe, Ot = gs(v ? Ss(gt, Xt) : gt, be, v ? Pn(Ue, Ct) : Ue);
      O[E] = Ot, se[E] = Ot - be;
    }
    if (r) {
      var Zt, x = E === "x" ? Tt : sn, I = E === "x" ? $t : In, N = O[_], V = _ === "y" ? "height" : "width", xe = N + d[x], Ie = N - d[I], ie = [Tt, sn].indexOf(f) !== -1, D = (Zt = re == null ? void 0 : re[_]) != null ? Zt : 0, C = ie ? xe : N - S[V] - H[V] - D + X.altAxis, Q = ie ? N + S[V] + H[V] - D - X.altAxis : Ie, ae = v && ie ? OB(C, N, Q) : gs(v ? C : xe, N, v ? Q : Ie);
      O[_] = ae, se[_] = ae - N;
    }
    t.modifiersData[a] = se;
  }
}
const $i = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: NB,
  requiresIfExists: ["offset"]
};
function wS(e, t, n) {
  let a, s = null;
  const o = L(null), i = L(!1), r = () => {
    s && (Le(null, s), s.remove(), s = null);
  }, l = () => {
    r(), i.value = !1;
  }, c = (u) => {
    i.value && l(), u.preventDefault(), s = document.createElement("div"), document.body.appendChild(s);
    const p = w(eI, {
      items: t.value,
      options: {
        showIcons: n
      }
    });
    a && (p.appContext = a), Le(p, s), s.style.position = "absolute", s.style.left = u.clientX + "px", s.style.top = u.clientY + "px";
    const m = s.firstElementChild;
    o.value = Wi(s, m, {
      placement: "right-start",
      modifiers: [zi, $i]
    }), i.value = !0;
  };
  Hs(L(s), l, i), Js(
    "keyup",
    (u) => {
      u.key === "Escape" && l();
    },
    i
  ), Ne(() => {
    var u, p;
    a = (u = ta()) == null ? void 0 : u.appContext, (p = e.value) == null || p.addEventListener("contextmenu", c);
  }), wn(() => {
    var u;
    (u = e.value) == null || u.removeEventListener("contextmenu", c), r();
  });
}
const kS = (e) => {
  const t = () => {
    if (typeof window > "u" || typeof navigator > "u")
      return {};
    const i = e ? e() : {}, r = i.browser ?? {}, l = i.os ?? {}, c = i.device ?? {}, u = window.screen ? `${window.screen.width}x${window.screen.height}` : "unknown", p = navigator.language || navigator.languages && navigator.languages[0] || "unknown";
    return {
      browserName: r.name ?? "unknown",
      browserVersion: r.version ?? "unknown",
      osName: l.name ?? "unknown",
      osVersion: l.version ?? "unknown",
      deviceType: c.type ?? "desktop",
      screenSize: u,
      timezoneOffset: String((/* @__PURE__ */ new Date()).getTimezoneOffset()),
      language: p
    };
  }, n = (i) => Object.keys(i).sort().map((r) => `${r}=${i[r]}`).join("|"), a = (i) => {
    let r = "";
    return i.forEach((l) => {
      r += String.fromCharCode(l);
    }), btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  }, s = async (i) => {
    var p;
    if (typeof window > "u" || !((p = window.crypto) != null && p.subtle))
      return "";
    const r = n(i), l = new TextEncoder().encode(r), c = await window.crypto.subtle.digest("SHA-256", l), u = new Uint8Array(c);
    return a(u).slice(0, 22);
  };
  return {
    collectClientSignals: t,
    normalizeSignals: n,
    generateVisitorId: s,
    generateVisitorScore: async (i) => {
      const r = await s({ ...i, score: "1" });
      if (!r)
        return 0;
      const l = r.charCodeAt(0), c = r.charCodeAt(1);
      return Math.min(100, Math.abs(l + c) % 101);
    }
  };
};
function _S(e, t, n, a) {
  let s = !1;
  const o = (d) => {
    switch (t) {
      case "left":
        return d.buttons % 2 === 1;
      case "middle":
        return d.buttons % 8 === 1;
      case "right":
        return d.buttons % 4 === 1;
    }
  }, i = (d) => {
    switch (n) {
      case "offset":
        return [d.offsetX, d.offsetY];
      case "client":
        return [d.clientX, d.clientY];
      case "page":
        return [d.pageX, d.pageY];
      case "screen":
        return [d.screenX, d.screenY];
    }
  }, r = (d) => {
    o(d) && c(...i(d));
  }, l = (d) => {
    o(d) || p(...i(d));
  }, c = (d, f) => {
    var g;
    s = !0, A(), (g = a.onDragStart) == null || g.call(a, d, f);
  }, u = (d) => {
    var f;
    if (s) {
      if (!o(d)) {
        p(...i(d));
        return;
      }
      d.preventDefault(), (f = a.onDrag) == null || f.call(a, ...i(d));
    }
  }, p = (d, f) => {
    var g;
    s && (s = !1, h(), (g = a.onDragEnd) == null || g.call(a, d, f));
  }, m = (d) => {
    d.addEventListener("mousedown", r), document.addEventListener("mouseup", l);
  }, v = (d) => {
    d.removeEventListener("mousedown", r), document.removeEventListener("mouseup", l);
  }, A = () => {
    document.addEventListener("mousemove", u);
  }, h = () => {
    document.removeEventListener("mousemove", u);
  };
  document.addEventListener(
    "contextmenu",
    (d) => {
      d.ctrlKey && (d.preventDefault(), d.stopPropagation());
    },
    { capture: !0 }
  ), e.value && m(e.value), Ae(e, (d, f) => {
    f && v(f), d && m(d);
  }), wn(() => {
    h();
  });
}
function RB(e, t, n) {
  bn(() => {
    t.modelValue && Object.assign(e, t.modelValue);
  }), Ae(
    () => e,
    () => {
      n("update:modelValue", e);
    },
    { deep: !0 }
  );
}
function SS(e, t) {
  const n = new ResizeObserver((a) => {
    for (const s of a)
      s.target === e.value && t(s.contentRect);
  });
  e.value && n.observe(e.value), Ae(e, (a, s) => {
    s && n.unobserve(s), a && n.observe(a);
  }), wn(() => {
    n.disconnect();
  });
}
function TS(e, t, n = 200) {
  let a = null;
  const s = L(null), o = () => {
    a && (Le(null, a), a.remove(), a = null);
  }, i = Ui();
  let r, l;
  const c = () => {
    window.clearTimeout(r), l = window.setTimeout(() => {
      o();
    }, n);
  }, u = () => {
    window.clearTimeout(l), r = window.setTimeout(() => {
      if (!e.value)
        return;
      a = document.createElement("div"), i.getElement().append(a);
      const d = w(ZE, {
        text: k(t)
      });
      Le(d, a), s.value = Wi(e.value, a, {
        modifiers: [zi, $i]
      });
    }, n);
  };
  let p = !1;
  const m = () => {
    !p && e.value && (e.value.addEventListener("mouseover", u), e.value.addEventListener("mouseout", c), p = !0);
  }, v = () => {
    var d, f;
    (d = e.value) == null || d.removeEventListener("mouseover", u), (f = e.value) == null || f.removeEventListener("mouseout", c), p = !1;
  }, A = () => {
    m();
  }, h = () => {
    v(), c();
  };
  Ae(e, () => {
    e.value ? A() : h();
  }), Ne(() => {
    A();
  }), wn(() => {
    h();
  });
}
const PB = { style: { "font-size": "12px", "margin-bottom": "0.25rem" } }, FB = { style: { display: "flex", "align-items": "center", gap: "0.5rem" } }, QB = ["min", "max", "step", "value", "disabled", "onInput"], UB = { style: { "font-size": "12px", "min-width": "42px", "text-align": "right" } }, YB = {
  key: 1,
  class: "pi pi-angle-right",
  style: { "margin-left": "auto" }
}, Nl = /* @__PURE__ */ Y({
  __name: "MContextMenu",
  props: {
    menuItems: {},
    menuItemsModel: {},
    x: {},
    y: {},
    callback: { type: Function }
  },
  emits: ["select", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = L();
    Js("keyup", (l) => {
      l.key === "Escape" && a("cancel");
    });
    const o = F(() => n.menuItems.map((l, c) => ({ label: l, command: () => a("select", c) }))), i = (l) => l.__isSlider === !0, r = (l, c) => {
      const u = c.target, p = Number(u.value);
      l.__sliderValue = p, l.__onValueChanged(p);
    };
    return Ne(async () => {
      if (await kn(), s.value) {
        const l = new PointerEvent("click", { clientX: n.x, clientY: n.y });
        s.value.show(l), l.stopImmediatePropagation();
      } else
        throw Error("div.value and/or menu.value is undefined");
    }), (l, c) => (y(), M("div", {
      style: { position: "absolute", inset: "0" },
      onClick: c[3] || (c[3] = xt((u) => a("cancel"), ["self"]))
    }, [
      w(k(Hl), {
        ref_key: "menu",
        ref: s,
        model: e.menuItemsModel ?? o.value,
        onHide: c[2] || (c[2] = (u) => e.menuItemsModel ? a("cancel") : void 0)
      }, {
        item: T(({ item: u, props: p }) => [
          i(u) ? (y(), M("div", {
            key: 0,
            style: { padding: "0.35rem 0.8rem", "min-width": "220px" },
            onMousedown: c[0] || (c[0] = xt(() => {
            }, ["stop"])),
            onClick: c[1] || (c[1] = xt(() => {
            }, ["stop"]))
          }, [
            b("div", PB, R(u.label), 1),
            b("div", FB, [
              b("input", {
                min: u.__sliderMin,
                max: u.__sliderMax,
                step: u.__sliderStep,
                value: u.__sliderValue,
                disabled: !!u.disabled,
                type: "range",
                style: { width: "150px" },
                onInput: xt((m) => r(u, m), ["stop"])
              }, null, 40, QB),
              b("span", UB, R(Number(u.__sliderValue).toFixed(0)), 1)
            ])
          ], 32)) : (y(), M("a", ni({ key: 1 }, p.action, { style: { display: "flex", "align-items": "center", gap: "0.5rem" } }), [
            u.icon ? (y(), M("span", {
              key: 0,
              class: J(u.icon)
            }, null, 2)) : W("", !0),
            b("span", null, R(u.label), 1),
            u.items ? (y(), M("span", YB)) : W("", !0)
          ], 16))
        ]),
        _: 1
      }, 8, ["model"])
    ]));
  }
}), GB = { style: { display: "flex", "flex-direction": "column", gap: "0.75rem", "min-width": "360px" } }, jB = { style: { display: "flex", "flex-direction": "column", gap: "0.25rem" } }, HB = { style: { display: "flex", "flex-direction": "column", gap: "0.25rem" } }, VB = { style: { display: "flex", "justify-content": "center" } }, KB = /* @__PURE__ */ Y({
  __name: "MSaveAsModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    name: {},
    options: {},
    selectedType: {},
    nameLabel: { default: "Name" },
    typeLabel: { default: "Type" }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s, name: o, selectedType: i, options: r } = at(n), l = L(o.value), c = r.value.length > 0 ? r.value[0].value : 0, u = L(typeof i.value == "number" ? i.value : c), p = L(null), m = () => {
      var h, d, f, g;
      (d = (h = p.value) == null ? void 0 : h.firstChild) == null || d.focus(), (g = (f = p.value) == null ? void 0 : f.firstChild) == null || g.select();
    };
    Ae(s, async () => {
      s.value && (await kn(), m());
    }), Ae(o, (h) => {
      l.value = h;
    }), Ae(i, (h) => {
      u.value = typeof h == "number" ? h : c;
    }), Ne(() => {
      s.value && m();
    });
    const v = () => {
      a("confirm", l.value, u.value);
    }, A = () => {
      a("cancel");
    };
    return (h, d) => (y(), G(Kn, {
      onClose: A,
      visible: k(s)
    }, {
      header: T(() => [
        q(h.$slots, "header", {}, () => [
          ke(R(e.header), 1)
        ])
      ]),
      default: T(() => [
        b("div", GB, [
          b("div", jB, [
            b("div", null, R(e.nameLabel), 1),
            b("div", {
              ref_key: "nameInputRef",
              ref: p
            }, [
              w(k(oi), {
                modelValue: l.value,
                "onUpdate:modelValue": d[0] || (d[0] = (f) => l.value = f),
                type: "text",
                style: { width: "100%" }
              }, null, 8, ["modelValue"])
            ], 512)
          ]),
          b("div", HB, [
            b("div", null, R(e.typeLabel), 1),
            w(k(Ms), {
              modelValue: u.value,
              "onUpdate:modelValue": d[1] || (d[1] = (f) => u.value = f),
              options: k(r),
              optionLabel: "label",
              optionValue: "value",
              style: { width: "100%" }
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ]),
      actions: T(() => [
        b("div", VB, [
          w(ft, {
            class: "btn-wizard-md mr-2",
            icon: "pi pi-check",
            onClick: v,
            label: h.$t("shared.ok")
          }, null, 8, ["label"]),
          w(ft, {
            class: "btn-wizard-md p-button-text",
            background: !1,
            outlined: !0,
            icon: "pi pi-times",
            label: h.$t("shared.cancel"),
            onClick: A
          }, null, 8, ["label"])
        ])
      ]),
      _: 3
    }, 8, ["visible"]));
  }
});
function tn() {
  let e;
  const t = L(!1), n = () => (t.value = !0, new Promise((s) => {
    e = s;
  })), a = (s) => {
    t.value = !1, e && e(s);
  };
  return {
    visible: bd(t),
    ask: n,
    tell: a
  };
}
function LS() {
  var m;
  let e = (m = ta()) == null ? void 0 : m.appContext;
  Ls(() => {
    var v;
    e = (v = ta()) == null ? void 0 : v.appContext;
  });
  const t = Ui();
  return {
    showSaveAsModal: (v, A, h, d, f, g) => {
      const B = document.createElement("div");
      t.getElement().append(B);
      const E = tn(), _ = () => {
        B && Le(null, B), B.remove();
      }, O = (z, X) => {
        E.tell({ name: z, type: X }), _();
      }, S = () => {
        E.tell(null), _();
      }, H = w(KB, {
        container: t.getElement(),
        visible: !0,
        onConfirm: O,
        onCancel: S,
        header: v,
        name: A,
        options: h,
        selectedType: d,
        nameLabel: f,
        typeLabel: g
      });
      return e && (H.appContext = e), Le(H, B), E.ask();
    },
    showChangeTransparencyModal: (v, A) => {
      const h = document.createElement("div");
      t.getElement().append(h);
      const d = tn(), f = () => {
        h && Le(null, h), h.remove();
      }, g = (_) => {
        d.tell(_), f();
      }, B = () => {
        d.tell(null), f();
      }, E = w(PC, {
        container: t.getElement(),
        visible: !0,
        onConfirm: g,
        onCancel: B,
        header: v,
        transparency: A
      });
      return e && (E.appContext = e), Le(E, h), d.ask();
    },
    showColorPickerModal: (v, A) => {
      const h = document.createElement("div");
      t.getElement().append(h);
      const d = tn(), f = () => {
        h && Le(null, h), h.remove();
      }, g = (_) => {
        d.tell(_), f();
      }, B = () => {
        d.tell(null), f();
      }, E = w(wy, {
        container: t.getElement(),
        visible: !0,
        onConfirm: g,
        onCancel: B,
        header: v,
        defaultColor: A
      });
      return e && (E.appContext = e), Le(E, h), d.ask();
    },
    showConfirmModal: (v, A) => {
      const h = document.createElement("div");
      t.getElement().append(h);
      const d = tn(), f = () => {
        h && Le(null, h), h.remove();
      }, g = () => {
        d.tell(!0), f();
      }, B = () => {
        d.tell(!1), f();
      }, E = w(_y, {
        container: t.getElement(),
        visible: !0,
        onConfirm: g,
        onCancel: B,
        header: v,
        text: A
      });
      return e && (E.appContext = e), Le(E, h), d.ask();
    },
    showInfoModal: (v, A) => {
      const h = document.createElement("div");
      t.getElement().append(h);
      const d = tn(), f = () => {
        h && Le(null, h), h.remove();
      }, g = () => {
        d.tell(), f();
      }, B = w(Dy, {
        container: t.getElement(),
        visible: !0,
        onConfirm: g,
        header: v,
        text: A
      });
      return e && (B.appContext = e), Le(B, h), d.ask();
    },
    showViewerHelpModal: () => {
      const v = document.createElement("div");
      t.getElement().append(v);
      const A = tn(), h = () => {
        v && Le(null, v), v.remove();
      }, d = () => {
        A.tell(), h();
      }, f = w(Uy, {
        container: t.getElement(),
        visible: !0,
        onConfirm: d
      });
      return e && (f.appContext = e), Le(f, v), A.ask();
    },
    showTextInputModal: (v, A, h) => {
      const d = document.createElement("div");
      t.getElement().append(d);
      const f = tn(), g = () => {
        d && Le(null, d), d.remove();
      }, B = (O) => {
        f.tell(O), g();
      }, E = () => {
        f.tell(null), g();
      }, _ = w(Ry, {
        container: t.getElement(),
        visible: !0,
        onConfirm: B,
        onCancel: E,
        header: v,
        text: A,
        label: h
      });
      return e && (_.appContext = e), Le(_, d), f.ask();
    },
    showContextMenu: (v, A, h) => new Promise((d) => {
      const f = document.createElement("div");
      t.getElement().append(f);
      const g = () => {
        f && Le(null, f), f.remove();
      }, B = (O) => {
        g(), d(O);
      }, E = () => {
        g(), d(null);
      }, _ = w(Nl, {
        container: t.getElement(),
        x: A,
        y: h,
        menuItems: v,
        onSelect: B,
        onCancel: E
      });
      e && (_.appContext = e), Le(_, f);
    }),
    showContextMenu2: (v, A, h) => new Promise((d) => {
      const f = document.createElement("div");
      t.getElement().append(f);
      let g = null, B = !1, E = !1, _ = !1;
      const O = () => {
        f && Le(null, f), f.remove();
      }, S = () => {
        _ || (_ = !0, setTimeout(() => {
          O(), d();
        }, 0));
      }, H = () => {
        E || _ || (E = !0, setTimeout(() => {
          if (E = !1, !(!B || _)) {
            if (g) {
              g.finally(() => {
                g = null, H();
              });
              return;
            }
            S();
          }
        }, 0));
      }, z = () => {
        B = !0, H();
      }, X = (Z) => Z.map((ce) => {
        const be = {
          ...ce,
          items: ce.items ? X(ce.items) : void 0
        };
        return ce.command && (be.command = async (gt) => {
          const Ue = ce.command, Pe = Promise.resolve(Ue ? Ue(gt) : void 0).then(() => {
          });
          g = Pe;
          try {
            await Pe;
          } finally {
            g === Pe && (g = null), B && H();
          }
        }), be;
      }), re = X(v), se = (Z) => {
        z();
      }, ve = () => {
        z();
      }, Re = w(Nl, {
        container: t.getElement(),
        x: A,
        y: h,
        menuItems: [],
        menuItemsModel: re,
        onSelect: se,
        onCancel: ve
      });
      e && (Re.appContext = e), Le(Re, f);
    }),
    showMUErrorModal: (v, A, h, d) => {
      const f = document.createElement("div");
      t.getElement().append(f);
      const g = tn(), B = () => {
        f && Le(null, f), f.remove();
      }, E = (S) => {
        g.tell(S), B();
      }, _ = () => {
        g.tell(!1), B();
      }, O = w(Yy, {
        container: t.getElement(),
        visible: !0,
        onConfirm: E,
        onCancel: _,
        header: v,
        text: A,
        showCancel: h,
        showYesNo: d
      });
      return e && (O.appContext = e), Le(O, f), g.ask();
    }
  };
}
const Rl = {
  showIcons: !1,
  menuStyle: void 0,
  menuClass: {},
  itemStyle: void 0,
  itemClass: ["hover:bg-selected"]
  // if hover: class is set in "class=" it seems to override the options, so we set it here
};
var nd = /* @__PURE__ */ ((e) => (e.EDIT_NOTES = "editNotesModal", e.RENAME_OBJECT = "renameObjectModal", e))(nd || {});
const WB = Y({
  components: {
    MIcon: wi
  },
  props: {
    items: {
      type: Array,
      required: !0
    },
    options: {
      type: Object,
      default: Rl
    }
  },
  emits: [
    "itemSelected"
    /* ITEM_SELECTED */
  ],
  setup(e, { emit: t }) {
    const n = tn();
    n.visible.value = !1;
    const a = async () => {
      console.log("show modal example"), n.visible.value = !0;
      const g = await n.ask();
      console.log("modal closed, value:", g);
    }, s = L(!1), o = L(!1), i = L(1), r = { ...Rl, ...e.options }, l = L(-1), c = (g, B) => {
      l.value = B;
    }, u = (g) => {
      t("itemSelected", g);
    }, p = L({ name: "Median Filter (Noise Reduction)", code: 0 });
    let m = Kt({
      value: 29,
      isRange: !1,
      iconSrc: "",
      minValue: 0,
      maxValue: 100,
      step: 1
    });
    const v = () => {
      s.value = !1;
    }, A = () => {
      o.value = !1;
    }, h = L([]), d = L(), f = L(null);
    return Ae(
      d,
      () => {
        f.value && f.value.destroy();
        const g = h.value[l.value];
        d.value && g && (f.value = Wi(g, d.value, {
          placement: "right-start",
          modifiers: [zi, $i]
        }));
      },
      {
        flush: "post"
      }
    ), xd(() => {
      h.value = [];
    }), yd(() => {
      f.value && f.value.destroy();
    }), {
      mergedOptions: r,
      selectedIndex: l,
      onItemHover: c,
      emitItemSelected: u,
      itemDivs: h,
      subMenu: d,
      notesModalVisible: s,
      id: i,
      showModalExample: a,
      modalExample: n,
      closeTest: v,
      ModalViews: nd,
      renameObjectModalVisible: o,
      closeRenameObjectModal: A,
      filterWizSliderModel: m,
      selectedItem: p
    };
  }
}), zB = ["onMouseenter"], $B = { class: "flex w-full justify-between items-center pointer-events-none" }, JB = { class: "overflow-hidden whitespace-nowrap pointer-events-none" }, qB = { key: 0 }, XB = {
  key: 0,
  style: {}
};
function ZB(e, t, n, a, s, o) {
  const i = ne("m-icon"), r = ne("MMenu", !0);
  return y(), M("div", {
    class: J([e.mergedOptions.menuClass, "p-menu p-component p-menu-overlay absolute flex-col select-none bg-not-selected all-radius min-w-220 z-50"]),
    style: Se(e.mergedOptions.menuStyle)
  }, [
    (y(!0), M(fe, null, He(e.items, (l, c) => (y(), M("div", {
      key: c,
      ref_for: !0,
      ref: (u) => {
        u && (e.itemDivs[c] = u);
      },
      class: "flex"
    }, [
      b("div", {
        class: J([[{ "pl-2": !e.mergedOptions.showIcons }, e.mergedOptions.itemClass], "w-rem-17 h-8 flex pr-2 items-center main-text-color"]),
        style: Se(e.mergedOptions.itemStyle),
        onMouseenter: xt((u) => e.onItemHover(l, c), ["stop"])
      }, [
        e.options.showIcons ? (y(), G(i, {
          key: 0,
          faIcon: l.iconFa,
          src: l.iconImg,
          class: "w-4/12 h-8"
        }, null, 8, ["faIcon", "src"])) : W("", !0),
        b("div", $B, [
          b("div", JB, R(l.text), 1),
          l.subItems ? (y(), M("div", qB, "▸")) : W("", !0)
        ])
      ], 46, zB),
      l.subItems && e.selectedIndex === c ? (y(), M("div", XB, [
        w(r, {
          ref_for: !0,
          ref: "subMenu",
          items: l.subItems,
          options: e.options,
          onItemSelected: (u) => e.emitItemSelected(l)
        }, null, 8, ["items", "options", "onItemSelected"])
      ])) : W("", !0)
    ], 512))), 128))
  ], 6);
}
const eI = /* @__PURE__ */ le(WB, [["render", ZB]]), tI = { class: "p-0 all-radius-16" }, nI = { class: "mt-2" }, aI = {
  class: "flex w-full min-w-0 picklist-header-row",
  style: { "max-height": "35px !important" }
}, sI = ["innerHTML"], oI = { class: "hidden" }, iI = {
  key: 1,
  class: "col-span-5 flex flex-col justify-end picklist-actions"
}, rI = { class: "flex flex-row gap-1 w-full" }, lI = ["src"], cI = /* @__PURE__ */ Y({
  __name: "MPickListItem",
  props: {
    modelValue: {},
    id: {},
    name: {},
    imgSrc: {},
    header: {},
    index: {},
    selected: { type: Boolean },
    selectedKey: {},
    callbacks: {},
    visible: { type: Boolean },
    isLocked: { type: Boolean },
    isTracked: { type: Boolean },
    hideHeader: { type: Boolean }
  },
  emits: ["update:modelValue", "update:pickListItemSelected"],
  setup(e, { emit: t }) {
    const n = e, a = Kt(_p()), { t: s } = pn(), o = t;
    RB(a, n, o), bn(() => {
      n.modelValue && Object.assign(a, n.modelValue);
    }), Ae(
      () => a,
      () => {
        o("update:modelValue", a);
      },
      { deep: !0 }
    );
    const i = L("bg-purple-500");
    bn(() => {
      n.id == n.index ? i.value = "p-highlight" : i.value = "";
    });
    const r = F(() => n.selected ? "var(--p-primary-color) !important" : ""), l = F(() => n.header.replace(/-/g, "-<wbr>")), c = L([
      {
        id: "object_hide",
        label: n.visible ? s("medic-web-engine.hideObject") : s("medic-web-engine.showObject"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.hideObject(n.selectedKey);
        }
      },
      {
        id: "object_delete",
        label: s("implant-planner.deleteObject"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.deleteObject(n.selectedKey);
        }
      },
      {
        id: "object_notes",
        label: s("shared.editNotes"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.editNotes(n.selectedKey);
        }
      },
      // { // TODO do I need this (has own icon)
      //     id: "object_unlock",
      //     label: "Toggle Lock Object",
      //     command: () => {
      //         const l = this.context.objects.getLockStatus(key);
      //         if (l != null) {
      //             this.context.objects.changeLockStatus(key, !l);
      //             updateDeferred();
      //         }
      //     },
      // },
      {
        id: "object_change_color",
        label: s("shared.changeColor"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.changeColor(n.selectedKey);
        }
      },
      {
        id: "object_change_transparency",
        label: s("medic-web-engine.changeTransparency"),
        items: [0, 30, 60].map((A) => ({
          label: A ? A + "%" : s("medic-web-engine.opaque"),
          command: () => {
            var h;
            p(), (h = n.callbacks) == null || h.changeTransparency(n.selectedKey, A);
          }
        }))
      },
      {
        label: s("medic-web-engine.toggleWireframe"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.toggleWireframe(n.selectedKey);
        }
      },
      {
        label: s("medic-web-engine.matchObject"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.matchObject(n.selectedKey);
        }
      },
      {
        id: "object_rename",
        label: s("medic-web-engine.renameObject"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.renameObject(n.selectedKey);
        }
      }
    ]);
    n.isTracked || (console.log("NotTracked!!"), c.value.push({
      id: "object_type_change",
      label: s("medic-web-engine.changeObjectType"),
      items: [
        "Marker Scan",
        "Anatomy",
        "Antagonist",
        "Waxup-Prosthesis",
        "Bone Surface",
        "Bone Graft",
        "Surgical Guide",
        "Bone Reduction Guide",
        "Acrylic Flange",
        "Bar",
        "Other"
      ].map((A) => ({
        label: A,
        command: () => {
          var h;
          p(), (h = n.callbacks) == null || h.changeObjectType(n.selectedKey, A);
        }
      }))
    })), c.value.push(
      {
        id: "object_duplicate",
        label: s("medic-web-engine.duplicateObject"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.duplicateObject(n.selectedKey);
        }
      },
      {
        label: s("medic-web-engine.calculateVolume"),
        command: () => {
          var A;
          p(), (A = n.callbacks) == null || A.calculateVolume(n.selectedKey);
        }
      }
    );
    const u = L(), p = () => {
      u.value.toggle(event);
    }, m = () => {
      var A;
      (A = n.callbacks) == null || A.toogleObjectVisibility(n.selectedKey);
    }, v = () => {
      var A;
      (A = n.callbacks) == null || A.toggleObjectPlacement(n.selectedKey);
    };
    return (A, h) => {
      const d = ne("TieredMenu"), f = Sa("tooltip");
      return y(), M("li", {
        "aria-selected": "false",
        class: "p-picklist-item",
        role: "option",
        tabindex: "0",
        style: Se({
          borderRadius: "16px",
          background: r.value
        })
      }, [
        b("div", tI, [
          b("div", null, [
            b("div", nI, [
              b("div", aI, [
                e.hideHeader ? W("", !0) : (y(), M("div", {
                  key: 0,
                  class: J([e.callbacks ? "flex grow min-w-0 picklist-header-text" : " flex w-full justify-center items-center"])
                }, [
                  Qt(b("span", {
                    class: J(["mt-4 text-l cursor-pointer", [e.callbacks ? "ml-2 wrap-text" : "text-center"]]),
                    innerHTML: l.value
                  }, null, 10, sI), [
                    [
                      f,
                      e.header,
                      void 0,
                      { top: !0 }
                    ]
                  ]),
                  b("div", oI, [
                    w(n0)
                  ])
                ], 2)),
                e.callbacks ? (y(), M("div", iI, [
                  b("div", rI, [
                    w(ft, {
                      class: "grow shrink",
                      toggled: !e.isLocked,
                      "is-toolbar-button": !0,
                      onToggledChange: v,
                      togglable: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      iconSrc: e.isLocked ? "/icons/new_icons/ik_object_placement.svg" : "/icons/new_icons/ik_object_placement_black.svg",
                      style: { height: "28px", width: "28px", "border-radius": "8px" }
                    }, null, 8, ["toggled", "iconSrc"]),
                    w(ft, {
                      class: "grow shrink",
                      "is-toolbar-button": !0,
                      iconSrc: e.visible ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg",
                      onClick: m,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px", width: "28px", "border-radius": "8px" }
                    }, null, 8, ["iconSrc"]),
                    w(ft, {
                      class: "grow shrink mr-2",
                      "is-toolbar-button": !0,
                      iconSrc: "/icons/new_icons/ik_menu_28.svg",
                      onClick: p,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px", width: "28px", "border-radius": "8px" }
                    }),
                    w(k(La), {
                      id: "overlay_ruler_panel",
                      ref_key: "opMenuDropdown",
                      ref: u,
                      showCloseIcon: !1,
                      appendTo: "body",
                      style: { "max-width": "350px" }
                    }, {
                      default: T(() => [
                        w(d, {
                          id: "object_list_dropdown_tiered_menu",
                          model: c.value
                        }, null, 8, ["model"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])) : W("", !0)
              ]),
              b("img", {
                src: e.imgSrc,
                class: "w-full mt-2 cursor-pointer picklist-image",
                draggable: "false"
              }, null, 8, lI)
            ])
          ])
        ])
      ], 4);
    };
  }
}), Pl = /* @__PURE__ */ le(cI, [["__scopeId", "data-v-1f202838"]]), uI = {
  key: 0,
  class: "p-picklist-header"
}, dI = {
  class: "w-full mt-2",
  style: { "list-style-type": "none" }
}, fI = {
  "aria-multiselectable": "true",
  class: "p-picklist-list p-picklist-source w-full",
  role: "listbox"
}, pI = /* @__PURE__ */ Y({
  __name: "MPickList",
  props: {
    header: { default: "" },
    items: {},
    selected: { type: Boolean, default: !0 },
    showItemsDropdown: { type: Boolean, default: !1 },
    hideDropdown: { type: Boolean },
    callbacks: {},
    forceSelected: { default: "" },
    heightStyle: { default: "" },
    style: { default: "" }
  },
  emits: ["hideObject", "pickListItemSelected"],
  setup(e, { emit: t }) {
    ai((A) => ({
      v23980a96: A.heightStyle
    }));
    const n = e, a = t, s = L(n.items), o = L(), i = (A) => {
      var h;
      return (h = s == null ? void 0 : s.value) == null ? void 0 : h.find((d) => d.id == A.toString());
    }, r = (A) => {
      o.value = i(A);
    };
    n.forceSelected && n.forceSelected != "" && r(Number(n.forceSelected));
    const l = L(-1), c = (A, h) => {
      l.value !== h && (l.value = h ?? 0, a("pickListItemSelected", A ?? {}));
    };
    function u() {
      s.value.forEach((A) => A.isSelected = !1);
    }
    const p = () => {
      u();
      const A = s.value.find((h) => {
        var d;
        return h.id === ((d = o.value) == null ? void 0 : d.id.toString());
      });
      A && o.value && (A.isSelected = !0, c(A, Number(A.id)));
    }, m = (A, h) => {
      u(), r(Number(A.id)), c(A, h);
    }, v = L(Math.random());
    return Ae(
      () => n.forceSelected,
      () => {
        console.log("ForceSelected:", n.forceSelected), n.showItemsDropdown && n.forceSelected && (r(Number(n.forceSelected)), v.value = Math.random());
      }
    ), (A, h) => (y(), M("div", {
      class: "p-picklist p-component h-full w-full",
      style: Se(n.style)
    }, [
      e.header ? (y(), M("div", uI)) : W("", !0),
      e.showItemsDropdown ? (y(), M("div", {
        key: 1,
        class: "p-picklist-header w-full",
        style: Se(n.heightStyle)
      }, [
        Qt(w(k(Ms), {
          class: "w-full",
          modelValue: o.value,
          "onUpdate:modelValue": h[0] || (h[0] = (d) => o.value = d),
          options: s.value,
          "option-label": "header",
          placeholder: A.$t("medic-web-framework.selectItem"),
          onChange: p
        }, null, 8, ["modelValue", "options", "placeholder"]), [
          [vo, !e.hideDropdown]
        ]),
        b("div", dI, [
          o.value ? (y(), G(Pl, {
            header: o.value.header,
            "hide-header": !0,
            index: l.value,
            imgSrc: o.value.imgSrc,
            selected: !0,
            selectedKey: o.value.id,
            callbacks: e.callbacks ?? void 0,
            visible: o.value.isVisible,
            isTracked: o.value.isTracked,
            isLocked: o.value.isLocked,
            key: v.value
          }, null, 8, ["header", "index", "imgSrc", "selectedKey", "callbacks", "visible", "isTracked", "isLocked"])) : W("", !0)
        ])
      ], 4)) : (y(), M("div", {
        key: 2,
        style: Se(n.heightStyle)
      }, [
        b("ul", fI, [
          (y(!0), M(fe, null, He(s.value, (d, f) => (y(), M("div", {
            key: d.header
          }, [
            (y(), G(Pl, {
              header: d.header,
              index: l.value,
              imgSrc: d.imgSrc,
              selected: f == l.value || ((d == null ? void 0 : d.isSelected) ?? !1),
              selectedKey: d.id,
              callbacks: e.callbacks ?? void 0,
              visible: d.isVisible,
              key: v.value,
              isTracked: d.isTracked,
              isLocked: d.isLocked,
              onClick: (g) => m(d, f)
            }, null, 8, ["header", "index", "imgSrc", "selected", "selectedKey", "callbacks", "visible", "isTracked", "isLocked", "onClick"]))
          ]))), 128))
        ])
      ], 4))
    ], 4));
  }
}), DS = /* @__PURE__ */ le(pI, [["__scopeId", "data-v-d2d2b2f8"]]), mI = { class: "text-2xl" }, AI = { class: "text-justify" }, Fl = "cookieSetting", MS = /* @__PURE__ */ Y({
  __name: "MCookieBanner",
  props: {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = ye(e, "modelValue");
    localStorage.getItem(Fl) || (t.value = !0);
    const a = (i) => {
      localStorage.setItem(Fl, i);
    }, s = () => {
      a("all"), t.value = !1;
    }, o = () => {
      a("essential"), t.value = !1;
    };
    return (i, r) => {
      const l = ne("Dialog");
      return y(), G(l, {
        modal: "",
        visible: t.value,
        "onUpdate:visible": r[0] || (r[0] = (c) => t.value = c),
        style: { width: "720px" },
        breakpoints: { "960px": "75vw", "640px": "100vw" }
      }, {
        header: T(() => [
          b("span", mI, R(i.$t("medic-web-framework.weUseCookiesToImproveYourExperience")), 1)
        ]),
        footer: T(() => [
          w(te, { class: "justify-center gap-4" }, {
            default: T(() => [
              w(Bs, {
                label: i.$t("medic-web-framework.acceptEssential"),
                icon: "pi pi-check",
                onClick: o
              }, null, 8, ["label"]),
              w(Vs, {
                id: "btnAcceptAllCookies",
                label: i.$t("medic-web-framework.acceptAll"),
                icon: "pi pi-check",
                onClick: s
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        default: T(() => [
          w(te, { class: "items-start justify-center" }, {
            default: T(() => [
              b("p", AI, R(i.$t("medic-web-framework.cookiesHelpUsImproveYourExperienceOnOurWebsiteTheyAllowUsToRememberPreferencesUnderstandHowPeopleUseOurSiteAndDeliverRelevantContent")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]);
    };
  }
}), OS = /* @__PURE__ */ Y({
  __name: "WeblinkUploadInvalidComponent",
  setup(e) {
    const t = Lt("dialogRef");
    return (n, a) => (y(), M(fe, null, [
      w(te, { class: "flex-col -mt-2 gap-16px" }, {
        default: T(() => [
          b("span", null, R(n.$t("medic-web-framework.supportedTypes")), 1),
          w(te, { class: "flex-row-wrap gap-4" }, {
            default: T(() => [
              (y(!0), M(fe, null, He(k(ec), (s) => (y(), G(k(jl), {
                label: s,
                key: s
              }, null, 8, ["label"]))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      w(k(Kl), { class: "mt-1" }),
      w(te, null, {
        default: T(() => [
          a[1] || (a[1] = b("div", { class: "grow" }, null, -1)),
          w(Vs, {
            label: n.$t("shared.close"),
            onClick: a[0] || (a[0] = (s) => k(t).close())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), gI = {
  class: "text-4xl bold",
  style: { "text-align": "center", color: "var(--webcad-primary-color-darker)" }
}, NS = /* @__PURE__ */ Y({
  __name: "WeblinkUploadNoPatientIdComponent",
  setup(e) {
    const t = Lt("dialogRef");
    return (n, a) => {
      const s = ne("Divider"), o = ne("Button");
      return y(), M(fe, null, [
        w(te, { class: "justify-center" }, {
          default: T(() => [
            b("span", gI, R(n.$t("medic-web-framework.pleaseSelectPatientFromPatientList")), 1)
          ]),
          _: 1
        }),
        w(s, { class: "mt-1" }),
        w(te, null, {
          default: T(() => [
            a[1] || (a[1] = b("div", { class: "grow" }, null, -1)),
            w(o, {
              class: "p-button p-component w-2/12 flex items-center justify-center",
              label: n.$t("shared.close"),
              onClick: a[0] || (a[0] = (i) => k(t).close())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), hI = { class: "w-full pt-2" }, vI = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" }, bI = { class: "flex col-span-6 pointer items-center gap-3" }, xI = { class: "flex col-span-6 justify-end" }, yI = { class: "flex gap-2" }, EI = { class: "flex align-center" }, CI = { class: "flex gap-2" }, BI = { class: "flex align-center" }, II = /* @__PURE__ */ Y({
  __name: "AppNotificationConfigComponent",
  props: /* @__PURE__ */ pt({
    hideEmailControls: { type: Boolean, default: !1 }
  }, {
    statusList: {},
    statusListModifiers: {},
    emailChatNotification: { type: Boolean, required: !0 },
    emailChatNotificationModifiers: {},
    emailStatusNotification: { required: !0 },
    emailStatusNotificationModifiers: {},
    emailOrderCreatedNotifications: { type: Boolean, required: !0 },
    emailOrderCreatedNotificationsModifiers: {}
  }),
  emits: /* @__PURE__ */ pt(["updateStatusNotification", "updateEmailChatNotification"], ["update:statusList", "update:emailChatNotification", "update:emailStatusNotification", "update:emailOrderCreatedNotifications"]),
  setup(e, { emit: t }) {
    const n = ye(e, "statusList"), a = ye(e, "emailChatNotification"), s = ye(e, "emailStatusNotification"), o = ye(e, "emailOrderCreatedNotifications"), i = fu(), r = L(i.isMobileView), l = t, c = e, u = () => {
      if (n.value) {
        const v = n.value.filter((A) => A.selected).map((A) => A.name);
        l("updateStatusNotification", v);
      }
    }, p = (v) => {
      l("updateEmailChatNotification", !v);
    }, m = (v) => {
      if (!n.value) return;
      const A = n.value.filter((d) => d.selected).map((d) => d.name), h = v ? A.filter((d) => d !== "ORDER_CREATED") : Array.from(/* @__PURE__ */ new Set([...A, "ORDER_CREATED"]));
      l("updateStatusNotification", h);
    };
    return Ne(() => {
      n.value && s.value && n.value.forEach((v) => {
        v.selected = s.value.includes(v.name);
      });
    }), Ae(
      i.$state,
      (v) => {
        r.value = v.isMobileView;
      },
      { deep: !0 }
    ), (v, A) => {
      const h = ne("Divider");
      return y(), M(fe, null, [
        b("div", hI, [
          b("div", vI, [
            (y(!0), M(fe, null, He(n.value, (d, f) => (y(), G(k(te), {
              class: "rg-panel gap-4",
              key: d.name
            }, {
              default: T(() => [
                b("div", bI, [
                  b("span", {
                    style: Se(`background-color: ${d.color};`),
                    class: "transparent-dot-lg"
                  }, null, 4),
                  b("span", null, R(d.displayString), 1)
                ]),
                w(k(On)),
                b("div", xI, [
                  w(ls, {
                    id: `status_switch_${f}`,
                    state: d.selected,
                    "onUpdate:state": (g) => d.selected = g,
                    onChange: u
                  }, null, 8, ["id", "state", "onUpdate:state"])
                ])
              ]),
              _: 2
            }, 1024))), 128))
          ])
        ]),
        c.hideEmailControls ? W("", !0) : (y(), G(h, { key: 0 })),
        c.hideEmailControls ? W("", !0) : (y(), G(k(cn), {
          key: 1,
          class: "flex w-full gap-6"
        }, {
          default: T(() => [
            w(k(On), { class: "rg-panel" }, {
              default: T(() => [
                b("span", yI, [
                  A[2] || (A[2] = b("span", { class: "flex pi pi-inbox align-center" }, null, -1)),
                  b("span", EI, R(v.$t("medic-web-framework.sendMeAnEmailForNewChatMessages")), 1)
                ]),
                w(k(On)),
                w(ls, {
                  id: "switchEmailChatNotifications",
                  class: "flex align-center",
                  state: a.value,
                  "onUpdate:state": A[0] || (A[0] = (d) => a.value = d),
                  onChange: p
                }, null, 8, ["state"])
              ]),
              _: 1
            }),
            w(k(On), { class: "rg-panel" }, {
              default: T(() => [
                b("span", CI, [
                  A[3] || (A[3] = b("span", { class: "flex pi pi-inbox align-center" }, null, -1)),
                  b("span", BI, R(v.$t("medic-web-framework.sendMeAnEmailForNewCreatedOrder")), 1)
                ]),
                w(k(On)),
                w(ls, {
                  id: "switchEmailOrderNotifications",
                  class: "flex align-center",
                  state: o.value,
                  "onUpdate:state": A[1] || (A[1] = (d) => o.value = d),
                  onChange: m
                }, null, 8, ["state"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      ], 64);
    };
  }
});
function ad(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var s = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(n, a, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), n;
}
var sd = {}, ut = {}, Ga = {};
Object.defineProperty(Ga, "__esModule", {
  value: !0
});
var od = Ga.TIMEZONES = void 0, wI = [{
  country: "CI",
  name: "Africa/Abidjan",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "GH",
  name: "Africa/Accra",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "ET",
  name: "Africa/Addis_Ababa",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "DZ",
  name: "Africa/Algiers",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "ER",
  name: "Africa/Asmara",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "ER",
  name: "Africa/Asmera",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "ML",
  name: "Africa/Bamako",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "CF",
  name: "Africa/Bangui",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "GM",
  name: "Africa/Banjul",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "GW",
  name: "Africa/Bissau",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "MW",
  name: "Africa/Blantyre",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "CG",
  name: "Africa/Brazzaville",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "BI",
  name: "Africa/Bujumbura",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "EG",
  name: "Africa/Cairo",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "MA",
  name: "Africa/Casablanca",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "ES",
  name: "Africa/Ceuta",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "GN",
  name: "Africa/Conakry",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "SN",
  name: "Africa/Dakar",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "TZ",
  name: "Africa/Dar_es_Salaam",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "DJ",
  name: "Africa/Djibouti",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "CM",
  name: "Africa/Douala",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "EH",
  name: "Africa/El_Aaiun",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "SL",
  name: "Africa/Freetown",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "BW",
  name: "Africa/Gaborone",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "ZW",
  name: "Africa/Harare",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "ZA",
  name: "Africa/Johannesburg",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "SS",
  name: "Africa/Juba",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "UG",
  name: "Africa/Kampala",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "SD",
  name: "Africa/Khartoum",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "RW",
  name: "Africa/Kigali",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "CD",
  name: "Africa/Kinshasa",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "NG",
  name: "Africa/Lagos",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "GA",
  name: "Africa/Libreville",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "TG",
  name: "Africa/Lome",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "AO",
  name: "Africa/Luanda",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "CD",
  name: "Africa/Lubumbashi",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "ZM",
  name: "Africa/Lusaka",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "GQ",
  name: "Africa/Malabo",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "MZ",
  name: "Africa/Maputo",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "LS",
  name: "Africa/Maseru",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Johannesburg"
}, {
  country: "SZ",
  name: "Africa/Mbabane",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Johannesburg"
}, {
  country: "SO",
  name: "Africa/Mogadishu",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "LR",
  name: "Africa/Monrovia",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "KE",
  name: "Africa/Nairobi",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "TD",
  name: "Africa/Ndjamena",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "NE",
  name: "Africa/Niamey",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "MR",
  name: "Africa/Nouakchott",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "BF",
  name: "Africa/Ouagadougou",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "BJ",
  name: "Africa/Porto-Novo",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "ST",
  name: "Africa/Sao_Tome",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "ML",
  name: "Africa/Timbuktu",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "LY",
  name: "Africa/Tripoli",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "TN",
  name: "Africa/Tunis",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "NA",
  name: "Africa/Windhoek",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "US",
  name: "America/Adak",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "US",
  name: "America/Anchorage",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "AI",
  name: "America/Anguilla",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "AG",
  name: "America/Antigua",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Araguaina",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Buenos_Aires",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Catamarca",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/ComodRivadavia",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Catamarca"
}, {
  country: "AR",
  name: "America/Argentina/Cordoba",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Jujuy",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/La_Rioja",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Mendoza",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Rio_Gallegos",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Salta",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/San_Juan",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/San_Luis",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Tucuman",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Ushuaia",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AW",
  name: "America/Aruba",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "PY",
  name: "America/Asuncion",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CA",
  name: "America/Atikokan",
  status: "Link",
  offset: "−05:00",
  link: "America/Panama"
}, {
  country: "US",
  name: "America/Atka",
  status: "Link",
  offset: "−10:00",
  link: "America/Adak"
}, {
  country: "BR",
  name: "America/Bahia",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "MX",
  name: "America/Bahia_Banderas",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BB",
  name: "America/Barbados",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "BR",
  name: "America/Belem",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "BZ",
  name: "America/Belize",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "CA",
  name: "America/Blanc-Sablon",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Boa_Vista",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CO",
  name: "America/Bogota",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Boise",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "AR",
  name: "America/Buenos_Aires",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Buenos_Aires"
}, {
  country: "CA",
  name: "America/Cambridge_Bay",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "BR",
  name: "America/Campo_Grande",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MX",
  name: "America/Cancun",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "VE",
  name: "America/Caracas",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "AR",
  name: "America/Catamarca",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Catamarca"
}, {
  country: "GF",
  name: "America/Cayenne",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "KY",
  name: "America/Cayman",
  status: "Link",
  offset: "−05:00",
  link: "America/Panama"
}, {
  country: "US",
  name: "America/Chicago",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Chihuahua",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Ciudad_Juarez",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Coral_Harbour",
  status: "Link",
  offset: "−05:00",
  link: "America/Panama"
}, {
  country: "AR",
  name: "America/Cordoba",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Cordoba"
}, {
  country: "CR",
  name: "America/Costa_Rica",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "CA",
  name: "America/Creston",
  status: "Link",
  offset: "−07:00",
  link: "America/Phoenix"
}, {
  country: "BR",
  name: "America/Cuiaba",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CW",
  name: "America/Curacao",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "GL",
  name: "America/Danmarkshavn",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "CA",
  name: "America/Dawson",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Dawson_Creek",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Denver",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Detroit",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "DM",
  name: "America/Dominica",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Edmonton",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "BR",
  name: "America/Eirunepe",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "SV",
  name: "America/El_Salvador",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Ensenada",
  status: "Link",
  offset: "−08:00",
  link: "America/Tijuana"
}, {
  country: "CA",
  name: "America/Fort_Nelson",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Fort_Wayne",
  status: "Link",
  offset: "−05:00",
  link: "America/Indiana/Indianapolis"
}, {
  country: "BR",
  name: "America/Fortaleza",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Glace_Bay",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "GL",
  name: "America/Godthab",
  status: "Link",
  offset: "−02:00",
  link: "America/Nuuk"
}, {
  country: "CA",
  name: "America/Goose_Bay",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "TC",
  name: "America/Grand_Turk",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "GD",
  name: "America/Grenada",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "GP",
  name: "America/Guadeloupe",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "GT",
  name: "America/Guatemala",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "EC",
  name: "America/Guayaquil",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "GY",
  name: "America/Guyana",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CA",
  name: "America/Halifax",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CU",
  name: "America/Havana",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "MX",
  name: "America/Hermosillo",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Indianapolis",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Knox",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Marengo",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Petersburg",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Tell_City",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Vevay",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Vincennes",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Winamac",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indianapolis",
  status: "Link",
  offset: "−05:00",
  link: "America/Indiana/Indianapolis"
}, {
  country: "CA",
  name: "America/Inuvik",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Iqaluit",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "JM",
  name: "America/Jamaica",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "AR",
  name: "America/Jujuy",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Jujuy"
}, {
  country: "US",
  name: "America/Juneau",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "US",
  name: "America/Kentucky/Louisville",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Kentucky/Monticello",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Knox_IN",
  status: "Link",
  offset: "−06:00",
  link: "America/Indiana/Knox"
}, {
  country: "BQ",
  name: "America/Kralendijk",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BO",
  name: "America/La_Paz",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "PE",
  name: "America/Lima",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Los_Angeles",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "US",
  name: "America/Louisville",
  status: "Link",
  offset: "−05:00",
  link: "America/Kentucky/Louisville"
}, {
  country: "SX",
  name: "America/Lower_Princes",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Maceio",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "NI",
  name: "America/Managua",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BR",
  name: "America/Manaus",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MF",
  name: "America/Marigot",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "MQ",
  name: "America/Martinique",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MX",
  name: "America/Matamoros",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Mazatlan",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "AR",
  name: "America/Mendoza",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Mendoza"
}, {
  country: "US",
  name: "America/Menominee",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Merida",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Metlakatla",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "MX",
  name: "America/Mexico_City",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "PM",
  name: "America/Miquelon",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Moncton",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MX",
  name: "America/Monterrey",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "UY",
  name: "America/Montevideo",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Montreal",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "MS",
  name: "America/Montserrat",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BS",
  name: "America/Nassau",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "US",
  name: "America/New_York",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "CA",
  name: "America/Nipigon",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "US",
  name: "America/Nome",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "BR",
  name: "America/Noronha",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "US",
  name: "America/North_Dakota/Beulah",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/North_Dakota/Center",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/North_Dakota/New_Salem",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "GL",
  name: "America/Nuuk",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "MX",
  name: "America/Ojinaga",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "PA",
  name: "America/Panama",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "CA",
  name: "America/Pangnirtung",
  status: "Link",
  offset: "−05:00",
  link: "America/Iqaluit"
}, {
  country: "SR",
  name: "America/Paramaribo",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "US",
  name: "America/Phoenix",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "HT",
  name: "America/Port-au-Prince",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "TT",
  name: "America/Port_of_Spain",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Porto_Acre",
  status: "Link",
  offset: "−05:00",
  link: "America/Rio_Branco"
}, {
  country: "BR",
  name: "America/Porto_Velho",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "PR",
  name: "America/Puerto_Rico",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CL",
  name: "America/Punta_Arenas",
  status: "Canonical",
  offset: "−03:00",
  link: "Magallanes Region"
}, {
  country: "CA",
  name: "America/Rainy_River",
  status: "Link",
  offset: "−06:00",
  link: "America/Winnipeg"
}, {
  country: "CA",
  name: "America/Rankin_Inlet",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BR",
  name: "America/Recife",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Regina",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "CA",
  name: "America/Resolute",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BR",
  name: "America/Rio_Branco",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "AR",
  name: "America/Rosario",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Cordoba"
}, {
  country: "MX",
  name: "America/Santa_Isabel",
  status: "Link",
  offset: "−08:00",
  link: "America/Tijuana"
}, {
  country: "BR",
  name: "America/Santarem",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CL",
  name: "America/Santiago",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "DO",
  name: "America/Santo_Domingo",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "BR",
  name: "America/Sao_Paulo",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "GL",
  name: "America/Scoresbysund",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "US",
  name: "America/Shiprock",
  status: "Link",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "US",
  name: "America/Sitka",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "BL",
  name: "America/St_Barthelemy",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/St_Johns",
  status: "Canonical",
  offset: "−03:30",
  link: ""
}, {
  country: "KN",
  name: "America/St_Kitts",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "LC",
  name: "America/St_Lucia",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "VI",
  name: "America/St_Thomas",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "VC",
  name: "America/St_Vincent",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Swift_Current",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "HN",
  name: "America/Tegucigalpa",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "GL",
  name: "America/Thule",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CA",
  name: "America/Thunder_Bay",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "MX",
  name: "America/Tijuana",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "CA",
  name: "America/Toronto",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "VG",
  name: "America/Tortola",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Vancouver",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "VI",
  name: "America/Virgin",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Whitehorse",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Winnipeg",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Yakutat",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "CA",
  name: "America/Yellowknife",
  status: "Link",
  offset: "−07:00",
  link: "America/Edmonton"
}, {
  country: "AQ",
  name: "Antarctica/Casey",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/Davis",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/DumontDUrville",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "AU",
  name: "Antarctica/Macquarie",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/Mawson",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/McMurdo",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Auckland"
}, {
  country: "AQ",
  name: "Antarctica/Palmer",
  status: "Canonical",
  offset: "−03:00",
  link: "Chilean Antarctica Region"
}, {
  country: "AQ",
  name: "Antarctica/Rothera",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/South_Pole",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Auckland"
}, {
  country: "AQ",
  name: "Antarctica/Syowa",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Riyadh"
}, {
  country: "AQ",
  name: "Antarctica/Troll",
  status: "Canonical",
  offset: "+00:00",
  link: "+01:00"
}, {
  country: "AQ",
  name: "Antarctica/Vostok",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "SJ",
  name: "Arctic/Longyearbyen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "YE",
  name: "Asia/Aden",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Riyadh"
}, {
  country: "KZ",
  name: "Asia/Almaty",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "JO",
  name: "Asia/Amman",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Anadyr",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Aqtau",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Aqtobe",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "TM",
  name: "Asia/Ashgabat",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "TM",
  name: "Asia/Ashkhabad",
  status: "Link",
  offset: "+05:00",
  link: "Asia/Ashgabat"
}, {
  country: "KZ",
  name: "Asia/Atyrau",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "IQ",
  name: "Asia/Baghdad",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "BH",
  name: "Asia/Bahrain",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Qatar"
}, {
  country: "AZ",
  name: "Asia/Baku",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "TH",
  name: "Asia/Bangkok",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Barnaul",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "LB",
  name: "Asia/Beirut",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "KG",
  name: "Asia/Bishkek",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "BN",
  name: "Asia/Brunei",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Kuching"
}, {
  country: "IN",
  name: "Asia/Calcutta",
  status: "Link",
  offset: "+05:30",
  link: "Asia/Kolkata"
}, {
  country: "RU",
  name: "Asia/Chita",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "MN",
  name: "Asia/Choibalsan",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Chongqing",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "CN",
  name: "Asia/Chungking",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "LK",
  name: "Asia/Colombo",
  status: "Canonical",
  offset: "+05:30",
  link: ""
}, {
  country: "BD",
  name: "Asia/Dacca",
  status: "Link",
  offset: "+06:00",
  link: "Asia/Dhaka"
}, {
  country: "SY",
  name: "Asia/Damascus",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "BD",
  name: "Asia/Dhaka",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "TL",
  name: "Asia/Dili",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "AE",
  name: "Asia/Dubai",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "TJ",
  name: "Asia/Dushanbe",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "CY",
  name: "Asia/Famagusta",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "PS",
  name: "Asia/Gaza",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Harbin",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "PS",
  name: "Asia/Hebron",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "VN",
  name: "Asia/Ho_Chi_Minh",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "HK",
  name: "Asia/Hong_Kong",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "MN",
  name: "Asia/Hovd",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Irkutsk",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "TR",
  name: "Asia/Istanbul",
  status: "Link",
  offset: "+03:00",
  link: "Europe/Istanbul"
}, {
  country: "ID",
  name: "Asia/Jakarta",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "ID",
  name: "Asia/Jayapura",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "IL",
  name: "Asia/Jerusalem",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "AF",
  name: "Asia/Kabul",
  status: "Canonical",
  offset: "+04:30",
  link: ""
}, {
  country: "RU",
  name: "Asia/Kamchatka",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "PK",
  name: "Asia/Karachi",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Kashgar",
  status: "Link",
  offset: "+06:00",
  link: "Asia/Urumqi"
}, {
  country: "NP",
  name: "Asia/Kathmandu",
  status: "Canonical",
  offset: "+05:45",
  link: ""
}, {
  country: "NP",
  name: "Asia/Katmandu",
  status: "Link",
  offset: "+05:45",
  link: "Asia/Kathmandu"
}, {
  country: "RU",
  name: "Asia/Khandyga",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "IN",
  name: "Asia/Kolkata",
  status: "Canonical",
  offset: "+05:30",
  link: "Time in India"
}, {
  country: "RU",
  name: "Asia/Krasnoyarsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "MY",
  name: "Asia/Kuala_Lumpur",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Singapore"
}, {
  country: "MY",
  name: "Asia/Kuching",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "KW",
  name: "Asia/Kuwait",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Riyadh"
}, {
  country: "MO",
  name: "Asia/Macao",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Macau"
}, {
  country: "MO",
  name: "Asia/Macau",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Magadan",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "ID",
  name: "Asia/Makassar",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "PH",
  name: "Asia/Manila",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "OM",
  name: "Asia/Muscat",
  status: "Link",
  offset: "+04:00",
  link: "Asia/Dubai"
}, {
  country: "CY",
  name: "Asia/Nicosia",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Novokuznetsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Novosibirsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Omsk",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Oral",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KH",
  name: "Asia/Phnom_Penh",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Bangkok"
}, {
  country: "ID",
  name: "Asia/Pontianak",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "KP",
  name: "Asia/Pyongyang",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "QA",
  name: "Asia/Qatar",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Qostanay",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Qyzylorda",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "MM",
  name: "Asia/Rangoon",
  status: "Link",
  offset: "+06:30",
  link: "Asia/Yangon"
}, {
  country: "SA",
  name: "Asia/Riyadh",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "VN",
  name: "Asia/Saigon",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Ho_Chi_Minh"
}, {
  country: "RU",
  name: "Asia/Sakhalin",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "UZ",
  name: "Asia/Samarkand",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KR",
  name: "Asia/Seoul",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Shanghai",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "SG",
  name: "Asia/Singapore",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Srednekolymsk",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "TW",
  name: "Asia/Taipei",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "UZ",
  name: "Asia/Tashkent",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "GE",
  name: "Asia/Tbilisi",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "IR",
  name: "Asia/Tehran",
  status: "Canonical",
  offset: "+03:30",
  link: ""
}, {
  country: "IL",
  name: "Asia/Tel_Aviv",
  status: "Link",
  offset: "+02:00",
  link: "Asia/Jerusalem"
}, {
  country: "BT",
  name: "Asia/Thimbu",
  status: "Link",
  offset: "+06:00",
  link: "Asia/Thimphu"
}, {
  country: "BT",
  name: "Asia/Thimphu",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "JP",
  name: "Asia/Tokyo",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Tomsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "ID",
  name: "Asia/Ujung_Pandang",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Makassar"
}, {
  country: "MN",
  name: "Asia/Ulaanbaatar",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "MN",
  name: "Asia/Ulan_Bator",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Ulaanbaatar"
}, {
  country: "CN",
  name: "Asia/Urumqi",
  status: "Canonical",
  offset: "+06:00",
  link: "Asia/Urumqi"
}, {
  country: "RU",
  name: "Asia/Ust-Nera",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "LA",
  name: "Asia/Vientiane",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Bangkok"
}, {
  country: "RU",
  name: "Asia/Vladivostok",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Yakutsk",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "MM",
  name: "Asia/Yangon",
  status: "Canonical",
  offset: "+06:30",
  link: ""
}, {
  country: "RU",
  name: "Asia/Yekaterinburg",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "AM",
  name: "Asia/Yerevan",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "PT",
  name: "Atlantic/Azores",
  status: "Canonical",
  offset: "−01:00",
  link: ""
}, {
  country: "BM",
  name: "Atlantic/Bermuda",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "ES",
  name: "Atlantic/Canary",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "CV",
  name: "Atlantic/Cape_Verde",
  status: "Canonical",
  offset: "−01:00",
  link: ""
}, {
  country: "FO",
  name: "Atlantic/Faeroe",
  status: "Link",
  offset: "+00:00",
  link: "Atlantic/Faroe"
}, {
  country: "FO",
  name: "Atlantic/Faroe",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "SJ",
  name: "Atlantic/Jan_Mayen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "PT",
  name: "Atlantic/Madeira",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "IS",
  name: "Atlantic/Reykjavik",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "GS",
  name: "Atlantic/South_Georgia",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "SH",
  name: "Atlantic/St_Helena",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "FK",
  name: "Atlantic/Stanley",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/ACT",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Sydney"
}, {
  country: "AU",
  name: "Australia/Adelaide",
  status: "Canonical",
  offset: "+09:30",
  link: ""
}, {
  country: "AU",
  name: "Australia/Brisbane",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Broken_Hill",
  status: "Canonical",
  offset: "+09:30",
  link: ""
}, {
  country: "AU",
  name: "Australia/Canberra",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Sydney"
}, {
  country: "AU",
  name: "Australia/Currie",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Hobart"
}, {
  country: "AU",
  name: "Australia/Darwin",
  status: "Canonical",
  offset: "+09:30",
  link: ""
}, {
  country: "AU",
  name: "Australia/Eucla",
  status: "Canonical",
  offset: "+08:45",
  link: ""
}, {
  country: "AU",
  name: "Australia/Hobart",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/LHI",
  status: "Link",
  offset: "+10:30",
  link: "Australia/Lord_Howe"
}, {
  country: "AU",
  name: "Australia/Lindeman",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Lord_Howe",
  status: "Canonical",
  offset: "+10:30",
  link: "This is the only time zone in the world that uses 30-minute DST transitions."
}, {
  country: "AU",
  name: "Australia/Melbourne",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/North",
  status: "Link",
  offset: "+09:30",
  link: "Australia/Darwin"
}, {
  country: "AU",
  name: "Australia/NSW",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Sydney"
}, {
  country: "AU",
  name: "Australia/Perth",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Queensland",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Brisbane"
}, {
  country: "AU",
  name: "Australia/South",
  status: "Link",
  offset: "+09:30",
  link: "Australia/Adelaide"
}, {
  country: "AU",
  name: "Australia/Sydney",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Tasmania",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Hobart"
}, {
  country: "AU",
  name: "Australia/Victoria",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Melbourne"
}, {
  country: "AU",
  name: "Australia/West",
  status: "Link",
  offset: "+08:00",
  link: "Australia/Perth"
}, {
  country: "AU",
  name: "Australia/Yancowinna",
  status: "Link",
  offset: "+09:30",
  link: "Australia/Broken_Hill"
}, {
  country: "BR",
  name: "Brazil/Acre",
  status: "Link",
  offset: "−05:00",
  link: "America/Rio_Branco"
}, {
  country: "BR",
  name: "Brazil/DeNoronha",
  status: "Link",
  offset: "−02:00",
  link: "America/Noronha"
}, {
  country: "BR",
  name: "Brazil/East",
  status: "Link",
  offset: "−03:00",
  link: "America/Sao_Paulo"
}, {
  country: "BR",
  name: "Brazil/West",
  status: "Link",
  offset: "−04:00",
  link: "America/Manaus"
}, {
  country: "CA",
  name: "Canada/Atlantic",
  status: "Link",
  offset: "−04:00",
  link: "America/Halifax"
}, {
  country: "CA",
  name: "Canada/Central",
  status: "Link",
  offset: "−06:00",
  link: "America/Winnipeg"
}, {
  country: "CA",
  name: "Canada/Eastern",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "CA",
  name: "Canada/Mountain",
  status: "Link",
  offset: "−07:00",
  link: "America/Edmonton"
}, {
  country: "CA",
  name: "Canada/Newfoundland",
  status: "Link",
  offset: "−03:30",
  link: "America/St_Johns"
}, {
  country: "CA",
  name: "Canada/Pacific",
  status: "Link",
  offset: "−08:00",
  link: "America/Vancouver"
}, {
  country: "CA",
  name: "Canada/Saskatchewan",
  status: "Link",
  offset: "−06:00",
  link: "America/Regina"
}, {
  country: "CA",
  name: "Canada/Yukon",
  status: "Link",
  offset: "−07:00",
  link: "America/Whitehorse"
}, {
  country: "",
  name: "CET",
  status: "Canonical",
  offset: "+01:00",
  link: "Europe/Paris"
}, {
  country: "CL",
  name: "Chile/Continental",
  status: "Link",
  offset: "−04:00",
  link: "America/Santiago"
}, {
  country: "CL",
  name: "Chile/EasterIsland",
  status: "Link",
  offset: "−06:00",
  link: "Pacific/Easter"
}, {
  country: "",
  name: "CST6CDT",
  status: "Canonical",
  offset: "−06:00",
  link: "America/Chicago"
}, {
  country: "CU",
  name: "Cuba",
  status: "Link",
  offset: "−05:00",
  link: "America/Havana"
}, {
  country: "",
  name: "EET",
  status: "Canonical",
  offset: "+02:00",
  link: "Europe/Sofia"
}, {
  country: "EG",
  name: "Egypt",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Cairo"
}, {
  country: "IE",
  name: "Eire",
  status: "Link",
  offset: "+00:00",
  link: "Europe/Dublin"
}, {
  country: "",
  name: "EST",
  status: "Canonical",
  offset: "−05:00",
  link: "America/Cancun"
}, {
  country: "",
  name: "EST5EDT",
  status: "Canonical",
  offset: "−05:00",
  link: "America/New_York"
}, {
  country: "",
  name: "Etc/GMT",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "",
  name: "Etc/GMT+0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/GMT+1",
  status: "Canonical",
  offset: "−01:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+10",
  status: "Canonical",
  offset: "−10:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+11",
  status: "Canonical",
  offset: "−11:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+12",
  status: "Canonical",
  offset: "−12:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+2",
  status: "Canonical",
  offset: "−02:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+3",
  status: "Canonical",
  offset: "−03:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+4",
  status: "Canonical",
  offset: "−04:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+5",
  status: "Canonical",
  offset: "−05:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+6",
  status: "Canonical",
  offset: "−06:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+7",
  status: "Canonical",
  offset: "−07:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+8",
  status: "Canonical",
  offset: "−08:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+9",
  status: "Canonical",
  offset: "−09:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/GMT-1",
  status: "Canonical",
  offset: "+01:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-10",
  status: "Canonical",
  offset: "+10:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-11",
  status: "Canonical",
  offset: "+11:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-12",
  status: "Canonical",
  offset: "+12:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-13",
  status: "Canonical",
  offset: "+13:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-14",
  status: "Canonical",
  offset: "+14:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-2",
  status: "Canonical",
  offset: "+02:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-3",
  status: "Canonical",
  offset: "+03:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-4",
  status: "Canonical",
  offset: "+04:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-5",
  status: "Canonical",
  offset: "+05:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-6",
  status: "Canonical",
  offset: "+06:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-7",
  status: "Canonical",
  offset: "+07:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-8",
  status: "Canonical",
  offset: "+08:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-9",
  status: "Canonical",
  offset: "+09:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/Greenwich",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/UCT",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "",
  name: "Etc/Universal",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "",
  name: "Etc/UTC",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "",
  name: "Etc/Zulu",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "NL",
  name: "Europe/Amsterdam",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Brussels"
}, {
  country: "AD",
  name: "Europe/Andorra",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Astrakhan",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "GR",
  name: "Europe/Athens",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "GB",
  name: "Europe/Belfast",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "RS",
  name: "Europe/Belgrade",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "DE",
  name: "Europe/Berlin",
  status: "Canonical",
  offset: "+01:00",
  link: "Trizone"
}, {
  country: "SK",
  name: "Europe/Bratislava",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Prague"
}, {
  country: "BE",
  name: "Europe/Brussels",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "RO",
  name: "Europe/Bucharest",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "HU",
  name: "Europe/Budapest",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "DE",
  name: "Europe/Busingen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Zurich"
}, {
  country: "MD",
  name: "Europe/Chisinau",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "DK",
  name: "Europe/Copenhagen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "IE",
  name: "Europe/Dublin",
  status: "Canonical",
  offset: "+00:00",
  link: "Irish Standard Time"
}, {
  country: "GI",
  name: "Europe/Gibraltar",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "GG",
  name: "Europe/Guernsey",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "FI",
  name: "Europe/Helsinki",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "IM",
  name: "Europe/Isle_of_Man",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "TR",
  name: "Europe/Istanbul",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "JE",
  name: "Europe/Jersey",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "RU",
  name: "Europe/Kaliningrad",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "UA",
  name: "Europe/Kiev",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Kyiv"
}, {
  country: "RU",
  name: "Europe/Kirov",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "UA",
  name: "Europe/Kyiv",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "PT",
  name: "Europe/Lisbon",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "SI",
  name: "Europe/Ljubljana",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "GB",
  name: "Europe/London",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "LU",
  name: "Europe/Luxembourg",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Brussels"
}, {
  country: "ES",
  name: "Europe/Madrid",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "MT",
  name: "Europe/Malta",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "AX",
  name: "Europe/Mariehamn",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Helsinki"
}, {
  country: "BY",
  name: "Europe/Minsk",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "MC",
  name: "Europe/Monaco",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Paris"
}, {
  country: "RU",
  name: "Europe/Moscow",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "CY",
  name: "Europe/Nicosia",
  status: "Link",
  offset: "+02:00",
  link: "Asia/Nicosia"
}, {
  country: "NO",
  name: "Europe/Oslo",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "FR",
  name: "Europe/Paris",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "ME",
  name: "Europe/Podgorica",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "CZ",
  name: "Europe/Prague",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "LV",
  name: "Europe/Riga",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "IT",
  name: "Europe/Rome",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Samara",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "SM",
  name: "Europe/San_Marino",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Rome"
}, {
  country: "BA",
  name: "Europe/Sarajevo",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "RU",
  name: "Europe/Saratov",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Simferopol",
  status: "Canonical",
  offset: "+03:00",
  link: "Disputed - Reflects data in the TZDB."
}, {
  country: "MK",
  name: "Europe/Skopje",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "BG",
  name: "Europe/Sofia",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "SE",
  name: "Europe/Stockholm",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "EE",
  name: "Europe/Tallinn",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "AL",
  name: "Europe/Tirane",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "MD",
  name: "Europe/Tiraspol",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Chisinau"
}, {
  country: "RU",
  name: "Europe/Ulyanovsk",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "UA",
  name: "Europe/Uzhgorod",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Kyiv"
}, {
  country: "LI",
  name: "Europe/Vaduz",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Zurich"
}, {
  country: "VA",
  name: "Europe/Vatican",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Rome"
}, {
  country: "AT",
  name: "Europe/Vienna",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "LT",
  name: "Europe/Vilnius",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Volgograd",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "PL",
  name: "Europe/Warsaw",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "HR",
  name: "Europe/Zagreb",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "UA",
  name: "Europe/Zaporozhye",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Kyiv"
}, {
  country: "CH",
  name: "Europe/Zurich",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "",
  name: "Factory",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "GB",
  name: "GB",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "GB",
  name: "GB-Eire",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "",
  name: "GMT",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "GMT+0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "GMT-0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "GMT0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Greenwich",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "HK",
  name: "Hongkong",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Hong_Kong"
}, {
  country: "",
  name: "HST",
  status: "Canonical",
  offset: "−10:00",
  link: "Pacific/Honolulu"
}, {
  country: "IS",
  name: "Iceland",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "MG",
  name: "Indian/Antananarivo",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "IO",
  name: "Indian/Chagos",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "CX",
  name: "Indian/Christmas",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Bangkok"
}, {
  country: "CC",
  name: "Indian/Cocos",
  status: "Link",
  offset: "+06:30",
  link: "Asia/Yangon"
}, {
  country: "KM",
  name: "Indian/Comoro",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "TF",
  name: "Indian/Kerguelen",
  status: "Link",
  offset: "+05:00",
  link: "Indian/Maldives"
}, {
  country: "SC",
  name: "Indian/Mahe",
  status: "Link",
  offset: "+04:00",
  link: "Asia/Dubai"
}, {
  country: "MV",
  name: "Indian/Maldives",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "MU",
  name: "Indian/Mauritius",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "YT",
  name: "Indian/Mayotte",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "RE",
  name: "Indian/Reunion",
  status: "Link",
  offset: "+04:00",
  link: "Asia/Dubai"
}, {
  country: "IR",
  name: "Iran",
  status: "Link",
  offset: "+03:30",
  link: "Asia/Tehran"
}, {
  country: "IL",
  name: "Israel",
  status: "Link",
  offset: "+02:00",
  link: "Asia/Jerusalem"
}, {
  country: "JM",
  name: "Jamaica",
  status: "Link",
  offset: "−05:00",
  link: "America/Jamaica"
}, {
  country: "JP",
  name: "Japan",
  status: "Link",
  offset: "+09:00",
  link: "Asia/Tokyo"
}, {
  country: "MH",
  name: "Kwajalein",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Kwajalein"
}, {
  country: "LY",
  name: "Libya",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Tripoli"
}, {
  country: "",
  name: "MET",
  status: "Canonical",
  offset: "+01:00",
  link: "Europe/Paris"
}, {
  country: "MX",
  name: "Mexico/BajaNorte",
  status: "Link",
  offset: "−08:00",
  link: "America/Tijuana"
}, {
  country: "MX",
  name: "Mexico/BajaSur",
  status: "Link",
  offset: "−07:00",
  link: "America/Mazatlan"
}, {
  country: "MX",
  name: "Mexico/General",
  status: "Link",
  offset: "−06:00",
  link: "America/Mexico_City"
}, {
  country: "",
  name: "MST",
  status: "Canonical",
  offset: "−07:00",
  link: "America/Phoenix"
}, {
  country: "",
  name: "MST7MDT",
  status: "Canonical",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "US",
  name: "Navajo",
  status: "Link",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "NZ",
  name: "NZ",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Auckland"
}, {
  country: "NZ",
  name: "NZ-CHAT",
  status: "Link",
  offset: "+12:45",
  link: "Pacific/Chatham"
}, {
  country: "WS",
  name: "Pacific/Apia",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "NZ",
  name: "Pacific/Auckland",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "PG",
  name: "Pacific/Bougainville",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "NZ",
  name: "Pacific/Chatham",
  status: "Canonical",
  offset: "+12:45",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Chuuk",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "CL",
  name: "Pacific/Easter",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "VU",
  name: "Pacific/Efate",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "KI",
  name: "Pacific/Enderbury",
  status: "Link",
  offset: "+13:00",
  link: "Pacific/Kanton"
}, {
  country: "TK",
  name: "Pacific/Fakaofo",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "FJ",
  name: "Pacific/Fiji",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "TV",
  name: "Pacific/Funafuti",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "EC",
  name: "Pacific/Galapagos",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "PF",
  name: "Pacific/Gambier",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "SB",
  name: "Pacific/Guadalcanal",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "GU",
  name: "Pacific/Guam",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "US",
  name: "Pacific/Honolulu",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "US",
  name: "Pacific/Johnston",
  status: "Link",
  offset: "−10:00",
  link: "Pacific/Honolulu"
}, {
  country: "KI",
  name: "Pacific/Kanton",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "KI",
  name: "Pacific/Kiritimati",
  status: "Canonical",
  offset: "+14:00",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Kosrae",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "MH",
  name: "Pacific/Kwajalein",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "MH",
  name: "Pacific/Majuro",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "PF",
  name: "Pacific/Marquesas",
  status: "Canonical",
  offset: "−09:30",
  link: ""
}, {
  country: "UM",
  name: "Pacific/Midway",
  status: "Link",
  offset: "−11:00",
  link: "Pacific/Pago_Pago"
}, {
  country: "NR",
  name: "Pacific/Nauru",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "NU",
  name: "Pacific/Niue",
  status: "Canonical",
  offset: "−11:00",
  link: ""
}, {
  country: "NF",
  name: "Pacific/Norfolk",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "NC",
  name: "Pacific/Noumea",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "AS",
  name: "Pacific/Pago_Pago",
  status: "Canonical",
  offset: "−11:00",
  link: ""
}, {
  country: "PW",
  name: "Pacific/Palau",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "PN",
  name: "Pacific/Pitcairn",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Pohnpei",
  status: "Link",
  offset: "+11:00",
  link: "Pacific/Guadalcanal"
}, {
  country: "FM",
  name: "Pacific/Ponape",
  status: "Link",
  offset: "+11:00",
  link: "Pacific/Guadalcanal"
}, {
  country: "PG",
  name: "Pacific/Port_Moresby",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "CK",
  name: "Pacific/Rarotonga",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "MP",
  name: "Pacific/Saipan",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Guam"
}, {
  country: "AS",
  name: "Pacific/Samoa",
  status: "Link",
  offset: "−11:00",
  link: "Pacific/Pago_Pago"
}, {
  country: "PF",
  name: "Pacific/Tahiti",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "KI",
  name: "Pacific/Tarawa",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "TO",
  name: "Pacific/Tongatapu",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Truk",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "UM",
  name: "Pacific/Wake",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "WF",
  name: "Pacific/Wallis",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "FM",
  name: "Pacific/Yap",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "PL",
  name: "Poland",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Warsaw"
}, {
  country: "PT",
  name: "Portugal",
  status: "Link",
  offset: "+00:00",
  link: "Europe/Lisbon"
}, {
  country: "CN",
  name: "PRC",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "",
  name: "PST8PDT",
  status: "Canonical",
  offset: "−08:00",
  link: "America/Los_Angeles"
}, {
  country: "TW",
  name: "ROC",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Taipei"
}, {
  country: "KR",
  name: "ROK",
  status: "Link",
  offset: "+09:00",
  link: "Asia/Seoul"
}, {
  country: "SG",
  name: "Singapore",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Singapore"
}, {
  country: "TR",
  name: "Turkey",
  status: "Link",
  offset: "+03:00",
  link: "Europe/Istanbul"
}, {
  country: "",
  name: "UCT",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "",
  name: "Universal",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "US",
  name: "US/Alaska",
  status: "Link",
  offset: "−09:00",
  link: "America/Anchorage"
}, {
  country: "US",
  name: "US/Aleutian",
  status: "Link",
  offset: "−10:00",
  link: "America/Adak"
}, {
  country: "US",
  name: "US/Arizona",
  status: "Link",
  offset: "−07:00",
  link: "America/Phoenix"
}, {
  country: "US",
  name: "US/Central",
  status: "Link",
  offset: "−06:00",
  link: "America/Chicago"
}, {
  country: "US",
  name: "US/East-Indiana",
  status: "Link",
  offset: "−05:00",
  link: "America/Indiana/Indianapolis"
}, {
  country: "US",
  name: "US/Eastern",
  status: "Link",
  offset: "−05:00",
  link: "America/New_York"
}, {
  country: "US",
  name: "US/Hawaii",
  status: "Link",
  offset: "−10:00",
  link: "Pacific/Honolulu"
}, {
  country: "US",
  name: "US/Indiana-Starke",
  status: "Link",
  offset: "−06:00",
  link: "America/Indiana/Knox"
}, {
  country: "US",
  name: "US/Michigan",
  status: "Link",
  offset: "−05:00",
  link: "America/Detroit"
}, {
  country: "US",
  name: "US/Mountain",
  status: "Link",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "US",
  name: "US/Pacific",
  status: "Link",
  offset: "−08:00",
  link: "America/Los_Angeles"
}, {
  country: "AS",
  name: "US/Samoa",
  status: "Link",
  offset: "−11:00",
  link: "Pacific/Pago_Pago"
}, {
  country: "",
  name: "UTC",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "RU",
  name: "W-SU",
  status: "Link",
  offset: "+03:00",
  link: "Europe/Moscow"
}, {
  country: "",
  name: "WET",
  status: "Canonical",
  offset: "+00:00",
  link: "Europe/Lisbon"
}, {
  country: "",
  name: "Zulu",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}];
od = Ga.TIMEZONES = wI;
const kI = /* @__PURE__ */ ql({
  __proto__: null,
  get TIMEZONES() {
    return od;
  },
  default: Ga
}, [Ga]), _I = /* @__PURE__ */ ad(kI);
Object.defineProperty(ut, "__esModule", {
  value: !0
});
var id = ut.findTzByKey = ld = ut.findTzByName = rd = ut.tzRawData = cd = ut.clientTz = dd = ut.listTz = void 0, Ji = _I, SI = Ji.TIMEZONES, rd = ut.tzRawData = SI, qi = function(t) {
  return Ji.TIMEZONES.find(function(n) {
    return n.name === t;
  });
};
id = ut.findTzByKey = qi;
var TI = function(t, n) {
  var a = n || ud();
  return a.find(function(s) {
    return s.included && s.included.includes(t);
  });
}, ld = ut.findTzByName = TI, Ql = function(t) {
  var n = t.data, a = t.displayName, s = t.offset;
  return {
    value: n.name,
    label: "(GMT".concat(n.offset, ") ").concat(a),
    included: [n.name],
    country: n.country,
    offset: n.offset,
    offsetValue: s
  };
}, LI = function() {
  var t = Intl.DateTimeFormat().resolvedOptions().timeZone, n = qi(t);
  return n.status === "Deprecated" ? n.link : t;
}, cd = ut.clientTz = LI, Ul = function(t) {
  var n = t.offset.split(/\d+/g), a;
  n[0] === "+" ? a = "+" : a = "-", t.offset = t.offset.replace(n[0], a);
  var s = +t.offset.replace(":", ""), o = t.name.split("/").slice(1), i = o.join("-").replace(/_/g, " "), r = "".concat(t.country, "_").concat(t.offset);
  return {
    key: r,
    offset: s,
    displayName: i
  };
}, ud = function() {
  var t = Ji.TIMEZONES.reduce(function(n, a) {
    if (a.status === "Deprecated") {
      if (a.link) {
        var s = qi(a.link), o = Ul(s), i = o.key, r = o.displayName, l = o.offset;
        n[i] ? n[i].included.push(a.name) : n[i] = Ql({
          data: s,
          displayName: r,
          offset: l
        });
      }
    } else if (a.country !== "") {
      var c = Ul(a), u = c.key, p = c.displayName, m = c.offset;
      n[u] ? n[u].included && !n[u].included.includes(a.name) && (n[u].label += ", ".concat(p), n[u].included.push(a.name)) : n[u] = Ql({
        data: a,
        displayName: p,
        offset: m
      });
    }
    return n;
  }, {});
  return Object.values(t).sort(function(n, a) {
    return n.offsetValue - a.offsetValue;
  });
}, dd = ut.listTz = ud;
const DI = /* @__PURE__ */ ql({
  __proto__: null,
  get clientTz() {
    return cd;
  },
  default: ut,
  get findTzByKey() {
    return id;
  },
  get findTzByName() {
    return ld;
  },
  get listTz() {
    return dd;
  },
  get tzRawData() {
    return rd;
  }
}, [ut]), MI = /* @__PURE__ */ ad(DI);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "listTz", {
    enumerable: !0,
    get: function() {
      return t.listTz;
    }
  }), Object.defineProperty(e, "clientTz", {
    enumerable: !0,
    get: function() {
      return t.clientTz;
    }
  }), Object.defineProperty(e, "findTzByName", {
    enumerable: !0,
    get: function() {
      return t.findTzByName;
    }
  }), Object.defineProperty(e, "tzRawData", {
    enumerable: !0,
    get: function() {
      return t.tzRawData;
    }
  }), Object.defineProperty(e, "findTzByKey", {
    enumerable: !0,
    get: function() {
      return t.findTzByKey;
    }
  });
  var t = MI;
})(sd);
const OI = 70, NI = 60, RS = /* @__PURE__ */ Y({
  __name: "AppTimezoneComponent",
  setup(e) {
    const t = B0(), n = Jn(), a = typeof window < "u" && window.innerHeight < 1200 ? NI : OI, s = L(), i = sd.listTz().flatMap((m) => p(m)), r = Ku(), l = L(r.getUser()), c = L(l.value.additionalData.timezone), u = async (m) => {
      await t.setUserTimezone(m.value), n.updateUserTimezone(m.value);
    };
    function p(m) {
      if (!m.label || m.label.length <= a || !m.label.includes(","))
        return [m];
      const v = Array.isArray(m.included) && m.included.length ? m.included : [m.value], A = m.label.split(",").map((f) => f.trim()).filter(Boolean), h = m.label.match(/^\(GMT[^)]+\)/), d = h ? `${h[0]}` : "";
      return v.map((f, g) => {
        const B = A[g] ?? A[A.length - 1] ?? m.label, E = B.startsWith("(GMT") || !d ? B : `${d} ${B}`;
        return {
          ...m,
          value: f,
          label: E,
          included: [f]
        };
      });
    }
    return Ne(() => {
      n.getUserTimezone() !== "" ? s.value = i.find((m) => m.value === n.getUserTimezone()).value : c.value && (s.value = i.find((m) => m.value === c.value).value);
    }), (m, v) => (y(), G(k(cn), null, {
      default: T(() => [
        w(k(Ms), {
          class: "w-full timezone-select",
          modelValue: s.value,
          "onUpdate:modelValue": v[0] || (v[0] = (A) => s.value = A),
          options: k(i),
          filter: "",
          "option-value": "value",
          "option-label": "label",
          "data-cy": "user-timezone-select",
          placeholder: m.$t("shared.selectTimezone"),
          onChange: u
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }));
  }
});
var eo = /* @__PURE__ */ ((e) => (e.US = "en-US", e.EU = "it-IT", e))(eo || {});
function PS(e, t, n) {
  const a = new Date(e);
  if (isNaN(a.getTime())) return "No Date Set";
  t || (t = eo.EU);
  const s = a.getDate(), o = a.getMonth() + 1, i = a.getFullYear();
  return t.includes("US") ? a.toLocaleDateString(t, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    ...n
  }) : `${s.toString().padStart(2, "0")}.${o.toString().padStart(2, "0")}.${i}`;
}
function FS(e, t, n) {
  const a = new Date(e);
  return isNaN(a.getTime()) ? "No Time Set" : (t || (t = eo.EU), a.toLocaleTimeString(t, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: t.includes("US"),
    ...n
  }));
}
function QS(e) {
  return e || (e = eo.EU), {
    "en-US": "mm/dd/yy",
    "it-IT": "dd.mm.yy"
  }[e] || "dd.mm.yy";
}
var RI = /* @__PURE__ */ ((e) => (e[e.SHIPPING = 0] = "SHIPPING", e[e.BILLING = 1] = "BILLING", e))(RI || {}), PI = /* @__PURE__ */ ((e) => (e[e.TEXT = 0] = "TEXT", e[e.DROPDOWN = 1] = "DROPDOWN", e[e.TEXT_OR_DROPDOWN = 2] = "TEXT_OR_DROPDOWN", e))(PI || {}), FI = /* @__PURE__ */ ((e) => (e[e.WORKFLOW = 0] = "WORKFLOW", e[e.STATUS = 1] = "STATUS", e[e.PRODUCTION_STEP = 2] = "PRODUCTION_STEP", e[e.OPERATOR = 3] = "OPERATOR", e[e.CONNECTION = 4] = "CONNECTION", e[e.MACHINE = 5] = "MACHINE", e))(FI || {}), QI = /* @__PURE__ */ ((e) => (e.technician = "technician", e.technicianFullScreen = "technicianFullScreen", e.customer = "customer", e))(QI || {}), UI = /* @__PURE__ */ ((e) => (e.ORDER_ATTACHMENT = "order_attachment", e.ORDER_NO_ATTACHMENT = "order_no_attachment", e.ORDER_FROM_WEBLINK = "order_from_weblink", e))(UI || {}), YI = /* @__PURE__ */ ((e) => (e.WEBLINK = "weblink", e))(YI || {}), GI = /* @__PURE__ */ ((e) => (e[e.SAVING = 0] = "SAVING", e[e.UPLOADING = 1] = "UPLOADING", e[e.DONE = 2] = "DONE", e[e.ERROR = 3] = "ERROR", e))(GI || {}), jI = /* @__PURE__ */ ((e) => (e[e.INIT = 0] = "INIT", e[e.ADD = 1] = "ADD", e[e.EDIT = 2] = "EDIT", e[e.DELETE = 3] = "DELETE", e[e.ERROR = 4] = "ERROR", e))(jI || {}), HI = /* @__PURE__ */ ((e) => (e.PATIENT_LIST_FILTER = "patientListFilter", e.LANG = "lang", e))(HI || {});
const VI = {
  symbol: Symbol(),
  install(e) {
    const t = new Gy();
    e.config.globalProperties.$input = t, e.provide(this.symbol, t);
  }
};
function US() {
  return li(VI.symbol);
}
class KI {
  constructor(t) {
    oe(this, "instances");
    oe(this, "sessionId", "");
    this.instances = t;
  }
  applySession(t) {
    this.sessionId = t;
    for (const n of this.instances) {
      const a = n.defaults;
      a.params || (a.params = {}), a.headers.common.Authorization = `Bearer ${t}`;
    }
  }
}
const WI = {
  symbol: Symbol(),
  install(e, t) {
    const n = new KI(t.axiosInstances);
    e.config.globalProperties.$sessionManager = n, e.provide(this.symbol, n);
  }
};
function YS() {
  const e = Lt(WI.symbol);
  if (!e) throw new Error("SessionManager is null!");
  return e;
}
const zI = {
  symbol: Symbol(),
  install(e, t) {
    e.config.globalProperties.$serverApi = t, e.provide(this.symbol, t);
  }
};
function GS() {
  const e = Lt(zI.symbol);
  if (!e) throw new Error("ServerApi is null!");
  return e;
}
const $I = {
  symbol: Symbol(),
  install(e, t) {
    const n = new rs.STLLibraryAPI(t.axiosInstance);
    e.config.globalProperties.$stlApi = n, e.provide(this.symbol, n);
  }
};
function jS() {
  const e = Lt($I.symbol);
  if (!e) throw new Error("STLLibraryApi is null");
  return e;
}
export {
  RI as AddressTypeEnum,
  Uk as App,
  Yk as AppConfig,
  j as AppLanguage,
  Fi as AppLanguageComponent,
  ci as AppName,
  II as AppNotificationConfigComponent,
  Qi as AppThemeConfigComponent,
  RS as AppTimezoneComponent,
  Wp as AppType,
  w_ as ArrayBufferToBase64,
  Sp as AssetPlugin,
  tc as AssetPluginConfiguration,
  ss as AuthEventBus,
  px as AuthEvents,
  mx as AuthPlugin,
  Ax as AuthPluginVue,
  U as ButtonEnum,
  na as ColorScheme,
  wt as ColorTheme,
  _p as CreateSliderModel,
  t_ as CreateSliderRangeModel,
  n_ as CreateSwitchModel,
  ic as DEFAULT_REMOTE_SUPPORT_URL,
  oc as DEFAULT_VIDEO_TUTORIAL_URL,
  eo as DateFormatEnum,
  zk as DefaultMap,
  $k as DownloadFile,
  PI as FieldTypeEnum,
  FI as Filter,
  Zk as FilterMatchMode,
  Xl as GUIConfiguration,
  tp as GUIConfigurationPluginInstaller,
  ep as GetColorScheme,
  Zf as GetColorTheme,
  Xf as GetDefaultPosition,
  hn as IconPosition,
  de as IconType,
  BS as ImageList,
  kC as ImageListItem,
  li as InjectPlugin,
  eS as InputDialog,
  ms as InputEventBus,
  VI as InputPluginVue,
  Gy as InputService,
  Ep as MButton,
  S1 as MButtonMenu,
  G1 as MCard,
  tS as MCenteredTextContainer,
  ES as MChooseFolderButton,
  T1 as MCloseButton,
  nS as MColorPicker,
  wy as MColorPickerModal,
  _y as MConfirmModal,
  te as MContainer,
  ma as MContainerColumn,
  On as MContainerGrow,
  cn as MContainerRow,
  aS as MContainerSplit,
  MS as MCookieBanner,
  X1 as MDialog,
  p0 as MDialogCancelButton,
  Bs as MDialogCancelButtonRedesign,
  m0 as MDialogConfirmButton,
  Vs as MDialogConfirmButtonRedesign,
  du as MDialogFooter,
  ls as MFSwitch,
  sS as MFileUpload,
  j1 as MGridItem,
  H1 as MGridItemCenter,
  V1 as MGridItemEnd,
  K1 as MGridItemExpand,
  W1 as MGridItemStart,
  z1 as MGridRow,
  wi as MIcon,
  ds as MIconButton,
  Dy as MInfoModal,
  oS as MInfoRowItem,
  iS as MInputNumber,
  L1 as MLargeIconButton,
  rS as MListComponent,
  lS as MLoading,
  eI as MMenu,
  Kn as MModal,
  Bn as MModalActionButton,
  DS as MPickList,
  Pl as MPickListItem,
  cS as MProgressBar,
  uS as MSelect,
  dS as MSlider,
  fS as MSliderFixedWidth,
  pS as MStepper,
  mS as MSwitch,
  AS as MSwitchStyled,
  gS as MTabContainer,
  hS as MTabItem,
  YE as MTemplateItem,
  vS as MTemplates,
  D1 as MTextButton,
  Ry as MTextInputModal,
  n0 as MToggleButton,
  kl as MTogglePanel,
  M1 as MToolbarButton,
  ZE as MTooltip,
  ft as MUButton,
  O1 as MUDropdown,
  Yy as MUErrorModal,
  u0 as MUInput,
  Z1 as MUSelectModal,
  IS as MUSwitch,
  bS as MUnsupportedBrowser,
  yS as MUploadDropArea,
  CS as MUploadFileButton,
  Uy as MViewerHelpModal,
  ya as MeasurementsDistanceUnit,
  Ut as MenuType,
  It as NavbarAction,
  we as NavbarEventBus,
  zn as NavbarNamedEvents,
  eC as NavbarPluginVue,
  C0 as NavbarService,
  wp as NotificationType,
  Oh as OemSerialNumber,
  Ha as OperatorPermissionsEnum,
  ja as OperatorRoleEnum,
  QI as OrderListViewMode,
  UI as OrderTypeEnum,
  YI as PoolName,
  Lh as RealGuideConfiguration,
  F1 as RgGlobalNavbar,
  U1 as RgLogoUserDropdown,
  q1 as RgSubTitle,
  J1 as RgTitle,
  $I as STLLibraryApiPluginVue,
  g1 as STLLibraryCache,
  xS as SendMediaMessageDialog,
  zI as ServerApiPluginVue,
  KI as SessionManager,
  WI as SessionPluginVue,
  A1 as SetupAppGui,
  kp as ShippingMessageType,
  fx as TVersionTypes,
  $1 as TitleSmall,
  jI as UIFormState,
  GI as UIState,
  Q1 as UserProfileDropdown,
  Y1 as UserProfileTemp,
  Wu as UserSettingsDialog,
  HI as UserSettingsEnum,
  OS as WeblinkUploadInvalidComponent,
  NS as WeblinkUploadNoPatientIdComponent,
  jp as ZIMVIE_VIDEO_TUTORIAL_URL,
  k1 as ZipGetData,
  x_ as addClassToElementByClass,
  v_ as addClassToElementId,
  j_ as advancedMeshFormats,
  L_ as applyDefaultLayout,
  Qr as checkIfExtraParamEnabled,
  o_ as cloneMaterialModel,
  J_ as convertFileSizeToMb,
  nc as countDecimals,
  K_ as countLabelOccurrences,
  Xk as createButtonModel,
  Ip as createDevLogger,
  a_ as createMaterialModel,
  s_ as createMaterialModelWithName,
  R_ as decodeFromBase64,
  Jk as devLogger,
  G_ as dicomFormats,
  N_ as encodeToBase64,
  Te as error,
  v1 as exception,
  m_ as extractSuffixes,
  Pp as fileFormats,
  PS as formatDateToLocale,
  Zi as formatFileSizeBytes,
  FS as formatTimeToLocale,
  qk as getAboutInfoModel,
  QS as getDateFormatFromLocale,
  T_ as getDefaultColor,
  e_ as getDefaultOperatorRoleModel,
  S_ as getDefaultPallete,
  l_ as getDefaultStatusModel,
  d_ as getDefaultWorkflowModel,
  c_ as getDefaultWorkflowRequestModel,
  f_ as getDefaultWorkflowStatus,
  u_ as getDefaultWorkflowStep,
  __ as getDocumentIcon,
  O_ as getEnumKeyByValue,
  Q_ as getFileSuffixInURL,
  vs as getIconPath,
  Ja as getIconSrc,
  bo as getImgSrc,
  z_ as getKeyPrefix,
  Lp as getLanguageName,
  Hk as getNamespacedUuid,
  i_ as getNewOperator,
  _1 as getOemSerialNumber,
  Mh as getRealGuideConfigurationIdentifier,
  Tr as getSleeveOriginalName,
  n1 as getStatusAppendMessage,
  e1 as getStatusClass,
  t1 as getStatusColor,
  X_ as getStepClass,
  I_ as getStepNameTranslations,
  Z_ as getStepTextClass,
  V_ as getStringBeforeFirstSlash,
  es as getUserAddressLabel,
  Vp as getVideoTutorialFallbackUrl,
  Wk as hasAllowUnsupportedBrowser,
  Lr as hasEditMaterialPermission,
  jg as hasEditUsersPermission,
  Gg as hasEditWorkflowPermission,
  E1 as hasPcSettingsAccess,
  C1 as hasTestingViewAccess,
  ac as hasUnsupportedFile,
  U_ as imgExtendedFormats,
  Fp as imgFormats,
  b1 as info,
  P_ as initI18n,
  p1 as isBrowser,
  Vk as isChromeUserAgent,
  Kk as isIOSDevice,
  H_ as isMeshFileFormat,
  g_ as isMobileView,
  f1 as isNode,
  h_ as isTabletView,
  Wa as isUserWeblinkAdmin,
  Us as isUserWeblinkOperator,
  Ys as isUserWeblinkReadOnlyOperator,
  y1 as isUserWeblinkUser,
  k_ as isValidDate,
  W_ as labelAlreadyExists,
  sc as meshFormats,
  Up as meshFormatsArray,
  jt as normalizeAppLanguage,
  d1 as openSuppportTicket,
  s1 as parseBase64CXml,
  $_ as parseGenericObjectsToTree3,
  a1 as parseStringCXml,
  m1 as persistSessionCookie,
  p_ as prepareStatusBodyModel,
  r_ as prepareStepBodyModel,
  y_ as removeClassToElementByClass,
  b_ as removeClassToElementId,
  C_ as removeElementStyle,
  q_ as removeFileExtensions,
  A_ as removeFileExtesion,
  Rp as replaceSuffix,
  F_ as replaceSuffixInURL,
  E_ as setElementFullHeight,
  D_ as setPatientListBackground,
  Dp as setProfileBtnMargin,
  M_ as setWizardBackground,
  h1 as setupNotificationStore,
  jk as sha1,
  Gk as sha256,
  Ge as success,
  Y_ as textureFormats,
  B_ as toCamelCase,
  L0 as toRealguideLanguageCode,
  l1 as toRemoteSupport,
  o1 as toUserDashboard,
  i1 as toUserForgetPassoword,
  r1 as toVideoTutorial,
  c1 as toWebRG,
  u1 as toWeblinkPcSelection,
  Ce as translation,
  Ur as useAppSettings,
  Sn as useAssets,
  Ku as useAuth,
  Ui as useBodyContainerDiv,
  kS as useClientInfo,
  wS as useContextMenu,
  Zl as useGuiConfiguration,
  N1 as useGuiConfigurationStore,
  US as useInput,
  D0 as useLocalizationStore,
  tn as useModal,
  LS as useModals,
  _S as useMouseDrag,
  tC as useNavbar,
  da as useNotificationStore,
  Hs as useOnClickOutside,
  Js as useOnGlobalKeyboardEvent,
  RB as useReactiveModel,
  SS as useResizeObserver,
  jS as useSTLLibraryApi,
  R1 as useSTLLibraryStore,
  GS as useServerApi,
  YS as useSessionManager,
  P1 as useTestingProtocolStore,
  TS as useTooltip,
  Jn as useUserSettingsStore,
  B0 as useUserStore,
  fu as useUtilStore,
  Qp as volumeFormats,
  x1 as warn,
  ec as weblinkUploadSupportedFormats
};
//# sourceMappingURL=medicwebframework.js.map
